
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("iwsIy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d7c17de4ac57e2ee$var$_react = $d7c17de4ac57e2ee$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $d7c17de4ac57e2ee$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $d7c17de4ac57e2ee$var$PeopleGroupIcon = (props)=>/*#__PURE__*/ $d7c17de4ac57e2ee$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M8.126 10H4c-1.113 0-2 .895-2 2v3.73c0 1.31 1.874 2.053 4 2.23v-2.964A3.002 3.002 0 019 12h.354a4 4 0 01-1.228-2zm7.748 0H20c1.105 0 2 .885 2 2v3.73c0 1.31-1.874 2.053-4 2.23v-2.964A3 3 0 0015 12h-.354a4 4 0 001.228-2zM9.967 5.554a3 3 0 10-1.963 3.274 3.999 3.999 0 011.963-3.274zm6.03 3.274a3 3 0 10-1.963-3.276 3.994 3.994 0 011.963 3.276z"/><path d="M7 15c0-1.105.887-2 2-2h6c1.105 0 2 .885 2 2v3.73c0 3.027-10 3.027-10 0V15z"/><circle cx="12" cy="9" r="3"/></g></svg>`
    }, props));
$d7c17de4ac57e2ee$var$PeopleGroupIcon.displayName = 'PeopleGroupIcon';
var $d7c17de4ac57e2ee$var$_default = $d7c17de4ac57e2ee$var$PeopleGroupIcon;
module.exports.default = $d7c17de4ac57e2ee$var$_default;

});

parcelRegister("96IgR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6a1703e228f19740$var$_react = $6a1703e228f19740$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $6a1703e228f19740$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $6a1703e228f19740$var$ErrorIcon = (props)=>/*#__PURE__*/ $6a1703e228f19740$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path d="M13.416 4.417a2.002 2.002 0 00-2.832 0l-6.168 6.167a2.002 2.002 0 000 2.833l6.168 6.167a2.002 2.002 0 002.832 0l6.168-6.167a2.002 2.002 0 000-2.833l-6.168-6.167z" fill="currentColor"/><path d="M12 14a1 1 0 01-1-1V8a1 1 0 012 0v5a1 1 0 01-1 1m0 3a1 1 0 010-2 1 1 0 010 2" fill="inherit"/></g></svg>`
    }, props));
$6a1703e228f19740$var$ErrorIcon.displayName = 'ErrorIcon';
var $6a1703e228f19740$var$_default = $6a1703e228f19740$var$ErrorIcon;
module.exports.default = $6a1703e228f19740$var$_default;

});

parcelRegister("oeORR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $048dbcd6d1394bcb$var$_react = $048dbcd6d1394bcb$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $048dbcd6d1394bcb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $048dbcd6d1394bcb$var$ActivityIcon = (props)=>/*#__PURE__*/ $048dbcd6d1394bcb$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M19.004 17C19 17 19 7.006 19 7.006 19 7 4.996 7 4.996 7 5 7 5 16.994 5 16.994 5 17 19.004 17 19.004 17zM3 7.006A2 2 0 014.995 5h14.01A2 2 0 0121 7.006v9.988A2 2 0 0119.005 19H4.995A2 2 0 013 16.994V7.006z" fill-rule="nonzero"/><path d="M4 6h16v5H4V6zm5 2c0 .556.446 1 .995 1h8.01c.54 0 .995-.448.995-1 0-.556-.446-1-.995-1h-8.01C9.455 7 9 7.448 9 8zM5 8c0 .556.448 1 1 1 .556 0 1-.448 1-1 0-.556-.448-1-1-1-.556 0-1 .448-1 1z"/></g></svg>`
    }, props));
$048dbcd6d1394bcb$var$ActivityIcon.displayName = 'ActivityIcon';
var $048dbcd6d1394bcb$var$_default = $048dbcd6d1394bcb$var$ActivityIcon;
module.exports.default = $048dbcd6d1394bcb$var$_default;

});

parcelRegister("iFXD5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d98a4f81d02f8071$var$_react = $d98a4f81d02f8071$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $d98a4f81d02f8071$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $d98a4f81d02f8071$var$AddonIcon = (props)=>/*#__PURE__*/ $d98a4f81d02f8071$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M5.376 6.455l5.248-3.104c.792-.469 1.963-.467 2.752 0l5.248 3.104C19.416 6.923 20 7.962 20 8.895v6.21c0 .936-.587 1.973-1.376 2.44l-5.248 3.104c-.792.469-1.963.467-2.752 0l-5.248-3.104C4.584 17.077 4 16.038 4 15.105v-6.21c0-.936.587-1.973 1.376-2.44zm6.99-1.314c-.165-.098-.566-.098-.733 0L6.385 8.245c-.166.098-.367.454-.367.65v6.21c0 .195.2.551.367.65l5.248 3.104c.166.098.567.098.734 0l5.248-3.104c.166-.098.367-.454.367-.65v-6.21c0-.195-.2-.551-.367-.65l-5.248-3.104z"/><path d="M12 16a4 4 0 110-8 4 4 0 010 8zm0-2a2 2 0 100-4 2 2 0 000 4z"/></g></svg>`
    }, props));
$d98a4f81d02f8071$var$AddonIcon.displayName = 'AddonIcon';
var $d98a4f81d02f8071$var$_default = $d98a4f81d02f8071$var$AddonIcon;
module.exports.default = $d98a4f81d02f8071$var$_default;

});

parcelRegister("eLhcP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $abf2cd30d4bf2060$var$_react = $abf2cd30d4bf2060$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $abf2cd30d4bf2060$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $abf2cd30d4bf2060$var$AppSwitcherIcon = (props)=>/*#__PURE__*/ $abf2cd30d4bf2060$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentColor" fill-rule="evenodd" d="M4 5.01C4 4.451 4.443 4 5.01 4h1.98C7.549 4 8 4.443 8 5.01v1.98C8 7.549 7.557 8 6.99 8H5.01C4.451 8 4 7.557 4 6.99V5.01zm0 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98C8 13.549 7.557 14 6.99 14H5.01C4.451 14 4 13.557 4 12.99v-1.98zm6-6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98C14 7.549 13.557 8 12.99 8h-1.98C10.451 8 10 7.557 10 6.99V5.01zm0 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01v-1.98zm6-6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98C20 7.549 19.557 8 18.99 8h-1.98C16.451 8 16 7.557 16 6.99V5.01zm0 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01v-1.98zm-12 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98C8 19.549 7.557 20 6.99 20H5.01C4.451 20 4 19.557 4 18.99v-1.98zm6 0c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01v-1.98zm6 0c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01v-1.98z"/></svg>`
    }, props));
$abf2cd30d4bf2060$var$AppSwitcherIcon.displayName = 'AppSwitcherIcon';
var $abf2cd30d4bf2060$var$_default = $abf2cd30d4bf2060$var$AppSwitcherIcon;
module.exports.default = $abf2cd30d4bf2060$var$_default;

});

parcelRegister("1j9EV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0f3f0ee35b88c73e$var$_react = $0f3f0ee35b88c73e$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $0f3f0ee35b88c73e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $0f3f0ee35b88c73e$var$BillingIcon = (props)=>/*#__PURE__*/ $0f3f0ee35b88c73e$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M7 4v16h10V4H7zm-2-.01C5 2.892 5.897 2 7.006 2h9.988C18.102 2 19 2.898 19 3.99v16.02c0 1.099-.897 1.99-2.006 1.99H7.006A2.003 2.003 0 015 20.01V3.99z" fill-rule="nonzero"/><rect x="8" y="6" width="8" height="2" rx="1"/><rect x="8" y="9" width="5" height="2" rx="1"/><rect x="8" y="12" width="5" height="2" rx="1"/><rect x="8" y="15" width="5" height="2" rx="1"/><rect x="14" y="12" width="2" height="2" rx="1"/><rect x="14" y="15" width="2" height="2" rx="1"/><rect x="14" y="9" width="2" height="2" rx="1"/></g></svg>`
    }, props));
$0f3f0ee35b88c73e$var$BillingIcon.displayName = 'BillingIcon';
var $0f3f0ee35b88c73e$var$_default = $0f3f0ee35b88c73e$var$BillingIcon;
module.exports.default = $0f3f0ee35b88c73e$var$_default;

});

parcelRegister("aWvIp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7f77ec2b05210607$var$_react = $7f77ec2b05210607$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $7f77ec2b05210607$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $7f77ec2b05210607$var$CheckCircleIcon = (props)=>/*#__PURE__*/ $7f77ec2b05210607$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle fill="currentColor" cx="12" cy="12" r="10"/><path d="M9.707 11.293a1 1 0 10-1.414 1.414l2 2a1 1 0 001.414 0l4-4a1 1 0 10-1.414-1.414L11 12.586l-1.293-1.293z" fill="inherit"/></g></svg>`
    }, props));
$7f77ec2b05210607$var$CheckCircleIcon.displayName = 'CheckCircleIcon';
var $7f77ec2b05210607$var$_default = $7f77ec2b05210607$var$CheckCircleIcon;
module.exports.default = $7f77ec2b05210607$var$_default;

});

parcelRegister("86Ndv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5e750fba7c07630a$var$_react = $5e750fba7c07630a$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $5e750fba7c07630a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $5e750fba7c07630a$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $5e750fba7c07630a$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M8.292 10.293a1.009 1.009 0 000 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 000-1.419.987.987 0 00-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 00-1.406 0z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$5e750fba7c07630a$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $5e750fba7c07630a$var$_default = $5e750fba7c07630a$var$ChevronDownIcon;
module.exports.default = $5e750fba7c07630a$var$_default;

});

parcelRegister("dtaN9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9ce65ad39d5363d8$var$_react = $9ce65ad39d5363d8$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $9ce65ad39d5363d8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $9ce65ad39d5363d8$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $9ce65ad39d5363d8$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M10.294 9.698a.988.988 0 010-1.407 1.01 1.01 0 011.419 0l2.965 2.94a1.09 1.09 0 010 1.548l-2.955 2.93a1.01 1.01 0 01-1.42 0 .988.988 0 010-1.407l2.318-2.297-2.327-2.307z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$9ce65ad39d5363d8$var$ChevronRightIcon.displayName = 'ChevronRightIcon';
var $9ce65ad39d5363d8$var$_default = $9ce65ad39d5363d8$var$ChevronRightIcon;
module.exports.default = $9ce65ad39d5363d8$var$_default;

});

parcelRegister("2KhVf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1ffdc7a77e26f852$var$_react = $1ffdc7a77e26f852$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $1ffdc7a77e26f852$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $1ffdc7a77e26f852$var$CreditcardFilledIcon = (props)=>/*#__PURE__*/ $1ffdc7a77e26f852$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M3 10.988h18V17c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2v-6.012zM6.013 16h2v-2h-2v2zM21 8.993V7c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v1.993" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$1ffdc7a77e26f852$var$CreditcardFilledIcon.displayName = 'CreditcardFilledIcon';
var $1ffdc7a77e26f852$var$_default = $1ffdc7a77e26f852$var$CreditcardFilledIcon;
module.exports.default = $1ffdc7a77e26f852$var$_default;

});

parcelRegister("hXGRB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d139322d15a7a750$var$_react = $d139322d15a7a750$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $d139322d15a7a750$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $d139322d15a7a750$var$DashboardIcon = (props)=>/*#__PURE__*/ $d139322d15a7a750$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor"><path d="M4 18h16.008C20 18 20 6 20 6H3.992C4 6 4 18 4 18zM2 5.994C2 4.893 2.898 4 3.99 4h16.02C21.108 4 22 4.895 22 5.994v12.012A1.997 1.997 0 0120.01 20H3.99A1.994 1.994 0 012 18.006V5.994z"/><path d="M7 5v14h2V5z"/><path d="M7 11h14V9H7z"/></g></svg>`
    }, props));
$d139322d15a7a750$var$DashboardIcon.displayName = 'DashboardIcon';
var $d139322d15a7a750$var$_default = $d139322d15a7a750$var$DashboardIcon;
module.exports.default = $d139322d15a7a750$var$_default;

});

parcelRegister("bkIGg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8404389a307bab2b$var$_react = $8404389a307bab2b$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $8404389a307bab2b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $8404389a307bab2b$var$EditorAddIcon = (props)=>/*#__PURE__*/ $8404389a307bab2b$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M13 11V7a1 1 0 00-2 0v4H7a1 1 0 000 2h4v4a1 1 0 002 0v-4h4a1 1 0 000-2h-4z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$8404389a307bab2b$var$EditorAddIcon.displayName = 'EditorAddIcon';
var $8404389a307bab2b$var$_default = $8404389a307bab2b$var$EditorAddIcon;
module.exports.default = $8404389a307bab2b$var$_default;

});

parcelRegister("24y6N", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $182669c75dfa02c6$var$_react = $182669c75dfa02c6$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $182669c75dfa02c6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $182669c75dfa02c6$var$EmojiAtlassianIcon = (props)=>/*#__PURE__*/ $182669c75dfa02c6$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M8.703 11.475c-.237-.253-.61-.239-.767.087L4.05 19.33a.464.464 0 00.415.672h5.412a.448.448 0 00.415-.26c1.167-2.408.46-6.077-1.59-8.267zm2.851-7.065c-2.174 3.443-2.03 7.257-.598 10.12l2.608 5.217c.078.159.24.26.416.26h5.411a.464.464 0 00.416-.671s-7.28-14.567-7.46-14.93c-.167-.325-.583-.332-.793.003z" fill="currentColor"/></svg>`
    }, props));
$182669c75dfa02c6$var$EmojiAtlassianIcon.displayName = 'EmojiAtlassianIcon';
var $182669c75dfa02c6$var$_default = $182669c75dfa02c6$var$EmojiAtlassianIcon;
module.exports.default = $182669c75dfa02c6$var$_default;

});

parcelRegister("4ki2H", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3267068b245906ad$var$_react = $3267068b245906ad$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $3267068b245906ad$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $3267068b245906ad$var$FilterIcon = (props)=>/*#__PURE__*/ $3267068b245906ad$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M7 13h10l1-2H6zM3.993 6c-.548 0-.79.405-.546.895L4 8h16l.553-1.105C20.8 6.4 20.555 6 20.007 6H3.993zm6.785 11.556a.87.87 0 00.727.444h.99c.279 0 .605-.2.727-.444L14 16h-4l.778 1.556z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$3267068b245906ad$var$FilterIcon.displayName = 'FilterIcon';
var $3267068b245906ad$var$_default = $3267068b245906ad$var$FilterIcon;
module.exports.default = $3267068b245906ad$var$_default;

});

parcelRegister("e5T2d", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a42c3910affccfb4$var$_react = $a42c3910affccfb4$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $a42c3910affccfb4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $a42c3910affccfb4$var$FolderIcon = (props)=>/*#__PURE__*/ $a42c3910affccfb4$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M20 19V8h-9.154l-.503-1.258-.455-1.136C9.778 5.33 9.291 5 9.003 5H3.997C4.002 5 4 19 4 19h16zM12.2 6h7.809C21.109 6 22 6.893 22 7.992v11.016c0 1.1-.898 1.992-1.991 1.992H3.991C2.891 21 2 20.107 2 19.008V5.006C2 3.898 2.896 3 3.997 3h5.006c1.103 0 2.327.826 2.742 1.862L12.2 6z" fill="currentColor"/></svg>`
    }, props));
$a42c3910affccfb4$var$FolderIcon.displayName = 'FolderIcon';
var $a42c3910affccfb4$var$_default = $a42c3910affccfb4$var$FolderIcon;
module.exports.default = $a42c3910affccfb4$var$_default;

});

parcelRegister("6nIG2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4a578bfd70cc9f83$var$_react = $4a578bfd70cc9f83$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $4a578bfd70cc9f83$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $4a578bfd70cc9f83$var$IssuesIcon = (props)=>/*#__PURE__*/ $4a578bfd70cc9f83$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M5 12.991c0 .007 14.005.009 14.005.009C18.999 13 19 5.009 19 5.009 19 5.002 4.995 5 4.995 5 5.001 5 5 12.991 5 12.991zM3 5.01C3 3.899 3.893 3 4.995 3h14.01C20.107 3 21 3.902 21 5.009v7.982c0 1.11-.893 2.009-1.995 2.009H4.995A2.004 2.004 0 013 12.991V5.01zM19 19c-.005 1.105-.9 2-2.006 2H7.006A2.009 2.009 0 015 19h14zm1-3a2.002 2.002 0 01-1.994 2H5.994A2.003 2.003 0 014 16h16z" fill-rule="nonzero"/><path d="M10.674 11.331c.36.36.941.36 1.3 0l2.758-2.763a.92.92 0 00-1.301-1.298l-2.108 2.11-.755-.754a.92.92 0 00-1.3 1.3l1.406 1.405z"/></g></svg>`
    }, props));
$4a578bfd70cc9f83$var$IssuesIcon.displayName = 'IssuesIcon';
var $4a578bfd70cc9f83$var$_default = $4a578bfd70cc9f83$var$IssuesIcon;
module.exports.default = $4a578bfd70cc9f83$var$_default;

});

parcelRegister("jG1wZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e533209b7442b630$var$_react = $e533209b7442b630$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $e533209b7442b630$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $e533209b7442b630$var$MoreIcon = (props)=>/*#__PURE__*/ $e533209b7442b630$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><circle cx="5" cy="12" r="2"/><circle cx="12" cy="12" r="2"/><circle cx="19" cy="12" r="2"/></g></svg>`
    }, props));
$e533209b7442b630$var$MoreIcon.displayName = 'MoreIcon';
var $e533209b7442b630$var$_default = $e533209b7442b630$var$MoreIcon;
module.exports.default = $e533209b7442b630$var$_default;

});

parcelRegister("aLjrh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7d5d5f54949dbd99$var$_react = $7d5d5f54949dbd99$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $7d5d5f54949dbd99$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $7d5d5f54949dbd99$var$NotificationIcon = (props)=>/*#__PURE__*/ $7d5d5f54949dbd99$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M6.485 17.669a2 2 0 002.829 0l-2.829-2.83a2 2 0 000 2.83zm4.897-12.191l-.725.725c-.782.782-2.21 1.813-3.206 2.311l-3.017 1.509c-.495.248-.584.774-.187 1.171l8.556 8.556c.398.396.922.313 1.171-.188l1.51-3.016c.494-.988 1.526-2.42 2.311-3.206l.725-.726a5.048 5.048 0 00.64-6.356 1.01 1.01 0 10-1.354-1.494c-.023.025-.046.049-.066.075a5.043 5.043 0 00-2.788-.84 5.036 5.036 0 00-3.57 1.478z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$7d5d5f54949dbd99$var$NotificationIcon.displayName = 'NotificationIcon';
var $7d5d5f54949dbd99$var$_default = $7d5d5f54949dbd99$var$NotificationIcon;
module.exports.default = $7d5d5f54949dbd99$var$_default;

});

parcelRegister("a10lp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $74aa43bc29155859$var$_react = $74aa43bc29155859$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $74aa43bc29155859$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $74aa43bc29155859$var$NotificationDirectIcon = (props)=>/*#__PURE__*/ $74aa43bc29155859$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M6.586 17.829a2 2 0 002.829 0L6.585 15a2 2 0 000 2.829zm4.798-12.351A5.036 5.036 0 0114.954 4c.972 0 1.945.28 2.788.839.02-.026.043-.05.066-.074a1.01 1.01 0 111.354 1.494 5.048 5.048 0 01-.64 6.356l-.725.725c-.782.783-1.813 2.21-2.312 3.207l-1.509 3.016c-.249.5-.773.584-1.171.187l-8.556-8.555c-.397-.397-.308-.924.187-1.172l3.017-1.508c.989-.494 2.42-1.526 3.206-2.312l.725-.725zm2.739 9.63c.517-.975 1.568-2.396 2.354-3.182l.725-.726a3.048 3.048 0 00.387-3.835c-.19-.286-.718-.766-.859-.86A3.043 3.043 0 0015.047 6a3.04 3.04 0 00-2.156.892l-.95.951c-.784.785-2.219 1.82-3.201 2.311l-1.74.87 6.07 6.069 1.053-1.985z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$74aa43bc29155859$var$NotificationDirectIcon.displayName = 'NotificationDirectIcon';
var $74aa43bc29155859$var$_default = $74aa43bc29155859$var$NotificationDirectIcon;
module.exports.default = $74aa43bc29155859$var$_default;

});

parcelRegister("8GAdb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $652e55d4accccbc5$var$_react = $652e55d4accccbc5$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $652e55d4accccbc5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $652e55d4accccbc5$var$OpenIcon = (props)=>/*#__PURE__*/ $652e55d4accccbc5$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M11.031 7A1.03 1.03 0 0010 8.036a1.05 1.05 0 001.044 1.045l3.121.014.014 3.121a1.05 1.05 0 001.045 1.044 1.03 1.03 0 001.036-1.035l-.019-4.161a1.053 1.053 0 00-1.045-1.045L11.035 7h-.004z"/><path d="M13.364 8.292l-7.072 7.071a1.002 1.002 0 000 1.415c.39.39 1.024.39 1.415 0l7.071-7.071A1.002 1.002 0 0014.071 8a1 1 0 00-.707.292z"/></g></svg>`
    }, props));
$652e55d4accccbc5$var$OpenIcon.displayName = 'OpenIcon';
var $652e55d4accccbc5$var$_default = $652e55d4accccbc5$var$OpenIcon;
module.exports.default = $652e55d4accccbc5$var$_default;

});

parcelRegister("cI9iM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9410cf464908763e$var$_react = $9410cf464908763e$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $9410cf464908763e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $9410cf464908763e$var$PersonIcon = (props)=>/*#__PURE__*/ $9410cf464908763e$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M6 14c0-1.105.902-2 2.009-2h7.982c1.11 0 2.009.894 2.009 2.006v4.44c0 3.405-12 3.405-12 0V14z"/><circle cx="12" cy="7" r="4"/></g></svg>`
    }, props));
$9410cf464908763e$var$PersonIcon.displayName = 'PersonIcon';
var $9410cf464908763e$var$_default = $9410cf464908763e$var$PersonIcon;
module.exports.default = $9410cf464908763e$var$_default;

});

parcelRegister("ktq0D", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ee7ab0ff59e83b3d$var$_react = $ee7ab0ff59e83b3d$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $ee7ab0ff59e83b3d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $ee7ab0ff59e83b3d$var$PersonCircleIcon = (props)=>/*#__PURE__*/ $ee7ab0ff59e83b3d$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M14.5 13.009h-5c-1.38 0-2.5 1.12-2.5 2.503v3.978a8.951 8.951 0 005 1.519 8.95 8.95 0 005-1.519v-3.978a2.502 2.502 0 00-2.5-2.503"/><circle cx="12" cy="9" r="3"/><path d="M12 20a8 8 0 100-16 8 8 0 000 16zm0 2C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z" fill-rule="nonzero"/></g></svg>`
    }, props));
$ee7ab0ff59e83b3d$var$PersonCircleIcon.displayName = 'PersonCircleIcon';
var $ee7ab0ff59e83b3d$var$_default = $ee7ab0ff59e83b3d$var$PersonCircleIcon;
module.exports.default = $ee7ab0ff59e83b3d$var$_default;

});

parcelRegister("1n6uL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0ffcfa3f9afe5f5a$var$_react = $0ffcfa3f9afe5f5a$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $0ffcfa3f9afe5f5a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $0ffcfa3f9afe5f5a$var$PremiumIcon = (props)=>/*#__PURE__*/ $0ffcfa3f9afe5f5a$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentColor" fill-rule="evenodd" d="M9.276 4.382L7.357 9.247l-4.863 1.917a.78.78 0 000 1.45l4.863 1.918 1.919 4.863a.78.78 0 001.45 0h-.001l1.918-4.863 4.864-1.919a.781.781 0 000-1.45l-4.864-1.916-1.918-4.865a.776.776 0 00-.44-.438.778.778 0 00-1.01.438zm8.297-2.03l-.743 1.886-1.884.743a.56.56 0 000 1.038l1.884.743.743 1.886a.558.558 0 001.038 0l.745-1.886 1.883-.743a.557.557 0 000-1.038l-1.883-.743-.745-1.885a.552.552 0 00-.314-.314.562.562 0 00-.724.314zm-.704 13.003l-.744 1.883-1.883.744a.553.553 0 00-.316.314.56.56 0 00.316.724l1.883.743.744 1.884c.057.144.17.258.314.315a.56.56 0 00.724-.315l.744-1.884 1.883-.743a.557.557 0 000-1.038l-1.883-.744-.744-1.883a.551.551 0 00-.315-.316.56.56 0 00-.723.316z"/></svg>`
    }, props));
$0ffcfa3f9afe5f5a$var$PremiumIcon.displayName = 'PremiumIcon';
var $0ffcfa3f9afe5f5a$var$_default = $0ffcfa3f9afe5f5a$var$PremiumIcon;
module.exports.default = $0ffcfa3f9afe5f5a$var$_default;

});

parcelRegister("ioiQ7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d639150540ca3770$var$_react = $d639150540ca3770$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $d639150540ca3770$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $d639150540ca3770$var$QuestionCircleIcon = (props)=>/*#__PURE__*/ $d639150540ca3770$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle fill="currentColor" cx="12" cy="12" r="10"/><circle fill="inherit" cx="12" cy="18" r="1"/><path d="M15.89 9.05a3.975 3.975 0 00-2.957-2.942C10.321 5.514 8.017 7.446 8 9.95l.005.147a.992.992 0 00.982.904c.552 0 1-.447 1.002-.998a2.004 2.004 0 014.007-.002c0 1.102-.898 2-2.003 2H12a1 1 0 00-1 .987v2.014a1.001 1.001 0 002.004 0v-.782c0-.217.145-.399.35-.472A3.99 3.99 0 0015.89 9.05" fill="inherit"/></g></svg>`
    }, props));
$d639150540ca3770$var$QuestionCircleIcon.displayName = 'QuestionCircleIcon';
var $d639150540ca3770$var$_default = $d639150540ca3770$var$QuestionCircleIcon;
module.exports.default = $d639150540ca3770$var$_default;

});

parcelRegister("k6W9R", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ea417b25f2e1b21d$var$_react = $ea417b25f2e1b21d$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $ea417b25f2e1b21d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $ea417b25f2e1b21d$var$RecentIcon = (props)=>/*#__PURE__*/ $ea417b25f2e1b21d$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M11 8.002v4.002c0 .28.116.53.301.712l2.47 2.47a1.003 1.003 0 001.414 0 1.003 1.003 0 000-1.415L13 11.586V8.004A1.009 1.009 0 0013 8V6a1 1 0 00-2 0v2.002zM12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$ea417b25f2e1b21d$var$RecentIcon.displayName = 'RecentIcon';
var $ea417b25f2e1b21d$var$_default = $ea417b25f2e1b21d$var$RecentIcon;
module.exports.default = $ea417b25f2e1b21d$var$_default;

});

parcelRegister("5318D", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3ace1d9d3a4d7e1f$var$_react = $3ace1d9d3a4d7e1f$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $3ace1d9d3a4d7e1f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $3ace1d9d3a4d7e1f$var$ScreenIcon = (props)=>/*#__PURE__*/ $3ace1d9d3a4d7e1f$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M3 6.009C3 4.899 3.893 4 4.995 4h14.01C20.107 4 21 4.902 21 6.009v7.982c0 1.11-.893 2.009-1.995 2.009H4.995A2.004 2.004 0 013 13.991V6.01zM5 14h14V6H5v8z" fill-rule="nonzero"/><path d="M10 17h4v3h-4zm-1 3.5a.5.5 0 01.491-.5h5.018a.5.5 0 01.491.5v.5H9v-.5z"/></g></svg>`
    }, props));
$3ace1d9d3a4d7e1f$var$ScreenIcon.displayName = 'ScreenIcon';
var $3ace1d9d3a4d7e1f$var$_default = $3ace1d9d3a4d7e1f$var$ScreenIcon;
module.exports.default = $3ace1d9d3a4d7e1f$var$_default;

});

parcelRegister("dsroq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9cc32389de297b6e$var$_react = $9cc32389de297b6e$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $9cc32389de297b6e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $9cc32389de297b6e$var$SearchIcon = (props)=>/*#__PURE__*/ $9cc32389de297b6e$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M16.436 15.085l3.94 4.01a1 1 0 01-1.425 1.402l-3.938-4.006a7.5 7.5 0 111.423-1.406zM10.5 16a5.5 5.5 0 100-11 5.5 5.5 0 000 11z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$9cc32389de297b6e$var$SearchIcon.displayName = 'SearchIcon';
var $9cc32389de297b6e$var$_default = $9cc32389de297b6e$var$SearchIcon;
module.exports.default = $9cc32389de297b6e$var$_default;

});

parcelRegister("iw0Y6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d7abf776b52155a3$var$_react = $d7abf776b52155a3$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $d7abf776b52155a3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $d7abf776b52155a3$var$SettingsIcon = (props)=>/*#__PURE__*/ $d7abf776b52155a3$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M11.701 16.7a5.002 5.002 0 110-10.003 5.002 5.002 0 010 10.004m8.368-3.117a1.995 1.995 0 01-1.346-1.885c0-.876.563-1.613 1.345-1.885a.48.48 0 00.315-.574 8.947 8.947 0 00-.836-1.993.477.477 0 00-.598-.195 2.04 2.04 0 01-1.29.08 1.988 1.988 0 01-1.404-1.395 2.04 2.04 0 01.076-1.297.478.478 0 00-.196-.597 8.98 8.98 0 00-1.975-.826.479.479 0 00-.574.314 1.995 1.995 0 01-1.885 1.346 1.994 1.994 0 01-1.884-1.345.482.482 0 00-.575-.315c-.708.2-1.379.485-2.004.842a.47.47 0 00-.198.582A2.002 2.002 0 014.445 7.06a.478.478 0 00-.595.196 8.946 8.946 0 00-.833 1.994.48.48 0 00.308.572 1.995 1.995 0 011.323 1.877c0 .867-.552 1.599-1.324 1.877a.479.479 0 00-.308.57 8.99 8.99 0 00.723 1.79.477.477 0 00.624.194c.595-.273 1.343-.264 2.104.238.117.077.225.185.302.3.527.8.512 1.58.198 2.188a.473.473 0 00.168.628 8.946 8.946 0 002.11.897.474.474 0 00.57-.313 1.995 1.995 0 011.886-1.353c.878 0 1.618.567 1.887 1.353a.475.475 0 00.57.313 8.964 8.964 0 002.084-.883.473.473 0 00.167-.631c-.318-.608-.337-1.393.191-2.195.077-.116.185-.225.302-.302.772-.511 1.527-.513 2.125-.23a.477.477 0 00.628-.19 8.925 8.925 0 00.728-1.793.478.478 0 00-.314-.573" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$d7abf776b52155a3$var$SettingsIcon.displayName = 'SettingsIcon';
var $d7abf776b52155a3$var$_default = $d7abf776b52155a3$var$SettingsIcon;
module.exports.default = $d7abf776b52155a3$var$_default;

});

parcelRegister("14lY4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0c77348158dae6ea$var$_react = $0c77348158dae6ea$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $0c77348158dae6ea$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $0c77348158dae6ea$var$ShipIcon = (props)=>/*#__PURE__*/ $0c77348158dae6ea$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M6 12h8v-2H6v2zM4 8.99C4 8.445 4.456 8 5.002 8h9.996C15.55 8 16 8.451 16 8.99V14H4V8.99z" fill-rule="nonzero"/><path d="M6 7.005C6 5.898 6.898 5 7.998 5h2.004C11.106 5 12 5.894 12 7.005V10H6V7.005zm4 0V7H7.999c.005 0 .002.003.002.005V8h2v-.995z"/><path d="M4.5 17h13.994l1.002-3H4.14l.36 3zm-2.495-4.012A.862.862 0 012.883 12h18.393c.55 0 .857.417.681.944l-1.707 5.112c-.174.521-.758.944-1.315.944H3.725a1.149 1.149 0 01-1.118-.988l-.602-5.024z" fill-rule="nonzero"/></g></svg>`
    }, props));
$0c77348158dae6ea$var$ShipIcon.displayName = 'ShipIcon';
var $0c77348158dae6ea$var$_default = $0c77348158dae6ea$var$ShipIcon;
module.exports.default = $0c77348158dae6ea$var$_default;

});

parcelRegister("23NQ5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1802859362692b41$var$_react = $1802859362692b41$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $1802859362692b41$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $1802859362692b41$var$ShortcutIcon = (props)=>/*#__PURE__*/ $1802859362692b41$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor"><path d="M19.005 19c-.003 0-.005.002-.005.002l.005-.002zM5 19.006c0-.004-.002-.006-.005-.006H5v.006zM5 4.994V5v-.006zM19 19v-6h2v6.002A1.996 1.996 0 0119.005 21H4.995A1.996 1.996 0 013 19.006V4.994C3 3.893 3.896 3 4.997 3H11v2H5v14h14zM5 4.994V5v-.006zm0 14.012c0-.004-.002-.006-.005-.006H5v.006zM11 5H5v14h14v-6h2v6.002A1.996 1.996 0 0119.005 21H4.995A1.996 1.996 0 013 19.006V4.994C3 3.893 3.896 3 4.997 3H11v2zm8 0v3a1 1 0 002 0V4a1 1 0 00-1-1h-4a1 1 0 000 2h3z"/><path d="M12.707 12.707l8-8a1 1 0 10-1.414-1.414l-8 8a1 1 0 001.414 1.414z"/></g></svg>`
    }, props));
$1802859362692b41$var$ShortcutIcon.displayName = 'ShortcutIcon';
var $1802859362692b41$var$_default = $1802859362692b41$var$ShortcutIcon;
module.exports.default = $1802859362692b41$var$_default;

});

parcelRegister("1ZFzZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $173bbdbf247c682d$var$_react = $173bbdbf247c682d$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $173bbdbf247c682d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $173bbdbf247c682d$var$SignInIcon = (props)=>/*#__PURE__*/ $173bbdbf247c682d$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M15.503 3H12v2h7v14h-7v2h7.006c1.1 0 1.994-.893 1.994-1.995V4.995A1.993 1.993 0 0019.006 3h-3.503z"/><path d="M3.977 11A.99.99 0 003 12.001c0 .551.437.999.977.999h11.047a.988.988 0 00.976-.999.99.99 0 00-.976-1.001H3.977z"/><path d="M12.303 8.305a1.053 1.053 0 000 1.478L14.5 12l-2.197 2.217a1.05 1.05 0 000 1.476c.404.409 1.06.409 1.465 0l2.93-2.955a1.055 1.055 0 000-1.477l-2.93-2.956a1.034 1.034 0 00-1.465 0z"/></g></svg>`
    }, props));
$173bbdbf247c682d$var$SignInIcon.displayName = 'SignInIcon';
var $173bbdbf247c682d$var$_default = $173bbdbf247c682d$var$SignInIcon;
module.exports.default = $173bbdbf247c682d$var$_default;

});

parcelRegister("daM3L", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $99717d2ff622f6d5$var$_react = $99717d2ff622f6d5$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $99717d2ff622f6d5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $99717d2ff622f6d5$var$StarIcon = (props)=>/*#__PURE__*/ $99717d2ff622f6d5$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M12 16.373l3.98 2.193-.76-4.655 3.276-3.347-4.524-.69L12 5.687l-1.972 4.189-4.524.689L8.78 13.91l-.762 4.655L12 16.373zm0 2.283l-3.016 1.662a2 2 0 01-2.939-2.075l.599-3.656-2.57-2.624a2 2 0 011.129-3.377l3.47-.528 1.518-3.224a2 2 0 013.618 0l1.519 3.224 3.47.528a2 2 0 011.127 3.377l-2.569 2.624.599 3.656a2 2 0 01-2.94 2.075L12 18.656z" fill="currentColor"/></svg>`
    }, props));
$99717d2ff622f6d5$var$StarIcon.displayName = 'StarIcon';
var $99717d2ff622f6d5$var$_default = $99717d2ff622f6d5$var$StarIcon;
module.exports.default = $99717d2ff622f6d5$var$_default;

});

parcelRegister("hlWtt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ca21c19e82ca8ae2$var$_react = $ca21c19e82ca8ae2$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $ca21c19e82ca8ae2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $ca21c19e82ca8ae2$var$StarFilledIcon = (props)=>/*#__PURE__*/ $ca21c19e82ca8ae2$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M12.072 17.284l-3.905 2.053a1 1 0 01-1.451-1.054l.745-4.349-3.159-3.08a1 1 0 01.554-1.705l4.366-.635 1.953-3.956a1 1 0 011.794 0l1.952 3.956 4.366.635a1 1 0 01.555 1.705l-3.16 3.08.746 4.349a1 1 0 01-1.45 1.054l-3.906-2.053z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$ca21c19e82ca8ae2$var$StarFilledIcon.displayName = 'StarFilledIcon';
var $ca21c19e82ca8ae2$var$_default = $ca21c19e82ca8ae2$var$StarFilledIcon;
module.exports.default = $ca21c19e82ca8ae2$var$_default;

});

parcelRegister("5YsMl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4598e13719f4189b$var$_react = $4598e13719f4189b$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $4598e13719f4189b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $4598e13719f4189b$var$WarningIcon = (props)=>/*#__PURE__*/ $4598e13719f4189b$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path d="M12.938 4.967c-.518-.978-1.36-.974-1.876 0L3.938 18.425c-.518.978-.045 1.771 1.057 1.771h14.01c1.102 0 1.573-.797 1.057-1.771L12.938 4.967z" fill="currentColor"/><path d="M12 15a1 1 0 01-1-1V9a1 1 0 012 0v5a1 1 0 01-1 1m0 3a1 1 0 010-2 1 1 0 010 2" fill="inherit"/></g></svg>`
    }, props));
$4598e13719f4189b$var$WarningIcon.displayName = 'WarningIcon';
var $4598e13719f4189b$var$_default = $4598e13719f4189b$var$WarningIcon;
module.exports.default = $4598e13719f4189b$var$_default;

});

parcelRegister("kigFe", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $6edb9f28366efd9a$export$2e2bcd8739ae039);
/** @jsx jsx */ parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $cMtFc = parcelRequire("cMtFc");

var $dlyGx = parcelRequire("dlyGx");
const $6edb9f28366efd9a$var$headerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    padding: (0, $dlyGx.padding),
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingBlockEnd: `${(0, $dlyGx.padding) - (0, $dlyGx.keylineHeight)}px`
});
/**
 * __Modal header__
 *
 * A modal header contains the title of the modal and can contain other React elements such as a close button.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples#modal-header)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-header-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const $6edb9f28366efd9a$var$ModalHeader = (props)=>{
    const { children: children, testId: userDefinedTestId } = props;
    const { testId: modalTestId } = (0, $cMtFc.useModal)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--header`;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $6edb9f28366efd9a$var$headerStyles,
        "data-testid": testId
    }, children);
};
var $6edb9f28366efd9a$export$2e2bcd8739ae039 = $6edb9f28366efd9a$var$ModalHeader;

});
parcelRegister("cMtFc", function(module, exports) {

$parcel$export(module.exports, "useModal", () => $fcb16fa0a8cd6eb7$export$33ffd74ebf07f060);

var $eUqFw = parcelRequire("eUqFw");

var $i7afc = parcelRequire("i7afc");
const $fcb16fa0a8cd6eb7$export$33ffd74ebf07f060 = ()=>{
    const modalContext = (0, $eUqFw.useContext)((0, $i7afc.ModalContext));
    if (modalContext == null) throw Error("@atlaskit/modal-dialog: Modal context unavailable \u2013 this component needs to be a child of ModalDialog.");
    return modalContext;
};

});
parcelRegister("i7afc", function(module, exports) {

$parcel$export(module.exports, "ModalContext", () => $a422b7509b33934c$export$ab57792b9b6974a6);
$parcel$export(module.exports, "ScrollContext", () => $a422b7509b33934c$export$dece24112a937f92);

var $eUqFw = parcelRequire("eUqFw");
const $a422b7509b33934c$export$ab57792b9b6974a6 = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $a422b7509b33934c$export$dece24112a937f92 = /*#__PURE__*/ (0, $eUqFw.createContext)(null);

});


parcelRegister("dlyGx", function(module, exports) {

$parcel$export(module.exports, "width", () => $7717be476311e05b$export$7e3df82ee760448c);
$parcel$export(module.exports, "gutter", () => $7717be476311e05b$export$f2b922cb4a245974);
$parcel$export(module.exports, "borderRadius", () => $7717be476311e05b$export$7a57f79000377ca2);
$parcel$export(module.exports, "verticalOffset", () => $7717be476311e05b$export$9212741279b5f103);
$parcel$export(module.exports, "padding", () => $7717be476311e05b$export$6f98e8eaf0be1996);
$parcel$export(module.exports, "keylineHeight", () => $7717be476311e05b$export$4c317248f944c2a9);
$parcel$export(module.exports, "keylineColor", () => $7717be476311e05b$export$d901150a4cc83165);
$parcel$export(module.exports, "textColor", () => $7717be476311e05b$export$32f78bffcd82ff28);
$parcel$export(module.exports, "iconColor", () => $7717be476311e05b$export$3797a580396e3639);

var $PdmhA = parcelRequire("PdmhA");

var $lcnyw = parcelRequire("lcnyw");
const $7717be476311e05b$export$7e3df82ee760448c = {
    values: [
        'small',
        'medium',
        'large',
        'x-large'
    ],
    widths: {
        small: 400,
        medium: 600,
        large: 800,
        'x-large': 968
    },
    defaultValue: 'medium'
};
const $7717be476311e05b$export$f2b922cb4a245974 = 60;
const $7717be476311e05b$var$gridSize = (0, $lcnyw.gridSize)();
const $7717be476311e05b$export$7a57f79000377ca2 = (0, $lcnyw.borderRadius)();
const $7717be476311e05b$export$9212741279b5f103 = $7717be476311e05b$var$gridSize * 2;
const $7717be476311e05b$export$6f98e8eaf0be1996 = $7717be476311e05b$var$gridSize * 3;
const $7717be476311e05b$export$4c317248f944c2a9 = 2;
const $7717be476311e05b$export$d901150a4cc83165 = `var(--ds-border, ${(0, $PdmhA.N30)})`;
const $7717be476311e05b$export$32f78bffcd82ff28 = `var(--ds-text, ${(0, $PdmhA.N900)})`;
const $7717be476311e05b$export$3797a580396e3639 = {
    danger: `var(--ds-icon-danger, ${(0, $PdmhA.R400)})`,
    warning: "var(--ds-icon-warning, #D97008)"
};

});


parcelRegister("boSVF", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $244f2d118fff9712$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $96IgR = parcelRequire("96IgR");

var $5YsMl = parcelRequire("5YsMl");

var $cMtFc = parcelRequire("cMtFc");

var $dlyGx = parcelRequire("dlyGx");
function $244f2d118fff9712$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $244f2d118fff9712$var$titleStyles = {
    name: "1yaejj3",
    styles: "display:flex;min-width:0;margin:var(--ds-space-0, 0px);gap:var(--ds-space-100, 8px);font:var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
const $244f2d118fff9712$var$textStyles = {
    name: "1k30s2j",
    styles: "min-width:0;flex:1 1 auto;word-wrap:break-word"
};
const $244f2d118fff9712$var$iconStyles = {
    name: "1cdsq8b",
    styles: "flex:0 0 auto;color:inherit;font-size:inherit;font-style:inherit;font-weight:inherit;letter-spacing:inherit;line-height:inherit"
};
const $244f2d118fff9712$var$truncatedTextStyles = {
    name: "1h52dri",
    styles: "overflow:hidden;text-overflow:ellipsis;white-space:nowrap"
};
const $244f2d118fff9712$var$TitleIcon = ({ appearance: appearance })=>{
    const Icon = appearance === 'danger' ? (0, (/*@__PURE__*/$parcel$interopDefault($96IgR))) : (0, (/*@__PURE__*/$parcel$interopDefault($5YsMl)));
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $244f2d118fff9712$var$iconStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)(Icon, {
        label: appearance,
        primaryColor: (0, $dlyGx.iconColor)[appearance]
    }));
};
/**
 * __Modal title__
 *
 * A modal title is used to display a title within a modal.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const $244f2d118fff9712$var$ModalTitle = (props)=>{
    const { appearance: appearance, children: children, isMultiline: isMultiline = true, testId: userDefinedTestId } = props;
    const { titleId: titleId, testId: modalTestId } = (0, $cMtFc.useModal)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--title`;
    return /*#__PURE__*/ (0, $byn9U.jsx)("h1", {
        css: $244f2d118fff9712$var$titleStyles,
        "data-testid": testId
    }, appearance && /*#__PURE__*/ (0, $byn9U.jsx)($244f2d118fff9712$var$TitleIcon, {
        appearance: appearance
    }), /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        id: titleId,
        css: [
            $244f2d118fff9712$var$textStyles,
            !isMultiline && $244f2d118fff9712$var$truncatedTextStyles
        ],
        "data-testid": testId && `${testId}-text`
    }, children));
};
var $244f2d118fff9712$export$2e2bcd8739ae039 = $244f2d118fff9712$var$ModalTitle;

});

parcelRegister("lfiOu", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $32d7be1cefbdd135$export$2e2bcd8739ae039);
/** @jsx jsx */ parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $8MHxr = parcelRequire("8MHxr");

var $cMtFc = parcelRequire("cMtFc");

var $84xlG = parcelRequire("84xlG");

var $dlyGx = parcelRequire("dlyGx");

var $eo7vn = parcelRequire("eo7vn");
function $32d7be1cefbdd135$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $32d7be1cefbdd135$var$bodyStyles = {
    name: "mkkf9p",
    styles: "flex:1 1 auto"
};
/**
 * Adding the padding here avoids cropping the keyline on its sides.
 * The combined vertical spacing is maintained by subtracting the
 * keyline height from header and footer.
 */ const $32d7be1cefbdd135$var$bodyScrollStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    padding: `${(0, $dlyGx.keylineHeight)}px ${(0, $dlyGx.padding)}px`
});
/**
 * Keylines will not be shown if scrolling in viewport so we do
 * not account for them in this case.
 */ const $32d7be1cefbdd135$var$viewportScrollStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    padding: `0px ${(0, $dlyGx.padding)}px`
});
/**
 * __Modal body__
 *
 * A modal body is used to display the main content of a modal.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-body-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const $32d7be1cefbdd135$var$ModalBody = (props)=>{
    const { children: children, testId: userDefinedTestId } = props;
    const { testId: modalTestId } = (0, $cMtFc.useModal)();
    const shouldScrollInViewport = (0, $eo7vn.default)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--body`;
    return shouldScrollInViewport ? /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $32d7be1cefbdd135$var$bodyStyles,
            $32d7be1cefbdd135$var$viewportScrollStyles
        ],
        "data-testid": testId
    }, children) : /*#__PURE__*/ (0, $byn9U.jsx)((0, $8MHxr.TouchScrollable), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $84xlG.default), {
        testId: userDefinedTestId || modalTestId
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $32d7be1cefbdd135$var$bodyStyles,
            $32d7be1cefbdd135$var$bodyScrollStyles
        ],
        "data-testid": testId
    }, children)));
};
var $32d7be1cefbdd135$export$2e2bcd8739ae039 = $32d7be1cefbdd135$var$ModalBody;

});
parcelRegister("84xlG", function(module, exports) {

$parcel$export(module.exports, "default", () => $56917204a240f120$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $74BVL = parcelRequire("74BVL");

var $8yx6O = parcelRequire("8yx6O");

var $1lQG9 = parcelRequire("1lQG9");

var $5Q9wj = parcelRequire("5Q9wj");

var $3jACL = parcelRequire("3jACL");

var $3LlFG = parcelRequire("3LlFG");

var $51sCz = parcelRequire("51sCz");

var $4Ywu9 = parcelRequire("4Ywu9");

var $dlyGx = parcelRequire("dlyGx");
const $56917204a240f120$var$baseStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'inherit',
    margin: "var(--ds-space-0, 0px)",
    flex: 'inherit',
    flexDirection: 'inherit',
    flexGrow: 1,
    overflowX: 'hidden',
    overflowY: 'auto',
    [(0, $4Ywu9.media).above.xs]: {
        height: 'unset',
        overflowY: 'auto'
    }
});
const $56917204a240f120$var$topKeylineStyles = /*#__PURE__*/ (0, $byn9U.css)({
    borderBlockStart: `${(0, $dlyGx.keylineHeight)}px solid ${(0, $dlyGx.keylineColor)}`
});
const $56917204a240f120$var$bottomKeylineStyles = /*#__PURE__*/ (0, $byn9U.css)({
    borderBlockEnd: `${(0, $dlyGx.keylineHeight)}px solid ${(0, $dlyGx.keylineColor)}`
});
/**
 * A container that shows top and bottom keylines when the
 * content overflows into the scrollable element.
 */ const $56917204a240f120$var$ScrollContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { testId: testId, children: children } = props;
    const [hasSiblings, setSiblings] = (0, $3LlFG.default)({
        previous: false,
        next: false
    });
    const [showContentFocus, setContentFocus] = (0, $eUqFw.useState)(false);
    const [showTopKeyline, setTopKeyline] = (0, $eUqFw.useState)(false);
    const [showBottomKeyline, setBottomKeyline] = (0, $eUqFw.useState)(false);
    const scrollableRef = (0, $eUqFw.useRef)(null);
    const setLazySiblings = (0, $3jACL.default)(setSiblings);
    const setLazyContentFocus = (0, $3jACL.default)((0, $8yx6O.default)(()=>{
        const target = scrollableRef.current;
        target && setContentFocus(target.scrollHeight > target.clientHeight);
    }));
    const setLazyKeylines = (0, $3jACL.default)((0, $8yx6O.default)(()=>{
        const target = scrollableRef.current;
        if (target) {
            const scrollableDistance = target.scrollHeight - target.clientHeight;
            if (hasSiblings.current.previous) setTopKeyline(target.scrollTop > (0, $dlyGx.keylineHeight));
            if (hasSiblings.current.next) setBottomKeyline(target.scrollTop <= scrollableDistance - (0, $dlyGx.keylineHeight));
        }
    }));
    (0, $eUqFw.useEffect)(()=>{
        const target = scrollableRef.current;
        const unbindWindowEvent = (0, $74BVL.bind)(window, {
            type: 'resize',
            listener: setLazyKeylines
        });
        const unbindTargetEvent = target ? (0, $74BVL.bind)(target, {
            type: 'scroll',
            listener: setLazyKeylines
        }) : (0, $5Q9wj.default);
        setLazyContentFocus();
        setLazyKeylines();
        setLazySiblings({
            previous: Boolean(target?.previousElementSibling),
            next: Boolean(target?.nextElementSibling)
        });
        return ()=>{
            unbindWindowEvent();
            unbindTargetEvent();
        };
    }, [
        setLazyContentFocus,
        setLazyKeylines,
        setLazySiblings
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $51sCz.default), {
        isInset: true
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // tabindex is allowed here so that keyboard users can scroll content
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
        tabIndex: showContentFocus ? 0 : undefined,
        role: showContentFocus ? 'region' : undefined,
        "aria-label": showContentFocus ? 'Scrollable content' : undefined,
        "data-testid": testId && `${testId}--scrollable`,
        ref: (0, $1lQG9.default)([
            ref,
            scrollableRef
        ]),
        css: [
            $56917204a240f120$var$baseStyles,
            showTopKeyline && $56917204a240f120$var$topKeylineStyles,
            showBottomKeyline && $56917204a240f120$var$bottomKeylineStyles
        ]
    }, children));
});
$56917204a240f120$var$ScrollContainer.displayName = 'ScrollContainer';
var $56917204a240f120$export$2e2bcd8739ae039 = $56917204a240f120$var$ScrollContainer;

});
parcelRegister("1lQG9", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2675af299684760$export$2e2bcd8739ae039);
function $e2675af299684760$export$2e2bcd8739ae039(refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === 'function') ref(value);
            else if (ref !== null) ref.current = value;
        });
    };
}

});

parcelRegister("3jACL", function(module, exports) {

$parcel$export(module.exports, "default", () => $c876b80030673e65$export$2e2bcd8739ae039);

var $9pgGL = parcelRequire("9pgGL");
function $c876b80030673e65$export$2e2bcd8739ae039(callback) {
    const ref = (0, $9pgGL.default)(()=>callback);
    return ref.current;
}

});
parcelRegister("9pgGL", function(module, exports) {

$parcel$export(module.exports, "default", () => $48f31527db186a1c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $48f31527db186a1c$var$uniqueReferencedValue = {};
function $48f31527db186a1c$export$2e2bcd8739ae039(initializer) {
    const ref = (0, $eUqFw.useRef)($48f31527db186a1c$var$uniqueReferencedValue);
    if (ref.current === $48f31527db186a1c$var$uniqueReferencedValue) ref.current = initializer();
    return ref;
}

});


parcelRegister("3LlFG", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e4d506e43ac50f6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $2e4d506e43ac50f6$export$2e2bcd8739ae039(initialState) {
    const [value, setValue] = (0, $eUqFw.useState)(initialState);
    const valueRef = (0, $eUqFw.useRef)(value);
    valueRef.current = value;
    return [
        valueRef,
        setValue
    ];
}

});

parcelRegister("4Ywu9", function(module, exports) {

$parcel$export(module.exports, "media", () => $5dc2002d305c5915$export$987d49ffe1b0900f);
$parcel$export(module.exports, "UNSAFE_media", () => $5dc2002d305c5915$export$c881183ca713c214);
/**
 * This is an object of usable media query helpers using our internal breakpoints configuration.
 *
 * When using Compiled CSS-in-JS, please ensure that only a single declaration can take effect at a time.
 * This means that you should avoid multiple breakpoints taking effect at the same time,
 * eg. ```{ [media.above.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * Instead, make sure that only one breakpoint can take effect at a time,
 * e.g, ```{ [media.only.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * For more details, please see <https://compiledcssinjs.com/docs/atomic-css#selector-specificity>.
 */ const $5dc2002d305c5915$export$987d49ffe1b0900f = {
    above: {
        xxs: '@media all',
        xs: '@media (min-width: 30rem)',
        sm: '@media (min-width: 48rem)',
        md: '@media (min-width: 64rem)',
        lg: '@media (min-width: 90rem)',
        xl: '@media (min-width: 110rem)'
    },
    only: {
        xxs: '@media (min-width: 0rem) and (max-width: 29.99rem)',
        xs: '@media (min-width: 30rem) and (max-width: 47.99rem)',
        sm: '@media (min-width: 48rem) and (max-width: 63.99rem)',
        md: '@media (min-width: 64rem) and (max-width: 89.99rem)',
        lg: '@media (min-width: 90rem) and (max-width: 109.99rem)',
        xl: '@media (min-width: 110rem)'
    },
    below: {
        xs: '@media not all and (min-width: 30rem)',
        sm: '@media not all and (min-width: 48rem)',
        md: '@media not all and (min-width: 64rem)',
        lg: '@media not all and (min-width: 90rem)',
        xl: '@media not all and (min-width: 110rem)'
    }
};
const $5dc2002d305c5915$export$c881183ca713c214 = $5dc2002d305c5915$export$987d49ffe1b0900f;

});


parcelRegister("eo7vn", function(module, exports) {

$parcel$export(module.exports, "default", () => $38cfd2158a03253c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $i7afc = parcelRequire("i7afc");
function $38cfd2158a03253c$export$2e2bcd8739ae039() {
    const shouldScrollInViewport = (0, $eUqFw.useContext)((0, $i7afc.ScrollContext));
    if (shouldScrollInViewport == null) throw Error("@atlaskit/modal-dialog: Scroll context unavailable \u2013 this component needs to be a child of ModalDialog.");
    return shouldScrollInViewport;
}

});


parcelRegister("2OJfS", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $82fa2bab5a342607$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $cMtFc = parcelRequire("cMtFc");

var $dlyGx = parcelRequire("dlyGx");
const $82fa2bab5a342607$var$footerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    padding: (0, $dlyGx.padding),
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: "var(--ds-space-100, 8px)",
    paddingBlockStart: `${(0, $dlyGx.padding) - (0, $dlyGx.keylineHeight)}px`
});
/**
 * __Modal footer__
 *
 * A modal footer often contains a primary action and the ability to cancel and close the dialog, though can contain any React element.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples#modal-footer)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-footer-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const $82fa2bab5a342607$var$ModalFooter = (props)=>{
    const { children: children, testId: userDefinedTestId } = props;
    const { testId: modalTestId } = (0, $cMtFc.useModal)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--footer`;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $82fa2bab5a342607$var$footerStyles,
        "data-testid": testId
    }, children);
};
var $82fa2bab5a342607$export$2e2bcd8739ae039 = $82fa2bab5a342607$var$ModalFooter;

});

parcelRegister("5KT10", function(module, exports) {

$parcel$export(module.exports, "ConfluenceIcon", () => $bd2fb8be68c26b84$export$68f3db7f6af48bcb);
/* eslint-disable max-len */ 
var $eUqFw = parcelRequire("eUqFw");

var $4q38b = parcelRequire("4q38b");

var $lpzFL = parcelRequire("lpzFL");

var $9m0Eq = parcelRequire("9m0Eq");

var $urYMl = parcelRequire("urYMl");
const $bd2fb8be68c26b84$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $9m0Eq.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M25.769 20.234c-6.584-3.183-8.507-3.66-11.282-3.66-3.254 0-6.028 1.355-8.507 5.16l-.406.622c-.333.513-.407.696-.407.915s.11.403.517.659l4.18 2.598c.222.146.407.22.592.22.222 0 .37-.11.592-.44l.665-1.024c1.036-1.574 1.96-2.086 3.144-2.086 1.036 0 2.257.293 3.773 1.025l4.365 2.049c.443.22.924.11 1.146-.403l2.071-4.537c.222-.512.074-.842-.444-1.098M6.572 12.22c6.584 3.184 8.507 3.66 11.281 3.66 3.255 0 6.03-1.354 8.507-5.16l.407-.622c.333-.512.407-.695.407-.915s-.11-.402-.518-.658l-4.18-2.598c-.221-.147-.406-.22-.591-.22-.222 0-.37.11-.592.44l-.666 1.024c-1.035 1.573-1.96 2.086-3.144 2.086-1.035 0-2.256-.293-3.772-1.025L9.346 6.183c-.444-.22-.924-.11-1.146.402l-2.072 4.538c-.222.512-.074.841.444 1.098"/>
    </svg>`;
};
const $bd2fb8be68c26b84$export$68f3db7f6af48bcb = ({ appearance: appearance, label: label = 'Confluence', size: size = (0, $lpzFL.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $lpzFL.defaultLogoParams).iconColor, textColor: textColor = (0, $lpzFL.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $4q38b.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $urYMl.default), {
        appearance: appearance,
        label: label,
        svg: $bd2fb8be68c26b84$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});
parcelRegister("4q38b", function(module, exports) {

$parcel$export(module.exports, "default", () => $0bf06ba22418d3f0$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $juktg = parcelRequire("juktg");

var $3vMGX = parcelRequire("3vMGX");
/**
 * A React hook which returns the current themes and color-mode set on `<html>`.
 *
 * @example
 * ```
 * const { colorMode, dark, light, spacing, typography } = useThemeObserver();
 *
 * // Performing side effects when it changes
 * useEffect(() => {
 *   console.log(`The color mode has changed to ${theme.colorMode}`);
 * }, [theme.colorMode]);
 * ```
 */ const $0bf06ba22418d3f0$var$useThemeObserver = ()=>{
    const [theme, setTheme] = (0, $eUqFw.useState)((0, $juktg.default)());
    (0, $eUqFw.useEffect)(()=>{
        const observer = new (0, $3vMGX.default)((theme)=>setTheme(theme));
        observer.observe();
        return ()=>observer.disconnect();
    }, []);
    return theme;
};
var $0bf06ba22418d3f0$export$2e2bcd8739ae039 = $0bf06ba22418d3f0$var$useThemeObserver;

});
parcelRegister("juktg", function(module, exports) {

$parcel$export(module.exports, "default", () => $73112f76ef618559$export$2e2bcd8739ae039);

var $kyri3 = parcelRequire("kyri3");

var $31snR = parcelRequire("31snR");

var $iednx = parcelRequire("iednx");
const $73112f76ef618559$var$isThemeColorMode = (colorMode)=>{
    return (0, $31snR.themeColorModes).find((mode)=>mode === colorMode) !== undefined;
};
const $73112f76ef618559$var$getGlobalTheme = ()=>{
    if (typeof document === 'undefined') return {};
    const element = document.documentElement;
    const colorMode = element.getAttribute((0, $kyri3.COLOR_MODE_ATTRIBUTE)) || '';
    const theme = element.getAttribute((0, $kyri3.THEME_DATA_ATTRIBUTE)) || '';
    return {
        ...(0, $iednx.themeStringToObject)(theme),
        ...$73112f76ef618559$var$isThemeColorMode(colorMode) && {
            colorMode: colorMode
        }
    };
};
var $73112f76ef618559$export$2e2bcd8739ae039 = $73112f76ef618559$var$getGlobalTheme;

});
parcelRegister("31snR", function(module, exports) {

$parcel$export(module.exports, "themeColorModes", () => $80ca8d8c810bbe93$export$83993de8eb66733);
$parcel$export(module.exports, "themeIds", () => $80ca8d8c810bbe93$export$7d43e72a58e3283f);
$parcel$export(module.exports, "themeIdsWithOverrides", () => $80ca8d8c810bbe93$export$92ba366331403db2);
$parcel$export(module.exports, "themeStateDefaults", () => $80ca8d8c810bbe93$export$9aedcfa7336a207);
$parcel$export(module.exports, "default", () => $80ca8d8c810bbe93$export$2e2bcd8739ae039);
/**
 * This file contains the source of truth for themes and all associated meta data.
 */ /**
 * Themes: The internal identifier of a theme.
 * These ids are what the actual theme files/folders are called.
 * style-dictionary will attempt to locate these in the file-system.
 */ const $80ca8d8c810bbe93$export$83993de8eb66733 = [
    'light',
    'dark',
    'auto'
];
const $80ca8d8c810bbe93$export$8ce7e340c74e86c5 = [
    'more',
    'no-preference',
    'auto'
];
const $80ca8d8c810bbe93$export$7d43e72a58e3283f = [
    'light-increased-contrast',
    'light',
    'light-future',
    'dark',
    'dark-future',
    'dark-increased-contrast',
    'legacy-light',
    'legacy-dark',
    'spacing',
    'shape',
    'typography-adg3',
    'typography-minor3'
];
const $80ca8d8c810bbe93$export$ba8a43b83ecc69f8 = [];
const $80ca8d8c810bbe93$export$92ba366331403db2 = [
    ...$80ca8d8c810bbe93$export$7d43e72a58e3283f,
    ...$80ca8d8c810bbe93$export$ba8a43b83ecc69f8
];
const $80ca8d8c810bbe93$var$themeConfig = {
    'atlassian-light': {
        id: 'light',
        displayName: 'Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        }
    },
    'atlassian-light-future': {
        id: 'light-future',
        displayName: 'Future Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        override: 'light'
    },
    'atlassian-light-increased-contrast': {
        id: 'light-increased-contrast',
        displayName: 'Light Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        extends: 'light',
        increasesContrastFor: 'light'
    },
    'atlassian-dark': {
        id: 'dark',
        displayName: 'Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        }
    },
    'atlassian-dark-future': {
        id: 'dark-future',
        displayName: 'Future Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        override: 'light'
    },
    'atlassian-dark-increased-contrast': {
        id: 'dark-increased-contrast',
        displayName: 'Dark Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        extends: 'dark',
        increasesContrastFor: 'dark'
    },
    'atlassian-legacy-light': {
        id: 'legacy-light',
        displayName: 'Light Theme (legacy)',
        palette: 'legacyPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        }
    },
    'atlassian-legacy-dark': {
        id: 'legacy-dark',
        displayName: 'Dark Theme (legacy)',
        palette: 'legacyPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        }
    },
    'atlassian-spacing': {
        id: 'spacing',
        displayName: 'Atlassian Spacing',
        palette: 'spacingScale',
        attributes: {
            type: 'spacing'
        }
    },
    'atlassian-typography-adg3': {
        id: 'typography-adg3',
        displayName: 'ADG3 Typography',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        }
    },
    'atlassian-shape': {
        id: 'shape',
        displayName: 'Atlassian Shape',
        palette: 'shapePalette',
        attributes: {
            type: 'shape'
        }
    },
    'atlassian-typography-minor3': {
        id: 'typography-minor3',
        displayName: 'Atlassian Typography (Minor Third)',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        }
    }
};
const $80ca8d8c810bbe93$export$9aedcfa7336a207 = {
    colorMode: 'auto',
    contrastMode: 'auto',
    dark: 'dark',
    light: 'light',
    shape: undefined,
    spacing: 'spacing',
    typography: undefined,
    UNSAFE_themeOptions: undefined
};
var $80ca8d8c810bbe93$export$2e2bcd8739ae039 = $80ca8d8c810bbe93$var$themeConfig;

});

parcelRegister("iednx", function(module, exports) {

$parcel$export(module.exports, "themeStringToObject", () => $66a09631b05a8331$export$f19b488f7c0547ee);
$parcel$export(module.exports, "themeObjectToString", () => $66a09631b05a8331$export$62c37ab81302621a);

var $31snR = parcelRequire("31snR");
const $66a09631b05a8331$var$themeKinds = [
    'light',
    'dark',
    'spacing',
    'typography',
    'shape'
];
const $66a09631b05a8331$var$customThemeOptions = 'UNSAFE_themeOptions';
const $66a09631b05a8331$var$isThemeKind = (themeKind)=>{
    return $66a09631b05a8331$var$themeKinds.find((kind)=>kind === themeKind) !== undefined;
};
const $66a09631b05a8331$var$isThemeIds = (themeId)=>{
    return (0, $31snR.themeIds).find((id)=>id === themeId) !== undefined;
};
const $66a09631b05a8331$var$isColorMode = (modeId)=>{
    return [
        'light',
        'dark',
        'auto'
    ].includes(modeId);
};
const $66a09631b05a8331$export$f19b488f7c0547ee = (themeState)=>{
    return themeState.split(' ').map((theme)=>theme.split(/:(.*)/s)).reduce((themeObject, [kind, id])=>{
        if (kind === 'colorMode' && $66a09631b05a8331$var$isColorMode(id)) themeObject[kind] = id;
        if ($66a09631b05a8331$var$isThemeKind(kind) && $66a09631b05a8331$var$isThemeIds(id)) // @ts-expect-error FIXME - this is a valid ts error
        themeObject[kind] = id;
        if (kind === $66a09631b05a8331$var$customThemeOptions) try {
            themeObject[$66a09631b05a8331$var$customThemeOptions] = JSON.parse(id);
        } catch (e) {
            new Error('Invalid custom theme string');
        }
        return themeObject;
    }, {});
};
const $66a09631b05a8331$export$62c37ab81302621a = (themeState)=>Object.entries(themeState).reduce((themeString, [kind, id])=>{
        if (// colorMode theme state
        kind === 'colorMode' && typeof id === 'string' && $66a09631b05a8331$var$isColorMode(id) || // custom theme state
        kind === $66a09631b05a8331$var$customThemeOptions && typeof id === 'object' || // other theme states
        $66a09631b05a8331$var$isThemeKind(kind) && typeof id === 'string' && $66a09631b05a8331$var$isThemeIds(id)) return themeString + `${themeString ? ' ' : ''}` + `${kind}:${typeof id === 'object' ? JSON.stringify(id) : id}`;
        return themeString;
    }, '');

});


parcelRegister("3vMGX", function(module, exports) {

$parcel$export(module.exports, "default", () => $55357d15c6f4bfa6$export$2e2bcd8739ae039);

var $XHGTv = parcelRequire("XHGTv");

var $kyri3 = parcelRequire("kyri3");

var $juktg = parcelRequire("juktg");
class $55357d15c6f4bfa6$export$2e2bcd8739ae039 {
    static{
        this.observer = null;
    }
    static{
        this.callbacks = new Set();
    }
    constructor(callback){
        this.legacyObserver = null;
        this.callback = callback;
        if ((0, $XHGTv.getBooleanFF)('platform.design-system-team.mutation-observer-performance-improvement_8usdg')) $55357d15c6f4bfa6$export$2e2bcd8739ae039.callbacks.add(callback);
    }
    observe() {
        if ((0, $XHGTv.getBooleanFF)('platform.design-system-team.mutation-observer-performance-improvement_8usdg')) {
            if (!$55357d15c6f4bfa6$export$2e2bcd8739ae039.observer) {
                $55357d15c6f4bfa6$export$2e2bcd8739ae039.observer = new MutationObserver(()=>{
                    const theme = (0, $juktg.default)();
                    $55357d15c6f4bfa6$export$2e2bcd8739ae039.callbacks.forEach((callback)=>callback(theme));
                });
                // Observer only needs to be configured once
                $55357d15c6f4bfa6$export$2e2bcd8739ae039.observer.observe(document.documentElement, {
                    attributeFilter: [
                        (0, $kyri3.THEME_DATA_ATTRIBUTE),
                        (0, $kyri3.COLOR_MODE_ATTRIBUTE)
                    ]
                });
            }
        } else {
            if (!this.legacyObserver) this.legacyObserver = new MutationObserver(()=>{
                this.callback((0, $juktg.default)());
            });
            this.legacyObserver.observe(document.documentElement, {
                attributeFilter: [
                    (0, $kyri3.THEME_DATA_ATTRIBUTE),
                    (0, $kyri3.COLOR_MODE_ATTRIBUTE)
                ]
            });
        }
    }
    disconnect() {
        if ((0, $XHGTv.getBooleanFF)('platform.design-system-team.mutation-observer-performance-improvement_8usdg')) {
            if (this.callback) $55357d15c6f4bfa6$export$2e2bcd8739ae039.callbacks.delete(this.callback);
            if ($55357d15c6f4bfa6$export$2e2bcd8739ae039.callbacks.size === 0 && $55357d15c6f4bfa6$export$2e2bcd8739ae039.observer) {
                $55357d15c6f4bfa6$export$2e2bcd8739ae039.observer.disconnect();
                $55357d15c6f4bfa6$export$2e2bcd8739ae039.observer = null;
            }
        } else this.legacyObserver && this.legacyObserver.disconnect();
    }
}

});


parcelRegister("lpzFL", function(module, exports) {

$parcel$export(module.exports, "defaultLogoParams", () => $7b2cbc1b56c22840$export$438460117ae6b7ee);
$parcel$export(module.exports, "sizes", () => $7b2cbc1b56c22840$export$c647cb0ee6e282fe);
const $7b2cbc1b56c22840$export$438460117ae6b7ee = {
    iconColor: 'inherit',
    label: '',
    size: 'medium',
    textColor: 'currentColor'
};
const $7b2cbc1b56c22840$export$793fba32aed8942a = {
    iconGradientStart: 'inherit',
    iconGradientStop: 'inherit'
};
const $7b2cbc1b56c22840$export$c647cb0ee6e282fe = {
    xsmall: 16,
    small: 24,
    medium: 32,
    large: 40,
    xlarge: 48
};
const $7b2cbc1b56c22840$export$31d7044b7540a6d8 = $7b2cbc1b56c22840$export$438460117ae6b7ee;

});

parcelRegister("9m0Eq", function(module, exports) {

$parcel$export(module.exports, "getColorsFromAppearance", () => $2cabbe911fcb4bd2$export$bbacc3980e0f3029);
$parcel$export(module.exports, "getColorsForLoom", () => $2cabbe911fcb4bd2$export$7818df200941dbbf);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $PdmhA = parcelRequire("PdmhA");
const $2cabbe911fcb4bd2$export$362a25f017e2bc8a = (appearance, colorMode)=>{
    let iconGradientStart, iconGradientStop, iconColor, textColor, atlassianLogoTextColor;
    switch(appearance){
        case 'brand':
            iconGradientStart = (0, $PdmhA.B400);
            iconGradientStop = (0, $PdmhA.B200);
            iconColor = (0, $PdmhA.B200);
            textColor = `var(--ds-text, ${0, $PdmhA.N800})`;
            // This is only used for the top level Atlassian wordmark (see AtlassianLogo
            // or AtlassianStartLogo for example), and is only different for the Brand
            // appearance - a bold brand color. For other appearances,
            // atlassianLogoTextColor is the same as textColor.
            atlassianLogoTextColor = (0, $PdmhA.B400);
            break;
        case 'neutral':
            iconGradientStart = (0, $PdmhA.N600);
            iconGradientStop = (0, $PdmhA.N100);
            iconColor = (0, $PdmhA.N100);
            textColor = (0, $PdmhA.N400);
            atlassianLogoTextColor = (0, $PdmhA.N400);
            break;
        case 'inverse':
            iconGradientStart = '#FFFFFF66';
            iconGradientStop = '#FFFFFF';
            iconColor = '#FFFFFF';
            textColor = '#FFFFFF';
            atlassianLogoTextColor = '#FFFFFF';
            break;
    }
    if (colorMode === 'dark' && appearance === 'inverse') {
        iconGradientStart = '#161A1D66';
        iconGradientStop = '#161A1D';
        iconColor = '#161A1D';
        textColor = '#161A1D';
        atlassianLogoTextColor = '#161A1D';
    }
    return {
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        iconColor: iconColor,
        textColor: textColor,
        atlassianLogoTextColor: atlassianLogoTextColor
    };
};
const $2cabbe911fcb4bd2$export$bbacc3980e0f3029 = (appearance, colorMode)=>{
    let iconColor, textColor, atlassianLogoTextColor;
    if (colorMode === 'dark') switch(appearance){
        case 'brand':
            iconColor = '#357DE8';
            textColor = '#E2E3E4';
            atlassianLogoTextColor = '#357DE8';
            break;
        case 'neutral':
            iconColor = '#96999E';
            textColor = '#BFC1C4';
            atlassianLogoTextColor = '#96999E';
            break;
        case 'inverse':
            iconColor = '#101214';
            textColor = '#101214';
            atlassianLogoTextColor = '#101214';
            break;
    }
    else switch(appearance){
        case 'brand':
            iconColor = '#1868DB';
            textColor = '#101214';
            atlassianLogoTextColor = '#1868DB';
            break;
        case 'neutral':
            iconColor = '#6C6F77';
            textColor = '#3B3D42';
            atlassianLogoTextColor = '#6C6F77';
            break;
        case 'inverse':
            iconColor = (0, $PdmhA.N0);
            textColor = (0, $PdmhA.N0);
            atlassianLogoTextColor = (0, $PdmhA.N0);
            break;
    }
    return {
        iconColor: iconColor,
        textColor: textColor,
        atlassianLogoTextColor: atlassianLogoTextColor
    };
};
const $2cabbe911fcb4bd2$export$7818df200941dbbf = (appearance, colorMode)=>{
    let iconColor = $2cabbe911fcb4bd2$export$bbacc3980e0f3029(appearance, colorMode).iconColor;
    let textColor = $2cabbe911fcb4bd2$export$bbacc3980e0f3029(appearance, colorMode).textColor;
    if (colorMode === 'dark') switch(appearance){
        case 'brand':
            iconColor = '#625DF5';
            textColor = '#EFF0FF';
            break;
    }
    else switch(appearance){
        case 'brand':
            iconColor = '#625DF5';
            textColor = '#252434';
            break;
    }
    return {
        iconColor: iconColor,
        textColor: textColor
    };
};

});

parcelRegister("urYMl", function(module, exports) {

$parcel$export(module.exports, "default", () => $46761837faa35cc1$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $lpzFL = parcelRequire("lpzFL");
function $46761837faa35cc1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $46761837faa35cc1$var$CSS_VAR_COLOR = '--logo-color';
const $46761837faa35cc1$var$CSS_VAR_FILL = '--logo-fill';
const $46761837faa35cc1$var$baseWrapperStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'inline-block',
    position: 'relative',
    color: `var(${$46761837faa35cc1$var$CSS_VAR_COLOR})`,
    fill: `var(${$46761837faa35cc1$var$CSS_VAR_FILL})`,
    lineHeight: 1,
    userSelect: 'none',
    whiteSpace: 'normal',
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    '> svg': {
        height: '100%',
        fill: 'inherit'
    }
});
const $46761837faa35cc1$var$stopColorStyles = {
    name: "1hl44m8",
    styles: "stop{stop-color:currentColor;}"
};
const $46761837faa35cc1$var$sizeStyles = Object.entries((0, $lpzFL.sizes)).reduce((acc, [key, val])=>{
    acc[key] = /*#__PURE__*/ (0, $byn9U.css)({
        height: `${val}px`
    });
    return acc;
}, {});
/**
 * __Wrapper__
 *
 * An internal component used by `@atlaskit/logo` to render logo SVGs with correct styles.
 */ const $46761837faa35cc1$var$Wrapper = ({ label: label, svg: svg, size: size, appearance: appearance, iconColor: iconColor, textColor: textColor, testId: userDefinedTestId, ...rest })=>{
    // Only required for old logos with gradients, which set gradient values to `inherit` when no appearance is provided
    const shouldApplyStopColor = appearance === undefined;
    const testId = userDefinedTestId && `${userDefinedTestId}--wrapper`;
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: [
            $46761837faa35cc1$var$baseWrapperStyles,
            shouldApplyStopColor && $46761837faa35cc1$var$stopColorStyles,
            size && $46761837faa35cc1$var$sizeStyles[size]
        ],
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            [$46761837faa35cc1$var$CSS_VAR_COLOR]: iconColor,
            [$46761837faa35cc1$var$CSS_VAR_FILL]: textColor
        },
        "aria-label": label ? label : undefined,
        role: label ? 'img' : undefined,
        dangerouslySetInnerHTML: {
            __html: svg
        },
        ...rest
    });
};
var $46761837faa35cc1$export$2e2bcd8739ae039 = $46761837faa35cc1$var$Wrapper;

});


parcelRegister("77CtJ", function(module, exports) {

$parcel$export(module.exports, "JiraIcon", () => $38f6d3b0d81fde12$export$c4b5b1f965d8b3eb);
/* eslint-disable max-len */ 
var $eUqFw = parcelRequire("eUqFw");

var $4q38b = parcelRequire("4q38b");

var $lpzFL = parcelRequire("lpzFL");

var $9m0Eq = parcelRequire("9m0Eq");

var $urYMl = parcelRequire("urYMl");
const $38f6d3b0d81fde12$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $9m0Eq.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M11.034 21.99h-2.22c-3.346 0-5.747-2.05-5.747-5.052h11.932c.619 0 1.019.44 1.019 1.062v12.007c-2.983 0-4.984-2.416-4.984-5.784zm5.893-5.967h-2.219c-3.347 0-5.748-2.013-5.748-5.015h11.933c.618 0 1.055.402 1.055 1.025V24.04c-2.983 0-5.02-2.416-5.02-5.784zm5.93-5.93h-2.219c-3.347 0-5.748-2.05-5.748-5.052h11.933c.618 0 1.018.439 1.018 1.025v12.007c-2.983 0-4.984-2.416-4.984-5.784z"/>
    </svg>`;
};
const $38f6d3b0d81fde12$export$c4b5b1f965d8b3eb = ({ appearance: appearance, label: label = 'Jira', size: size = (0, $lpzFL.defaultLogoParams).size, testId: testId, textColor: textColor = (0, $lpzFL.defaultLogoParams).textColor, iconColor: iconColor = (0, $lpzFL.defaultLogoParams).iconColor })=>{
    const { colorMode: colorMode } = (0, $4q38b.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $urYMl.default), {
        appearance: appearance,
        label: label,
        svg: $38f6d3b0d81fde12$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("8cU5f", function(module, exports) {

$parcel$export(module.exports, "default", () => $3fb971103818d470$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

var $591ND = parcelRequire("591ND");

var $5Q9wj = parcelRequire("5Q9wj");

var $kVO3J = parcelRequire("kVO3J");

var $lSV8Z = parcelRequire("lSV8Z");
var $hYDGa = parcelRequire("hYDGa");

var $5LHuc = parcelRequire("5LHuc");

var $i6BC8 = parcelRequire("i6BC8");

var $gmZvv = parcelRequire("gmZvv");

var $lcnyw = parcelRequire("lcnyw");

var $e4oGB = parcelRequire("e4oGB");

var $b68Pq = parcelRequire("b68Pq");

var $3iORZ = parcelRequire("3iORZ");

var $dPawH = parcelRequire("dPawH");

var $FbZPV = parcelRequire("FbZPV");
const $3fb971103818d470$var$tooltipZIndex = (0, $lcnyw.layers).tooltip();
const $3fb971103818d470$var$analyticsAttributes = {
    componentName: 'tooltip',
    packageName: undefined,
    packageVersion: undefined
};
// Inverts motion direction
const $3fb971103818d470$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * Converts a Popper placement to it's general direction.
 *
 * @param placement - Popper Placement value, e.g. 'top-start'
 * @returns Popper Direction, e.g. 'top'
 */ const $3fb971103818d470$var$getDirectionFromPlacement = (placement)=>placement.split('-')[0];
function $3fb971103818d470$var$Tooltip({ children: children, position: position = 'bottom', mousePosition: mousePosition = 'bottom', content: content, truncate: truncate = false, component: Container = (0, $dPawH.default), tag: TargetContainer = 'div', testId: testId, delay: delay = 300, onShow: onShow = (0, $5Q9wj.default), onHide: onHide = (0, $5Q9wj.default), hideTooltipOnClick: hideTooltipOnClick = false, hideTooltipOnMouseDown: hideTooltipOnMouseDown = false, analyticsContext: analyticsContext, strategy: strategy = 'fixed', ignoreTooltipPointerEvents: ignoreTooltipPointerEvents = false }) {
    const tooltipPosition = position === 'mouse' ? mousePosition : position;
    const onShowHandler = (0, $591ND.usePlatformLeafSyntheticEventHandler)({
        fn: onShow,
        action: 'displayed',
        analyticsData: analyticsContext,
        ...$3fb971103818d470$var$analyticsAttributes
    });
    const onHideHandler = (0, $591ND.usePlatformLeafSyntheticEventHandler)({
        fn: onHide,
        action: 'hidden',
        analyticsData: analyticsContext,
        ...$3fb971103818d470$var$analyticsAttributes
    });
    const apiRef = (0, $eUqFw.useRef)(null);
    const [state, setState] = (0, $eUqFw.useState)('hide');
    const targetRef = (0, $eUqFw.useRef)(null);
    const containerRef = (0, $eUqFw.useRef)(null);
    // This function is deliberately _not_ memoized as it needs to re-run every render
    // to pick up any child ref changes. If you use render props you don't have this issue.
    const setImplicitRefFromChildren = (node)=>{
        containerRef.current = node;
        targetRef.current = node ? node.firstElementChild : null;
    };
    // This is memoized and passed into the render props callback.
    const setDirectRef = (0, $eUqFw.useCallback)((node)=>{
        targetRef.current = node;
    }, []);
    // Putting a few things into refs so that we don't have to break memoization
    const lastState = (0, $eUqFw.useRef)(state);
    const lastDelay = (0, $eUqFw.useRef)(delay);
    const lastHandlers = (0, $eUqFw.useRef)({
        onShowHandler: onShowHandler,
        onHideHandler: onHideHandler
    });
    const hasCalledShowHandler = (0, $eUqFw.useRef)(false);
    (0, $eUqFw.useEffect)(()=>{
        lastState.current = state;
        lastDelay.current = delay;
        lastHandlers.current = {
            onShowHandler: onShowHandler,
            onHideHandler: onHideHandler
        };
    }, [
        delay,
        onHideHandler,
        onShowHandler,
        state
    ]);
    const start = (0, $eUqFw.useCallback)((api)=>{
        // @ts-ignore
        apiRef.current = api;
        hasCalledShowHandler.current = false;
    }, []);
    const done = (0, $eUqFw.useCallback)(()=>{
        if (!apiRef.current) return;
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) lastHandlers.current.onHideHandler();
        // @ts-ignore
        apiRef.current = null;
        // @ts-ignore
        hasCalledShowHandler.current = false;
        // just in case
        setState('hide');
    }, []);
    const abort = (0, $eUqFw.useCallback)(()=>{
        if (!apiRef.current) return;
        apiRef.current.abort();
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) lastHandlers.current.onHideHandler();
        // @ts-ignore
        apiRef.current = null;
    }, []);
    (0, $eUqFw.useEffect)(function mount() {
        return function unmount() {
            if (apiRef.current) abort();
        };
    }, [
        abort
    ]);
    const isDraggingRef = (0, $eUqFw.useRef)(false);
    (0, $eUqFw.useEffect)(()=>{
        return (0, $e4oGB.register)({
            onRegister ({ isDragging: isDragging }) {
                isDraggingRef.current = isDragging;
            },
            onDragStart () {
                /**
				 * Hiding any visible tooltips when a drag starts because otherwise it
				 * looks janky (disappears and reappears), and is not required.
				 */ apiRef.current?.requestHide({
                    isImmediate: true
                });
                isDraggingRef.current = true;
            },
            onDragEnd () {
                isDraggingRef.current = false;
            }
        });
    }, []);
    const showTooltip = (0, $eUqFw.useCallback)((source)=>{
        /**
			 * Prevent tooltips from being shown during a drag. This can occur with
			 * the native drag and drop API, where some pointer events can fire
			 * when they should not and lead to jank with tooltips.
			 */ if (isDraggingRef.current) return;
        if (apiRef.current && !apiRef.current.isActive()) abort();
        // Tell the tooltip to keep showing
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
        const entry = {
            source: source,
            delay: lastDelay.current,
            show: ({ isImmediate: isImmediate })=>{
                // Call the onShow handler if it hasn't been called yet
                if (!hasCalledShowHandler.current) {
                    hasCalledShowHandler.current = true;
                    lastHandlers.current.onShowHandler();
                }
                setState(isImmediate ? 'show-immediate' : 'fade-in');
            },
            hide: ({ isImmediate: isImmediate })=>{
                if (isImmediate) setState('hide');
                else setState('before-fade-out');
            },
            done: done
        };
        const api = (0, $b68Pq.show)(entry);
        start(api);
    }, [
        abort,
        done,
        start
    ]);
    const hideTooltipOnEsc = (0, $eUqFw.useCallback)(()=>{
        apiRef.current?.requestHide({
            isImmediate: true
        });
    }, [
        apiRef
    ]);
    (0, $kVO3J.default)({
        onClose: hideTooltipOnEsc,
        isDisabled: state === 'hide' || state === 'fade-out'
    });
    (0, $eUqFw.useEffect)(()=>{
        if (state === 'hide') return 0, $5Q9wj.default;
        if (state === 'before-fade-out') setState('fade-out');
        const unbind = (0, $74BVL.bind)(window, {
            type: 'scroll',
            listener: ()=>{
                if (apiRef.current) apiRef.current.requestHide({
                    isImmediate: true
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        return unbind;
    }, [
        state
    ]);
    const onMouseDown = (0, $eUqFw.useCallback)(()=>{
        if (hideTooltipOnMouseDown && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnMouseDown
    ]);
    const onClick = (0, $eUqFw.useCallback)(()=>{
        if (hideTooltipOnClick && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnClick
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseover of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    const onMouseOver = (0, $eUqFw.useCallback)((event)=>{
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        const source = position === 'mouse' ? {
            type: 'mouse',
            // TODO: ideally not recalculating this object each time
            mouse: (0, $FbZPV.getMousePosition)({
                left: event.clientX,
                top: event.clientY
            })
        } : {
            type: 'keyboard'
        };
        showTooltip(source);
    }, [
        position,
        showTooltip
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseout of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    const onMouseOut = (0, $eUqFw.useCallback)((event)=>{
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    const onMouseMove = position === 'mouse' ? (event)=>{
        if (apiRef.current?.isActive()) apiRef.current.mousePosition = (0, $FbZPV.getMousePosition)({
            left: event.clientX,
            top: event.clientY
        });
    } : undefined;
    const onMouseOverTooltip = (0, $eUqFw.useCallback)(()=>{
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
    }, []);
    const onFocus = (0, $eUqFw.useCallback)(()=>{
        showTooltip({
            type: 'keyboard'
        });
    }, [
        showTooltip
    ]);
    const onBlur = (0, $eUqFw.useCallback)(()=>{
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    const onAnimationFinished = (0, $eUqFw.useCallback)((transition)=>{
        // Using lastState here because motion is not picking up the latest value
        if (transition === 'exiting' && lastState.current === 'fade-out' && apiRef.current) // @ts-ignore: refs are writeable
        apiRef.current.finishHideAnimation();
    }, []);
    // Doing a cast because typescript is struggling to narrow the type
    const CastTargetContainer = TargetContainer;
    const shouldRenderTooltipContainer = state !== 'hide' && Boolean(content);
    const shouldRenderTooltipChildren = state !== 'hide' && state !== 'fade-out';
    const getReferenceElement = ()=>{
        if (position === 'mouse' && apiRef.current?.mousePosition) return apiRef.current?.mousePosition;
        return targetRef.current || undefined;
    };
    const tooltipId = (0, $3iORZ.default)('tooltip', shouldRenderTooltipContainer);
    const tooltipTriggerProps = {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseMove: onMouseMove,
        onMouseDown: onMouseDown,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur
    };
    // Don't set `data-testid` unless it's defined, as it's not in the interface.
    if (testId) // @ts-expect-error - Adding `data-testid` to the TriggerProps interface breaks Buttons.
    tooltipTriggerProps['data-testid'] = `${testId}--container`;
    // This useEffect is purely for managing the aria attribute when using the
    // wrapped children approach.
    (0, $eUqFw.useEffect)(()=>{
        // If there is no container element, we should exit early, because that
        // means they are using the render prop API, and that is implemented in a
        // different way. If there is no target element yet or tooltipId, we also
        // shouldn't do anything because there is nothing to operate on or with.
        if (!containerRef.current || !targetRef.current || !tooltipId) return;
        const target = targetRef.current;
        if (shouldRenderTooltipContainer) target.setAttribute('aria-describedby', tooltipId);
        else target.removeAttribute('aria-describedby');
    }, [
        shouldRenderTooltipContainer,
        tooltipId
    ]);
    const hiddenContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        "data-testid": testId ? `${testId}-hidden` : undefined,
        hidden: true,
        id: tooltipId
    }, typeof content === 'function' ? content({}) : content);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, typeof children === 'function' ? // once we deprecate the wrapped approach, we can put the aria
    // attribute back into the tooltipTriggerProps and make it required
    // instead of optional in `types`
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children({
        ...tooltipTriggerProps,
        'aria-describedby': tooltipId,
        ref: setDirectRef
    }), shouldRenderTooltipContainer && hiddenContent) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(CastTargetContainer, {
        ...tooltipTriggerProps,
        ref: setImplicitRefFromChildren,
        role: "presentation"
    }, children, shouldRenderTooltipContainer && hiddenContent), shouldRenderTooltipContainer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gmZvv.default), {
        zIndex: $3fb971103818d470$var$tooltipZIndex
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i6BC8.Popper), {
        placement: tooltipPosition,
        referenceElement: getReferenceElement(),
        strategy: strategy
    }, ({ ref: ref, style: style, update: update, placement: placement })=>{
        // Invert the entrance and exit directions.
        // E.g. a tooltip's position is on the 'right', it should enter from and exit to the 'left'
        // This gives the effect the tooltip is appearing from the target
        const direction = position === 'mouse' ? undefined : $3fb971103818d470$var$invertedDirection[$3fb971103818d470$var$getDirectionFromPlacement(placement)];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lSV8Z.default), {
            appear: true
        }, shouldRenderTooltipChildren && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hYDGa.default), {
            distance: "constant",
            entranceDirection: direction,
            exitDirection: direction,
            onFinish: onAnimationFinished,
            duration: state === 'show-immediate' ? 0 : (0, $5LHuc.mediumDurationMs)
        }, ({ className: className })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Container, {
                ref: ref,
                /**
													 * "Tooltip" classname is a hook used by tests to manipulate
													 * and hide tooltips, including in VR snapshots
													 **/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: `Tooltip ${className}`,
                style: {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    ...style,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    ...ignoreTooltipPointerEvents && {
                        pointerEvents: 'none'
                    }
                },
                truncate: truncate,
                placement: tooltipPosition,
                testId: getReferenceElement() ? testId : testId && `${testId}--unresolved`,
                onMouseOut: onMouseOut,
                onMouseOver: onMouseOverTooltip
            }, typeof content === 'function' ? content({
                update: update
            }) : content)));
    })) : null);
}
$3fb971103818d470$var$Tooltip.displayName = 'Tooltip';
var $3fb971103818d470$export$2e2bcd8739ae039 = $3fb971103818d470$var$Tooltip;

});
parcelRegister("kVO3J", function(module, exports) {

$parcel$export(module.exports, "default", () => $753bd8784aa528d9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

function $753bd8784aa528d9$export$2e2bcd8739ae039({ onClose: onClose, isDisabled: isDisabled }) {
    const escapePressed = (0, $eUqFw.useRef)(false);
    const onKeyDown = (0, $eUqFw.useCallback)((e)=>{
        if (isDisabled || escapePressed.current || e.key !== (0, $54717ce5fa2c74b1$export$2bb790b9008907b4)) // We're either already handling the key down event or it's not escape.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled
    ]);
    const onKeyUp = (0, $eUqFw.useCallback)(()=>{
        escapePressed.current = false;
    }, []);
    (0, $eUqFw.useEffect)(()=>{
        return (0, $74BVL.bindAll)(document, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp
    ]);
}

});
/**
 * Character key codes which can be used in keyboard events.
 */ const $54717ce5fa2c74b1$export$390330c10ff2b9a1 = 'ArrowUp';
const $54717ce5fa2c74b1$export$a80636c6f41931fe = 'ArrowDown';
const $54717ce5fa2c74b1$export$4af703091671bc = 'Home';
const $54717ce5fa2c74b1$export$e2bc30913faa5db7 = 'End';
const $54717ce5fa2c74b1$export$10f6869ed0a7d75b = 'Tab';
const $54717ce5fa2c74b1$export$8152f929a25a0ff4 = 'Enter';
const $54717ce5fa2c74b1$export$e51a3576c045c8d5 = 'Space';
const $54717ce5fa2c74b1$export$2bb790b9008907b4 = 'Escape';


parcelRegister("e4oGB", function(module, exports) {

$parcel$export(module.exports, "register", () => $89787f5f1d3ba871$export$6503ec6e8aabbaf);
/* eslint-disable @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop */ /**
 * We are listening directly to drag events instead of using a monitor from
 * `@atlaskit/pragmatic-drag-and-drop` to avoid the bundle size cost, as it
 * would affect almost every view in every product.
 *
 * We can reconsider this choice in the future.
 */ 
var $74BVL = parcelRequire("74BVL");
const $89787f5f1d3ba871$var$registrations = new Set();
let $89787f5f1d3ba871$var$cleanupEndEventListeners = null;
function $89787f5f1d3ba871$var$onDragStart() {
    if ($89787f5f1d3ba871$var$cleanupEndEventListeners) // If the cleanup function exists then we've already run this
    return;
    $89787f5f1d3ba871$var$cleanupEndEventListeners = (0, $74BVL.bindAll)(window, [
        {
            type: 'dragend',
            listener: $89787f5f1d3ba871$var$onDragEnd
        },
        {
            type: 'pointerdown',
            listener: $89787f5f1d3ba871$var$onDragEnd
        },
        {
            type: 'pointermove',
            listener: (()=>{
                let callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    $89787f5f1d3ba871$var$onDragEnd();
                };
            })()
        }
    ]);
    const clone = Array.from($89787f5f1d3ba871$var$registrations);
    clone.forEach((subscriber)=>{
        subscriber.onDragStart();
    });
}
function $89787f5f1d3ba871$var$onDragEnd() {
    $89787f5f1d3ba871$var$cleanupEndEventListeners?.();
    $89787f5f1d3ba871$var$cleanupEndEventListeners = null;
    const clone = Array.from($89787f5f1d3ba871$var$registrations);
    clone.forEach((subscriber)=>{
        subscriber.onDragEnd();
    });
}
function $89787f5f1d3ba871$var$bindStartEvents() {
    return (0, $74BVL.bindAll)(window, [
        {
            type: 'dragstart',
            listener: $89787f5f1d3ba871$var$onDragStart
        },
        {
            type: 'dragenter',
            listener: $89787f5f1d3ba871$var$onDragStart
        }
    ]);
}
let $89787f5f1d3ba871$var$cleanupStartEventListeners = null;
function $89787f5f1d3ba871$export$6503ec6e8aabbaf(registration) {
    // if first registration, bind event listeners
    if (!$89787f5f1d3ba871$var$cleanupStartEventListeners) // note: currently never unbinding these event listeners
    $89787f5f1d3ba871$var$cleanupStartEventListeners = $89787f5f1d3ba871$var$bindStartEvents();
    $89787f5f1d3ba871$var$registrations.add(registration);
    /**
	 * The reasoning for this behavior is so that if a tooltip mounts during
	 * a drag it can still be suppressed.
	 *
	 * We use a separate callback instead of onDragStart to avoid infinite loops.
	 */ registration.onRegister({
        isDragging: $89787f5f1d3ba871$var$cleanupEndEventListeners !== null
    });
    return function unregister() {
        $89787f5f1d3ba871$var$registrations.delete(registration);
        if ($89787f5f1d3ba871$var$registrations.size === 0) {
            $89787f5f1d3ba871$var$cleanupStartEventListeners?.();
            $89787f5f1d3ba871$var$cleanupStartEventListeners = null;
        }
    };
}

});

parcelRegister("b68Pq", function(module, exports) {

$parcel$export(module.exports, "show", () => $e419e64720bfb6f9$export$57bf213be019eeb0);

var $9qZhf = parcelRequire("9qZhf");
let $e419e64720bfb6f9$var$active = null;
function $e419e64720bfb6f9$export$57bf213be019eeb0(entry) {
    let phase = 'waiting-to-show';
    function isActive() {
        return Boolean($e419e64720bfb6f9$var$active && $e419e64720bfb6f9$var$active.entry === entry);
    }
    function cleanup() {
        if (isActive()) {
            (0, $9qZhf.clearScheduled)();
            $e419e64720bfb6f9$var$active = null;
        }
    }
    function done() {
        if (isActive()) entry.done();
        phase = 'done';
        cleanup();
    }
    function immediatelyHideAndDone() {
        if (isActive()) entry.hide({
            isImmediate: true
        });
        done();
    }
    function keep() {
        if (!isActive()) return;
        // aborting a wait to hide
        if (phase === 'waiting-to-hide') {
            phase = 'shown';
            (0, $9qZhf.clearScheduled)();
            return;
        }
        // aborting hide animation
        if (phase === 'hide-animating') {
            phase = 'shown';
            (0, $9qZhf.clearScheduled)();
            entry.show({
                isImmediate: false
            });
            return;
        }
    }
    function requestHide({ isImmediate: isImmediate }) {
        if (!isActive()) return;
        // If we were not showing yet anyway; finish straight away
        if (phase === 'waiting-to-show') {
            immediatelyHideAndDone();
            return;
        }
        // already waiting to hide
        if (phase === 'waiting-to-hide') return;
        if (isImmediate) {
            immediatelyHideAndDone();
            return;
        }
        phase = 'waiting-to-hide';
        (0, $9qZhf.scheduleTimeout)(()=>{
            phase = 'hide-animating';
            entry.hide({
                isImmediate: false
            });
        }, entry.delay);
    }
    function finishHideAnimation() {
        if (isActive() && phase === 'hide-animating') done();
    }
    function isVisible() {
        return phase === 'shown' || phase === 'waiting-to-hide' || phase === 'hide-animating';
    }
    function getInitialMouse() {
        if (entry.source.type === 'mouse') return entry.source.mouse;
        return null;
    }
    function start() {
        const showImmediately = Boolean($e419e64720bfb6f9$var$active && $e419e64720bfb6f9$var$active.isVisible());
        // If there was an active tooltip; we tell it to remove itself at once!
        if ($e419e64720bfb6f9$var$active) {
            (0, $9qZhf.clearScheduled)();
            $e419e64720bfb6f9$var$active.entry.hide({
                isImmediate: true
            });
            $e419e64720bfb6f9$var$active.entry.done();
            $e419e64720bfb6f9$var$active = null;
        }
        // this tooltip is now the active tooltip
        $e419e64720bfb6f9$var$active = {
            entry: entry,
            isVisible: isVisible
        };
        function show() {
            phase = 'shown';
            entry.show({
                isImmediate: showImmediately
            });
        }
        if (showImmediately) {
            show();
            return;
        }
        phase = 'waiting-to-show';
        (0, $9qZhf.scheduleTimeout)(show, entry.delay);
    }
    // let's get started!
    start();
    const result = {
        keep: keep,
        abort: cleanup,
        isActive: isActive,
        requestHide: requestHide,
        finishHideAnimation: finishHideAnimation,
        mousePosition: getInitialMouse()
    };
    return result;
}

});
parcelRegister("9qZhf", function(module, exports) {

$parcel$export(module.exports, "clearScheduled", () => $7dbfbdfec4230fa7$export$eaf678f6f93f5250);
$parcel$export(module.exports, "scheduleTimeout", () => $7dbfbdfec4230fa7$export$5f4d6617421d489b);
let $7dbfbdfec4230fa7$var$delayId = null;
function $7dbfbdfec4230fa7$export$eaf678f6f93f5250() {
    if ($7dbfbdfec4230fa7$var$delayId != null) {
        window.clearTimeout($7dbfbdfec4230fa7$var$delayId);
        $7dbfbdfec4230fa7$var$delayId = null;
    }
}
function $7dbfbdfec4230fa7$export$5f4d6617421d489b(fn, delay) {
    $7dbfbdfec4230fa7$export$eaf678f6f93f5250();
    $7dbfbdfec4230fa7$var$delayId = window.setTimeout(()=>{
        $7dbfbdfec4230fa7$var$delayId = null;
        fn();
    }, delay);
}

});


parcelRegister("3iORZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $9bb7c4fa7016f0c0$export$2e2bcd8739ae039);

var $jFtVs = parcelRequire("jFtVs");
function $9bb7c4fa7016f0c0$export$2e2bcd8739ae039(prefix, shouldRenderId) {
    const seed = (0, $jFtVs.useUIDSeed)();
    return shouldRenderId ? `${seed(prefix)}` : undefined;
}

});

parcelRegister("dPawH", function(module, exports) {

$parcel$export(module.exports, "default", () => $7709415186bb42bf$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $PdmhA = parcelRequire("PdmhA");

var $g3tFP = parcelRequire("g3tFP");
function $7709415186bb42bf$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7709415186bb42bf$var$baseStyles = /*#__PURE__*/ (0, $byn9U.css)({
    boxSizing: 'border-box',
    maxWidth: '240px',
    padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-075, 6px)"}`,
    insetBlockStart: "var(--ds-space-0, 0px)",
    insetInlineStart: "var(--ds-space-0, 0px)",
    borderRadius: "var(--ds-border-radius, 3px)",
    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    overflowWrap: 'break-word',
    wordWrap: 'break-word',
    backgroundColor: `var(--ds-background-neutral-bold, ${(0, $PdmhA.N800)})`,
    color: `var(--ds-text-inverse, ${(0, $PdmhA.N0)})`
});
const $7709415186bb42bf$var$truncateStyles = {
    name: "1e1ci1f",
    styles: "max-width:420px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap"
};
const $7709415186bb42bf$var$TooltipContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function TooltipContainer({ style: style, className: className, children: children, truncate: truncate, placement: placement, testId: testId, onMouseOut: onMouseOut, onMouseOver: onMouseOver, id: id }, ref) {
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $g3tFP.default), {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        placement: placement,
        testId: testId,
        id: id,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        css: [
            $7709415186bb42bf$var$baseStyles,
            truncate ? $7709415186bb42bf$var$truncateStyles : null
        ]
    }, children);
});
$7709415186bb42bf$var$TooltipContainer.displayName = 'TooltipContainer';
var $7709415186bb42bf$export$2e2bcd8739ae039 = $7709415186bb42bf$var$TooltipContainer;

});
parcelRegister("g3tFP", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b965e13e2506d09$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lcnyw = parcelRequire("lcnyw");
const $7b965e13e2506d09$var$VAR_PRIMITIVE_ZINDEX = 'tooltipPrimitiveZindex';
const $7b965e13e2506d09$var$primitiveStyles = /*#__PURE__*/ (0, $byn9U.css)({
    zindex: `var(${$7b965e13e2506d09$var$VAR_PRIMITIVE_ZINDEX})`,
    cursor: `default`
});
const $7b965e13e2506d09$var$TooltipPrimitive = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function TooltipPrimitive({ style: style, className: className, children: children, placement: placement, testId: testId, onMouseOut: onMouseOut, onMouseOver: onMouseOver, id: id }, ref) {
    const styleWithZIndex = {
        ...style,
        [$7b965e13e2506d09$var$VAR_PRIMITIVE_ZINDEX]: (0, $lcnyw.layers).tooltip()
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: styleWithZIndex,
        "data-testid": testId ? `${testId}--wrapper` : undefined
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        role: "tooltip",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        // Because the tooltip should not be focusable, there is no reason to have key events.
        /* eslint-disable jsx-a11y/mouse-events-have-key-events */ onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        /* eslint-enable jsx-a11y/mouse-events-have-key-events */ css: $7b965e13e2506d09$var$primitiveStyles,
        "data-placement": placement,
        "data-testid": testId,
        id: id
    }, children));
});
$7b965e13e2506d09$var$TooltipPrimitive.displayName = 'TooltipPrimitive';
var $7b965e13e2506d09$export$2e2bcd8739ae039 = $7b965e13e2506d09$var$TooltipPrimitive;

});


parcelRegister("FbZPV", function(module, exports) {

$parcel$export(module.exports, "getMousePosition", () => $e4af402eec8ac769$export$642213d516a9b928);
function $e4af402eec8ac769$export$642213d516a9b928(mouseCoordinates) {
    const safeMouse = mouseCoordinates || {
        top: 0,
        left: 0
    };
    const getBoundingClientRect = ()=>({
            top: safeMouse.top,
            left: safeMouse.left,
            bottom: safeMouse.top,
            right: safeMouse.left,
            width: 0,
            height: 0
        });
    return {
        getBoundingClientRect: getBoundingClientRect,
        clientWidth: 0,
        clientHeight: 0
    };
}

});


parcelRegister("dxopF", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ce92a55e318ecfb$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lSV8Z = parcelRequire("lSV8Z");
/**
 * __Modal transition__
 *
 * A modal transition wraps a modal to provide a fluid transition upon opening and closing.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const $9ce92a55e318ecfb$var$ModalTransition = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lSV8Z.default), {
        appear: true
    }, props.children);
};
var $9ce92a55e318ecfb$export$2e2bcd8739ae039 = $9ce92a55e318ecfb$var$ModalTransition;

});

parcelRegister("hI5oG", function(module, exports) {

$parcel$export(module.exports, "default", () => $18e0376f04fb9cfc$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/no-deprecated-design-token-usage */ /** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $3OG2c = parcelRequire("3OG2c");

var $a3tbV = parcelRequire("a3tbV");

var $2fFJv = parcelRequire("2fFJv");
function $18e0376f04fb9cfc$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// https://atlassian.design/foundations/typography
const $18e0376f04fb9cfc$var$levelMap = {
    h900: 'h1',
    h800: 'h1',
    h700: 'h2',
    h600: 'h3',
    h500: 'h4',
    h400: 'h5',
    h300: 'h6',
    // NB: These two levels are not covered at all by the existing @atlaskit/css-reset
    h200: 'div',
    h100: 'div'
};
const $18e0376f04fb9cfc$var$headingResetStyles = {
    name: "15h7b0j",
    styles: "color:var(--ds-text, #172B4D);margin-block:var(--ds-space-0, 0px)"
};
const $18e0376f04fb9cfc$var$h900Styles = {
    name: "1d6o2on",
    styles: "font-size:var(--ds-font-size-600, 35px);font-weight:var(--ds-font-weight-medium, 500);letter-spacing:-0.01em;line-height:var(--ds-font-lineHeight-600, 40px)"
};
const $18e0376f04fb9cfc$var$h800Styles = {
    name: "eft61t",
    styles: "font-size:var(--ds-font-size-500, 29px);font-weight:var(--ds-font-weight-semibold, 600);letter-spacing:-0.01em;line-height:var(--ds-font-lineHeight-500, 32px)"
};
const $18e0376f04fb9cfc$var$h700Styles = {
    name: "e89lyy",
    styles: "font-size:var(--ds-font-size-400, 24px);font-weight:var(--ds-font-weight-medium, 500);letter-spacing:-0.01em;line-height:var(--ds-font-lineHeight-400, 28px)"
};
const $18e0376f04fb9cfc$var$h600Styles = {
    name: "1wnx1ww",
    styles: "font-size:var(--ds-font-size-300, 20px);font-weight:var(--ds-font-weight-medium, 500);letter-spacing:-0.008em;line-height:var(--ds-font-lineHeight-300, 24px)"
};
const $18e0376f04fb9cfc$var$h500Styles = {
    name: "15j1f2c",
    styles: "font-size:var(--ds-font-size-200, 16px);font-weight:var(--ds-font-weight-semibold, 600);letter-spacing:-0.006em;line-height:var(--ds-font-lineHeight-200, 20px)"
};
const $18e0376f04fb9cfc$var$h400Styles = {
    name: "142cq6w",
    styles: "font-size:var(--ds-font-size-100, 14px);font-weight:var(--ds-font-weight-semibold, 600);letter-spacing:-0.003em;line-height:var(--ds-font-lineHeight-100, 16px)"
};
const $18e0376f04fb9cfc$var$h300Styles = {
    name: "10qfspt",
    styles: "font-size:var(--ds-font-size-075, 12px);font-weight:var(--ds-font-weight-semibold, 600);letter-spacing:0;line-height:var(--ds-font-lineHeight-100, 16px);text-transform:uppercase"
};
const $18e0376f04fb9cfc$var$h200Styles = {
    name: "1aglc16",
    styles: "font-size:var(--ds-font-size-075, 12px);font-weight:var(--ds-font-weight-semibold, 600);letter-spacing:0;line-height:var(--ds-font-lineHeight-100, 16px)"
};
const $18e0376f04fb9cfc$var$h100Styles = {
    name: "hggx7u",
    styles: "font-size:var(--ds-font-size-050, 11px);font-weight:var(--ds-font-weight-bold, 700);letter-spacing:0;line-height:var(--ds-font-lineHeight-100, 16px)"
};
const $18e0376f04fb9cfc$var$inverseStyles = {
    name: "1w1uf9i",
    styles: "color:var(--ds-text-inverse, #FFF)"
};
const $18e0376f04fb9cfc$var$subtlestStyles = {
    name: "19lmzdd",
    styles: "color:var(--ds-text-subtlest, #6B778C)"
};
/**
 * __Heading__
 *
 * A heading is a typography component used to display text in different sizes and formats.
 *
 * @example
 *
 * ```jsx
 * import Heading from '@atlaskit/heading';
 *
 * const H100 = () => (
 *   <Heading level="h100">h100</Heading>
 * );
 * ```
 */ const $18e0376f04fb9cfc$var$OldHeading = ({ children: children, level: level, id: id, testId: testId, as: as, color: color = 'default' })=>{
    typeof $2fFJv;
    const [hLevel, inferredElement] = (0, $3OG2c.useHeading)($18e0376f04fb9cfc$var$levelMap[level]);
    const Markup = as || inferredElement;
    const isSubtleHeading = level === 'h200' || level === 'h100';
    const needsAriaRole = Markup === 'div' && hLevel;
    return /*#__PURE__*/ (0, $byn9U.jsx)(Markup, {
        id: id,
        "data-testid": testId,
        role: needsAriaRole ? 'heading' : undefined,
        "aria-level": needsAriaRole ? hLevel : undefined,
        css: [
            $18e0376f04fb9cfc$var$headingResetStyles,
            level === 'h100' && $18e0376f04fb9cfc$var$h100Styles,
            level === 'h200' && $18e0376f04fb9cfc$var$h200Styles,
            level === 'h300' && $18e0376f04fb9cfc$var$h300Styles,
            level === 'h400' && $18e0376f04fb9cfc$var$h400Styles,
            level === 'h500' && $18e0376f04fb9cfc$var$h500Styles,
            level === 'h600' && $18e0376f04fb9cfc$var$h600Styles,
            level === 'h700' && $18e0376f04fb9cfc$var$h700Styles,
            level === 'h800' && $18e0376f04fb9cfc$var$h800Styles,
            level === 'h900' && $18e0376f04fb9cfc$var$h900Styles,
            color === 'inverse' && $18e0376f04fb9cfc$var$inverseStyles,
            color === 'default' && isSubtleHeading && $18e0376f04fb9cfc$var$subtlestStyles
        ]
    }, children);
};
/**
 * __Heading__
 *
 * A heading is a typography component used to display text in different sizes and formats.
 *
 * @example
 *
 * ```jsx
 * import Heading from '@atlaskit/heading';
 *
 * // New component
 * <Heading size="xxlarge">Page title</Heading>
 *
 * // Old component
 * const H100 = () => (
 *   <Heading level="h100">h100</Heading>
 * );
 * ```
 */ const $18e0376f04fb9cfc$var$Heading = ({ level: level, ...props })=>{
    return level ? // eslint-disable-next-line jsx-a11y/heading-has-content, @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $byn9U.jsx)($18e0376f04fb9cfc$var$OldHeading, {
        level: level,
        ...props
    }) : // eslint-disable-next-line jsx-a11y/heading-has-content, @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $byn9U.jsx)((0, $a3tbV.default), props);
};
var $18e0376f04fb9cfc$export$2e2bcd8739ae039 = $18e0376f04fb9cfc$var$Heading;

});
parcelRegister("3OG2c", function(module, exports) {

$parcel$export(module.exports, "useHeading", () => $799d62ae31ccea75$export$97a37b1befbbf9b1);
$parcel$export(module.exports, "default", () => $799d62ae31ccea75$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $799d62ae31ccea75$var$HeadingLevelContext = /*#__PURE__*/ (0, $eUqFw.createContext)(0);
const $799d62ae31ccea75$export$6a64a1e2d0bbbf75 = ()=>{
    return (0, $eUqFw.useContext)($799d62ae31ccea75$var$HeadingLevelContext);
};
const $799d62ae31ccea75$export$97a37b1befbbf9b1 = (fallback)=>{
    const hLevel = $799d62ae31ccea75$export$6a64a1e2d0bbbf75();
    /**
	 * Order here is important, we for now apply
	 * 1. inferred a11y level (this only applies if context is present)
	 * 2. default final fallback
	 */ return [
        hLevel,
        hLevel && (hLevel > 6 ? 'div' : `h${hLevel}`) || fallback
    ];
};
/**
 * __Heading level provider__
 *
 * The Heading level provider injects the heading level to all `Heading` components below it in the component tree.
 *
 * @example
 * ```tsx
 * // Will correctly infer the heading level
 * <HeadingContext value={1}>
 *  <Heading>H1</Heading>
 *  <HeadingContext>
 *    <Heading>H2</Heading>
 *  </HeadingContext>
 * </HeadingContext>
 * ```
 */ const $799d62ae31ccea75$var$HeadingLevelContextProvider = ({ children: children, value: value })=>{
    const parentHeadingLevel = $799d62ae31ccea75$export$6a64a1e2d0bbbf75();
    const headingLevel = parentHeadingLevel + 1;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($799d62ae31ccea75$var$HeadingLevelContext.Provider, {
        value: value || headingLevel
    }, children);
};
var $799d62ae31ccea75$export$2e2bcd8739ae039 = $799d62ae31ccea75$var$HeadingLevelContextProvider;

});

parcelRegister("a3tbV", function(module, exports) {

$parcel$export(module.exports, "default", () => $f15d8336011bc22e$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $9seLS = parcelRequire("9seLS");
var $5Yal2 = parcelRequire("5Yal2");

var $3OG2c = parcelRequire("3OG2c");

var $2fFJv = parcelRequire("2fFJv");
function $f15d8336011bc22e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f15d8336011bc22e$var$sizeTagMap = {
    xxlarge: 'h1',
    xlarge: 'h1',
    large: 'h2',
    medium: 'h3',
    small: 'h4',
    xsmall: 'h5',
    xxsmall: 'h6'
};
const $f15d8336011bc22e$var$headingResetStyles = {
    name: "13qcr8i",
    styles: "letter-spacing:normal;margin-block:0;text-transform:none"
};
const $f15d8336011bc22e$var$useColor = (colorProp)=>{
    const surface = (0, $5Yal2.useSurface)();
    /**
   * Where the color of the surface is inverted we always override the color
   * as there is no valid choice that is not covered by the override.
   */ if ((0, $9seLS.inverseColorMap).hasOwnProperty(surface)) return (0, $9seLS.inverseColorMap)[surface];
    return colorProp || 'color.text';
};
/**
 * __Heading__
 *
 * Heading is a typography component used to display text in defined sizes and styles.
 *
 * @example
 *
 * ```jsx
 * <Heading size="xxlarge">Page title</Heading>
 * ```
 */ const $f15d8336011bc22e$var$Heading = ({ children: children, size: size, id: id, testId: testId, as: as, color: colorProp })=>{
    typeof $2fFJv;
    // Technically size can be undefined here due to how the types work.
    // Once removing the level prop this assertion can be removed since size will be a required prop.
    const [hLevel, inferredElement] = (0, $3OG2c.useHeading)($f15d8336011bc22e$var$sizeTagMap[size]);
    const Component = as || inferredElement;
    const needsAriaRole = Component === 'div' && hLevel;
    const color = $f15d8336011bc22e$var$useColor(colorProp);
    return /*#__PURE__*/ (0, $byn9U.jsx)(Component, {
        id: id,
        "data-testid": testId,
        role: needsAriaRole ? 'heading' : undefined,
        "aria-level": needsAriaRole ? hLevel : undefined,
        css: [
            $f15d8336011bc22e$var$headingResetStyles,
            size && $f15d8336011bc22e$var$headingSizeStylesMap[size],
            $f15d8336011bc22e$export$93e8ddd840a408f9[color]
        ]
    }, children);
};
const $f15d8336011bc22e$export$93e8ddd840a408f9 = {
    'color.text': {
        name: "nws7uq",
        styles: "color:var(--ds-text, #172B4D)"
    },
    'color.text.inverse': {
        name: "1wvsb8v",
        styles: "color:var(--ds-text-inverse, #FFFFFF)"
    },
    'color.text.warning.inverse': {
        name: "tgubtb",
        styles: "color:var(--ds-text-warning-inverse, #172B4D)"
    }
};
/**
 * THIS SECTION WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::df829c6c0aa19bb57c0c77dc08d12d60>>
 * @codegenId typography
 * @codegenCommand yarn workspace @atlaskit/heading codegen
 */ const $f15d8336011bc22e$var$headingSizeStylesMap = {
    xxlarge: {
        name: "1qhbl6z",
        styles: "font:var(--ds-font-heading-xxlarge, normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
    },
    xlarge: {
        name: "1ha0ri1",
        styles: "font:var(--ds-font-heading-xlarge, normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
    },
    large: {
        name: "a1v0au",
        styles: "font:var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
    },
    medium: {
        name: "gjlouo",
        styles: "font:var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
    },
    small: {
        name: "17t1a33",
        styles: "font:var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
    },
    xsmall: {
        name: "19n0psn",
        styles: "font:var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
    },
    xxsmall: {
        name: "1xm9io",
        styles: "font:var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
    }
};
var /**
 * @codegenEnd
 */ $f15d8336011bc22e$export$2e2bcd8739ae039 = $f15d8336011bc22e$var$Heading;

});


parcelRegister("ho1Ek", function(module, exports) {

$parcel$export(module.exports, "VAR_LEFT_PANEL_WIDTH", () => $9bfcd1a3e554435a$export$cbfb0f5b2869b17b);
$parcel$export(module.exports, "VAR_LEFT_SIDEBAR_WIDTH", () => $9bfcd1a3e554435a$export$a30f2e00489a8957);
$parcel$export(module.exports, "VAR_RIGHT_SIDEBAR_WIDTH", () => $9bfcd1a3e554435a$export$c103b605cd368aed);
$parcel$export(module.exports, "VAR_RIGHT_PANEL_WIDTH", () => $9bfcd1a3e554435a$export$fa34f417972d6341);
$parcel$export(module.exports, "VAR_TOP_NAVIGATION_HEIGHT", () => $9bfcd1a3e554435a$export$3a6a779d9181047c);
$parcel$export(module.exports, "VAR_BANNER_HEIGHT", () => $9bfcd1a3e554435a$export$bcd94a6a792e7f96);
$parcel$export(module.exports, "VAR_LEFT_SIDEBAR_FLYOUT", () => $9bfcd1a3e554435a$export$b6744d31294864fd);
$parcel$export(module.exports, "DIMENSIONS", () => $9bfcd1a3e554435a$export$d67ac355184b7646);
$parcel$export(module.exports, "LEFT_PANEL", () => $9bfcd1a3e554435a$export$344062f7cfc9528e);
$parcel$export(module.exports, "RIGHT_PANEL", () => $9bfcd1a3e554435a$export$c7139cc2d6110b5f);
$parcel$export(module.exports, "BANNER", () => $9bfcd1a3e554435a$export$238d30785c4bca84);
$parcel$export(module.exports, "TOP_NAVIGATION", () => $9bfcd1a3e554435a$export$bec6dca2e63de4ae);
$parcel$export(module.exports, "CONTENT", () => $9bfcd1a3e554435a$export$d1213e82613ff4df);
$parcel$export(module.exports, "DEFAULT_BANNER_HEIGHT", () => $9bfcd1a3e554435a$export$be83e7118304b28e);
$parcel$export(module.exports, "DEFAULT_TOP_NAVIGATION_HEIGHT", () => $9bfcd1a3e554435a$export$4a98ee0bd1ae362);
$parcel$export(module.exports, "DEFAULT_LEFT_SIDEBAR_WIDTH", () => $9bfcd1a3e554435a$export$539e68c09584883a);
$parcel$export(module.exports, "DEFAULT_RIGHT_SIDEBAR_WIDTH", () => $9bfcd1a3e554435a$export$b92df8810d2fcd01);
$parcel$export(module.exports, "DEFAULT_RIGHT_PANEL_WIDTH", () => $9bfcd1a3e554435a$export$c3e41153b9288bcf);
$parcel$export(module.exports, "DEFAULT_LEFT_PANEL_WIDTH", () => $9bfcd1a3e554435a$export$c4d6152f86ea28f6);
$parcel$export(module.exports, "COLLAPSED_LEFT_SIDEBAR_WIDTH", () => $9bfcd1a3e554435a$export$46acf8758e9e2636);
$parcel$export(module.exports, "MOBILE_COLLAPSED_LEFT_SIDEBAR_WIDTH", () => $9bfcd1a3e554435a$export$70740f5ad8360a78);
$parcel$export(module.exports, "DEFAULT_LEFT_SIDEBAR_FLYOUT_WIDTH", () => $9bfcd1a3e554435a$export$991d5285ad765a3d);
$parcel$export(module.exports, "MIN_LEFT_SIDEBAR_DRAG_THRESHOLD", () => $9bfcd1a3e554435a$export$6949d4f32b161684);
$parcel$export(module.exports, "MAX_MOBILE_SIDEBAR_FLYOUT_WIDTH", () => $9bfcd1a3e554435a$export$d6e7e8af042815bb);
$parcel$export(module.exports, "TRANSITION_DURATION", () => $9bfcd1a3e554435a$export$3749e1104328fde4);
$parcel$export(module.exports, "FLYOUT_DELAY", () => $9bfcd1a3e554435a$export$1074d925b0b82be5);
$parcel$export(module.exports, "PAGE_LAYOUT_LS_KEY", () => $9bfcd1a3e554435a$export$451e84a45a9e4a75);
$parcel$export(module.exports, "IS_SIDEBAR_DRAGGING", () => $9bfcd1a3e554435a$export$802bb2c050f3db5c);
$parcel$export(module.exports, "IS_SIDEBAR_COLLAPSING", () => $9bfcd1a3e554435a$export$5e5e1875c3fd8f4f);
$parcel$export(module.exports, "GRAB_AREA_LINE_SELECTOR", () => $9bfcd1a3e554435a$export$70c702a8c5895f03);
$parcel$export(module.exports, "GRAB_AREA_SELECTOR", () => $9bfcd1a3e554435a$export$48a43f91e4becf4e);
$parcel$export(module.exports, "RESIZE_BUTTON_SELECTOR", () => $9bfcd1a3e554435a$export$dac2fb31a9f6844d);
$parcel$export(module.exports, "RESIZE_CONTROL_SELECTOR", () => $9bfcd1a3e554435a$export$9ecd22db14e6c70e);
$parcel$export(module.exports, "PAGE_LAYOUT_SLOT_SELECTOR", () => $9bfcd1a3e554435a$export$5253dd9707b8c3ba);
$parcel$export(module.exports, "DEFAULT_I18N_PROPS_SKIP_LINKS", () => $9bfcd1a3e554435a$export$206a08f7f8beb554);
$parcel$export(module.exports, "PAGE_LAYOUT_CONTAINER_SELECTOR", () => $9bfcd1a3e554435a$export$659ee746b31b360d);
$parcel$export(module.exports, "LEFT_PANEL_WIDTH", () => $9bfcd1a3e554435a$export$f963aecf2d4465bd);
$parcel$export(module.exports, "RIGHT_PANEL_WIDTH", () => $9bfcd1a3e554435a$export$750459958906793);
$parcel$export(module.exports, "LEFT_SIDEBAR_WIDTH", () => $9bfcd1a3e554435a$export$f897e1ed9f8ed251);
$parcel$export(module.exports, "RIGHT_SIDEBAR_WIDTH", () => $9bfcd1a3e554435a$export$b44ab66843c05a69);
$parcel$export(module.exports, "TOP_NAVIGATION_HEIGHT", () => $9bfcd1a3e554435a$export$aeff86a16f13529);
$parcel$export(module.exports, "BANNER_HEIGHT", () => $9bfcd1a3e554435a$export$ed7cc0d417ee89e);
$parcel$export(module.exports, "LEFT_SIDEBAR_FLYOUT_WIDTH", () => $9bfcd1a3e554435a$export$d2fa14f05b61e66);
// dimension vars
const $9bfcd1a3e554435a$export$cbfb0f5b2869b17b = 'leftPanelWidth';
const $9bfcd1a3e554435a$export$a30f2e00489a8957 = 'leftSidebarWidth';
const $9bfcd1a3e554435a$export$c103b605cd368aed = 'rightSidebarWidth';
const $9bfcd1a3e554435a$export$fa34f417972d6341 = 'rightPanelWidth';
const $9bfcd1a3e554435a$export$3a6a779d9181047c = 'topNavigationHeight';
const $9bfcd1a3e554435a$export$bcd94a6a792e7f96 = 'bannerHeight';
const $9bfcd1a3e554435a$export$b6744d31294864fd = 'leftSidebarFlyoutWidth';
const $9bfcd1a3e554435a$export$d67ac355184b7646 = [
    $9bfcd1a3e554435a$export$cbfb0f5b2869b17b,
    $9bfcd1a3e554435a$export$fa34f417972d6341,
    $9bfcd1a3e554435a$export$bcd94a6a792e7f96,
    $9bfcd1a3e554435a$export$3a6a779d9181047c,
    $9bfcd1a3e554435a$export$a30f2e00489a8957,
    $9bfcd1a3e554435a$export$c103b605cd368aed
];
const $9bfcd1a3e554435a$export$344062f7cfc9528e = 'left-panel';
const $9bfcd1a3e554435a$export$c7139cc2d6110b5f = 'right-panel';
const $9bfcd1a3e554435a$export$238d30785c4bca84 = 'banner';
const $9bfcd1a3e554435a$export$bec6dca2e63de4ae = 'top-navigation';
const $9bfcd1a3e554435a$export$d1213e82613ff4df = 'content';
const $9bfcd1a3e554435a$export$2d8180803f50fc5 = 'main';
const $9bfcd1a3e554435a$export$50ea883ba6f28ff5 = 'left-sidebar';
const $9bfcd1a3e554435a$export$7bf43119a6b49ddb = 'right-sidebar';
const $9bfcd1a3e554435a$export$be83e7118304b28e = 56;
const $9bfcd1a3e554435a$export$4a98ee0bd1ae362 = 56;
const $9bfcd1a3e554435a$export$539e68c09584883a = 240;
const $9bfcd1a3e554435a$export$b92df8810d2fcd01 = 280;
const $9bfcd1a3e554435a$export$c3e41153b9288bcf = 368;
const $9bfcd1a3e554435a$export$c4d6152f86ea28f6 = 368;
const $9bfcd1a3e554435a$export$46acf8758e9e2636 = 20;
const $9bfcd1a3e554435a$export$70740f5ad8360a78 = 16;
const $9bfcd1a3e554435a$export$f562af313cda0684 = 80;
const $9bfcd1a3e554435a$export$991d5285ad765a3d = 240;
const $9bfcd1a3e554435a$export$6949d4f32b161684 = 200;
const $9bfcd1a3e554435a$export$d6e7e8af042815bb = 350;
const $9bfcd1a3e554435a$export$3749e1104328fde4 = 300;
const $9bfcd1a3e554435a$export$1074d925b0b82be5 = 200;
const $9bfcd1a3e554435a$export$24d54fc362d78805 = 'expandedLeftSidebarWidth';
const $9bfcd1a3e554435a$export$451e84a45a9e4a75 = 'DS_PAGE_LAYOUT_UI_STATE';
const $9bfcd1a3e554435a$export$802bb2c050f3db5c = 'data-is-sidebar-dragging';
const $9bfcd1a3e554435a$export$5e5e1875c3fd8f4f = 'data-is-sidebar-collapsing';
const $9bfcd1a3e554435a$export$60b3bc5d4ac00d5e = 'data-is-flyout-open';
const $9bfcd1a3e554435a$export$70c702a8c5895f03 = 'data-grab-area-line';
const $9bfcd1a3e554435a$export$48a43f91e4becf4e = 'data-grab-area';
const $9bfcd1a3e554435a$export$dac2fb31a9f6844d = 'data-resize-button';
const $9bfcd1a3e554435a$export$9ecd22db14e6c70e = 'data-resize-control';
const $9bfcd1a3e554435a$export$5253dd9707b8c3ba = 'data-ds--page-layout--slot';
const $9bfcd1a3e554435a$export$206a08f7f8beb554 = 'Skip to:';
const $9bfcd1a3e554435a$export$659ee746b31b360d = 'data-layout-container';
const $9bfcd1a3e554435a$export$f963aecf2d4465bd = `var(--${$9bfcd1a3e554435a$export$cbfb0f5b2869b17b}, 0px)`;
const $9bfcd1a3e554435a$export$750459958906793 = `var(--${$9bfcd1a3e554435a$export$fa34f417972d6341}, 0px)`;
const $9bfcd1a3e554435a$export$f897e1ed9f8ed251 = `var(--${$9bfcd1a3e554435a$export$a30f2e00489a8957}, 0px)`;
const $9bfcd1a3e554435a$export$b44ab66843c05a69 = `var(--${$9bfcd1a3e554435a$export$c103b605cd368aed}, 0px)`;
const $9bfcd1a3e554435a$export$aeff86a16f13529 = `var(--${$9bfcd1a3e554435a$export$3a6a779d9181047c}, 0px)`;
const $9bfcd1a3e554435a$export$ed7cc0d417ee89e = `var(--${$9bfcd1a3e554435a$export$bcd94a6a792e7f96}, 0px)`;
const $9bfcd1a3e554435a$export$d2fa14f05b61e66 = `var(--${$9bfcd1a3e554435a$export$b6744d31294864fd}, ${$9bfcd1a3e554435a$export$991d5285ad765a3d}px)`;

});

parcelRegister("ce8OV", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b13c4031a112ab9$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $bVhyO = parcelRequire("bVhyO");

var $5Y0DT = parcelRequire("5Y0DT");
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $6b13c4031a112ab9$var$svgStyles = /*#__PURE__*/ (0, $byn9U.css)((0, $5Y0DT.commonSVGStyles));
/**
 * __SVG__
 *
 * An icon is used as a visual representation of common actions and commands to provide context.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-svgs)
 */ const $6b13c4031a112ab9$var$SVG = /*#__PURE__*/ (0, $eUqFw.memo)(function SVG({ size: size = 'medium', label: label, primaryColor: primaryColor = 'currentColor', secondaryColor: secondaryColor, testId: testId, children: children }) {
    return /*#__PURE__*/ (0, $byn9U.jsx)("svg", {
        viewBox: "0 0 24 24",
        style: {
            color: primaryColor,
            fill: secondaryColor || (0, $bVhyO.getBackground)()
        },
        css: [
            $6b13c4031a112ab9$var$svgStyles,
            (0, $5Y0DT.sizeStyleMap)[size]
        ],
        "data-testid": testId,
        "aria-label": label || undefined,
        role: label ? 'img' : 'presentation'
    }, children);
});
var $6b13c4031a112ab9$export$2e2bcd8739ae039 = $6b13c4031a112ab9$var$SVG;

});

parcelRegister("aOw1G", function(module, exports) {

$parcel$export(module.exports, "default", () => $985fd010d3fd2a46$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $6Pq2D = parcelRequire("6Pq2D");

var $8MHxr = parcelRequire("8MHxr");

var $lUFyV = parcelRequire("lUFyV");

var $51vNN = parcelRequire("51vNN");

var $5Q9wj = parcelRequire("5Q9wj");

var $etCs9 = parcelRequire("etCs9");

var $hYDGa = parcelRequire("hYDGa");

var $XHGTv = parcelRequire("XHGTv");

var $gmZvv = parcelRequire("gmZvv");

var $lcnyw = parcelRequire("lcnyw");

var $kl9S2 = parcelRequire("kl9S2");

var $e9rR7 = parcelRequire("e9rR7");

var $kMXYx = parcelRequire("kMXYx");
function $985fd010d3fd2a46$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $985fd010d3fd2a46$var$fillScreenStyles = {
    name: "1yerbni",
    styles: "width:100vw;height:100vh;position:fixed;inset-block-start:var(--ds-space-0, 0);inset-inline-start:var(--ds-space-0, 0);overflow-y:auto;-webkit-overflow-scrolling:touch"
};
const $985fd010d3fd2a46$var$allowlistElements = (element, callback)=>{
    // allows focus to reach elements outside the modal if they contain the data-atlas-extension attribute
    if (element.hasAttribute('data-atlas-extension')) return false;
    // allows to pass a callback function to allow elements be ignored by focus lock
    if (typeof callback === 'function') return callback(element);
    return true;
};
/**
 * __Modal wrapper__
 *
 * A modal wrapper displays content that requires user interaction, in a layer above the page.
 * This component is primary container for other modal components.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const $985fd010d3fd2a46$var$ModalWrapper = (props)=>{
    const { autoFocus: autoFocus = true, focusLockAllowlist: focusLockAllowlist, shouldCloseOnEscapePress: shouldCloseOnEscapePress = true, shouldCloseOnOverlayClick: shouldCloseOnOverlayClick = true, shouldScrollInViewport: shouldScrollInViewport = false, shouldReturnFocus: shouldReturnFocus = true, stackIndex: stackIndexOverride, onClose: onClose = (0, $5Q9wj.default), onStackChange: onStackChange = (0, $5Q9wj.default), isBlanketHidden: isBlanketHidden, children: children, height: height, width: width, onCloseComplete: onCloseComplete, onOpenComplete: onOpenComplete, label: label, testId: testId } = props;
    const calculatedStackIndex = (0, $e9rR7.default)({
        onStackChange: onStackChange
    });
    const stackIndex = stackIndexOverride || calculatedStackIndex;
    const isForeground = stackIndex === 0;
    // When a user supplies a ref to focus we skip auto focus via react-focus-lock
    const autoFocusLock = typeof autoFocus === 'boolean' ? autoFocus : false;
    const onCloseHandler = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: onClose,
        action: 'closed',
        componentName: 'modalDialog',
        packageName: undefined,
        packageVersion: undefined
    });
    const onBlanketClicked = (0, $eUqFw.useCallback)((e)=>{
        if (shouldCloseOnOverlayClick) onCloseHandler(e);
    }, [
        shouldCloseOnOverlayClick,
        onCloseHandler
    ]);
    (0, $kMXYx.default)();
    const modalDialogWithBlanket = /*#__PURE__*/ (0, $byn9U.jsx)((0, $51vNN.default), {
        isTinted: !isBlanketHidden,
        onBlanketClicked: onBlanketClicked,
        testId: testId && `${testId}--blanket`
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $kl9S2.default), {
        testId: testId,
        label: label,
        autoFocus: autoFocus,
        stackIndex: stackIndex,
        onClose: onCloseHandler,
        shouldCloseOnEscapePress: shouldCloseOnEscapePress && isForeground,
        shouldScrollInViewport: shouldScrollInViewport,
        height: height,
        width: width,
        onCloseComplete: onCloseComplete,
        onOpenComplete: onOpenComplete
    }, children));
    let returnFocus = true;
    let onDeactivation;
    if ('boolean' === typeof shouldReturnFocus) returnFocus = shouldReturnFocus;
    else onDeactivation = ()=>{
        window.setTimeout(()=>{
            shouldReturnFocus.current?.focus();
        }, 0);
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $etCs9.UNSAFE_LAYERING), {
        isDisabled: (0, $XHGTv.getBooleanFF)('platform.design-system-team.layering_qmiw3') ? false : true
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $gmZvv.default), {
        zIndex: (0, $lcnyw.layers).modal()
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $hYDGa.default), null, (fadeInProps)=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
            ...fadeInProps,
            css: $985fd010d3fd2a46$var$fillScreenStyles,
            "aria-hidden": !isForeground
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $6Pq2D.default), {
            autoFocus: autoFocusLock,
            disabled: (0, $XHGTv.getBooleanFF)('platform.design-system-team.multiple-modal-inappropriate-focus_z5u4j') ? undefined : !isForeground,
            returnFocus: returnFocus,
            onDeactivation: onDeactivation,
            whiteList: (element)=>$985fd010d3fd2a46$var$allowlistElements(element, focusLockAllowlist)
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8MHxr))), null), shouldScrollInViewport ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $8MHxr.TouchScrollable), null, modalDialogWithBlanket) : modalDialogWithBlanket)))));
};
var $985fd010d3fd2a46$export$2e2bcd8739ae039 = $985fd010d3fd2a46$var$ModalWrapper;

});
parcelRegister("51vNN", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e46e116f295c5fc$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lUFyV = parcelRequire("lUFyV");

var $5Q9wj = parcelRequire("5Q9wj");

var $PdmhA = parcelRequire("PdmhA");

var $lcnyw = parcelRequire("lcnyw");
function $2e46e116f295c5fc$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $2e46e116f295c5fc$var$packageName = undefined;
const $2e46e116f295c5fc$var$packageVersion = undefined;
const $2e46e116f295c5fc$var$analyticsAttributes = {
    componentName: 'blanket',
    packageName: $2e46e116f295c5fc$var$packageName,
    packageVersion: $2e46e116f295c5fc$var$packageVersion
};
const $2e46e116f295c5fc$var$baseStyles = /*#__PURE__*/ (0, $byn9U.css)({
    position: 'fixed',
    zIndex: (0, $lcnyw.layers).blanket(),
    inset: 0,
    backgroundColor: `var(--ds-blanket, ${(0, $PdmhA.N100A)})`,
    overflowY: 'auto',
    pointerEvents: 'initial'
});
const $2e46e116f295c5fc$var$shouldAllowClickThroughStyles = {
    name: "je8g23",
    styles: "pointer-events:none"
};
const $2e46e116f295c5fc$var$invisibleStyles = {
    name: "1peqg37",
    styles: "background-color:transparent"
};
/**
 * __Blanket__
 *
 * A Blanket provides the overlay layer for components such as a modal dialog or a tooltip
 *
 * - [Examples](https://atlaskit.atlassian.com/examples/design-system/blanket/basic-usage)
 */ const $2e46e116f295c5fc$var$Blanket = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)(function Blanket({ shouldAllowClickThrough: shouldAllowClickThrough = false, isTinted: isTinted = false, onBlanketClicked: onBlanketClicked = (0, $5Q9wj.default), testId: testId, children: children, analyticsContext: analyticsContext }, ref) {
    const mouseDownTarget = (0, $eUqFw.useRef)(null);
    const onBlanketClickedWithAnalytics = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: onBlanketClicked,
        action: 'clicked',
        analyticsData: analyticsContext,
        ...$2e46e116f295c5fc$var$analyticsAttributes
    });
    const blanketClickOutsideChildren = (0, $eUqFw.useCallback)((e)=>e.currentTarget === e.target && mouseDownTarget.current === e.target ? onBlanketClickedWithAnalytics(e) : undefined, [
        onBlanketClickedWithAnalytics
    ]);
    const onClick = shouldAllowClickThrough ? undefined : blanketClickOutsideChildren;
    const onMouseDown = (0, $eUqFw.useCallback)((e)=>{
        mouseDownTarget.current = e.target;
    }, []);
    return(/**
     * It is not normally acceptable to add click and key handlers to non-interactive
     * elements as this is an accessibility anti-pattern. However, because this
     * instance is to enable light dismiss functionality instead of creating an
     * inaccessible custom element, we can add role="presentation" so that there
     * are no negative impacts to assistive technologies.
     */ /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        role: "presentation",
        css: [
            $2e46e116f295c5fc$var$baseStyles,
            shouldAllowClickThrough && $2e46e116f295c5fc$var$shouldAllowClickThroughStyles,
            !isTinted && $2e46e116f295c5fc$var$invisibleStyles
        ],
        onClick: onClick,
        onMouseDown: onMouseDown,
        "data-testid": testId,
        ref: ref
    }, children));
}));
$2e46e116f295c5fc$var$Blanket.displayName = 'Blanket';
var $2e46e116f295c5fc$export$2e2bcd8739ae039 = $2e46e116f295c5fc$var$Blanket;

});

parcelRegister("etCs9", function(module, exports) {

$parcel$export(module.exports, "LevelContext", () => $f01de1631a52daae$export$650d12d3c2ddb8fc);
$parcel$export(module.exports, "TopLevelContext", () => $f01de1631a52daae$export$48b383b280e20440);
$parcel$export(module.exports, "UNSAFE_LAYERING", () => $f01de1631a52daae$export$a183686c3f6f4ea8);

var $eUqFw = parcelRequire("eUqFw");

var $5Q9wj = parcelRequire("5Q9wj");
const $f01de1631a52daae$export$650d12d3c2ddb8fc = /*#__PURE__*/ (0, $eUqFw.createContext)(0);
const $f01de1631a52daae$export$48b383b280e20440 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    topLevelRef: {
        current: null
    },
    setTopLevel: (0, $5Q9wj.default)
});
/**
 *
 *  @internal
 * Context Provider Component which provider the current level of nested layers
 * It handles level management when it mounts and unmounts
 *
 */ const $f01de1631a52daae$var$LevelProvider = ({ children: children, currentLevel: currentLevel })=>{
    const { setTopLevel: setTopLevel } = (0, $eUqFw.useContext)($f01de1631a52daae$export$48b383b280e20440);
    setTopLevel(currentLevel);
    (0, $eUqFw.useEffect)(()=>{
        // avoid immediate cleanup using setTimeout when component unmount
        // this will make sure non-top layer components can get the correct top level value
        // when multiple layers trigger onClose in sequence.
        // From React 17, the useEffect cleanup functions are delayed till the commit phase is completed. In other words, the useEffect cleanup functions run asynchronously - for example, if the component is unmounting, the cleanup runs after the screen has been updated.
        // TODO revisit after we migrate to react 18. https://product-fabric.atlassian.net/browse/DSP-13139
        return ()=>{
            setTimeout(()=>{
                setTopLevel(currentLevel - 1);
            }, 0);
        };
    }, [
        setTopLevel,
        currentLevel
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f01de1631a52daae$export$650d12d3c2ddb8fc.Provider, {
        value: currentLevel
    }, children);
};
/**
 *
 *  @internal
 * Context Provider Component which provides the top level of all nested layers
 * It provides initial top level ref value as 0 and set top level method
 *
 */ const $f01de1631a52daae$var$LayeringProvider = ({ children: children })=>{
    const topLevelRef = (0, $eUqFw.useRef)(0);
    const value = (0, $eUqFw.useMemo)(()=>({
            topLevelRef: topLevelRef,
            setTopLevel: (level)=>{
                topLevelRef.current = level;
            }
        }), [
        topLevelRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f01de1631a52daae$export$48b383b280e20440.Provider, {
        value: value
    }, children);
};
const $f01de1631a52daae$export$a183686c3f6f4ea8 = ({ children: children, isDisabled: isDisabled = true })=>{
    const currentLevel = (0, $eUqFw.useContext)($f01de1631a52daae$export$650d12d3c2ddb8fc);
    if (isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
    const isNested = currentLevel > 0;
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f01de1631a52daae$var$LevelProvider, {
        currentLevel: currentLevel + 1
    }, children);
    return isNested ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f01de1631a52daae$var$LayeringProvider, null, content);
};

});

parcelRegister("kl9S2", function(module, exports) {

$parcel$export(module.exports, "default", () => $564a89a7ae58a2ac$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $jFtVs = parcelRequire("jFtVs");

var $1lQG9 = parcelRequire("1lQG9");

var $hhlqA = parcelRequire("hhlqA");

var $51sCz = parcelRequire("51sCz");

var $eN43R = parcelRequire("eN43R");

var $hYDGa = parcelRequire("hYDGa");

var $XHGTv = parcelRequire("XHGTv");

var $4Ywu9 = parcelRequire("4Ywu9");

var $PdmhA = parcelRequire("PdmhA");

var $kyri3 = parcelRequire("kyri3");

var $dlyGx = parcelRequire("dlyGx");

var $i7afc = parcelRequire("i7afc");

var $4kGMG = parcelRequire("4kGMG");

var $1dIle = parcelRequire("1dIle");

var $9puPw = parcelRequire("9puPw");
function $564a89a7ae58a2ac$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// reset pointer-events on iframe inside modal
const $564a89a7ae58a2ac$var$resetPointerEventsOnIframeStyles = {
    name: "197mn9k",
    styles: "iframe:is([aria-modal] iframe){pointer-events:auto;}"
};
const $564a89a7ae58a2ac$var$dialogStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    width: '100%',
    maxWidth: '100vw',
    height: '100%',
    minHeight: 0,
    maxHeight: '100vh',
    // Flex-grow set to 0 to prevent this element from filling its parent flexbox container
    flex: '0 1 auto',
    flexDirection: 'column',
    backgroundColor: `var(--ds-surface-overlay, ${(0, $PdmhA.N0)})`,
    color: (0, $dlyGx.textColor),
    [(0, $kyri3.CURRENT_SURFACE_CSS_VAR)]: `var(--ds-surface-overlay, ${(0, $PdmhA.N0)})`,
    pointerEvents: 'auto',
    [(0, $4Ywu9.media).above.xs]: {
        width: 'var(--modal-dialog-width)',
        maxWidth: 'inherit',
        borderRadius: (0, $dlyGx.borderRadius),
        boxShadow: `var(--ds-shadow-overlay, ${`0 0 0 1px ${(0, $PdmhA.N30A)}, 0 2px 1px ${(0, $PdmhA.N30A)}, 0 0 20px -6px ${(0, $PdmhA.N60A)}`})`,
        marginInlineEnd: 'inherit',
        marginInlineStart: 'inherit'
    },
    /**
   * This is to support scrolling if the modal's children are wrapped in
   * a form.
   */ // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    '& > form:only-child': {
        display: 'inherit',
        maxHeight: 'inherit',
        flexDirection: 'inherit'
    }
});
const $564a89a7ae58a2ac$var$viewportScrollStyles = /*#__PURE__*/ (0, $byn9U.css)({
    /**
   * This ensures that the element fills the viewport on mobile
   * while also allowing it to overflow if its height is larger than
   * the viewport.
   */ minHeight: '100vh',
    maxHeight: 'none',
    [(0, $4Ywu9.media).above.xs]: {
        minHeight: 'var(--modal-dialog-height)'
    }
});
const $564a89a7ae58a2ac$var$bodyScrollStyles = /*#__PURE__*/ (0, $byn9U.css)({
    [(0, $4Ywu9.media).above.xs]: {
        height: 'var(--modal-dialog-height)',
        maxHeight: 'inherit'
    }
});
const $564a89a7ae58a2ac$var$ModalDialog = (props)=>{
    const { width: width = 'medium', shouldScrollInViewport: shouldScrollInViewport = false, shouldCloseOnEscapePress: shouldCloseOnEscapePress, autoFocus: autoFocus, stackIndex: stackIndex, onClose: onClose, onCloseComplete: onCloseComplete, onOpenComplete: onOpenComplete, height: height, children: children, label: label, testId: testId } = props;
    const id = (0, $jFtVs.useUID)();
    const titleId = `modal-dialog-title-${id}`;
    (0, $hhlqA.default)(typeof autoFocus === 'object' ? autoFocus : undefined, // When a user supplies  a ref to focus we enable this hook
    typeof autoFocus === 'object');
    const [motionRef, onMotionFinish] = (0, $4kGMG.default)({
        onOpenComplete: onOpenComplete,
        onCloseComplete: onCloseComplete
    });
    const modalDialogContext = (0, $eUqFw.useMemo)(()=>({
            testId: testId,
            titleId: titleId,
            onClose: onClose
        }), [
        testId,
        titleId,
        onClose
    ]);
    (0, $eN43R.useCloseOnEscapePress)({
        onClose: onClose,
        isDisabled: !shouldCloseOnEscapePress
    });
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $9puPw.default), {
        stackIndex: stackIndex,
        shouldScrollInViewport: shouldScrollInViewport,
        testId: testId
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $i7afc.ModalContext).Provider, {
        value: modalDialogContext
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $i7afc.ScrollContext).Provider, {
        value: shouldScrollInViewport
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $hYDGa.default), {
        entranceDirection: "bottom",
        onFinish: onMotionFinish
    }, (bottomFadeInProps)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $51sCz.default), null, /*#__PURE__*/ (0, $byn9U.jsx)("section", {
            ...bottomFadeInProps,
            "aria-label": label,
            ref: (0, $1lQG9.default)([
                bottomFadeInProps.ref,
                motionRef
            ]),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                '--modal-dialog-width': (0, $1dIle.dialogWidth)(width),
                '--modal-dialog-height': (0, $1dIle.dialogHeight)(height)
            },
            css: [
                $564a89a7ae58a2ac$var$dialogStyles,
                shouldScrollInViewport ? $564a89a7ae58a2ac$var$viewportScrollStyles : $564a89a7ae58a2ac$var$bodyScrollStyles
            ],
            role: "dialog",
            "aria-labelledby": label ? undefined : titleId,
            "data-testid": testId,
            "data-modal-stack": stackIndex,
            tabIndex: -1,
            "aria-modal": true
        }, children, (0, $XHGTv.getBooleanFF)('platform.design-system-team.iframe_gojiv') && /*#__PURE__*/ (0, $byn9U.jsx)((0, $byn9U.Global), {
            styles: $564a89a7ae58a2ac$var$resetPointerEventsOnIframeStyles
        })))))));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$564a89a7ae58a2ac$export$2e2bcd8739ae039 = $564a89a7ae58a2ac$var$ModalDialog;

});
parcelRegister("eN43R", function(module, exports) {

$parcel$export(module.exports, "useCloseOnEscapePress", () => $52149d1bb4892290$export$4a4bf067ea9e7886);
$parcel$export(module.exports, "UNSAFE_useLayering", () => $52149d1bb4892290$export$cec37b93989366d4);

var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

var $etCs9 = parcelRequire("etCs9");
const $52149d1bb4892290$var$ESCAPE = 'Escape';
function $52149d1bb4892290$export$4a4bf067ea9e7886({ onClose: onClose, isDisabled: isDisabled }) {
    const escapePressed = (0, $eUqFw.useRef)(false);
    const { isLayerDisabled: isLayerDisabled } = $52149d1bb4892290$export$cec37b93989366d4();
    const onKeyDown = (0, $eUqFw.useCallback)((e)=>{
        const isDisabledLayer = isLayerDisabled();
        if (isDisabled || escapePressed.current || e.key !== $52149d1bb4892290$var$ESCAPE || isDisabledLayer) // We're either already handling the key down event or it's not escape or disabled.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled,
        isLayerDisabled
    ]);
    const onKeyUp = (0, $eUqFw.useCallback)(()=>{
        escapePressed.current = false;
    }, []);
    (0, $eUqFw.useEffect)(()=>{
        return (0, $74BVL.bindAll)(document, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp
    ]);
}
function $52149d1bb4892290$export$cec37b93989366d4() {
    const currentLevel = (0, $eUqFw.useContext)((0, $etCs9.LevelContext));
    const { topLevelRef: topLevelRef } = (0, $eUqFw.useContext)((0, $etCs9.TopLevelContext));
    const isLayerDisabled = (0, $eUqFw.useCallback)(()=>{
        return !!topLevelRef.current && currentLevel !== topLevelRef.current;
    }, [
        currentLevel,
        topLevelRef
    ]);
    return {
        currentLevel: currentLevel,
        topLevelRef: topLevelRef,
        isLayerDisabled: isLayerDisabled
    };
}

});

parcelRegister("4kGMG", function(module, exports) {

$parcel$export(module.exports, "default", () => $0189a48ba662ea46$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $0189a48ba662ea46$export$2e2bcd8739ae039({ onOpenComplete: onOpenComplete, onCloseComplete: onCloseComplete }) {
    const motionRef = (0, $eUqFw.useRef)(null);
    const onMotionFinish = (0, $eUqFw.useCallback)((state)=>{
        if (state === 'entering' && onOpenComplete) onOpenComplete(motionRef.current, true);
        if (state === 'exiting' && onCloseComplete) onCloseComplete(motionRef.current);
    }, [
        onOpenComplete,
        onCloseComplete
    ]);
    return [
        motionRef,
        onMotionFinish
    ];
}

});

parcelRegister("1dIle", function(module, exports) {

$parcel$export(module.exports, "dialogWidth", () => $bdc9c988039069a1$export$a3da89b899389ed8);
$parcel$export(module.exports, "dialogHeight", () => $bdc9c988039069a1$export$ceba93bf0bdd16f2);

var $dlyGx = parcelRequire("dlyGx");
const $bdc9c988039069a1$export$a3da89b899389ed8 = (input)=>{
    if (!input) return 'auto';
    const isWidthName = (0, $dlyGx.width).values.indexOf(input.toString()) !== -1;
    const widthName = isWidthName && input;
    if (widthName) return `${(0, $dlyGx.width).widths[widthName]}px`;
    return typeof input === 'number' ? `${input}px` : input;
};
const $bdc9c988039069a1$export$ceba93bf0bdd16f2 = (input)=>{
    if (!input) return 'auto';
    return typeof input === 'number' ? `${input}px` : input;
};

});

parcelRegister("9puPw", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7ce69be7fe4a9b4$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ /** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");


var $5LHuc = parcelRequire("5LHuc");

var $4Ywu9 = parcelRequire("4Ywu9");

var $lcnyw = parcelRequire("lcnyw");

var $dlyGx = parcelRequire("dlyGx");
function $e7ce69be7fe4a9b4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e7ce69be7fe4a9b4$var$maxWidthDimensions = `calc(100vw - ${(0, $dlyGx.gutter) * 2}px)`;
const $e7ce69be7fe4a9b4$var$maxHeightDimensions = `calc(100vh - ${(0, $dlyGx.gutter) * 2 - 1}px)`;
// Flex and min-content are set to constrain the height of the body and support multi-column scrolling experiences
const $e7ce69be7fe4a9b4$var$positionerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    width: '100%',
    maxWidth: '100%',
    height: '100%',
    position: 'fixed',
    zIndex: (0, $lcnyw.layers).modal(),
    flexDirection: 'column',
    insetBlockStart: 0,
    insetInlineStart: 0
});
const $e7ce69be7fe4a9b4$var$viewportScrollStyles = /*#__PURE__*/ (0, $byn9U.css)({
    height: 'auto',
    position: 'relative',
    [(0, $4Ywu9.media).above.xs]: {
        margin: `${(0, $dlyGx.gutter)}px auto`,
        pointerEvents: 'none'
    }
});
const $e7ce69be7fe4a9b4$var$bodyScrollStyles = /*#__PURE__*/ (0, $byn9U.css)({
    [(0, $4Ywu9.media).above.xs]: {
        maxWidth: $e7ce69be7fe4a9b4$var$maxWidthDimensions,
        maxHeight: $e7ce69be7fe4a9b4$var$maxHeightDimensions,
        position: 'absolute',
        insetBlockStart: `${(0, $dlyGx.gutter)}px`,
        insetInlineEnd: 0,
        insetInlineStart: 0,
        marginInlineEnd: 'auto',
        marginInlineStart: 'auto',
        pointerEvents: 'none'
    }
});
const $e7ce69be7fe4a9b4$var$stackTransitionStyles = /*#__PURE__*/ (0, $byn9U.css)({
    transitionDuration: `${(0, $5LHuc.mediumDurationMs)}ms`,
    transitionProperty: 'transform',
    transitionTimingFunction: (0, $d58b680a02f4d6a4$export$c07234257a03d5e9),
    /**
   * Duplicated from @atlaskit/motion/accessibility
   * because @repo/internal/styles/consistent-style-ordering
   * doesn't work well with object spreading.
   */ '@media (prefers-reduced-motion: reduce)': {
        animation: 'none',
        transition: 'none'
    }
});
const $e7ce69be7fe4a9b4$var$stackTransformStyles = {
    name: "937ak9",
    styles: "transform:translateY(var(--modal-dialog-translate-y))"
};
const $e7ce69be7fe4a9b4$var$stackIdleStyles = {
    name: "179q9ic",
    styles: "transform:none"
};
const $e7ce69be7fe4a9b4$var$Positioner = (props)=>{
    const { children: children, stackIndex: stackIndex, shouldScrollInViewport: shouldScrollInViewport, testId: testId } = props;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            '--modal-dialog-translate-y': `${stackIndex * ((0, $dlyGx.verticalOffset) / 2)}px`
        },
        css: [
            $e7ce69be7fe4a9b4$var$positionerStyles,
            $e7ce69be7fe4a9b4$var$stackTransitionStyles,
            /* We only want to apply transform on modals shifting to the back of the stack. */ stackIndex > 0 ? $e7ce69be7fe4a9b4$var$stackTransformStyles : $e7ce69be7fe4a9b4$var$stackIdleStyles,
            shouldScrollInViewport ? $e7ce69be7fe4a9b4$var$viewportScrollStyles : $e7ce69be7fe4a9b4$var$bodyScrollStyles
        ],
        "data-testid": testId && `${testId}--positioner`
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$e7ce69be7fe4a9b4$export$2e2bcd8739ae039 = $e7ce69be7fe4a9b4$var$Positioner;

});
const $d58b680a02f4d6a4$export$c07234257a03d5e9 = 'cubic-bezier(0.15,1,0.3,1)';
const $d58b680a02f4d6a4$export$57636bb43b1ccbb0 = 'cubic-bezier(0.2,0,0,1)';
const $d58b680a02f4d6a4$export$929e5a82286172a6 = 'cubic-bezier(0.8,0,0,0.8)';



parcelRegister("e9rR7", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b5197087b85bab8$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3jACL = parcelRequire("3jACL");

var $d7Ieg = parcelRequire("d7Ieg");

var $3LlFG = parcelRequire("3LlFG");

var $lSV8Z = parcelRequire("lSV8Z");
/**
 *  ________________________________________________
 * | MAJOR VERSIONS WILL NOT KNOW ABOUT EACH OTHER! |
 *  ------------------------------------------------
 *
 * An array which holds references to all currently open modal dialogs.
 * This will only work for modal dialogs of the same major version,
 * as the reference will be different between them.
 *
 * E.g. V11 won't know about any from V12.
 */ const $4b5197087b85bab8$var$modalStackRegister = [];
function $4b5197087b85bab8$export$2e2bcd8739ae039({ onStackChange: onStackChange }) {
    const { isExiting: isExiting } = (0, $lSV8Z.useExitingPersistence)();
    const [stackIndexRef, setStackIndex] = (0, $3LlFG.default)(0);
    const currentStackIndex = stackIndexRef.current;
    const previousStackIndex = (0, $d7Ieg.default)(stackIndexRef.current);
    // We want to ensure this function **never changes** during the lifecycle of this component.
    // This is why it's assigned to a ref and not in a useMemo/useCallback.
    const updateStack = (0, $3jACL.default)(()=>{
        const newStackIndex = $4b5197087b85bab8$var$modalStackRegister.indexOf(updateStack);
        // We access the stack index ref instead of state because this closure will always only
        // have the initial state and not any of the later values.
        if (stackIndexRef.current !== newStackIndex) {
            setStackIndex(newStackIndex);
            stackIndexRef.current = newStackIndex;
        }
    });
    (0, $eUqFw.useEffect)(()=>{
        const currentStackIndex = $4b5197087b85bab8$var$modalStackRegister.indexOf(updateStack);
        if (!isExiting && currentStackIndex === -1) // We are opening the modal dialog.
        // Add ourselves to the modal stack register!
        $4b5197087b85bab8$var$modalStackRegister.unshift(updateStack);
        if (isExiting && currentStackIndex !== -1) // We are closing the modal dialog using a wrapping modal transition component.
        // Remove ourselves from the modal stack register!
        // NOTE: Modal dialogs that don't have a wrapping modal transition component won't flow through here!
        // For that scenario we cleanup when the component unmounts.
        $4b5197087b85bab8$var$modalStackRegister.splice(currentStackIndex, 1);
        // Fire all registered modal dialogs to update their position in the stack.
        $4b5197087b85bab8$var$modalStackRegister.forEach((cb)=>cb());
    }, [
        updateStack,
        isExiting
    ]);
    (0, $eUqFw.useEffect)(()=>()=>{
            // Final cleanup just in case this modal dialog did not have a wrapping modal transition.
            const currentStackIndex = $4b5197087b85bab8$var$modalStackRegister.indexOf(updateStack);
            if (currentStackIndex !== -1) {
                $4b5197087b85bab8$var$modalStackRegister.splice(currentStackIndex, 1);
                $4b5197087b85bab8$var$modalStackRegister.forEach((cb)=>cb());
            }
        }, [
        updateStack
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (previousStackIndex === undefined) // Initial case that we don't need to notify about.
        return;
        if (previousStackIndex !== currentStackIndex) onStackChange(currentStackIndex);
    }, [
        onStackChange,
        previousStackIndex,
        currentStackIndex
    ]);
    return currentStackIndex;
}

});
parcelRegister("d7Ieg", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce2eb5f059e7dd1e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $ce2eb5f059e7dd1e$export$2e2bcd8739ae039(value) {
    const ref = (0, $eUqFw.useRef)();
    (0, $eUqFw.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}

});


parcelRegister("kMXYx", function(module, exports) {

$parcel$export(module.exports, "default", () => $69ad3c242244a008$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");
/**
 * Returns how far the body is scrolled from the top of the viewport.
 *
 *   ____
 * ||____|| <-- overflow
 *  |    |  <-- viewport
 *  |____|
 *
 * Scroll distance is the height of overflow outside the viewport.
 */ function $69ad3c242244a008$var$getScrollDistance() {
    return window.pageYOffset || document.documentElement?.scrollTop || document.body?.scrollTop || 0;
}
function $69ad3c242244a008$export$2e2bcd8739ae039() {
    const [scrollTopOffset, setScrollTopOffset] = (0, $eUqFw.useState)(0);
    (0, $eUqFw.useLayoutEffect)(()=>{
        setScrollTopOffset($69ad3c242244a008$var$getScrollDistance());
    }, []);
    const onWindowScroll = (0, $eUqFw.useCallback)(()=>{
        if ($69ad3c242244a008$var$getScrollDistance() !== scrollTopOffset) window.scrollTo(window.pageXOffset, scrollTopOffset);
    }, [
        scrollTopOffset
    ]);
    (0, $eUqFw.useEffect)(()=>{
        return (0, $74BVL.bind)(window, {
            type: 'scroll',
            listener: onWindowScroll
        });
    }, [
        onWindowScroll
    ]);
    return scrollTopOffset;
}

});


parcelRegister("1VTNc", function(module, exports) {

$parcel$export(module.exports, "spotlightButtonTheme", () => $1686648abb4cb9d9$export$39a36121076ca24);
$parcel$export(module.exports, "modalButtonTheme", () => $1686648abb4cb9d9$export$d131eb21ba4cbd16);

var $PdmhA = parcelRequire("PdmhA");
const $1686648abb4cb9d9$var$spotlightTheme = {
    default: {
        background: {
            default: `var(--ds-background-inverse-subtle, ${$PdmhA.P500})`,
            hover: `var(--ds-background-inverse-subtle-hovered, ${$PdmhA.P200})`,
            active: `var(--ds-background-inverse-subtle-pressed, ${$PdmhA.P500})`,
            disabled: `var(--ds-background-disabled, ${$PdmhA.P400})`,
            selected: `var(--ds-background-inverse-subtle-pressed, ${$PdmhA.R500})`,
            focus: `var(--ds-background-inverse-subtle, ${$PdmhA.P500})`
        },
        color: {
            default: `var(--ds-text-inverse, ${$PdmhA.N0})`,
            hover: `var(--ds-text-inverse, ${$PdmhA.N0})`,
            active: `var(--ds-text-inverse, ${$PdmhA.N0})`,
            disabled: {
                light: `var(--ds-text-disabled, ${$PdmhA.N0})`,
                dark: `var(--ds-text-disabled, ${$PdmhA.DN30})`
            },
            selected: `var(--ds-text-inverse, ${$PdmhA.N0})`,
            focus: `var(--ds-text-inverse, ${$PdmhA.N0})`
        }
    },
    subtle: {
        background: {
            default: 'none',
            hover: `var(--ds-background-inverse-subtle-hovered, ${$PdmhA.P200})`,
            active: `var(--ds-background-inverse-subtle-pressed, ${$PdmhA.P500})`,
            disabled: 'none',
            selected: {
                light: `var(--ds-background-selected-hovered, ${$PdmhA.N700})`,
                dark: `var(--ds-background-selected-hovered, ${$PdmhA.DN0})`
            },
            focusSelected: {
                light: `var(--ds-background-selected-hovered, ${$PdmhA.N700})`,
                dark: `var(--ds-background-selected-hovered, ${$PdmhA.DN0})`
            }
        },
        color: {
            default: `var(--ds-text-inverse, ${$PdmhA.N0})`,
            hover: `var(--ds-text-inverse, ${$PdmhA.N0})`,
            active: `var(--ds-text-inverse, ${$PdmhA.N0})`,
            disabled: `var(--ds-text-disabled, ${$PdmhA.N0})`,
            selected: `var(--ds-text-inverse, ${$PdmhA.N0})`,
            focus: `var(--ds-text-inverse, ${$PdmhA.N0})`
        }
    },
    'subtle-link': {
        textDecoration: {
            hover: `underline ${`var(--ds-text-inverse, ${$PdmhA.P75})`}`
        },
        textDecorationLine: {
            active: 'none'
        },
        color: {
            default: `var(--ds-text-inverse, ${$PdmhA.N0})`,
            hover: `var(--ds-text-inverse, ${$PdmhA.P75})`,
            active: `var(--ds-text-inverse, ${$PdmhA.P100})`,
            disabled: `var(--ds-text-discovery, ${$PdmhA.P500})`,
            selected: `var(--ds-text-selected, ${$PdmhA.N0})`,
            focus: `var(--ds-text-inverse, ${$PdmhA.N0})`
        }
    }
};
const $1686648abb4cb9d9$var$modalTheme = {
    primary: {
        background: {
            default: `var(--ds-background-discovery-bold, ${$PdmhA.P400})`,
            hover: `var(--ds-background-discovery-bold-hovered, ${$PdmhA.P200})`,
            active: `var(--ds-background-discovery-bold-pressed, ${$PdmhA.P500})`,
            disabled: {
                light: `var(--ds-background-disabled, ${$PdmhA.N30})`,
                dark: `var(--ds-background-disabled, ${$PdmhA.DN70})`
            },
            selected: `var(--ds-background-selected-hovered, ${$PdmhA.R500})`,
            focus: `var(--ds-background-discovery-bold-hovered, ${$PdmhA.P400})`
        },
        color: {
            default: `var(--ds-text-inverse, ${$PdmhA.N0})`,
            disabled: {
                light: `var(--ds-text-disabled, ${$PdmhA.N0})`,
                dark: `var(--ds-text-disabled, ${$PdmhA.DN30})`
            },
            selected: `var(--ds-text-selected, ${$PdmhA.N0})`,
            focus: `var(--ds-text-inverse, ${$PdmhA.N0})`
        }
    }
};
function $1686648abb4cb9d9$var$extract(newTheme, { mode: mode, appearance: appearance, state: state }) {
    if (!newTheme[appearance]) return undefined;
    const root = newTheme[appearance];
    return Object.keys(root).reduce((acc, val)=>{
        let node = root;
        [
            val,
            state,
            mode
        ].forEach((item)=>{
            if (!node[item]) return undefined;
            if (typeof node[item] !== 'object') {
                acc[val] = node[item];
                return undefined;
            }
            node = node[item];
            return undefined;
        });
        return acc;
    }, {});
}
const $1686648abb4cb9d9$export$39a36121076ca24 = (current, themeProps)=>{
    const { buttonStyles: buttonStyles, ...rest } = current(themeProps);
    return {
        buttonStyles: {
            ...buttonStyles,
            ...$1686648abb4cb9d9$var$extract($1686648abb4cb9d9$var$spotlightTheme, themeProps)
        },
        ...rest
    };
};
const $1686648abb4cb9d9$export$d131eb21ba4cbd16 = (current, themeProps)=>{
    const { buttonStyles: buttonStyles, ...rest } = current(themeProps);
    return {
        buttonStyles: {
            ...buttonStyles,
            ...$1686648abb4cb9d9$var$extract($1686648abb4cb9d9$var$modalTheme, themeProps)
        },
        ...rest
    };
};

});

parcelRegister("3MV1G", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f6aed3cb518bc88$export$2e2bcd8739ae039);
$parcel$export(module.exports, "Popup", () => (parcelRequire("bWh63")).Popup);

var $bWh63 = parcelRequire("bWh63");
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$6f6aed3cb518bc88$export$2e2bcd8739ae039 = (0, $bWh63.Popup);

});
parcelRegister("bWh63", function(module, exports) {

$parcel$export(module.exports, "Popup", () => $cf1eb387401e6e84$export$129a32eedafa97c5);
/* eslint-disable @repo/internal/react/require-jsdoc */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $jFtVs = parcelRequire("jFtVs");

var $etCs9 = parcelRequire("etCs9");

var $8nlzU = parcelRequire("8nlzU");
var $6frYP = parcelRequire("6frYP");

var $gmZvv = parcelRequire("gmZvv");

var $lcnyw = parcelRequire("lcnyw");

var $glmoE = parcelRequire("glmoE");

var $59zSl = parcelRequire("59zSl");
const $cf1eb387401e6e84$var$defaultLayer = (0, $lcnyw.layers).layer();
const $cf1eb387401e6e84$export$129a32eedafa97c5 = /*#__PURE__*/ (0, $eUqFw.memo)(({ isOpen: isOpen, id: providedId, offset: offset, testId: testId, trigger: trigger, content: content, onClose: onClose, boundary: boundary, rootBoundary: rootBoundary = 'viewport', shouldFlip: shouldFlip = true, placement: placement = 'auto', fallbackPlacements: fallbackPlacements, popupComponent: PopupContainer, autoFocus: autoFocus = true, zIndex: zIndex = $cf1eb387401e6e84$var$defaultLayer, shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick = false, shouldRenderToParent: shouldRenderToParent = false, shouldDisableFocusLock: shouldDisableFocusLock = false, strategy: strategy, role: role, label: label, titleId: titleId })=>{
    const [triggerRef, setTriggerRef] = (0, $eUqFw.useState)(null);
    const getMergedTriggerRef = (0, $59zSl.useGetMemoizedMergedTriggerRef)();
    const generatedId = (0, $jFtVs.useUID)();
    const id = providedId || generatedId;
    const renderPopperWrapper = /*#__PURE__*/ (0, $byn9U.jsx)((0, $etCs9.UNSAFE_LAYERING), {
        isDisabled: false
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $glmoE.default), {
        content: content,
        isOpen: isOpen,
        placement: placement,
        fallbackPlacements: fallbackPlacements,
        boundary: boundary,
        rootBoundary: rootBoundary,
        shouldFlip: shouldFlip,
        offset: offset,
        popupComponent: PopupContainer,
        id: id,
        testId: testId,
        onClose: onClose,
        autoFocus: autoFocus,
        shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
        shouldRenderToParent: shouldRenderToParent,
        shouldDisableFocusLock: shouldDisableFocusLock,
        triggerRef: triggerRef,
        strategy: strategy,
        role: role,
        label: label,
        titleId: titleId
    }));
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $8nlzU.Manager), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $6frYP.Reference), null, ({ ref: ref })=>{
        return trigger({
            ref: getMergedTriggerRef(ref, setTriggerRef, isOpen),
            'aria-controls': isOpen ? id : undefined,
            'aria-expanded': isOpen,
            'aria-haspopup': true
        });
    }), isOpen && (shouldRenderToParent ? renderPopperWrapper : /*#__PURE__*/ (0, $byn9U.jsx)((0, $gmZvv.default), {
        zIndex: zIndex
    }, renderPopperWrapper)));
});
var $cf1eb387401e6e84$export$2e2bcd8739ae039 = $cf1eb387401e6e84$export$129a32eedafa97c5;

});
parcelRegister("glmoE", function(module, exports) {

$parcel$export(module.exports, "default", () => $78ac3ee02e63d39e$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $eN43R = parcelRequire("eN43R");

var $XHGTv = parcelRequire("XHGTv");

var $i6BC8 = parcelRequire("i6BC8");

var $PdmhA = parcelRequire("PdmhA");

var $lcnyw = parcelRequire("lcnyw");

var $kyri3 = parcelRequire("kyri3");

var $6d4oE = parcelRequire("6d4oE");

var $7QWVu = parcelRequire("7QWVu");

var $hCFvg = parcelRequire("hCFvg");
function $78ac3ee02e63d39e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $78ac3ee02e63d39e$var$popupStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'block',
    boxSizing: 'border-box',
    zIndex: (0, $lcnyw.layers).layer(),
    flex: '1 1 auto',
    backgroundColor: `var(--ds-surface-overlay, ${(0, $PdmhA.N0)})`,
    borderRadius: "var(--ds-border-radius, 3px)",
    boxShadow: `var(--ds-shadow-overlay, ${`0 4px 8px -2px ${(0, $PdmhA.N50A)}, 0 0 1px ${(0, $PdmhA.N60A)}`})`,
    [(0, $kyri3.CURRENT_SURFACE_CSS_VAR)]: `var(--ds-surface-overlay, ${(0, $PdmhA.N0)})`,
    '&:focus': {
        outline: 'none'
    }
});
const $78ac3ee02e63d39e$var$popupOverflowStyles = {
    name: "1qmr6ab",
    styles: "overflow:auto"
};
// disables iframe pointer events while popup is open, except if iframe is nested inside popup
// solves an issue of popup not being closed on iframe click
const $78ac3ee02e63d39e$var$blockPointerEventsOnExternalIframeStyles = {
    name: "14jbkx2",
    styles: "iframe:not([data-ds--level] iframe){pointer-events:none;}"
};
const $78ac3ee02e63d39e$var$DefaultPopupComponent = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { shouldRenderToParent: shouldRenderToParent, children: children, ...htmlAttributes } = props;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $78ac3ee02e63d39e$var$popupStyles,
            !shouldRenderToParent && $78ac3ee02e63d39e$var$popupOverflowStyles
        ],
        ...htmlAttributes,
        ref: ref
    }, children);
});
function $78ac3ee02e63d39e$var$PopperWrapper({ isOpen: isOpen, id: id, offset: offset, testId: testId, content: content, fallbackPlacements: fallbackPlacements, onClose: onClose, boundary: boundary, rootBoundary: rootBoundary, shouldFlip: shouldFlip, placement: placement = 'auto', popupComponent: PopupContainer = $78ac3ee02e63d39e$var$DefaultPopupComponent, autoFocus: autoFocus = true, triggerRef: triggerRef, shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick, shouldRenderToParent: shouldRenderToParent, shouldDisableFocusLock: shouldDisableFocusLock, strategy: strategy, role: role, label: label, titleId: titleId }) {
    const [popupRef, setPopupRef] = (0, $eUqFw.useState)(null);
    const [initialFocusRef, setInitialFocusRef] = (0, $eUqFw.useState)(null);
    // We have cases when we need to prohibit focus locking
    // e.g. in DropdownMenu
    const shouldCloseOnTab = shouldRenderToParent && shouldDisableFocusLock;
    (0, $hCFvg.useFocusManager)({
        initialFocusRef: initialFocusRef,
        popupRef: popupRef,
        shouldCloseOnTab: shouldCloseOnTab
    });
    (0, $7QWVu.useCloseManager)({
        isOpen: isOpen,
        onClose: onClose,
        popupRef: popupRef,
        triggerRef: triggerRef,
        shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
        shouldCloseOnTab: shouldCloseOnTab
    });
    const { currentLevel: currentLevel } = (0, $eN43R.UNSAFE_useLayering)();
    const modifiers = (0, $eUqFw.useMemo)(()=>[
            {
                name: 'flip',
                enabled: shouldFlip,
                options: {
                    rootBoundary: rootBoundary,
                    boundary: boundary,
                    fallbackPlacements: fallbackPlacements
                }
            }
        ], [
        shouldFlip,
        rootBoundary,
        boundary,
        fallbackPlacements
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $i6BC8.Popper), {
        placement: placement,
        offset: offset,
        modifiers: modifiers,
        strategy: strategy
    }, ({ ref: ref, style: style, placement: placement, update: update })=>{
        return /*#__PURE__*/ (0, $byn9U.jsx)(PopupContainer, {
            id: id,
            "data-ds--level": currentLevel,
            "data-placement": placement,
            "data-testid": testId,
            role: role,
            "aria-label": label,
            "aria-labelledby": titleId,
            ref: (node)=>{
                if (node) {
                    if (typeof ref === 'function') ref(node);
                    else ref.current = node;
                    setPopupRef(node);
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: style,
            // using tabIndex={-1} would cause a bug where Safari focuses
            // first on the browser address bar when using keyboard
            tabIndex: autoFocus ? 0 : undefined,
            shouldRenderToParent: shouldRenderToParent
        }, (0, $XHGTv.getBooleanFF)('platform.design-system-team.iframe_gojiv') && /*#__PURE__*/ (0, $byn9U.jsx)((0, $byn9U.Global), {
            styles: $78ac3ee02e63d39e$var$blockPointerEventsOnExternalIframeStyles
        }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $6d4oE.RepositionOnUpdate), {
            update: update
        }, content({
            update: update,
            isOpen: isOpen,
            onClose: onClose,
            setInitialFocusRef: setInitialFocusRef
        })));
    });
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$78ac3ee02e63d39e$export$2e2bcd8739ae039 = $78ac3ee02e63d39e$var$PopperWrapper;

});
parcelRegister("6d4oE", function(module, exports) {

$parcel$export(module.exports, "RepositionOnUpdate", () => $4978713e116e51ec$export$51eddd7655ca235a);

var $eUqFw = parcelRequire("eUqFw");
const $4978713e116e51ec$export$51eddd7655ca235a = ({ children: children, update: update })=>{
    // Ref used here to skip update on first render (when refs haven't been set)
    const isFirstRenderRef = (0, $eUqFw.useRef)(true);
    (0, $eUqFw.useLayoutEffect)(()=>{
        if (isFirstRenderRef.current) {
            isFirstRenderRef.current = false;
            return;
        }
        // callback function from popper that repositions pop-up on content Update
        update();
    }, [
        update
    ]);
    // wrapping in fragment to make TS happy (known issue with FC returning children)
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), null, children);
};

});

parcelRegister("7QWVu", function(module, exports) {

$parcel$export(module.exports, "useCloseManager", () => $b54c0fc5e1b578fa$export$92dae2778ae88f9d);
// eslint-disable-next-line @typescript-eslint/consistent-type-imports

var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

var $5Q9wj = parcelRequire("5Q9wj");

var $eN43R = parcelRequire("eN43R");

var $XHGTv = parcelRequire("XHGTv");
const $b54c0fc5e1b578fa$export$92dae2778ae88f9d = ({ isOpen: isOpen, onClose: onClose, popupRef: popupRef, triggerRef: triggerRef, shouldUseCaptureOnOutsideClick: capture, shouldCloseOnTab: shouldCloseOnTab })=>{
    const { isLayerDisabled: isLayerDisabled, currentLevel: currentLevel } = (0, $eN43R.UNSAFE_useLayering)();
    (0, $eUqFw.useEffect)(()=>{
        if (!isOpen || !popupRef) return 0, $5Q9wj.default;
        const closePopup = (event)=>{
            if (onClose) onClose(event);
        };
        // This check is required for cases where components like
        // Select or DDM are placed inside a Popup. A click
        // on a MenuItem or Option would close the Popup, without registering
        // a click on DDM/Select.
        // Users would have to call `onClose` manually to close the Popup in these cases.
        // You can see the bug in action here:
        // https://codesandbox.io/s/atlaskitpopup-default-forked-2eb87?file=/example.tsx:0-1788
        const onClick = (event)=>{
            const { target: target } = event;
            const doesDomNodeExist = document.body.contains(target);
            if (!doesDomNodeExist) return;
            if (isLayerDisabled() && (0, $XHGTv.getBooleanFF)('platform.design-system-team.iframe-layering_p3eb8')) //if it is a disabled layer, we need to disable its click listener.
            return;
            const isClickOnPopup = popupRef && popupRef.contains(target);
            const isClickOnTrigger = triggerRef && triggerRef.contains(target);
            if (!isClickOnPopup && !isClickOnTrigger) closePopup(event);
        };
        const onKeyDown = (event)=>{
            if (isLayerDisabled()) return;
            const { key: key } = event;
            if (key === 'Escape' || key === 'Esc' || shouldCloseOnTab && key === 'Tab') closePopup(event);
        };
        const unbind = (0, $74BVL.bindAll)(window, [
            {
                type: 'click',
                listener: onClick,
                options: {
                    capture: capture
                }
            },
            {
                type: 'keydown',
                listener: onKeyDown
            }
        ]);
        // bind onBlur event listener to fix popup not close when clicking on iframe outside
        let unbindBlur = (0, $5Q9wj.default);
        if ((0, $XHGTv.getBooleanFF)('platform.design-system-team.iframe-layering_p3eb8')) unbindBlur = (0, $74BVL.bind)(window, {
            type: 'blur',
            listener: function onBlur(e) {
                if (isLayerDisabled() || !(document.activeElement instanceof HTMLIFrameElement)) return;
                const wrapper = document.activeElement.closest('[data-ds--level]');
                if (!wrapper || currentLevel > Number(wrapper.getAttribute('data-ds--level'))) closePopup(e);
            }
        });
        return ()=>{
            unbind();
            unbindBlur();
        };
    }, [
        isOpen,
        onClose,
        popupRef,
        triggerRef,
        capture,
        isLayerDisabled,
        shouldCloseOnTab,
        currentLevel
    ]);
};

});

parcelRegister("hCFvg", function(module, exports) {

$parcel$export(module.exports, "useFocusManager", () => $277923fb09be5c23$export$10c5169755ce7bd7);

var $eUqFw = parcelRequire("eUqFw");

var $a2Ury = parcelRequire("a2Ury");

var $5Q9wj = parcelRequire("5Q9wj");
const $277923fb09be5c23$export$10c5169755ce7bd7 = ({ initialFocusRef: initialFocusRef, popupRef: popupRef, shouldCloseOnTab: shouldCloseOnTab })=>{
    (0, $eUqFw.useEffect)(()=>{
        if (!popupRef || shouldCloseOnTab) return 0, $5Q9wj.default;
        const trapConfig = {
            clickOutsideDeactivates: true,
            escapeDeactivates: true,
            initialFocus: initialFocusRef || popupRef,
            fallbackFocus: popupRef,
            returnFocusOnDeactivate: true
        };
        const focusTrap = (0, (/*@__PURE__*/$parcel$interopDefault($a2Ury)))(popupRef, trapConfig);
        let frameId = null;
        // wait for the popup to reposition itself before we focus
        frameId = requestAnimationFrame(()=>{
            frameId = null;
            focusTrap.activate();
        });
        return ()=>{
            if (frameId != null) {
                cancelAnimationFrame(frameId);
                frameId = null;
            }
            focusTrap.deactivate();
        };
    }, [
        popupRef,
        initialFocusRef,
        shouldCloseOnTab
    ]);
};

});


parcelRegister("59zSl", function(module, exports) {

$parcel$export(module.exports, "useGetMemoizedMergedTriggerRef", () => $d42cd26ca36852cb$export$7cc5c058dd769dff);

var $eUqFw = parcelRequire("eUqFw");

var $5iWql = parcelRequire("5iWql");
const $d42cd26ca36852cb$export$7cc5c058dd769dff = ()=>{
    const [getMemoizedMergedTriggerRef] = (0, $eUqFw.useState)(()=>(0, $5iWql.default)((ref, setTriggerRef, isOpen)=>{
            return (node)=>{
                if (node && isOpen) {
                    if (typeof ref === 'function') ref(node);
                    else if (ref) ref.current = node;
                    setTriggerRef(node);
                }
            };
        }));
    return getMemoizedMergedTriggerRef;
};

});



parcelRegister("iJlfe", function(module, exports) {

$parcel$export(module.exports, "default", () => $448a91e99b3083ec$export$2e2bcd8739ae039);
/** @jsx jsx */ // eslint-disable-next-line @repo/internal/fs/filename-pattern-match

var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $jFtVs = parcelRequire("jFtVs");

var $bFzGY = parcelRequire("bFzGY");

var $PdmhA = parcelRequire("PdmhA");

var $6AJyI = parcelRequire("6AJyI");

var $eri7S = parcelRequire("eri7S");

var $6PZxV = parcelRequire("6PZxV");

var $8DZtu = parcelRequire("8DZtu");

var $lcJeR = parcelRequire("lcJeR");

var $6ecEX = parcelRequire("6ecEX");
const $448a91e99b3083ec$var$packageName = undefined;
const $448a91e99b3083ec$var$packageVersion = undefined;
const $448a91e99b3083ec$var$getStyles = (css, { size: size, radius: radius, appearance: appearance, borderColor: borderColor = `var(--ds-surface-overlay, ${0, $PdmhA.N0})`, stackIndex: stackIndex, isInteractive: isInteractive, isDisabled: isDisabled })=>//eslint-disable-next-line @repo/internal/react/no-css-string-literals
    css`
		height: ${size}px;
		width: ${size}px;
		align-items: stretch;
		background-color: ${borderColor};
		border-radius: ${appearance === 'circle' ? '50%' : `${radius}px`};
		box-sizing: content-box;
		cursor: inherit;
		display: flex;
		flex-direction: column;
		justify-content: center;
		outline: none;
		overflow: hidden;
		position: static;
		transform: translateZ(0);
		transition:
			transform 200ms,
			opacity 200ms;
		box-shadow: 0 0 0 ${0, $eri7S.BORDER_WIDTH}px ${borderColor};
		border: none;
		margin: ${"var(--ds-space-025, 2px)"};
		padding: ${"var(--ds-space-0, 0px)"};

		/* Added font-size and font-family styles to fix alignment issue in firefox for interactive button avatar */
		font-size: inherit;
		font-family: inherit;

		&::-moz-focus-inner {
			border: 0;
			margin: ${"var(--ds-space-0, 0px)"};
			padding: ${"var(--ds-space-0, 0px)"};
		}

		&::after {
			background-color: transparent;
			inset: 0px;

			/* Added border-radius style to fix hover issue in safari */
			border-radius: ${appearance === 'circle' ? '50%' : `${radius}px`};
			content: ' ';
			opacity: 0;
			pointer-events: none;
			position: absolute;
			transition: opacity 200ms;
			width: 100%;
		}

		${stackIndex && `position: relative;`}

		${isInteractive && `
      cursor: pointer;

      :focus {
        outline: none;
        box-shadow: 0 0 0 ${0, $eri7S.BORDER_WIDTH}px ${`var(--ds-border-focused, ${0, $PdmhA.B300})`}
      }

      :hover {
        &::after {
          background-color: ${`var(--ds-interaction-hovered, ${0, $PdmhA.N70A})`};
          opacity: 1;
        }
      }

      :active {
        &::after {
          background-color: ${`var(--ds-interaction-pressed, ${0, $PdmhA.N70A})`};
          opacity: 1;
        }
      }

      :active {
        transform: scale(${0, $eri7S.ACTIVE_SCALE_FACTOR});
      }

      @media screen and (forced-colors: active) {
        &:focus-visible {
          outline: 1px solid
        }
      }
    `}

    ${isDisabled && `
        cursor: not-allowed;

        &::after {
          opacity: ${"var(--ds-opacity-disabled, 0.7)"};
          pointer-events: none;
          background-color: ${`var(--ds-surface, ${0, $PdmhA.N0})`};
        }
      `}
	`;
/**
 * __Avatar__
 *
 * An avatar is a visual representation of a user or entity.
 *
 * - [Examples](https://atlassian.design/components/avatar/examples)
 * - [Code](https://atlassian.design/components/avatar/code)
 * - [Usage](https://atlassian.design/components/avatar/usage)
 */ const $448a91e99b3083ec$var$Avatar = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ analyticsContext: analyticsContext, appearance: appearance = 'circle', label: label, borderColor: borderColor, children: children, href: href, isDisabled: isDisabled, name: name, onClick: onClick, presence: presence, size: sizeProp = 'medium', src: src, stackIndex: stackIndex, status: status, target: target, testId: testId, as: AvatarContainer = 'div' }, ref)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const context = (0, $6PZxV.useAvatarContext)();
    const size = context?.size || sizeProp;
    const customPresenceNode = /*#__PURE__*/ (0, $eUqFw.isValidElement)(presence) ? presence : null;
    const customStatusNode = /*#__PURE__*/ (0, $eUqFw.isValidElement)(status) ? status : null;
    const isValidIconSize = size !== 'xxlarge' && size !== 'xsmall';
    const lastAnalytics = (0, $eUqFw.useRef)(analyticsContext);
    const uuid = (0, $jFtVs.useUIDSeed)()('avatar');
    (0, $eUqFw.useEffect)(()=>{
        lastAnalytics.current = analyticsContext;
    }, [
        analyticsContext
    ]);
    const onClickHandler = (0, $eUqFw.useCallback)((event)=>{
        if (isDisabled || typeof onClick !== 'function') return;
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'avatar',
            attributes: {
                componentName: 'avatar',
                packageName: $448a91e99b3083ec$var$packageName,
                packageVersion: $448a91e99b3083ec$var$packageVersion
            }
        });
        /**
     * To avoid wrapping this component in AnalyticsContext we manually
     * push the parent context's meta data into the context.
     */ const context = {
            componentName: 'avatar',
            packageName: $448a91e99b3083ec$var$packageName,
            packageVersion: $448a91e99b3083ec$var$packageVersion,
            ...lastAnalytics.current
        };
        analyticsEvent.context.push(context);
        /**
     * Replicating the logic in the `withAnalyticsEvents` HOC.
     */ const clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        onClick(event, analyticsEvent);
    }, [
        createAnalyticsEvent,
        isDisabled,
        onClick
    ]);
    const getTestId = (testId, children)=>!children ? {
            'data-testid': `${testId}--inner`
        } : {
            testId: `${testId}--inner`
        };
    const componentProps = ()=>{
        if (isDisabled) return {
            disabled: true
        };
        // return only relevant props for either anchor or button elements
        return {
            ...href && (0, $6ecEX.getLinkProps)(href, target),
            ...onClick && !href ? (0, $6ecEX.getButtonProps)(onClickHandler) : {
                onClick: onClick
            }
        };
    };
    const isPresence = isValidIconSize && presence && !status;
    const isStatus = isValidIconSize && status;
    // add presence or status to the label by default if presence and status are passed as a string
    // if status or presence are nodes this is not added to the label by default
    const defaultLabel = [
        name,
        isStatus && !customStatusNode && `(${status})`,
        isPresence && !customPresenceNode && `(${presence})`
    ].filter(Boolean).join(' ');
    const isInteractive = onClick || href || isDisabled;
    const containerShouldBeImage = Boolean(!isInteractive && defaultLabel);
    return /*#__PURE__*/ (0, $byn9U.jsx)(AvatarContainer, {
        "data-testid": testId,
        role: containerShouldBeImage ? 'img' : undefined,
        "aria-labelledby": containerShouldBeImage ? `${uuid}-label` : undefined,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'inline-block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'relative',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            outline: 0,
            zIndex: stackIndex
        }
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $byn9U.ClassNames), null, ({ css: css })=>{
        const props = {
            className: $448a91e99b3083ec$var$getStyles(css, {
                size: (0, $eri7S.AVATAR_SIZES)[size],
                radius: (0, $eri7S.AVATAR_RADIUS)[size],
                appearance: appearance,
                borderColor: borderColor,
                stackIndex: stackIndex,
                isInteractive: Boolean(href || onClick) && !isDisabled,
                isDisabled: isDisabled
            }),
            ...componentProps(),
            ...testId && getTestId(testId, children),
            ...(isInteractive || children) && {
                'aria-label': label || defaultLabel
            },
            children: /*#__PURE__*/ (0, $byn9U.jsx)((0, $6AJyI.default), {
                // Only pass in the name if an image is provded and the
                // container is not being used as an `img` role
                alt: !containerShouldBeImage && src ? name : undefined,
                appearance: appearance,
                size: size,
                src: src,
                testId: testId
            }),
            ref: ref
        };
        return children ? children(props) : /*#__PURE__*/ (0, $eUqFw.createElement)((0, $6ecEX.getCustomElement)(isDisabled, href, onClick), props);
    }), isPresence && /*#__PURE__*/ (0, $byn9U.jsx)((0, $8DZtu.PresenceWrapper), {
        appearance: appearance,
        size: size,
        presence: typeof presence === 'string' ? presence : undefined,
        testId: testId
    }, customPresenceNode), isStatus && /*#__PURE__*/ (0, $byn9U.jsx)((0, $lcJeR.StatusWrapper), {
        appearance: appearance,
        size: size,
        borderColor: borderColor,
        status: typeof status === 'string' ? status : undefined,
        testId: testId
    }, customStatusNode), containerShouldBeImage ? /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        "data-testid": testId && `${testId}--label`,
        id: `${uuid}-label`,
        hidden: true
    }, defaultLabel) : undefined);
});
$448a91e99b3083ec$var$Avatar.displayName = 'Avatar';
var $448a91e99b3083ec$export$2e2bcd8739ae039 = $448a91e99b3083ec$var$Avatar;

});
parcelRegister("6AJyI", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd400e55ad422969$export$2e2bcd8739ae039);
/** @jsx jsx */ // eslint-disable-next-line @repo/internal/fs/filename-pattern-match

var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $cI9iM = parcelRequire("cI9iM");

var $14lY4 = parcelRequire("14lY4");

var $PdmhA = parcelRequire("PdmhA");

var $eri7S = parcelRequire("eri7S");
function $fd400e55ad422969$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $fd400e55ad422969$export$ebe0b8fe8b6acbfd = `var(--ds-icon-inverse, ${(0, $PdmhA.N0)})`;
const $fd400e55ad422969$export$72502e51aebdd94e = `var(--ds-icon-subtle, ${(0, $PdmhA.N90)})`;
const $fd400e55ad422969$var$avatarDefaultIconStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'block',
    width: '100%',
    height: '100%',
    backgroundColor: $fd400e55ad422969$export$72502e51aebdd94e
});
const $fd400e55ad422969$var$nestedAvatarStyles = Object.entries((0, $eri7S.AVATAR_SIZES)).reduce((styles, [key, size])=>{
    return {
        ...styles,
        [key]: /*#__PURE__*/ (0, $byn9U.css)({
            // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
            '& svg': {
                width: `${size}px`,
                height: `${size}px`
            }
        })
    };
}, {});
const $fd400e55ad422969$var$avatarImageStyles = {
    name: "1gr7gcv",
    styles: "display:flex;width:100%;height:100%;flex:1 1 100%"
};
/**
 * __Avatar image__
 *
 * An avatar image is an internal component used to control the rendering phases of an image.
 */ const $fd400e55ad422969$var$AvatarImage = ({ alt: alt = '', src: src, appearance: appearance, size: size, testId: testId })=>{
    const [hasImageErrored, setHasImageErrored] = (0, $eUqFw.useState)(false);
    const borderRadius = appearance === 'circle' ? '50%' : `${(0, $eri7S.AVATAR_RADIUS)[size]}px`;
    const isHidden = !alt ? true : undefined;
    // If src changes, reset state
    (0, $eUqFw.useEffect)(()=>{
        setHasImageErrored(false);
    }, [
        src
    ]);
    if (!src || hasImageErrored) return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: [
            $fd400e55ad422969$var$avatarDefaultIconStyles,
            $fd400e55ad422969$var$nestedAvatarStyles[size]
        ]
    }, appearance === 'circle' ? /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cI9iM))), {
        label: alt,
        primaryColor: $fd400e55ad422969$export$ebe0b8fe8b6acbfd,
        secondaryColor: $fd400e55ad422969$export$72502e51aebdd94e,
        testId: testId && `${testId}--person`,
        "aria-hidden": isHidden
    }) : /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($14lY4))), {
        label: alt,
        primaryColor: $fd400e55ad422969$export$ebe0b8fe8b6acbfd,
        secondaryColor: $fd400e55ad422969$export$72502e51aebdd94e,
        testId: testId && `${testId}--ship`,
        "aria-hidden": isHidden
    }));
    return /*#__PURE__*/ (0, $byn9U.jsx)("img", {
        src: src,
        alt: alt,
        "data-testid": testId && `${testId}--image`,
        css: $fd400e55ad422969$var$avatarImageStyles,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            borderRadius: borderRadius
        },
        onError: ()=>setHasImageErrored(true),
        "aria-hidden": isHidden
    });
};
var $fd400e55ad422969$export$2e2bcd8739ae039 = $fd400e55ad422969$var$AvatarImage;

});
parcelRegister("eri7S", function(module, exports) {

$parcel$export(module.exports, "AVATAR_SIZES", () => $87ac36054c2add67$export$9a270941bcff7e77);
$parcel$export(module.exports, "AVATAR_RADIUS", () => $87ac36054c2add67$export$e6da6efe4d1a5c9b);
$parcel$export(module.exports, "BORDER_WIDTH", () => $87ac36054c2add67$export$e2bd4c1faded7921);
$parcel$export(module.exports, "ACTIVE_SCALE_FACTOR", () => $87ac36054c2add67$export$89a980dfdf90df51);
$parcel$export(module.exports, "CSS_VAR_AVATAR_BGCOLOR", () => $87ac36054c2add67$export$3c061e31594ebabe);
$parcel$export(module.exports, "ICON_SIZES", () => $87ac36054c2add67$export$fdc820179f1f9be4);
$parcel$export(module.exports, "ICON_OFFSET", () => $87ac36054c2add67$export$382610e783aa2ae8);
// eslint-disable-next-line @repo/internal/fs/filename-pattern-match, @atlaskit/design-system/no-deprecated-imports

var $lcnyw = parcelRequire("lcnyw");
const $87ac36054c2add67$export$9a270941bcff7e77 = {
    xsmall: (0, $lcnyw.gridSize)() * 2,
    small: (0, $lcnyw.gridSize)() * 3,
    medium: (0, $lcnyw.gridSize)() * 4,
    large: (0, $lcnyw.gridSize)() * 5,
    xlarge: (0, $lcnyw.gridSize)() * 12,
    xxlarge: (0, $lcnyw.gridSize)() * 16
};
const $87ac36054c2add67$export$e6da6efe4d1a5c9b = {
    xsmall: 2,
    small: 2,
    medium: 3,
    large: 3,
    xlarge: 6,
    xxlarge: 12
};
const $87ac36054c2add67$export$e2bd4c1faded7921 = 2;
const $87ac36054c2add67$export$89a980dfdf90df51 = 0.9;
const $87ac36054c2add67$export$3c061e31594ebabe = '--avatar-background-color';
const $87ac36054c2add67$export$fdc820179f1f9be4 = {
    small: 12,
    medium: 14,
    large: 15,
    xlarge: 18
};
const $87ac36054c2add67$export$382610e783aa2ae8 = {
    small: 0,
    medium: 0,
    large: 1,
    xlarge: 7
};

});


parcelRegister("6PZxV", function(module, exports) {

$parcel$export(module.exports, "AvatarContext", () => $13bd4a9d2b547d84$export$a20dad690e1279e2);
$parcel$export(module.exports, "useAvatarContext", () => $13bd4a9d2b547d84$export$b50b87a1c4086b23);

var $eUqFw = parcelRequire("eUqFw");
const $13bd4a9d2b547d84$export$a20dad690e1279e2 = /*#__PURE__*/ (0, $eUqFw.createContext)(undefined);
const $13bd4a9d2b547d84$export$b50b87a1c4086b23 = ()=>(0, $eUqFw.useContext)($13bd4a9d2b547d84$export$a20dad690e1279e2);

});

parcelRegister("8DZtu", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c823831f9e985b0$export$2e2bcd8739ae039);
$parcel$export(module.exports, "PresenceWrapper", () => $6c823831f9e985b0$export$972c5e90200fa0ef);
// eslint-disable-next-line @repo/internal/fs/filename-pattern-match

var $eUqFw = parcelRequire("eUqFw");

var $PdmhA = parcelRequire("PdmhA");

var $eri7S = parcelRequire("eri7S");

var $j53Tc = parcelRequire("j53Tc");
const $6c823831f9e985b0$var$BusyIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("circle", {
    fill: `var(--ds-icon-danger, ${(0, $PdmhA.R300)})`,
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
    fill: `var(--ds-surface-overlay, ${(0, $PdmhA.N0)})`,
    d: "M3.3,1.9l2.8,2.8c0.2,0.2,0.2,0.5,0,0.7L5.4,6.1c-0.2,0.2-0.5,0.2-0.7,0L1.9,3.3c-0.2-0.2-0.2-0.5,0-0.7l0.7-0.7C2.8,1.7,3.1,1.7,3.3,1.9z"
}));
const $6c823831f9e985b0$var$FocusIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
    fill: `var(--ds-icon-discovery, ${(0, $PdmhA.P300)})`,
    d: "M4,8 C1.790861,8 0,6.209139 0,4 C0,1.790861 1.790861,0 4,0 C6.209139,0 8,1.790861 8,4 C8,6.209139 6.209139,8 4,8 Z M4,6.66666667 C5.47275933,6.66666667 6.66666667,5.47275933 6.66666667,4 C6.66666667,2.52724067 5.47275933,1.33333333 4,1.33333333 C2.52724067,1.33333333 1.33333333,2.52724067 1.33333333,4 C1.33333333,5.47275933 2.52724067,6.66666667 4,6.66666667 Z M4,5.33333333 C3.26362033,5.33333333 2.66666667,4.73637967 2.66666667,4 C2.66666667,3.26362033 3.26362033,2.66666667 4,2.66666667 C4.73637967,2.66666667 5.33333333,3.26362033 5.33333333,4 C5.33333333,4.73637967 4.73637967,5.33333333 4,5.33333333 Z"
}));
const $6c823831f9e985b0$var$OfflineIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
    fill: `var(--ds-text-subtlest, ${(0, $PdmhA.N200)})`,
    d: "M4,8 C6.209139,8 8,6.209139 8,4 C8,1.790861 6.209139,0 4,0 C1.790861,0 0,1.790861 0,4 C0,6.209139 1.790861,8 4,8 Z M4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 Z"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
    fill: `var(--ds-surface-overlay, ${(0, $PdmhA.N40)})`,
    d: "M4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 Z"
}));
const $6c823831f9e985b0$var$OnlineIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("circle", {
    fill: `var(--ds-icon-success, ${(0, $PdmhA.G300)})`,
    cx: "4",
    cy: "4",
    r: "4"
});
function $6c823831f9e985b0$var$getPresence(presence) {
    switch(presence){
        case 'busy':
            return $6c823831f9e985b0$var$BusyIndicator;
        case 'focus':
            return $6c823831f9e985b0$var$FocusIndicator;
        case 'offline':
            return $6c823831f9e985b0$var$OfflineIndicator;
        case 'online':
            return $6c823831f9e985b0$var$OnlineIndicator;
    }
}
/**
 * __Avatar presence__
 *
 * A presence shows an avatar’s availability.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-presence/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-presence/code)
 * - [Usage](https://atlassian.design/components/avatar/avatar-presence/usage)
 */ const $6c823831f9e985b0$var$AvatarPresence = ({ borderColor: borderColor, children: children, presence: presence })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j53Tc.default), {
        bgColor: borderColor
    }, presence ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        height: "100%",
        version: "1.1",
        viewBox: "0 0 8 8",
        width: "100%",
        xmlns: "http://www.w3.org/2000/svg"
    }, $6c823831f9e985b0$var$getPresence(presence)) : children);
var $6c823831f9e985b0$export$2e2bcd8739ae039 = $6c823831f9e985b0$var$AvatarPresence;
const $6c823831f9e985b0$export$972c5e90200fa0ef = ({ size: size, appearance: appearance, children: children, borderColor: borderColor, presence: presence, testId: testId })=>{
    const position = appearance === 'square' ? -4 : (0, $eri7S.ICON_OFFSET)[size];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        "aria-hidden": "true",
        "data-testid": testId && `${testId}--presence`,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            pointerEvents: 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute',
            bottom: `${position}px`,
            height: `${(0, $eri7S.ICON_SIZES)[size]}px`,
            right: `${position}px`,
            width: `${(0, $eri7S.ICON_SIZES)[size]}px`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6c823831f9e985b0$var$AvatarPresence, {
        borderColor: borderColor,
        presence: !children ? presence : undefined
    }, children));
};

});
parcelRegister("j53Tc", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d8c16c039483b9f$export$2e2bcd8739ae039);
/** @jsx jsx */ // eslint-disable-next-line @repo/internal/fs/filename-pattern-match

var $byn9U = parcelRequire("byn9U");

var $PdmhA = parcelRequire("PdmhA");

var $eri7S = parcelRequire("eri7S");
function $8d8c16c039483b9f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $8d8c16c039483b9f$var$iconWrapperStyles = {
    name: "1kwqznv",
    styles: "display:flex;box-sizing:border-box;width:100%;height:100%;align-items:center;align-content:center;border-radius:var(--ds-border-radius-circle, 50%);overflow:hidden"
};
/**
 * __Icon wrapper__
 *
 * An icon wrapper is used internally only.
 */ const $8d8c16c039483b9f$var$IconWrapper = ({ bgColor: bgColor = `var(--ds-surface-overlay, ${0, $PdmhA.N0})`, children: children })=>/*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $8d8c16c039483b9f$var$iconWrapperStyles,
        role: "presentation",
        style: {
            border: `${(0, $eri7S.BORDER_WIDTH)}px solid ${bgColor}`,
            backgroundColor: bgColor
        }
    }, children);
var $8d8c16c039483b9f$export$2e2bcd8739ae039 = $8d8c16c039483b9f$var$IconWrapper;

});


parcelRegister("lcJeR", function(module, exports) {

$parcel$export(module.exports, "default", () => $09a193fba3c21822$export$2e2bcd8739ae039);
$parcel$export(module.exports, "StatusWrapper", () => $09a193fba3c21822$export$8045894f255f9726);
// eslint-disable-next-line @repo/internal/fs/filename-pattern-match

var $eUqFw = parcelRequire("eUqFw");

var $PdmhA = parcelRequire("PdmhA");

var $eri7S = parcelRequire("eri7S");

var $j53Tc = parcelRequire("j53Tc");
const $09a193fba3c21822$var$ApprovedIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("circle", {
    fill: `var(--ds-icon-success, ${(0, $PdmhA.G400)})`,
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
    fill: `var(--ds-surface-overlay, ${(0, $PdmhA.N0)})`,
    d: "M2.47140452,3.52859548 C2.21105499,3.26824595 1.78894501,3.26824595 1.52859548,3.52859548 C1.26824595,3.78894501 1.26824595,4.21105499 1.52859548,4.47140452 L2.86192881,5.80473785 C3.12227834,6.06508738 3.54438833,6.06508738 3.80473785,5.80473785 L6.47140452,3.13807119 C6.73175405,2.87772166 6.73175405,2.45561167 6.47140452,2.19526215 C6.21105499,1.93491262 5.78894501,1.93491262 5.52859548,2.19526215 L3.33333333,4.39052429 L2.47140452,3.52859548 Z"
}));
const $09a193fba3c21822$var$DeclinedIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("circle", {
    fill: `var(--ds-icon-danger, ${(0, $PdmhA.R400)})`,
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
    fill: `var(--ds-surface-overlay, ${(0, $PdmhA.N0)})`,
    d: "M4.890661,4.0088336 L5.81806461,3.07802178 C6.06167933,2.83351177 6.06048933,2.43826992 5.81540668,2.19522442 C5.57032402,1.95217891 5.17415651,1.95336612 4.93054179,2.19787613 L4.00765946,3.12415007 L3.06906871,2.18377143 C2.82523777,1.93947602 2.42906937,1.93863765 2.18420182,2.18189887 C1.93933427,2.42516008 1.93849394,2.82040282 2.18232488,3.06469822 L3.12544091,4.00961077 L2.20275024,4.93569234 C1.95913552,5.18020236 1.96032551,5.5754442 2.20540817,5.81848971 C2.45049083,6.06153521 2.84665833,6.060348 3.09027306,5.81583799 L4.00844245,4.89429431 L4.9092123,5.79678001 C5.15304324,6.04107541 5.54921164,6.04191379 5.79407919,5.79865257 C6.03894674,5.55539135 6.03978708,5.16014862 5.79595614,4.91585321 L4.890661,4.0088336 Z"
}));
const $09a193fba3c21822$var$LockedIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("circle", {
    fill: `var(--ds-text-subtlest, ${(0, $PdmhA.N40)})`,
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
    fill: `var(--ds-surface-overlay, ${(0, $PdmhA.N500)})`,
    d: "M4.13074827,1.21766493 L4.10368158,1.21766493 C3.36340745,1.21766493 2.76388015,1.80793503 2.76388015,2.5367787 L2.76388015,3.21632216 L3.44054754,3.21632216 L3.44054754,2.54344089 C3.44054754,2.17901906 3.74031119,1.88388401 4.11044825,1.88388401 L4.1239816,1.88388401 C4.49411866,1.88388401 4.79388232,2.17901906 4.79388232,2.54344089 L4.79388232,3.21632216 L5.47054971,3.21632216 L5.47054971,2.5367787 C5.47054971,1.80793503 4.8710224,1.21766493 4.13074827,1.21766493 M2.76388015,3.21632216 L3.44054754,3.21632216 L3.44054754,3.88254123 L2.76388015,3.88254123 L2.76388015,3.21632216 Z M4.79388232,3.21632216 L5.47054971,3.21632216 L5.47054971,3.88254123 L4.79388232,3.88254123 L4.79388232,3.21632216 Z M4.79401765,3.88254123 L3.44068287,3.88254123 L2.76401548,3.88254123 C2.39049508,3.88254123 2.08734809,4.18100738 2.08734809,4.54876031 L2.08734809,5.54808892 C2.08734809,6.10000287 2.53735205,6.54741753 3.09094491,6.54741753 L5.14375561,6.54741753 C5.69802683,6.54741753 6.14735243,6.10385072 6.14735243,5.54808892 L6.14735243,4.54876031 C6.14735243,4.18100738 5.84420544,3.88254123 5.47068504,3.88254123 L4.79401765,3.88254123 Z"
}));
function $09a193fba3c21822$var$getStatus(status) {
    switch(status){
        case 'approved':
            return $09a193fba3c21822$var$ApprovedIndicator;
        case 'declined':
            return $09a193fba3c21822$var$DeclinedIndicator;
        case 'locked':
            return $09a193fba3c21822$var$LockedIndicator;
    }
}
/**
 * __Avatar status__
 *
 * An avatar status shows contextual information, such as if someone approves or declines something.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-status/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-status/code)
 */ const $09a193fba3c21822$var$AvatarStatus = ({ borderColor: borderColor, children: children, status: status })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j53Tc.default), {
        bgColor: borderColor
    }, status ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        height: "100%",
        version: "1.1",
        viewBox: "0 0 8 8",
        width: "100%",
        xmlns: "http://www.w3.org/2000/svg"
    }, $09a193fba3c21822$var$getStatus(status)) : children);
var $09a193fba3c21822$export$2e2bcd8739ae039 = $09a193fba3c21822$var$AvatarStatus;
const $09a193fba3c21822$export$8045894f255f9726 = ({ size: size, status: status, appearance: appearance, borderColor: borderColor, children: children, testId: testId })=>{
    const position = appearance === 'square' ? 0 : (0, $eri7S.ICON_OFFSET)[size];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        "aria-hidden": "true",
        "data-testid": testId && `${testId}--status`,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute',
            height: `${(0, $eri7S.ICON_SIZES)[size]}px`,
            right: `${position}px`,
            top: `${position}px`,
            width: `${(0, $eri7S.ICON_SIZES)[size]}px`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($09a193fba3c21822$var$AvatarStatus, {
        borderColor: borderColor,
        status: !children ? status : undefined
    }, children));
};

});

parcelRegister("6ecEX", function(module, exports) {

$parcel$export(module.exports, "getLinkProps", () => $76f3d55517805afd$export$60113ebe1cf0ecf);
$parcel$export(module.exports, "getButtonProps", () => $76f3d55517805afd$export$cca6f1bef43616d3);
$parcel$export(module.exports, "getCustomElement", () => $76f3d55517805afd$export$83ee468102cdf04c);
// eslint-disable-next-line @repo/internal/fs/filename-pattern-match
const $76f3d55517805afd$export$60113ebe1cf0ecf = (href, target)=>({
        href: href,
        rel: target === '_blank' ? 'noopener noreferrer' : null,
        target: target
    });
const $76f3d55517805afd$export$cca6f1bef43616d3 = (onClick)=>({
        type: 'button',
        onClick: onClick
    });
const $76f3d55517805afd$export$83ee468102cdf04c = (isDisabled, href, onClick)=>{
    if (href && !isDisabled) return 'a';
    if (onClick || isDisabled) return 'button';
    return 'span';
};

});


parcelRegister("6OfWd", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd131b446ad30d0e$export$2e2bcd8739ae039);
/* eslint-disable import/order */ 
var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

var $6zOB7 = parcelRequire("6zOB7");


var $1lQG9 = parcelRequire("1lQG9");

var $5Q9wj = parcelRequire("5Q9wj");

var $2WwAS = parcelRequire("2WwAS");

var $7PTrT = parcelRequire("7PTrT");

var $86Ndv = parcelRequire("86Ndv");

var $3MV1G = parcelRequire("3MV1G");

var $lcnyw = parcelRequire("lcnyw");

var $dkYal = parcelRequire("dkYal");

var $jiH6M = parcelRequire("jiH6M");

var $7mYCs = parcelRequire("7mYCs");

var $h1Q9j = parcelRequire("h1Q9j");

var $8gwL5 = parcelRequire("8gwL5");
const $cd131b446ad30d0e$var$gridSize = (0, $lcnyw.gridSize)();
const $cd131b446ad30d0e$var$MAX_HEIGHT = `calc(100vh - ${$cd131b446ad30d0e$var$gridSize * 2}px)`;
const $cd131b446ad30d0e$var$opposites = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left',
    start: 'end',
    auto: 'auto',
    end: 'start'
};
const $cd131b446ad30d0e$var$getFallbackPlacements = (placement)=>{
    const placementPieces = placement.split('-');
    const mainAxis = placementPieces[0];
    // Left, right and auto placements can rely on standard popper sliding behaviour
    if (![
        'top',
        'bottom'
    ].includes(mainAxis)) return undefined;
    else if (placementPieces.length === 2 && [
        'start',
        'end'
    ].includes(placementPieces[1])) {
        const crossAxis = placementPieces[1];
        return [
            `${mainAxis}`,
            `${mainAxis}-${$cd131b446ad30d0e$var$opposites[crossAxis]}`,
            `${$cd131b446ad30d0e$var$opposites[mainAxis]}-${crossAxis}`,
            `${$cd131b446ad30d0e$var$opposites[mainAxis]}`,
            `${$cd131b446ad30d0e$var$opposites[mainAxis]}-${$cd131b446ad30d0e$var$opposites[crossAxis]}`,
            'auto'
        ];
    } else return [
        `${mainAxis}-start`,
        `${mainAxis}-end`,
        `${$cd131b446ad30d0e$var$opposites[mainAxis]}`,
        `${$cd131b446ad30d0e$var$opposites[mainAxis]}-start`,
        `${$cd131b446ad30d0e$var$opposites[mainAxis]}-end`,
        `auto`
    ];
};
/**
 * __Dropdown menu__
 *
 * A dropdown menu displays a list of actions or options to a user.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/usage)
 */ const $cd131b446ad30d0e$var$DropdownMenu = ({ autoFocus: autoFocus = false, children: children, defaultOpen: defaultOpen = false, isLoading: isLoading = false, isOpen: isOpen, onOpenChange: onOpenChange = (0, $5Q9wj.default), placement: placement = 'bottom-start', shouldFlip: shouldFlip = true, shouldRenderToParent: shouldRenderToParent = false, spacing: spacing, statusLabel: statusLabel, testId: testId, trigger: trigger, zIndex: zIndex = (0, $lcnyw.layers).modal(), label: label })=>{
    const [isLocalOpen, setLocalIsOpen] = (0, $2WwAS.default)(isOpen, ()=>defaultOpen);
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $eUqFw.useState)(false);
    const id = (0, $8gwL5.default)();
    const itemRef = (0, $h1Q9j.default)();
    const fallbackPlacements = (0, $eUqFw.useMemo)(()=>$cd131b446ad30d0e$var$getFallbackPlacements(placement), [
        placement
    ]);
    const handleTriggerClicked = (0, $eUqFw.useCallback)(// TODO: event is an `any` and is being cast incorrectly
    // This means that the public type for `onOpenChange` is incorrect
    // current: (event: React.MouseEvent | React.KeyboardEvent) => void;
    // correct: (event: React.MouseEvent | KeyboardEvent) => void;
    // https://product-fabric.atlassian.net/browse/DSP-4692
    (event)=>{
        const newValue = !isLocalOpen;
        const { clientX: clientX, clientY: clientY, type: type, detail: detail } = event;
        if (type === 'keydown') setTriggeredUsingKeyboard(true);
        else if (clientX === 0 || clientY === 0) // Hitting enter/space is registered as a click
        // with both clientX and clientY === 0
        setTriggeredUsingKeyboard(true);
        else if (detail === 0) // Fix for Safari. clientX and clientY !== 0 in Safari
        setTriggeredUsingKeyboard(true);
        else {
            // The trigger element must be focused to avoid problems with an incorrectly focused element after closing DropdownMenu
            itemRef?.current?.focus();
            setTriggeredUsingKeyboard(false);
        }
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        itemRef,
        onOpenChange,
        isLocalOpen,
        setLocalIsOpen
    ]);
    const handleOnClose = (0, $eUqFw.useCallback)((event)=>{
        if (event.key !== 'Escape' && event.key !== 'Tab' && event.target?.closest?.(`[id^=${(0, $8gwL5.PREFIX)}] [aria-haspopup]`)) // Check if it is within dropdown and it is a trigger button
        // if it is a nested dropdown, clicking trigger won't close the dropdown
        // Dropdown can be closed by pressing Escape, Tab or Shift + Tab
        return;
        if (event.key === 'Tab' && event.shiftKey || event.key === 'Escape') requestAnimationFrame(()=>{
            itemRef.current?.focus();
        });
        const newValue = false;
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        onOpenChange,
        setLocalIsOpen,
        itemRef
    ]);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $7PTrT.default)();
    // When a trigger is focused, we want to open the dropdown if
    // the user presses the DownArrow
    (0, $eUqFw.useEffect)(()=>{
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $5Q9wj.default;
        // Being safe: we don't want to open the dropdown if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isLocalOpen) return 0, $5Q9wj.default;
        return (0, $74BVL.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                let isNestedTriggerButton;
                if (e.target instanceof HTMLElement) isNestedTriggerButton = e.target.closest(`[id^=${(0, $8gwL5.PREFIX)}] [aria-haspopup]`);
                if (e.key === (0, $54717ce5fa2c74b1$export$a80636c6f41931fe) && !isNestedTriggerButton) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                } else if ((e.code === (0, $54717ce5fa2c74b1$export$e51a3576c045c8d5) || e.key === (0, $54717ce5fa2c74b1$export$8152f929a25a0ff4)) && e.detail === 0) // This allows us to focus on the first element if the dropdown was triggered by a custom trigger with a custom onClick
                setTriggeredUsingKeyboard(true);
                else if (e.key === (0, $54717ce5fa2c74b1$export$10f6869ed0a7d75b) && isNestedTriggerButton) // This closes dropdown if it is a nested dropdown
                handleOnClose(e);
            }
        });
    }, [
        isFocused,
        isLocalOpen,
        handleTriggerClicked,
        handleOnClose
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7mYCs.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        id: isLocalOpen ? id : undefined,
        shouldFlip: shouldFlip,
        isOpen: isLocalOpen,
        onClose: handleOnClose,
        zIndex: zIndex,
        placement: placement,
        fallbackPlacements: fallbackPlacements,
        testId: testId && `${testId}--content`,
        shouldUseCaptureOnOutsideClick: true,
        shouldRenderToParent: shouldRenderToParent,
        shouldDisableFocusLock: true,
        trigger: ({ ref: ref, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, // DSP-13312 TODO: remove spread props in future major release
        ...rest })=>{
            if (typeof trigger === 'function') return trigger({
                'aria-controls': ariaControls,
                'aria-expanded': ariaExpanded,
                'aria-haspopup': ariaHasPopup,
                ...rest,
                ...bindFocus,
                triggerRef: (0, $1lQG9.default)([
                    ref,
                    itemRef
                ]),
                isSelected: isLocalOpen,
                onClick: handleTriggerClicked,
                testId: testId && `${testId}--trigger`
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zOB7.default), {
                ...bindFocus,
                ref: (0, $1lQG9.default)([
                    ref,
                    itemRef
                ]),
                "aria-controls": ariaControls,
                "aria-expanded": ariaExpanded,
                "aria-haspopup": ariaHasPopup,
                isSelected: isLocalOpen,
                iconAfter: (0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))),
                onClick: handleTriggerClicked,
                testId: testId && `${testId}--trigger`,
                "aria-label": label
            }, trigger);
        },
        content: ({ setInitialFocusRef: setInitialFocusRef, update: update })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dkYal.default), {
                onClose: handleOnClose
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jiH6M.default), {
                spacing: spacing,
                maxHeight: $cd131b446ad30d0e$var$MAX_HEIGHT,
                maxWidth: 800,
                onClose: handleOnClose,
                onUpdate: update,
                isLoading: isLoading,
                statusLabel: statusLabel,
                setInitialFocusRef: isTriggeredUsingKeyboard || autoFocus ? setInitialFocusRef : undefined,
                shouldRenderToParent: shouldRenderToParent,
                isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
                autoFocus: autoFocus,
                testId: testId && `${testId}--menu-wrapper`
            }, children))
    }));
};
var $cd131b446ad30d0e$export$2e2bcd8739ae039 = $cd131b446ad30d0e$var$DropdownMenu;

});
parcelRegister("6zOB7", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a8bd316b08fe19e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4ZL0y = parcelRequire("4ZL0y");

var $3Ucf8 = parcelRequire("3Ucf8");
/**
 * __Button__
 *
 * A button triggers an event or action.
 *
 * - [Examples](https://atlassian.design/components/button/examples)
 * - [Code](https://atlassian.design/components/button/code)
 * - [Usage](https://atlassian.design/components/button/usage)
 */ const $4a8bd316b08fe19e$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef(function Button({ analyticsContext: analyticsContext, appearance: appearance, autoFocus: autoFocus, children: children, iconAfter: iconAfter, iconBefore: iconBefore, interactionName: interactionName, isDisabled: isDisabled, isLoading: isLoading, isSelected: isSelected, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, overlay: overlay, shouldFitContainer: shouldFitContainer, spacing: spacing, testId: testId, type: type = 'button', UNSAFE_iconAfter_size: UNSAFE_iconAfter_size, UNSAFE_iconBefore_size: UNSAFE_iconBefore_size, ...rest }, ref) {
    const baseProps = (0, $3Ucf8.default)({
        analyticsContext: analyticsContext,
        appearance: appearance,
        autoFocus: autoFocus,
        buttonType: 'button',
        children: children,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        interactionName: interactionName,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchEndCapture: onTouchEndCapture,
        onTouchStartCapture: onTouchStartCapture,
        overlay: overlay,
        ref: ref,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        UNSAFE_iconAfter_size: UNSAFE_iconAfter_size,
        UNSAFE_iconBefore_size: UNSAFE_iconBefore_size
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ZL0y.default), {
        ...rest,
        ref: baseProps.ref,
        xcss: baseProps.xcss,
        isDisabled: baseProps.isDisabled,
        onClick: baseProps.onClick,
        onMouseDownCapture: baseProps.onMouseDownCapture,
        onMouseUpCapture: baseProps.onMouseUpCapture,
        onKeyDownCapture: baseProps.onKeyDownCapture,
        onKeyUpCapture: baseProps.onKeyUpCapture,
        onTouchStartCapture: baseProps.onTouchStartCapture,
        onTouchEndCapture: baseProps.onTouchEndCapture,
        onPointerDownCapture: baseProps.onPointerDownCapture,
        onPointerUpCapture: baseProps.onPointerUpCapture,
        onClickCapture: baseProps.onClickCapture,
        type: type,
        testId: testId,
        analyticsContext: analyticsContext,
        interactionName: interactionName,
        componentName: "Button"
    }, baseProps.children);
}));
$4a8bd316b08fe19e$var$Button.displayName = 'Button';
var $4a8bd316b08fe19e$export$2e2bcd8739ae039 = $4a8bd316b08fe19e$var$Button;

});
parcelRegister("3Ucf8", function(module, exports) {

$parcel$export(module.exports, "default", () => $84f5605b031ec678$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3ICHT = parcelRequire("3ICHT");

var $byjW4 = parcelRequire("byjW4");

var $fE1y3 = parcelRequire("fE1y3");
/**
 * __Use default button base__
 *
 * A React hook that accepts a set of default Button props,
 * and processes them to return consistent base props for usage
 * across Button and LinkButton variants.
 *
 * @private
 */ const $84f5605b031ec678$var$useDefaultButton = ({ analyticsContext: analyticsContext, appearance: appearance, autoFocus: autoFocus, buttonType: buttonType, children: children, iconAfter: IconAfter, iconBefore: IconBefore, interactionName: interactionName, isDisabled: isDisabled, isLoading: isLoading = false, isSelected: isSelected, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, overlay: overlay, ref: ref, shouldFitContainer: shouldFitContainer, spacing: spacing, UNSAFE_iconAfter_size: UNSAFE_iconAfter_size, UNSAFE_iconBefore_size: UNSAFE_iconBefore_size })=>{
    const hasOverlay = Boolean(overlay || isLoading);
    const baseProps = (0, $fE1y3.default)({
        analyticsContext: analyticsContext,
        appearance: appearance,
        autoFocus: autoFocus,
        buttonType: buttonType,
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), null, IconBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3ICHT.default), {
            type: "icon",
            position: "before",
            hasOverlay: hasOverlay
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(IconBefore, {
            label: "",
            size: UNSAFE_iconBefore_size,
            color: 'currentColor'
        })), children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3ICHT.default), {
            hasOverlay: hasOverlay
        }, children), IconAfter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3ICHT.default), {
            type: "icon",
            position: "after",
            hasOverlay: hasOverlay
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(IconAfter, {
            label: "",
            size: UNSAFE_iconAfter_size,
            color: 'currentColor'
        }))),
        interactionName: interactionName,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        onClick: onClick,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture,
        overlay: isLoading ? (0, $byjW4.default)({
            spacing: spacing,
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }) : overlay,
        ref: ref,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        hasIconBefore: Boolean(IconBefore),
        hasIconAfter: Boolean(IconAfter)
    });
    return baseProps;
};
var $84f5605b031ec678$export$2e2bcd8739ae039 = $84f5605b031ec678$var$useDefaultButton;

});
parcelRegister("3ICHT", function(module, exports) {

$parcel$export(module.exports, "default", () => $4778d4b230a21253$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");
const $4778d4b230a21253$var$textStyles = (0, $1ZAYh.xcss)({
    // content can grow and shrink
    flexGrow: 1,
    flexShrink: 1,
    // ellipsis for overflow text
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
const $4778d4b230a21253$var$iconStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    // icon size cannot grow and shrink
    flexGrow: 0,
    flexShrink: 0,
    alignSelf: 'center',
    fontSize: 0,
    lineHeight: 0,
    userSelect: 'none'
});
const $4778d4b230a21253$var$commonStyles = (0, $1ZAYh.xcss)({
    transition: 'opacity 0.3s'
});
const $4778d4b230a21253$var$fadeStyles = (0, $1ZAYh.xcss)({
    opacity: 0
});
/**
 * These CSS variables consumed by the new icons, to allow them to have appropriate
 * padding inside Button while also maintaining spacing for the existing icons.
 *
 * These styles can be removed once the new icons are fully rolled out, feature flag
 * platform.design-system-team.enable-new-icons is cleaned up,
 * and we bump Button to set padding based on the new icons.
 */ const $4778d4b230a21253$var$beforeIconStyles = (0, $1ZAYh.xcss)({
    // @ts-ignore
    '--ds--button--new-icon-padding-start': "var(--ds-space-050, 4px)",
    // @ts-ignore
    '--ds--button--new-icon-padding-end': "var(--ds-space-025, 2px)"
});
const $4778d4b230a21253$var$afterIconStyles = (0, $1ZAYh.xcss)({
    // @ts-ignore
    '--ds--button--new-icon-padding-start': "var(--ds-space-025, 2px)",
    // @ts-ignore
    '--ds--button--new-icon-padding-end': "var(--ds-space-050, 4px)"
});
/**
 * __Content__
 *
 * Used for slots within a Button, including icons and text content.
 */ const $4778d4b230a21253$var$Content = ({ children: children, type: type = 'text', hasOverlay: hasOverlay, position: position })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "span",
        xcss: [
            $4778d4b230a21253$var$commonStyles,
            ...type === 'text' ? [
                $4778d4b230a21253$var$textStyles
            ] : [
                $4778d4b230a21253$var$iconStyles
            ],
            ...hasOverlay ? [
                $4778d4b230a21253$var$fadeStyles
            ] : [],
            ...position === 'before' ? [
                $4778d4b230a21253$var$beforeIconStyles
            ] : [],
            ...position === 'after' ? [
                $4778d4b230a21253$var$afterIconStyles
            ] : []
        ]
    }, children);
};
var $4778d4b230a21253$export$2e2bcd8739ae039 = $4778d4b230a21253$var$Content;

});

parcelRegister("byjW4", function(module, exports) {

$parcel$export(module.exports, "default", () => $346199fe426f0bc4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4Bees = parcelRequire("4Bees");
function $346199fe426f0bc4$var$getIconSpacing(spacing) {
    switch(spacing){
        case 'compact':
            return 'small';
        case 'none':
            return 'xsmall';
        default:
            return 'medium';
    }
}
function $346199fe426f0bc4$var$getSpinnerAppearance({ appearance: appearance, isDisabled: isDisabled, isSelected: isSelected }) {
    if (isDisabled || isSelected) return 'inherit';
    if (appearance === 'primary' || appearance === 'danger' || appearance === 'discovery') return 'invert';
    return 'inherit';
}
function $346199fe426f0bc4$export$2e2bcd8739ae039({ appearance: appearance, spacing: spacing, isDisabled: isDisabled, isSelected: isSelected }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
        label: ", Loading",
        size: $346199fe426f0bc4$var$getIconSpacing(spacing),
        appearance: $346199fe426f0bc4$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        })
    });
}

});

parcelRegister("fE1y3", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f92f4a271b94157$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1lQG9 = parcelRequire("1lQG9");

var $hhlqA = parcelRequire("hhlqA");

var $XHGTv = parcelRequire("XHGTv");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $PdmhA = parcelRequire("PdmhA");

var $lcnyw = parcelRequire("lcnyw");

var $j5H17 = parcelRequire("j5H17");

var $alfOm = parcelRequire("alfOm");
const $9f92f4a271b94157$var$fontSize = (0, $lcnyw.fontSize)();
const $9f92f4a271b94157$var$buttonStyles = (0, $1ZAYh.xcss)({
    display: 'inline-flex',
    boxSizing: 'border-box',
    width: 'auto',
    maxWidth: '100%',
    position: 'relative',
    alignItems: 'baseline',
    justifyContent: 'center',
    columnGap: 'space.050',
    background: `var(--ds-background-neutral, ${$PdmhA.N20A})`,
    borderRadius: 'border.radius.100',
    borderWidth: 'border.width.0',
    // @ts-expect-error
    color: `var(--ds-text, ${$PdmhA.N500})`,
    flexShrink: 0,
    height: `${32 / $9f92f4a271b94157$var$fontSize}em`,
    paddingInlineEnd: 'space.150',
    paddingInlineStart: 'space.150',
    textAlign: 'center',
    transition: 'background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)',
    verticalAlign: 'middle',
    ':visited': {
        // @ts-expect-error
        color: `var(--ds-text, ${$PdmhA.N500})`
    }
});
const $9f92f4a271b94157$var$baseButtonStyles = (0, $1ZAYh.xcss)({
    fontFamily: 'inherit',
    fontSize: 'inherit',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: `${32 / $9f92f4a271b94157$var$fontSize}em`,
    paddingBlock: 'space.0'
});
const $9f92f4a271b94157$var$tokenizedButtonStyles = (0, $1ZAYh.xcss)({
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    paddingBlock: 'space.075'
});
const $9f92f4a271b94157$var$defaultInteractiveStyles = (0, $1ZAYh.xcss)({
    ':hover': {
        background: "var(--ds-background-neutral-hovered, #091e4214)",
        // @ts-expect-error
        color: `var(--ds-text, ${$PdmhA.N500})`,
        transitionDuration: '0s, 0.15s'
    },
    ':active': {
        background: `var(--ds-background-neutral-pressed, ${$PdmhA.B75})`,
        // @ts-expect-error
        color: `var(--ds-text, ${$PdmhA.B400})`,
        transitionDuration: '0s, 0s'
    }
});
const $9f92f4a271b94157$var$primaryStyles = (0, $1ZAYh.xcss)({
    background: "var(--ds-background-brand-bold, #0052CC)",
    // @ts-expect-error
    color: "var(--ds-text-inverse, #FFFFFF)",
    ':visited': {
        // @ts-expect-error
        color: "var(--ds-text-inverse, #FFFFFF)"
    }
});
const $9f92f4a271b94157$var$primaryInteractiveStyles = (0, $1ZAYh.xcss)({
    ':hover': {
        // @ts-expect-error
        color: "var(--ds-text-inverse, #FFFFFF)",
        background: "var(--ds-background-brand-bold-hovered, #0065FF)"
    },
    ':active': {
        // @ts-expect-error
        color: "var(--ds-text-inverse, #FFFFFF)",
        background: "var(--ds-background-brand-bold-pressed, #0747A6)"
    }
});
const $9f92f4a271b94157$var$warningStyles = (0, $1ZAYh.xcss)({
    background: "var(--ds-background-warning-bold, #FFAB00)",
    // @ts-expect-error
    color: "var(--ds-text-warning-inverse, #172B4D)",
    ':visited': {
        // @ts-expect-error
        color: "var(--ds-text-warning-inverse, #172B4D)"
    }
});
const $9f92f4a271b94157$var$warningInteractiveStyles = (0, $1ZAYh.xcss)({
    ':hover': {
        // @ts-expect-error
        color: "var(--ds-text-warning-inverse, #172B4D)",
        background: "var(--ds-background-warning-bold-hovered, #FFC400)"
    },
    ':active': {
        // @ts-expect-error
        color: "var(--ds-text-warning-inverse, #172B4D)",
        background: "var(--ds-background-warning-bold-pressed, #FF991F)"
    }
});
const $9f92f4a271b94157$var$dangerStyles = (0, $1ZAYh.xcss)({
    background: "var(--ds-background-danger-bold, #DE350B)",
    color: 'color.text.inverse',
    ':visited': {
        color: 'color.text.inverse'
    }
});
const $9f92f4a271b94157$var$dangerInteractiveStyles = (0, $1ZAYh.xcss)({
    ':hover': {
        color: 'color.text.inverse',
        background: "var(--ds-background-danger-bold-hovered, #FF5630)"
    },
    ':active': {
        color: 'color.text.inverse',
        background: "var(--ds-background-danger-bold-pressed, #BF2600)"
    }
});
const $9f92f4a271b94157$var$discoveryStyles = (0, $1ZAYh.xcss)({
    background: "var(--ds-background-discovery-bold, #5243AA)",
    color: 'color.text.inverse',
    ':visited': {
        color: 'color.text.inverse'
    }
});
const $9f92f4a271b94157$var$discoveryInteractiveStyles = (0, $1ZAYh.xcss)({
    ':hover': {
        color: 'color.text.inverse',
        background: "var(--ds-background-discovery-bold-hovered, #8777D9)"
    },
    ':active': {
        color: 'color.text.inverse',
        background: "var(--ds-background-discovery-bold-pressed, #5243AA)"
    }
});
const $9f92f4a271b94157$var$subtleStyles = (0, $1ZAYh.xcss)({
    background: "var(--ds-background-neutral-subtle, transparent)",
    // @ts-expect-error
    color: "var(--ds-text, #42526E)",
    ':visited': {
        // @ts-expect-error
        color: "var(--ds-text, #42526E)"
    }
});
const $9f92f4a271b94157$var$subtleInteractiveStyles = (0, $1ZAYh.xcss)({
    ':hover': {
        background: "var(--ds-background-neutral-subtle-hovered, #091e4214)",
        // @ts-expect-error
        color: "var(--ds-text, #42526E)"
    },
    ':active': {
        background: "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
        // @ts-expect-error
        color: "var(--ds-text, #42526E)"
    }
});
const $9f92f4a271b94157$var$linkStyles = (0, $1ZAYh.xcss)({
    // @ts-expect-error
    color: `var(--ds-link, ${$PdmhA.B400})`,
    background: "var(--ds-background-neutral-subtle, transparent)",
    textDecoration: 'none',
    ':hover': {
        // @ts-expect-error
        color: `var(--ds-link, ${$PdmhA.B300})`,
        background: "var(--ds-background-neutral-subtle, transparent)"
    },
    ':active': {
        // @ts-expect-error
        color: "var(--ds-link-pressed, #0055CC)",
        background: "var(--ds-background-neutral-subtle, transparent)"
    },
    ':visited': {
        // @ts-expect-error
        color: `var(--ds-link, ${$PdmhA.B400})`
    }
});
const $9f92f4a271b94157$var$subtleLinkStyles = (0, $1ZAYh.xcss)({
    // @ts-expect-error
    color: `var(--ds-text-subtle, ${$PdmhA.N200})`,
    background: "var(--ds-background-neutral-subtle, transparent)",
    textDecoration: 'none',
    ':hover': {
        // @ts-expect-error
        color: `var(--ds-text-subtle, ${$PdmhA.N90})`,
        background: "var(--ds-background-neutral-subtle, transparent)"
    },
    ':active': {
        // @ts-expect-error
        color: `var(--ds-text, ${$PdmhA.N400})`,
        background: "var(--ds-background-neutral-subtle, transparent)"
    },
    ':visited': {
        // @ts-expect-error
        color: `var(--ds-text-subtle, ${$PdmhA.N200})`
    }
});
// Required due to Jira's AUI CSS reset: https://product-fabric.atlassian.net/browse/DSP-15687
const $9f92f4a271b94157$var$linkDecorationUnsetStyles = (0, $1ZAYh.xcss)({
    textDecoration: 'none',
    ':hover': {
        textDecoration: 'none'
    },
    ':active': {
        textDecoration: 'none'
    },
    ':focus': {
        textDecoration: 'none'
    }
});
const $9f92f4a271b94157$var$linkDecorationStyles = (0, $1ZAYh.xcss)({
    ':hover': {
        textDecoration: 'underline'
    },
    ':focus': {
        textDecoration: 'underline'
    }
});
const $9f92f4a271b94157$var$disabledStyles = (0, $1ZAYh.xcss)({
    background: `var(--ds-background-disabled, ${$PdmhA.N20A})`,
    // @ts-expect-error
    color: "var(--ds-text-disabled, #091E424F)",
    ':hover': {
        background: `var(--ds-background-disabled, ${$PdmhA.N20A})`,
        // @ts-expect-error
        color: "var(--ds-text-disabled, #091E424F)"
    },
    ':active': {
        background: `var(--ds-background-disabled, ${$PdmhA.N20A})`,
        // @ts-expect-error
        color: "var(--ds-text-disabled, #091E424F)"
    }
});
const $9f92f4a271b94157$var$selectedStyles = (0, $1ZAYh.xcss)({
    background: `var(--ds-background-selected, ${$PdmhA.N700})`,
    // @ts-expect-error
    color: `var(--ds-text-selected, ${$PdmhA.N20})`,
    ':visited': {
        // @ts-expect-error
        color: `var(--ds-text-selected, ${$PdmhA.N20})`
    }
});
const $9f92f4a271b94157$var$selectedInteractiveStyles = (0, $1ZAYh.xcss)({
    ':hover': {
        // @ts-expect-error
        color: `var(--ds-text-selected, ${$PdmhA.N20})`,
        background: `var(--ds-background-selected-hovered, ${$PdmhA.N700})`
    },
    ':active': {
        // @ts-expect-error
        color: `var(--ds-text-selected, ${$PdmhA.N20})`,
        background: `var(--ds-background-selected-pressed, ${$PdmhA.N700})`
    }
});
// TODO: Remove me once we kill color fallbacks
const $9f92f4a271b94157$var$selectedWarningStyles = (0, $1ZAYh.xcss)({
    background: `var(--ds-background-selected, ${$PdmhA.Y400})`,
    // @ts-expect-error
    color: `var(--ds-text-selected, ${$PdmhA.N800})`,
    ':hover': {
        // @ts-expect-error
        color: `var(--ds-text-selected, ${$PdmhA.N20})`,
        background: `var(--ds-background-selected, ${$PdmhA.Y400})`
    },
    ':active': {
        // @ts-expect-error
        color: `var(--ds-text-selected, ${$PdmhA.N20})`,
        background: `var(--ds-background-selected, ${$PdmhA.Y400})`
    }
});
// TODO: Remove me once we kill color fallbacks
const $9f92f4a271b94157$var$selectedDangerStyles = (0, $1ZAYh.xcss)({
    background: `var(--ds-background-selected, ${$PdmhA.R500})`,
    // @ts-expect-error
    color: `var(--ds-text-selected, ${$PdmhA.N20})`,
    ':hover': {
        // @ts-expect-error
        color: `var(--ds-text-selected, ${$PdmhA.N20})`,
        background: `var(--ds-background-selected, ${$PdmhA.R500})`
    },
    ':active': {
        // @ts-expect-error
        color: `var(--ds-text-selected, ${$PdmhA.N20})`,
        background: `var(--ds-background-selected, ${$PdmhA.R500})`
    }
});
// TODO: Remove me once we kill color fallbacks
const $9f92f4a271b94157$var$selectedDiscoveryStyles = (0, $1ZAYh.xcss)({
    background: "var(--ds-background-selected, #403294)",
    // @ts-expect-error
    color: `var(--ds-text-selected, ${$PdmhA.N20})`,
    ':hover': {
        // @ts-expect-error
        color: `var(--ds-text-selected, ${$PdmhA.N20})`,
        background: "var(--ds-background-selected, #403294)"
    },
    ':active': {
        // @ts-expect-error
        color: `var(--ds-text-selected, ${$PdmhA.N20})`,
        background: "var(--ds-background-selected, #403294)"
    }
});
const $9f92f4a271b94157$var$spacingCompactStyles = (0, $1ZAYh.xcss)({
    columnGap: 'space.050',
    height: `${24 / $9f92f4a271b94157$var$fontSize}em`,
    paddingInlineEnd: 'space.150',
    paddingInlineStart: 'space.150',
    verticalAlign: 'middle'
});
const $9f92f4a271b94157$var$baseSpacingCompactStyles = (0, $1ZAYh.xcss)({
    lineHeight: `${24 / $9f92f4a271b94157$var$fontSize}em`
});
const $9f92f4a271b94157$var$tokenizedSpacingCompactStyles = (0, $1ZAYh.xcss)({
    paddingBlock: 'space.025'
});
const $9f92f4a271b94157$var$spacingNoneStyles = (0, $1ZAYh.xcss)({
    columnGap: 'space.0',
    height: 'auto',
    lineHeight: 'inherit',
    paddingInlineEnd: 'space.0',
    paddingInlineStart: 'space.0',
    verticalAlign: 'baseline'
});
const $9f92f4a271b94157$var$tokenizedSpacingNoneStyles = (0, $1ZAYh.xcss)({
    paddingBlock: 'space.0'
});
const $9f92f4a271b94157$var$circleStyles = (0, $1ZAYh.xcss)({
    borderRadius: 'border.radius.circle'
});
const $9f92f4a271b94157$var$fullWidthStyles = (0, $1ZAYh.xcss)({
    width: '100%'
});
const $9f92f4a271b94157$var$loadingOverlayStyles = (0, $1ZAYh.xcss)({
    cursor: 'progress'
});
const $9f92f4a271b94157$var$nonInteractiveStyles = (0, $1ZAYh.xcss)({
    cursor: 'not-allowed'
});
const $9f92f4a271b94157$var$iconButtonStyles = (0, $1ZAYh.xcss)({
    height: `${32 / $9f92f4a271b94157$var$fontSize}em`,
    width: `${32 / $9f92f4a271b94157$var$fontSize}em`,
    paddingInlineEnd: 'space.0',
    paddingInlineStart: 'space.0'
});
const $9f92f4a271b94157$var$iconButtonCompactStyles = (0, $1ZAYh.xcss)({
    width: `${24 / $9f92f4a271b94157$var$fontSize}em`,
    height: `${24 / $9f92f4a271b94157$var$fontSize}em`
});
const $9f92f4a271b94157$var$buttonIconBeforeStyles = (0, $1ZAYh.xcss)({
    paddingInlineStart: 'space.100'
});
const $9f92f4a271b94157$var$buttonIconAfterStyles = (0, $1ZAYh.xcss)({
    paddingInlineEnd: 'space.100'
});
const $9f92f4a271b94157$var$splitButtonStyles = (0, $1ZAYh.xcss)({
    ':focus-visible': {
        zIndex: 'card'
    }
});
const $9f92f4a271b94157$var$navigationSplitButtonStyles = (0, $1ZAYh.xcss)({
    width: '24px',
    backgroundColor: 'color.background.neutral.subtle',
    paddingInlineEnd: 'space.075',
    paddingInlineStart: 'space.075'
});
const $9f92f4a271b94157$var$overlayStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    position: 'absolute',
    alignItems: 'center',
    justifyContent: 'center',
    insetBlockEnd: 'space.0',
    insetBlockStart: 'space.0',
    insetInlineEnd: 'space.0',
    insetInlineStart: 'space.0'
});
/**
 * __Use button base__
 *
 * A React hook that accepts a set of common Button props,
 * and processes them to return consistent base props for usage
 * across various Button components.
 *
 * It also:
 * - Implements auto focus when enabled.
 * - Appends the `onClick` event with UFO analytics tracking.
 *
 * @private
 */ const $9f92f4a271b94157$var$useButtonBase = ({ appearance: propAppearance = 'default', autoFocus: autoFocus = false, isDisabled: propIsDisabled = false, isLoading: isLoading = false, isSelected: isSelected = false, isIconButton: // TODO: Separate Icon Button styling from button base
isIconButton = false, isCircle: isCircle = false, hasIconBefore: // TODO: Separate icon slot styling from button base
hasIconBefore = false, hasIconAfter: hasIconAfter = false, children: children, onClick: onClick, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onTouchStartCapture: onTouchStartCapture, onTouchEndCapture: onTouchEndCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onClickCapture: onClickCapture, overlay: overlay, ref: ref, shouldFitContainer: shouldFitContainer = false, spacing: propSpacing = 'default' })=>{
    const localRef = (0, $eUqFw.useRef)(null);
    const splitButtonContext = (0, $j5H17.useSplitButtonContext)();
    const isSplitButton = Boolean(splitButtonContext);
    const isNavigationSplitButton = splitButtonContext?.isNavigationSplitButton || false;
    const appearance = splitButtonContext?.appearance || propAppearance;
    const spacing = splitButtonContext?.spacing || propSpacing;
    const isDisabled = splitButtonContext?.isDisabled || propIsDisabled;
    const hasOverlay = Boolean(overlay);
    const isInteractive = !isDisabled && !isLoading && !hasOverlay;
    const isEffectivelyDisabled = isDisabled || Boolean(overlay);
    (0, $hhlqA.default)(localRef, autoFocus);
    return {
        ref: (0, $1lQG9.default)([
            localRef,
            ref
        ]),
        xcss: [
            (0, $XHGTv.getBooleanFF)('platform.design-system-team.button-tokenised-typography-styles') ? $9f92f4a271b94157$var$tokenizedButtonStyles : $9f92f4a271b94157$var$baseButtonStyles,
            $9f92f4a271b94157$var$buttonStyles,
            appearance === 'default' && isInteractive && $9f92f4a271b94157$var$defaultInteractiveStyles,
            appearance === 'primary' && $9f92f4a271b94157$var$primaryStyles,
            appearance === 'primary' && isInteractive && $9f92f4a271b94157$var$primaryInteractiveStyles,
            appearance === 'warning' && $9f92f4a271b94157$var$warningStyles,
            appearance === 'warning' && isInteractive && $9f92f4a271b94157$var$warningInteractiveStyles,
            appearance === 'danger' && $9f92f4a271b94157$var$dangerStyles,
            appearance === 'danger' && isInteractive && $9f92f4a271b94157$var$dangerInteractiveStyles,
            appearance === 'discovery' && $9f92f4a271b94157$var$discoveryStyles,
            appearance === 'discovery' && isInteractive && $9f92f4a271b94157$var$discoveryInteractiveStyles,
            appearance === 'subtle' && $9f92f4a271b94157$var$subtleStyles,
            appearance === 'subtle' && isInteractive && $9f92f4a271b94157$var$subtleInteractiveStyles,
            appearance === 'link' && $9f92f4a271b94157$var$linkStyles,
            appearance === 'subtle-link' && $9f92f4a271b94157$var$subtleLinkStyles,
            !isSelected && (appearance === 'link' || appearance === 'subtle-link') ? $9f92f4a271b94157$var$linkDecorationStyles : $9f92f4a271b94157$var$linkDecorationUnsetStyles,
            isSelected && $9f92f4a271b94157$var$selectedStyles,
            isSelected && isInteractive && $9f92f4a271b94157$var$selectedInteractiveStyles,
            // TODO: remove me once we kill color fallbacks
            isSelected && appearance === 'danger' && $9f92f4a271b94157$var$selectedDangerStyles,
            // TODO: remove me once we kill color fallbacks
            isSelected && appearance === 'warning' && $9f92f4a271b94157$var$selectedWarningStyles,
            // TODO: remove me once we kill color fallbacks
            isSelected && appearance === 'discovery' && $9f92f4a271b94157$var$selectedDiscoveryStyles,
            isDisabled && $9f92f4a271b94157$var$disabledStyles,
            isCircle && !isSplitButton && $9f92f4a271b94157$var$circleStyles,
            spacing === 'compact' && $9f92f4a271b94157$var$spacingCompactStyles,
            spacing === 'compact' && ((0, $XHGTv.getBooleanFF)('platform.design-system-team.button-tokenised-typography-styles') ? $9f92f4a271b94157$var$tokenizedSpacingCompactStyles : $9f92f4a271b94157$var$baseSpacingCompactStyles),
            spacing === 'none' && $9f92f4a271b94157$var$spacingNoneStyles,
            spacing === 'none' && (0, $XHGTv.getBooleanFF)('platform.design-system-team.button-tokenised-typography-styles') && $9f92f4a271b94157$var$tokenizedSpacingNoneStyles,
            spacing !== 'none' && hasIconBefore && $9f92f4a271b94157$var$buttonIconBeforeStyles,
            spacing !== 'none' && hasIconAfter && $9f92f4a271b94157$var$buttonIconAfterStyles,
            isIconButton && $9f92f4a271b94157$var$iconButtonStyles,
            isIconButton && spacing === 'compact' && $9f92f4a271b94157$var$iconButtonCompactStyles,
            shouldFitContainer && $9f92f4a271b94157$var$fullWidthStyles,
            isLoading && $9f92f4a271b94157$var$loadingOverlayStyles,
            (isDisabled || hasOverlay && !isLoading) && $9f92f4a271b94157$var$nonInteractiveStyles,
            isSplitButton && $9f92f4a271b94157$var$splitButtonStyles,
            isNavigationSplitButton && $9f92f4a271b94157$var$navigationSplitButtonStyles
        ],
        // Consider overlay buttons to be effectively disabled
        isDisabled: isEffectivelyDisabled,
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), null, children, overlay ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            as: "span",
            xcss: $9f92f4a271b94157$var$overlayStyles
        }, overlay) : null),
        ...(0, $alfOm.default)(isEffectivelyDisabled, {
            onClick: onClick,
            onMouseDownCapture: onMouseDownCapture,
            onMouseUpCapture: onMouseUpCapture,
            onKeyDownCapture: onKeyDownCapture,
            onKeyUpCapture: onKeyUpCapture,
            onTouchStartCapture: onTouchStartCapture,
            onTouchEndCapture: onTouchEndCapture,
            onPointerDownCapture: onPointerDownCapture,
            onPointerUpCapture: onPointerUpCapture,
            onClickCapture: onClickCapture
        })
    };
};
var $9f92f4a271b94157$export$2e2bcd8739ae039 = $9f92f4a271b94157$var$useButtonBase;

});
parcelRegister("j5H17", function(module, exports) {

$parcel$export(module.exports, "SplitButtonContext", () => $288d53effe11d2ef$export$4b86304b2c0d7e71);
$parcel$export(module.exports, "useSplitButtonContext", () => $288d53effe11d2ef$export$47e2c6fdb142d947);

var $eUqFw = parcelRequire("eUqFw");
const $288d53effe11d2ef$export$4b86304b2c0d7e71 = /*#__PURE__*/ (0, $eUqFw.createContext)(undefined);
const $288d53effe11d2ef$export$47e2c6fdb142d947 = ()=>{
    const context = (0, $eUqFw.useContext)($288d53effe11d2ef$export$4b86304b2c0d7e71);
    if (!context) return undefined;
    if (context.appearance === 'navigation') {
        const newContext = {
            spacing: 'default',
            appearance: 'subtle',
            isDisabled: false,
            isActiveOverSelected: false,
            isNavigationSplitButton: true,
            isHighlighted: context.isHighlighted
        };
        return newContext;
    }
    const splitButtonContext = {
        spacing: context.spacing,
        appearance: context.appearance,
        isDisabled: context.isDisabled,
        isActiveOverSelected: true,
        isNavigationSplitButton: false,
        isHighlighted: false
    };
    return splitButtonContext;
};

});

parcelRegister("alfOm", function(module, exports) {

$parcel$export(module.exports, "default", () => $d09f2c06bb45703d$export$2e2bcd8739ae039);
function $d09f2c06bb45703d$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
const $d09f2c06bb45703d$var$tabKeyCode = 9;
function $d09f2c06bb45703d$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $d09f2c06bb45703d$var$tabKeyCode) return;
    $d09f2c06bb45703d$var$abort(event);
}
function $d09f2c06bb45703d$export$2e2bcd8739ae039(shouldBlockEvents, events) {
    return shouldBlockEvents ? {
        onMouseDownCapture: $d09f2c06bb45703d$var$abort,
        onMouseUpCapture: $d09f2c06bb45703d$var$abort,
        onKeyDownCapture: $d09f2c06bb45703d$var$onKey,
        onKeyUpCapture: $d09f2c06bb45703d$var$onKey,
        onTouchStartCapture: $d09f2c06bb45703d$var$abort,
        onTouchEndCapture: $d09f2c06bb45703d$var$abort,
        onPointerDownCapture: $d09f2c06bb45703d$var$abort,
        onPointerUpCapture: $d09f2c06bb45703d$var$abort,
        onClickCapture: $d09f2c06bb45703d$var$abort,
        // Just smashing the existing onClick for good measure
        onClick: $d09f2c06bb45703d$var$abort
    } : events;
}

});




parcelRegister("2WwAS", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc974ed9b9ba7adb$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $fc974ed9b9ba7adb$export$2e2bcd8739ae039(propValue, getDefaultPropValue = ()=>propValue) {
    const isControlled = propValue !== undefined;
    const [valueState, setValue] = (0, $eUqFw.useState)(getDefaultPropValue);
    const isControlledRef = (0, $eUqFw.useRef)(isControlled);
    (0, $eUqFw.useEffect)(()=>{
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    const value = isControlled ? propValue : valueState;
    const setValueIfUncontrolled = (0, $eUqFw.useCallback)((newValue)=>{
        if (!isControlledRef.current) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}

});

parcelRegister("7PTrT", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cf74c53325012fd$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $2cf74c53325012fd$export$2e2bcd8739ae039() {
    const [isFocused, setIsFocused] = (0, $eUqFw.useState)(false);
    // ensure bindFocus has a stable ref
    const bindFocus = (0, $eUqFw.useRef)({
        onFocus: ()=>setIsFocused(true),
        onBlur: ()=>setIsFocused(false)
    });
    (0, $eUqFw.useEffect)(()=>{
        // handle the case where a component might
        // unmount while being focused.
        return ()=>setIsFocused(false);
    }, []);
    return {
        isFocused: isFocused,
        bindFocus: bindFocus.current
    };
}

});

parcelRegister("dkYal", function(module, exports) {

$parcel$export(module.exports, "FocusManagerContext", () => $cf3cae93cc4408b7$export$f18c1d4fc7326096);
$parcel$export(module.exports, "default", () => $cf3cae93cc4408b7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

var $5Q9wj = parcelRequire("5Q9wj");

var $eN43R = parcelRequire("eN43R");

var $9wjz6 = parcelRequire("9wjz6");
const $cf3cae93cc4408b7$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    menuItemRefs: [],
    registerRef: (0, $5Q9wj.default)
});
/**
 * Focus manager logic.
 */ const $cf3cae93cc4408b7$var$FocusManager = ({ children: children, onClose: onClose })=>{
    const menuItemRefs = (0, $eUqFw.useRef)([]);
    const registerRef = (0, $eUqFw.useCallback)((ref)=>{
        if (ref && !menuItemRefs.current.includes(ref)) menuItemRefs.current.push(ref);
    }, []);
    const { isLayerDisabled: isLayerDisabled } = (0, $eN43R.UNSAFE_useLayering)();
    // Intentionally rebinding on each render
    (0, $eUqFw.useEffect)(()=>{
        return (0, $74BVL.bind)(window, {
            type: 'keydown',
            listener: (0, $9wjz6.default)(menuItemRefs.current, isLayerDisabled, onClose)
        });
    });
    const contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cf3cae93cc4408b7$export$f18c1d4fc7326096.Provider, {
        value: contextValue
    }, children);
};
var $cf3cae93cc4408b7$export$2e2bcd8739ae039 = $cf3cae93cc4408b7$var$FocusManager;

});
parcelRegister("9wjz6", function(module, exports) {

$parcel$export(module.exports, "default", () => $66539497081f56cc$export$2e2bcd8739ae039);

const $66539497081f56cc$var$actionMap = {
    [(0, $54717ce5fa2c74b1$export$a80636c6f41931fe)]: 'next',
    [(0, $54717ce5fa2c74b1$export$390330c10ff2b9a1)]: 'prev',
    [(0, $54717ce5fa2c74b1$export$4af703091671bc)]: 'first',
    [(0, $54717ce5fa2c74b1$export$e2bc30913faa5db7)]: 'last'
};
/**
 * `currentFocusedIdx + 1` will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ const $66539497081f56cc$var$getNextFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx + 1 < refs.length){
        const isDisabled = refs[currentFocusedIdx + 1].hasAttribute('disabled');
        if (!isDisabled) return refs[currentFocusedIdx + 1];
        currentFocusedIdx++;
    }
};
/**
 * `currentFocusedIdx - 1` will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ const $66539497081f56cc$var$getPrevFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx > 0){
        const isDisabled = refs[currentFocusedIdx - 1].hasAttribute('disabled');
        if (!isDisabled) return refs[currentFocusedIdx - 1];
        currentFocusedIdx--;
    }
};
function $66539497081f56cc$export$2e2bcd8739ae039(refs, isLayerDisabled, onClose) {
    return (e)=>{
        const currentFocusedIdx = refs.findIndex((el)=>document.activeElement?.isSameNode(el));
        if (isLayerDisabled()) {
            // if nested dropdown isOpen we need to close on Tab key press
            if (e.key === (0, $54717ce5fa2c74b1$export$10f6869ed0a7d75b) && !e.shiftKey) onClose(e);
            // if it is a nested dropdown and the level of the given dropdown is not the current level,
            // we don't need to have focus on it
            return;
        }
        const action = $66539497081f56cc$var$actionMap[e.key];
        switch(action){
            case 'next':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                if (currentFocusedIdx < refs.length - 1) {
                    const nextFocusableElement = $66539497081f56cc$var$getNextFocusableElement(refs, currentFocusedIdx);
                    nextFocusableElement?.focus();
                } else {
                    const firstFocusableElement = $66539497081f56cc$var$getNextFocusableElement(refs, -1);
                    firstFocusableElement?.focus();
                }
                break;
            case 'prev':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                if (currentFocusedIdx > 0) {
                    const prevFocusableElement = $66539497081f56cc$var$getPrevFocusableElement(refs, currentFocusedIdx);
                    prevFocusableElement?.focus();
                } else {
                    const lastFocusableElement = $66539497081f56cc$var$getPrevFocusableElement(refs, refs.length);
                    lastFocusableElement?.focus();
                }
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                const nextFocusableElement = $66539497081f56cc$var$getNextFocusableElement(refs, -1);
                nextFocusableElement?.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                const prevFocusableElement = $66539497081f56cc$var$getPrevFocusableElement(refs, refs.length);
                prevFocusableElement?.focus();
                break;
            default:
                return;
        }
    };
}

});


parcelRegister("jiH6M", function(module, exports) {

$parcel$export(module.exports, "default", () => $964014f36228d6e8$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $8PFhw = parcelRequire("8PFhw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $4Bees = parcelRequire("4Bees");

var $dkYal = parcelRequire("dkYal");

var $fccfd = parcelRequire("fccfd");

var $1g0c9 = parcelRequire("1g0c9");
const $964014f36228d6e8$var$spinnerContainerStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    minWidth: '160px',
    padding: 'space.250',
    justifyContent: 'center'
});
const $964014f36228d6e8$var$LoadingIndicator = ({ statusLabel: statusLabel = 'Loading', testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        xcss: $964014f36228d6e8$var$spinnerContainerStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $4Bees.default), {
        size: "small",
        label: statusLabel,
        testId: testId
    }));
/**
 *
 * MenuWrapper wraps all the menu items.
 * It handles the logic to close the menu when a MenuItem is clicked, but leaves it open
 * if a CheckboxItem or RadioItem is clicked.
 * It also sets focus to the first menu item when opened.
 */ const $964014f36228d6e8$var$MenuWrapper = ({ children: children, isLoading: isLoading, maxHeight: maxHeight, maxWidth: maxWidth, onClose: onClose, onUpdate: onUpdate, statusLabel: statusLabel, setInitialFocusRef: setInitialFocusRef, shouldRenderToParent: shouldRenderToParent, spacing: spacing, testId: testId, isTriggeredUsingKeyboard: isTriggeredUsingKeyboard, autoFocus: autoFocus })=>{
    const { menuItemRefs: menuItemRefs } = (0, $eUqFw.useContext)((0, $dkYal.FocusManagerContext));
    const closeOnMenuItemClick = (e)=>{
        const isTargetMenuItemOrDecendant = menuItemRefs.some((menuItem)=>{
            const isCheckboxOrRadio = (0, $fccfd.default)(menuItem) || (0, $1g0c9.default)(menuItem);
            return menuItem.contains(e.target) && !isCheckboxOrRadio;
        });
        // Close menu if the click is triggered from a MenuItem or
        // its descendant. Don't close the menu if the click is triggered
        // from a MenuItemRadio or MenuItemCheckbox so that the user can
        // select multiple items.
        if (isTargetMenuItemOrDecendant && onClose) onClose(e);
    };
    // Using useEffect here causes a flicker.
    // useLayoutEffect ensures that the update and render happen in the same
    // rAF tick.
    (0, $eUqFw.useLayoutEffect)(()=>{
        onUpdate();
    }, [
        isLoading,
        onUpdate
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const firstFocusableRef = menuItemRefs.find((ref)=>!ref.hasAttribute('disabled')) ?? null;
        if (shouldRenderToParent && (isTriggeredUsingKeyboard || autoFocus)) firstFocusableRef?.focus();
        setInitialFocusRef?.(firstFocusableRef);
    }, [
        menuItemRefs,
        setInitialFocusRef,
        autoFocus,
        shouldRenderToParent,
        isTriggeredUsingKeyboard
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $8PFhw.default), {
        isLoading: isLoading,
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        onClick: closeOnMenuItemClick,
        role: "menu",
        spacing: spacing,
        testId: testId && `${testId}--menu-group`
    }, isLoading ? /*#__PURE__*/ (0, $byn9U.jsx)($964014f36228d6e8$var$LoadingIndicator, {
        statusLabel: statusLabel,
        testId: testId && `${testId}--loading-indicator`
    }) : children);
};
var $964014f36228d6e8$export$2e2bcd8739ae039 = $964014f36228d6e8$var$MenuWrapper;

});
parcelRegister("8PFhw", function(module, exports) {

$parcel$export(module.exports, "default", () => $44b5e9dfb8fd0d85$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $XHGTv = parcelRequire("XHGTv");

var $8jcoK = parcelRequire("8jcoK");
function $44b5e9dfb8fd0d85$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $44b5e9dfb8fd0d85$var$baseStyles = {
    name: "1u0qf12",
    styles: "display:flex;position:static;flex-direction:column;overflow:auto"
};
/**
 * __Menu group__
 *
 * A menu group includes all the actions or items in a menu.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/menu-group)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $44b5e9dfb8fd0d85$var$MenuGroup = ({ isLoading: isLoading, maxWidth: maxWidth, minWidth: minWidth, minHeight: minHeight, maxHeight: maxHeight, testId: testId, role: role, spacing: spacing = 'cozy', // Although this isn't defined on props it is available because we've used
// Spread props below and on the jsx element. To forcibly block usage I've
// picked it out and supressed the expected type error.
// @ts-expect-error
className: UNSAFE_className, ...rest })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $8jcoK.SpacingContext).Provider, {
        value: spacing
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8jcoK.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
        value: "border"
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "aria-busy": isLoading,
        style: {
            minWidth: minWidth,
            maxWidth: maxWidth,
            minHeight: minHeight,
            maxHeight: maxHeight
        },
        css: $44b5e9dfb8fd0d85$var$baseStyles,
        "data-testid": testId,
        role: role,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $XHGTv.getBooleanFF)('platform.design-system-team.unsafe-overrides-killswitch_c8j9m') ? undefined : UNSAFE_className,
        ...rest
    })));
var $44b5e9dfb8fd0d85$export$2e2bcd8739ae039 = $44b5e9dfb8fd0d85$var$MenuGroup;

});
parcelRegister("8jcoK", function(module, exports) {

$parcel$export(module.exports, "SpacingContext", () => $e3910e7f4549d599$export$443076ec7ebce042);
$parcel$export(module.exports, "SELECTION_STYLE_CONTEXT_DO_NOT_USE", () => $e3910e7f4549d599$export$9ca534b70725964d);

var $eUqFw = parcelRequire("eUqFw");
const $e3910e7f4549d599$export$443076ec7ebce042 = /*#__PURE__*/ (0, $eUqFw.createContext)('cozy');
const $e3910e7f4549d599$export$9ca534b70725964d = /*#__PURE__*/ (0, $eUqFw.createContext)('border');

});


parcelRegister("fccfd", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cc914649461e3b8$export$2e2bcd8739ae039);
function $2cc914649461e3b8$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'checkbox' || role === 'menuitemcheckbox';
}

});

parcelRegister("1g0c9", function(module, exports) {

$parcel$export(module.exports, "default", () => $3727e20ee9b5acb1$export$2e2bcd8739ae039);
function $3727e20ee9b5acb1$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'radio' || role === 'menuitemradio';
}

});


parcelRegister("7mYCs", function(module, exports) {

$parcel$export(module.exports, "SelectionStoreContext", () => $9b55d88a204a2c6b$export$756f795847463ebd);
$parcel$export(module.exports, "default", () => $9b55d88a204a2c6b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5Q9wj = parcelRequire("5Q9wj");
const $9b55d88a204a2c6b$export$756f795847463ebd = /*#__PURE__*/ (0, $eUqFw.createContext)({
    setItemState: (0, $5Q9wj.default),
    getItemState: ()=>undefined,
    setGroupState: (0, $5Q9wj.default),
    getGroupState: ()=>({})
});
/**
 * Selection store will persist data as long as it remains mounted.
 * It handles the uncontrolled story for dropdown menu when the menu
 * items can be mounted/unmounted depending if the menu is open or closed.
 */ const $9b55d88a204a2c6b$var$SelectionStore = (props)=>{
    const { children: children } = props;
    const store = (0, $eUqFw.useRef)({});
    const context = (0, $eUqFw.useMemo)(()=>({
            setItemState: (group, id, value)=>{
                if (!store.current[group]) store.current[group] = {};
                store.current[group][id] = value;
            },
            getItemState: (group, id)=>{
                if (!store.current[group]) return undefined;
                return store.current[group][id];
            },
            setGroupState: (group, value)=>{
                store.current[group] = value;
            },
            getGroupState: (group)=>{
                return store.current[group] || {};
            }
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9b55d88a204a2c6b$export$756f795847463ebd.Provider, {
        value: context
    }, children);
};
var $9b55d88a204a2c6b$export$2e2bcd8739ae039 = $9b55d88a204a2c6b$var$SelectionStore;

});

parcelRegister("h1Q9j", function(module, exports) {

$parcel$export(module.exports, "default", () => $6def866028b8c887$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dkYal = parcelRequire("dkYal");
// This function is called whenever a MenuItem mounts.
// The refs stored in the context are used to programatically
// control focus on a user navigates using the keyboard.
function $6def866028b8c887$var$useRegisterItemWithFocusManager() {
    const { registerRef: registerRef } = (0, $eUqFw.useContext)((0, $dkYal.FocusManagerContext));
    const itemRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(()=>{
        if (itemRef.current !== null) registerRef(itemRef.current);
    }, [
        registerRef
    ]);
    return itemRef;
}
var $6def866028b8c887$export$2e2bcd8739ae039 = $6def866028b8c887$var$useRegisterItemWithFocusManager;

});

parcelRegister("8gwL5", function(module, exports) {

$parcel$export(module.exports, "PREFIX", () => $bbafb6080e6e0b27$export$8a682ae47622dbb9);
$parcel$export(module.exports, "default", () => $bbafb6080e6e0b27$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $bbafb6080e6e0b27$export$8a682ae47622dbb9 = 'ds--dropdown--';
const $bbafb6080e6e0b27$var$generateRandomString = ()=>// This string is used only on client side usually triggered after a user interaction.
    // Therefore, so there is no risk of mismatch
    // between server and client generated markup.
    // eslint-disable-next-line @repo/internal/react/disallow-unstable-values
    `${$bbafb6080e6e0b27$export$8a682ae47622dbb9}${Math.random().toString(16).substr(2, 8)}`;
function $bbafb6080e6e0b27$export$2e2bcd8739ae039() {
    const cachedId = (0, $eUqFw.useRef)($bbafb6080e6e0b27$var$generateRandomString());
    return cachedId.current;
}

});


parcelRegister("hD6GJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $67738981858b3f25$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1lQG9 = parcelRequire("1lQG9");

var $bULPy = parcelRequire("bULPy");

var $e7PSD = parcelRequire("e7PSD");

var $bo4OB = parcelRequire("bo4OB");

var $h1Q9j = parcelRequire("h1Q9j");
/**
 * __Dropdown menu item__
 *
 * A dropdown item populates the dropdown menu with items. Every item should be inside a dropdown item group.
 *
 * - [Examples](https://atlassian.design/components/dropdown-item/examples)
 * - [Code](https://atlassian.design/components/dropdown-item/code)
 * - [Usage](https://atlassian.design/components/dropdown-item/usage)
 */ const $67738981858b3f25$var$DropdownMenuItem = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, component: component, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, rel: rel, shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, target: target, testId: testId, ...rest }, ref)=>{
    const itemRef = (0, $h1Q9j.default)();
    if (component) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e7PSD.default), {
        component: component,
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: onClick,
        ref: (0, $1lQG9.default)([
            ref,
            itemRef
        ]),
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        href: href,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        ...rest
    }, children);
    else if (href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bo4OB.default), {
        description: description,
        href: href,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: onClick,
        ref: (0, $1lQG9.default)([
            ref,
            itemRef
        ]),
        rel: rel,
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        target: target,
        testId: testId,
        ...rest
    }, children);
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: onClick,
        ref: (0, $1lQG9.default)([
            ref,
            itemRef
        ]),
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        ...rest
    }, children);
});
var $67738981858b3f25$export$2e2bcd8739ae039 = $67738981858b3f25$var$DropdownMenuItem;

});
parcelRegister("bULPy", function(module, exports) {

$parcel$export(module.exports, "default", () => $39b0e2e9c8007bba$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $1Ivg5 = parcelRequire("1Ivg5");

var $5Q9wj = parcelRequire("5Q9wj");

var $XHGTv = parcelRequire("XHGTv");

var $1RaV8 = parcelRequire("1RaV8");
/**
 * __Button item__
 *
 * A button item is used to populate a menu with items that are buttons.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/button-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $39b0e2e9c8007bba$var$ButtonItem = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)(// Type needed on props to extract types with extract react types.
(props, ref)=>{
    const { children: children, cssFn: cssFn = (0, $5Q9wj.default), description: description, iconAfter: iconAfter, iconBefore: iconBefore, isDisabled: isDisabled = false, isSelected: isSelected = false, onClick: onClick, testId: testId, overrides: overrides, onMouseDown: onMouseDown, shouldTitleWrap: shouldTitleWrap, shouldDescriptionWrap: shouldDescriptionWrap, // Although this isn't defined on props it is available because we've used
    // Spread props below and on the jsx element. To forcibly block usage I've
    // picked it out and supressed the expected type error.
    // @ts-expect-error
    className: UNSAFE_className, ...rest } = props;
    const onMouseDownHandler = onMouseDown;
    if (!children) return null;
    (0, $1Ivg5.propDeprecationWarning)('', 'cssFn', cssFn !== (0, $5Q9wj.default), '' // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $1RaV8.default), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $XHGTv.getBooleanFF)('platform.design-system-team.unsafe-overrides-killswitch_c8j9m') ? undefined : UNSAFE_className,
        ...rest,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        overrides: overrides,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isDisabled: isDisabled,
        isSelected: isSelected,
        description: description,
        title: children,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        css: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        cssFn({
            isSelected: isSelected,
            isDisabled: isDisabled
        }),
        testId: testId && `${testId}--primitive`
    }, ({ children: children, className: className })=>/*#__PURE__*/ (0, $byn9U.jsx)("button", {
            "data-testid": testId,
            ...rest,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            ref: ref,
            disabled: isDisabled,
            onClick: onClick,
            onMouseDown: onMouseDownHandler,
            type: "button"
        }, children));
}));
var $39b0e2e9c8007bba$export$2e2bcd8739ae039 = $39b0e2e9c8007bba$var$ButtonItem;

});
parcelRegister("1RaV8", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c2d88c5fd62aedd$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $1Ivg5 = parcelRequire("1Ivg5");

var $51sCz = parcelRequire("51sCz");

var $XHGTv = parcelRequire("XHGTv");

var $9Amv1 = parcelRequire("9Amv1");
var $1zbEq = parcelRequire("1zbEq");
var $1ZAYh = parcelRequire("1ZAYh");

var $PdmhA = parcelRequire("PdmhA");

var $8jcoK = parcelRequire("8jcoK");
function $5c2d88c5fd62aedd$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $5c2d88c5fd62aedd$var$defaultRender = (Component, props)=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $byn9U.jsx)(Component, props);
const $5c2d88c5fd62aedd$var$beforeAfterElementStyles = {
    name: "sjfyf",
    styles: "display:flex;align-items:center;justify-content:center;flex-shrink:0"
};
const $5c2d88c5fd62aedd$var$contentStyles = (0, $1ZAYh.xcss)({
    outline: 'none',
    overflow: 'hidden',
    textAlign: 'left'
});
const $5c2d88c5fd62aedd$var$baseContentStyles = (0, $1ZAYh.xcss)({
    lineHeight: "var(--ds-font-lineHeight-100, 16px)"
});
const $5c2d88c5fd62aedd$var$truncateStyles = {
    name: "hdknak",
    styles: "display:block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap"
};
const $5c2d88c5fd62aedd$var$titleStyles = {
    name: "183yev2",
    styles: "font:var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
const $5c2d88c5fd62aedd$var$wordBreakStyles = {
    name: "1sdjnkx",
    styles: "word-break:break-word"
};
const $5c2d88c5fd62aedd$var$descriptionStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text-subtlest, ${(0, $PdmhA.N200)})`
});
const $5c2d88c5fd62aedd$var$baseDescriptionStyles = {
    name: "qmaizn",
    styles: "font-size:var(--ds-font-size-075, 12px);margin-block-start:var(--ds-space-050, 4px)"
};
const $5c2d88c5fd62aedd$var$tokenizedDescriptionStyles = {
    name: "z7wamg",
    styles: "font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
const $5c2d88c5fd62aedd$var$disabledDescriptionStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text-disabled, ${(0, $PdmhA.N200)})`
});
const $5c2d88c5fd62aedd$var$positionRelativeStyles = {
    name: "bjn8wh",
    styles: "position:relative"
};
const $5c2d88c5fd62aedd$var$primitiveStyles = {
    name: "vfenhj",
    styles: "display:flex;box-sizing:border-box;width:100%;min-height:40px;margin:var(--ds-space-0, 0px);align-items:center;border:0;outline:0;text-decoration:none;user-select:none;&::-moz-focus-inner{border:0;}&:hover{text-decoration:none;}"
};
const $5c2d88c5fd62aedd$var$primitiveBaseStyles = {
    name: "u4rmul",
    styles: "font-size:var(--ds-font-size-100, 14px)"
};
const $5c2d88c5fd62aedd$var$spacingMapStyles = {
    cozy: {
        name: "1x13z0k",
        styles: "padding-block:var(--ds-space-100, 8px);padding-inline:var(--ds-space-200, 16px)"
    },
    compact: {
        name: "1xdhs5i",
        styles: "min-height:32px;padding-block:var(--ds-space-050, 4px);padding-inline:var(--ds-space-150, 12px)"
    }
};
const $5c2d88c5fd62aedd$var$interactiveStyles = {
    name: "e0dnmk",
    styles: "cursor:pointer"
};
const $5c2d88c5fd62aedd$var$unselectedStyles = /*#__PURE__*/ (0, $byn9U.css)({
    backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
    color: 'currentColor',
    '&:visited': {
        color: 'currentColor'
    },
    '&:hover': {
        backgroundColor: `var(--ds-background-neutral-subtle-hovered, ${(0, $PdmhA.N20)})`,
        color: 'currentColor'
    },
    '&:active': {
        backgroundColor: `var(--ds-background-neutral-subtle-pressed, ${(0, $PdmhA.N30)})`,
        boxShadow: 'none',
        color: 'currentColor'
    }
});
const $5c2d88c5fd62aedd$var$disabledStyles = /*#__PURE__*/ (0, $byn9U.css)({
    cursor: 'not-allowed',
    '&, :hover, :active': {
        backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
        color: `var(--ds-text-disabled, ${(0, $PdmhA.N200)})`
    }
});
const $5c2d88c5fd62aedd$var$selectedBorderStyles = {
    name: "1dgy7ry",
    styles: "&::before{width:2px;position:absolute;background:var(--ds-border-selected, transparent);content:\"\";inset-block-end:0;inset-block-start:0;inset-inline-start:0;}"
};
const $5c2d88c5fd62aedd$var$selectedNotchStyles = /*#__PURE__*/ (0, $byn9U.css)({
    '&::before': {
        width: 4,
        position: 'absolute',
        background: "var(--ds-border-selected, transparent)",
        borderRadius: `0 ${"var(--ds-border-radius, 4px)"} ${"var(--ds-border-radius, 4px)"} 0`,
        content: '""',
        insetBlockEnd: "var(--ds-space-150, 12px)",
        insetBlockStart: "var(--ds-space-150, 12px)",
        insetInlineStart: 0
    }
});
const $5c2d88c5fd62aedd$var$selectedStyles = /*#__PURE__*/ (0, $byn9U.css)({
    backgroundColor: `var(--ds-background-selected, ${(0, $PdmhA.N20)})`,
    // Fallback set as babel plugin inserts one otherwise
    color: "var(--ds-text-selected, currentColor)",
    '&:visited': {
        color: "var(--ds-text-selected, currentColor)"
    },
    '&:hover': {
        backgroundColor: `var(--ds-background-selected-hovered, ${(0, $PdmhA.N20)})`,
        color: "var(--ds-text-selected, currentColor)"
    },
    '&:active': {
        backgroundColor: `var(--ds-background-selected-pressed, ${(0, $PdmhA.N30)})`,
        color: "var(--ds-text-selected, currentColor)"
    }
});
const $5c2d88c5fd62aedd$var$gapMap = {
    compact: 'space.100',
    cozy: 'space.150'
};
/**
 * __Menu item primitive__
 *
 * Menu item primitive contains all the styles for menu items,
 * including support for selected, disabled, and interaction states.
 *
 * Using children as function prop you wire up this to your own host element.
 *
 * ```jsx
 * <MenuItemPrimitive>
 *   {({ children, ...props }) => <button {...props}>{children}</button>}
 * </MenuItemPrimitive>
 * ```
 */ const $5c2d88c5fd62aedd$var$MenuItemPrimitive = ({ children: children, title: title, description: description, iconAfter: iconAfter, iconBefore: iconBefore, overrides: overrides, className: UNSAFE_externalClassName, shouldTitleWrap: shouldTitleWrap = false, shouldDescriptionWrap: shouldDescriptionWrap = false, isDisabled: isDisabled = false, isSelected: isSelected = false, testId: testId })=>{
    (0, $1Ivg5.propDeprecationWarning)('', 'overrides', overrides !== undefined, '' // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    const spacing = (0, $eUqFw.useContext)((0, $8jcoK.SpacingContext));
    const selectionStyle = (0, $eUqFw.useContext)((0, $8jcoK.SELECTION_STYLE_CONTEXT_DO_NOT_USE));
    const renderTitle = overrides && overrides.Title && overrides.Title.render || $5c2d88c5fd62aedd$var$defaultRender;
    const UNSAFE_className = (0, $XHGTv.getBooleanFF)('platform.design-system-team.unsafe-overrides-killswitch_c8j9m') ? undefined : UNSAFE_externalClassName;
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $byn9U.ClassNames), null, ({ css: cn, cx: cx })=>{
        return /*#__PURE__*/ (0, $byn9U.jsx)((0, $51sCz.default), {
            isInset: true
        }, children({
            className: cx([
                cn([
                    $5c2d88c5fd62aedd$var$positionRelativeStyles,
                    $5c2d88c5fd62aedd$var$primitiveStyles,
                    (0, $XHGTv.getBooleanFF)('platform.design-system-team.menu-tokenised-typography-styles') ? undefined : $5c2d88c5fd62aedd$var$primitiveBaseStyles,
                    $5c2d88c5fd62aedd$var$spacingMapStyles[spacing],
                    !isDisabled && !isSelected && $5c2d88c5fd62aedd$var$unselectedStyles,
                    !isDisabled && isSelected && [
                        $5c2d88c5fd62aedd$var$selectedStyles,
                        [
                            selectionStyle === 'border' && $5c2d88c5fd62aedd$var$selectedBorderStyles,
                            selectionStyle === 'notch' && $5c2d88c5fd62aedd$var$selectedNotchStyles
                        ]
                    ],
                    isDisabled ? $5c2d88c5fd62aedd$var$disabledStyles : $5c2d88c5fd62aedd$var$interactiveStyles
                ]),
                UNSAFE_className
            ]),
            children: /*#__PURE__*/ (0, $byn9U.jsx)((0, $9Amv1.default), {
                as: "span",
                spread: "space-between",
                alignBlock: "center",
                space: $5c2d88c5fd62aedd$var$gapMap[spacing],
                grow: "fill",
                testId: testId && `${testId}--container`
            }, iconBefore && /*#__PURE__*/ (0, $byn9U.jsx)("span", {
                "data-item-elem-before": true,
                css: $5c2d88c5fd62aedd$var$beforeAfterElementStyles,
                "data-testid": testId && `${testId}--icon-before`
            }, iconBefore), title && /*#__PURE__*/ (0, $byn9U.jsx)((0, $1zbEq.default), {
                alignBlock: "center",
                grow: "fill",
                xcss: (0, $XHGTv.getBooleanFF)('platform.design-system-team.menu-tokenised-typography-styles') ? $5c2d88c5fd62aedd$var$contentStyles : [
                    $5c2d88c5fd62aedd$var$contentStyles,
                    $5c2d88c5fd62aedd$var$baseContentStyles
                ]
            }, renderTitle('span', {
                children: title,
                className: cn((0, $XHGTv.getBooleanFF)('platform.design-system-team.menu-tokenised-typography-styles') ? $5c2d88c5fd62aedd$var$titleStyles : undefined, shouldTitleWrap ? $5c2d88c5fd62aedd$var$wordBreakStyles : $5c2d88c5fd62aedd$var$truncateStyles),
                'data-item-title': true
            }), description && /*#__PURE__*/ (0, $byn9U.jsx)("span", {
                "data-item-description": true,
                css: [
                    $5c2d88c5fd62aedd$var$descriptionStyles,
                    (0, $XHGTv.getBooleanFF)('platform.design-system-team.menu-tokenised-typography-styles') ? $5c2d88c5fd62aedd$var$tokenizedDescriptionStyles : $5c2d88c5fd62aedd$var$baseDescriptionStyles,
                    isDisabled && $5c2d88c5fd62aedd$var$disabledDescriptionStyles,
                    shouldDescriptionWrap ? $5c2d88c5fd62aedd$var$wordBreakStyles : $5c2d88c5fd62aedd$var$truncateStyles
                ]
            }, description)), iconAfter && /*#__PURE__*/ (0, $byn9U.jsx)("span", {
                "data-item-elem-after": true,
                css: $5c2d88c5fd62aedd$var$beforeAfterElementStyles,
                "data-testid": testId && `${testId}--icon-after`
            }, iconAfter))
        }));
    });
};
var $5c2d88c5fd62aedd$export$2e2bcd8739ae039 = $5c2d88c5fd62aedd$var$MenuItemPrimitive;

});


parcelRegister("e7PSD", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa38d104f225a0f2$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $1Ivg5 = parcelRequire("1Ivg5");

var $5Q9wj = parcelRequire("5Q9wj");

var $XHGTv = parcelRequire("XHGTv");

var $1RaV8 = parcelRequire("1RaV8");
const $aa38d104f225a0f2$var$preventEvent = (e)=>{
    e.preventDefault();
};
/**
 * __Custom item__
 *
 * A custom item is used to populate a menu with items that can be any element.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/custom-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $aa38d104f225a0f2$var$CustomItem = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)(({ component: Component, cssFn: cssFn = (0, $5Q9wj.default), isDisabled: isDisabled = false, isSelected: isSelected = false, onClick: onClick, testId: testId, children: children, description: description, iconAfter: iconAfter, iconBefore: iconBefore, overrides: overrides, onMouseDown: onMouseDown, shouldTitleWrap: shouldTitleWrap, shouldDescriptionWrap: shouldDescriptionWrap, // Although this isn't defined on props it is available because we've used
// Spread props below and on the jsx element. To forcibly block usage I've
// picked it out and supressed the expected type error.
// @ts-expect-error
className: UNSAFE_className, ...rest }, ref)=>{
    const onMouseDownHandler = onMouseDown;
    if (!Component) return null;
    (0, $1Ivg5.propDeprecationWarning)('', 'cssFn', cssFn !== (0, $5Q9wj.default), '' // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $1RaV8.default), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $XHGTv.getBooleanFF)('platform.design-system-team.unsafe-overrides-killswitch_c8j9m') ? undefined : UNSAFE_className,
        ...rest,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        overrides: overrides,
        description: description,
        iconAfter: iconAfter,
        title: children,
        iconBefore: iconBefore,
        isSelected: isSelected,
        isDisabled: isDisabled,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: (0, $byn9U.css)(cssFn({
            isDisabled: isDisabled,
            isSelected: isSelected
        })),
        testId: testId && `${testId}--primitive`
    }, ({ children: children, className: className })=>/*#__PURE__*/ (0, $byn9U.jsx)(Component, {
            "data-testid": testId,
            ...rest,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            ref: ref,
            draggable: false,
            onDragStart: $aa38d104f225a0f2$var$preventEvent,
            onMouseDown: isDisabled ? $aa38d104f225a0f2$var$preventEvent : onMouseDownHandler,
            onClick: isDisabled ? $aa38d104f225a0f2$var$preventEvent : onClick,
            tabIndex: isDisabled ? -1 : undefined,
            "aria-disabled": isDisabled
        }, children));
}));
var $aa38d104f225a0f2$export$2e2bcd8739ae039 = $aa38d104f225a0f2$var$CustomItem;

});

parcelRegister("bo4OB", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa4d17ce40ea0b32$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $1Ivg5 = parcelRequire("1Ivg5");

var $5Q9wj = parcelRequire("5Q9wj");

var $XHGTv = parcelRequire("XHGTv");

var $1RaV8 = parcelRequire("1RaV8");
const $fa4d17ce40ea0b32$var$preventEvent = (e)=>{
    e.preventDefault();
};
/**
 * __Link item__
 *
 * A link item is used to populate a menu with items that are links.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/link-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $fa4d17ce40ea0b32$var$LinkItem = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)(// Type needed on props to extract types with extract react types.
(props, ref)=>{
    const { children: children, href: href, cssFn: cssFn = (0, $5Q9wj.default), description: description, iconAfter: iconAfter, iconBefore: iconBefore, isDisabled: isDisabled = false, isSelected: isSelected = false, onClick: onClick, testId: testId, overrides: overrides, onMouseDown: onMouseDown, shouldTitleWrap: shouldTitleWrap, shouldDescriptionWrap: shouldDescriptionWrap, // Although this isn't defined on props it is available because we've used
    // Spread props below and on the jsx element. To forcibly block usage I've
    // picked it out and supressed the expected type error.
    // @ts-expect-error
    className: UNSAFE_className, ...rest } = props;
    const onMouseDownHandler = onMouseDown;
    if (!children) return null;
    (0, $1Ivg5.propDeprecationWarning)('', 'cssFn', cssFn !== (0, $5Q9wj.default), '' // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $1RaV8.default), {
        ...rest,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $XHGTv.getBooleanFF)('platform.design-system-team.unsafe-overrides-killswitch_c8j9m') ? undefined : UNSAFE_className,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        overrides: overrides,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isSelected: isSelected,
        isDisabled: isDisabled,
        description: description,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        css: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        cssFn({
            isSelected: isSelected,
            isDisabled: isDisabled
        }),
        title: children,
        testId: testId && `${testId}--primitive`
    }, ({ children: children, className: className })=>/*#__PURE__*/ (0, $byn9U.jsx)("a", {
            "data-testid": testId,
            ...rest,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            href: isDisabled ? undefined : href,
            draggable: false,
            // eslint-disable-next-line @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop
            onDragStart: $fa4d17ce40ea0b32$var$preventEvent,
            onMouseDown: isDisabled ? $fa4d17ce40ea0b32$var$preventEvent : onMouseDownHandler,
            onClick: isDisabled ? $fa4d17ce40ea0b32$var$preventEvent : onClick,
            "aria-current": isSelected ? 'page' : undefined,
            "aria-disabled": isDisabled,
            ref: ref
        }, children));
}));
var $fa4d17ce40ea0b32$export$2e2bcd8739ae039 = $fa4d17ce40ea0b32$var$LinkItem;

});


parcelRegister("fEubG", function(module, exports) {

$parcel$export(module.exports, "default", () => $920365f1041780e0$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jFtVs = parcelRequire("jFtVs");

var $8BKky = parcelRequire("8BKky");

var $lmkW0 = parcelRequire("lmkW0");
/**
 * __Dropdown item checkbox group__
 *
 * A wrapping element for dropdown menu items.
 *
 */ const $920365f1041780e0$var$DropdownMenuItemGroup = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, id: id, isList: isList, isScrollable: isScrollable, title: title, testId: testId, hasSeparator: hasSeparator, overrides: overrides, ...rest }, ref)=>{
    const uid = (0, $jFtVs.useUID)();
    const titleId = `dropdown-menu-item-group-title-${uid}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BKky.default), {
        id: id,
        ref: ref,
        isList: isList,
        isScrollable: isScrollable,
        hasSeparator: hasSeparator,
        testId: testId,
        titleId: title ? titleId : undefined,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides, @atlaskit/design-system/no-deprecated-apis
        overrides: overrides,
        ...rest
    }, title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lmkW0.default), {
        id: titleId,
        title: title
    }), children);
});
var $920365f1041780e0$export$2e2bcd8739ae039 = $920365f1041780e0$var$DropdownMenuItemGroup;

});
parcelRegister("8BKky", function(module, exports) {

$parcel$export(module.exports, "default", () => $073dff249b778dca$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage, @atlaskit/design-system/ensure-design-token-usage/preview */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $1Ivg5 = parcelRequire("1Ivg5");

var $XHGTv = parcelRequire("XHGTv");

var $PdmhA = parcelRequire("PdmhA");

var $lcnyw = parcelRequire("lcnyw");

var $4lTFP = parcelRequire("4lTFP");

var $5wpwq = parcelRequire("5wpwq");
function $073dff249b778dca$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $073dff249b778dca$var$gridSize = (0, $lcnyw.gridSize)();
const $073dff249b778dca$var$itemHeadingTopMargin = $073dff249b778dca$var$gridSize * 2.5;
const $073dff249b778dca$var$itemHeadingBottomMargin = $073dff249b778dca$var$gridSize * 0.75;
// Skeleton content is slightly shorter than the real content.
// Because of that we slightly increase the top margin to offset this so the
// containing size both real and skeleton always equal approx 30px.
const $073dff249b778dca$var$itemHeadingContentHeight = (0, $4lTFP.headingSizes).h100.lineHeight;
const $073dff249b778dca$var$skeletonHeadingHeight = $073dff249b778dca$var$gridSize;
const $073dff249b778dca$var$skeletonHeadingMarginOffset = 3;
const $073dff249b778dca$var$skeletonHeadingTopMargin = $073dff249b778dca$var$itemHeadingTopMargin + ($073dff249b778dca$var$itemHeadingContentHeight - $073dff249b778dca$var$skeletonHeadingHeight) - $073dff249b778dca$var$skeletonHeadingMarginOffset;
// We want to move the entire body up by 3px without affecting the height of the skeleton container.
const $073dff249b778dca$var$skeletonHeadingBottomMargin = $073dff249b778dca$var$itemHeadingBottomMargin + $073dff249b778dca$var$skeletonHeadingMarginOffset;
const $073dff249b778dca$var$sectionPaddingTopBottom = $073dff249b778dca$var$gridSize * 0.75;
const $073dff249b778dca$var$VAR_SEPARATOR_COLOR = '--ds-menu-seperator-color';
const $073dff249b778dca$var$sectionStyles = /*#__PURE__*/ (0, $byn9U.css)({
    '&::before, &::after': {
        display: 'block',
        height: $073dff249b778dca$var$sectionPaddingTopBottom,
        content: '""'
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    '& [data-ds--menu--heading-item]': {
        marginBlockEnd: $073dff249b778dca$var$itemHeadingBottomMargin,
        marginBlockStart: $073dff249b778dca$var$itemHeadingTopMargin,
        '&:first-of-type': {
            marginBlockStart: $073dff249b778dca$var$itemHeadingTopMargin - $073dff249b778dca$var$sectionPaddingTopBottom
        }
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    '& [data-ds--menu--skeleton-heading-item]': {
        marginBlockEnd: $073dff249b778dca$var$skeletonHeadingBottomMargin,
        marginBlockStart: $073dff249b778dca$var$skeletonHeadingTopMargin,
        '&:first-of-type': {
            marginBlockStart: $073dff249b778dca$var$skeletonHeadingTopMargin - $073dff249b778dca$var$sectionPaddingTopBottom
        }
    },
    '&:focus': {
        // NOTE: Firefox allows elements that have "overflow: auto" to gain focus (as if it had tab-index="0")
        // We have made a deliberate choice to leave this behaviour as is.
        // This makes the outline go inside by 1px so it can actually be displayed
        // else it gets cut off from the overflow: scroll from the parent menu group.
        outlineOffset: -1
    }
});
const $073dff249b778dca$var$scrollableStyles = {
    name: "qji62u",
    styles: "flex-shrink:1;overflow:auto"
};
const $073dff249b778dca$var$unscrollableStyles = {
    name: "ozd7xs",
    styles: "flex-shrink:0"
};
const $073dff249b778dca$var$thickSeparatorStyles = /*#__PURE__*/ (0, $byn9U.css)({
    borderBlockStart: `2px solid var(${$073dff249b778dca$var$VAR_SEPARATOR_COLOR}, ${`var(--ds-border, ${(0, $PdmhA.N30A)})`})`
});
const $073dff249b778dca$var$thinSeparatorStyles = /*#__PURE__*/ (0, $byn9U.css)({
    borderBlockStart: `1px solid var(${$073dff249b778dca$var$VAR_SEPARATOR_COLOR}, ${`var(--ds-border, ${(0, $PdmhA.N30A)})`})`
});
const $073dff249b778dca$var$noSeparatorStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // this is to ensure that adjacent sections without separators don't get additional margins.
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    '[data-section] + &': {
        marginBlockStart: -6
    }
});
/**
 * __Section__
 *
 * A section includes related actions or items in a menu.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/section)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $073dff249b778dca$var$Section = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, overrides: overrides, title: title, titleId: titleId, testId: testId, isScrollable: isScrollable, hasSeparator: hasSeparator, id: id, isList: isList = false, // Although this isn't defined on props it is available because we've used
// Spread props below and on the jsx element. To forcibly block usage I've
// picked it out and supressed the expected type error.
// @ts-expect-error
className: UNSAFE_className, ...rest }, ref)=>{
    (0, $1Ivg5.propDeprecationWarning)('', 'overrides', overrides !== undefined, '' // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    const UNSAFE_headingOverrides = (0, $XHGTv.getBooleanFF)('platform.design-system-team.unsafe-overrides-killswitch_c8j9m') ? undefined : overrides && overrides.HeadingItem && overrides.HeadingItem.cssFn;
    const content = isList ? /*#__PURE__*/ (0, $byn9U.jsx)("ul", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            margin: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            padding: 0
        }
    }, (0, $eUqFw.Children).map((0, $eUqFw.Children).toArray(children), (child, index)=>/*#__PURE__*/ (0, $byn9U.jsx)("li", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                listStyleType: 'none',
                margin: 0,
                padding: 0
            },
            key: index
        }, child))) : children;
    const childrenMarkup = title !== undefined ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $5wpwq.default), {
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        cssFn: UNSAFE_headingOverrides,
        testId: testId && `${testId}--heading`,
        "aria-hidden": true
    }, title), content) : /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, content);
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ...rest,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $XHGTv.getBooleanFF)('platform.design-system-team.unsafe-overrides-killswitch_c8j9m') ? undefined : UNSAFE_className,
        id: id,
        // NOTE: Firefox allows elements that have "overflow: auto" to gain focus (as if it had tab-index="0")
        // We have made a deliberate choice to leave this behaviour as is.
        css: [
            $073dff249b778dca$var$sectionStyles,
            isScrollable ? $073dff249b778dca$var$scrollableStyles : $073dff249b778dca$var$unscrollableStyles,
            hasSeparator ? (0, $XHGTv.getBooleanFF)('platform.design-system-team.section-1px-seperator-borders') ? $073dff249b778dca$var$thinSeparatorStyles : $073dff249b778dca$var$thickSeparatorStyles : $073dff249b778dca$var$noSeparatorStyles
        ],
        "aria-label": title,
        "aria-labelledby": titleId,
        "data-testid": testId,
        role: "group",
        "data-section": true,
        ref: ref
    }, childrenMarkup);
});
var $073dff249b778dca$export$2e2bcd8739ae039 = $073dff249b778dca$var$Section;

});
parcelRegister("5wpwq", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b4e8b314a8e2773$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $1Ivg5 = parcelRequire("1Ivg5");

var $5Q9wj = parcelRequire("5Q9wj");

var $XHGTv = parcelRequire("XHGTv");

var $PdmhA = parcelRequire("PdmhA");

var $4lTFP = parcelRequire("4lTFP");
function $2b4e8b314a8e2773$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $2b4e8b314a8e2773$var$itemHeadingContentHeight = (0, $4lTFP.headingSizes).h100.lineHeight;
const $2b4e8b314a8e2773$var$itemHeadingFontSize = (0, $4lTFP.headingSizes).h100.size;
const $2b4e8b314a8e2773$var$headingStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text-subtle, ${(0, $PdmhA.N300)})`,
    paddingBlock: "var(--ds-space-0, 0px)",
    paddingInline: "var(--ds-space-200, 16px)",
    textTransform: 'uppercase'
});
const $2b4e8b314a8e2773$var$baseHeadingStyles = /*#__PURE__*/ (0, $byn9U.css)({
    fontSize: $2b4e8b314a8e2773$var$itemHeadingFontSize,
    fontWeight: "var(--ds-font-weight-bold, 700)",
    lineHeight: $2b4e8b314a8e2773$var$itemHeadingContentHeight / $2b4e8b314a8e2773$var$itemHeadingFontSize
});
const $2b4e8b314a8e2773$var$tokenizedHeadingStyles = {
    name: "1xm9io",
    styles: "font:var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
/**
 * __Heading item__
 *
 * A heading item is used to describe sibling menu items.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/heading-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $2b4e8b314a8e2773$var$HeadingItem = /*#__PURE__*/ (0, $eUqFw.memo)(({ children: children, testId: testId, headingLevel: headingLevel = 2, id: id, cssFn: cssFn = (0, $5Q9wj.default), // Although this isn't defined on props it is available because we've used
// Spread props below and on the jsx element. To forcibly block usage I've
// picked it out and supressed the expected type error.
// @ts-expect-error
className: UNSAFE_className, ...rest })=>{
    (0, $1Ivg5.propDeprecationWarning)('', 'cssFn', cssFn !== (0, $5Q9wj.default), '' // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    const UNSAFE_overrides = (0, $XHGTv.getBooleanFF)('platform.design-system-team.unsafe-overrides-killswitch_c8j9m') ? undefined : /*#__PURE__*/ (0, $byn9U.css)(cssFn(undefined));
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $2b4e8b314a8e2773$var$headingStyles,
            (0, $XHGTv.getBooleanFF)('platform.design-system-team.menu-tokenised-typography-styles') ? $2b4e8b314a8e2773$var$tokenizedHeadingStyles : $2b4e8b314a8e2773$var$baseHeadingStyles,
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            UNSAFE_overrides
        ],
        role: "heading",
        "aria-level": headingLevel,
        "data-testid": testId,
        "data-ds--menu--heading-item": true,
        id: id,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $XHGTv.getBooleanFF)('platform.design-system-team.unsafe-overrides-killswitch_c8j9m') ? undefined : UNSAFE_className,
        ...rest
    }, children);
});
var $2b4e8b314a8e2773$export$2e2bcd8739ae039 = $2b4e8b314a8e2773$var$HeadingItem;

});


parcelRegister("lmkW0", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c8b6b0ed3e98f7b$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $PdmhA = parcelRequire("PdmhA");

var $4lTFP = parcelRequire("4lTFP");
const $4c8b6b0ed3e98f7b$var$itemHeadingContentHeight = (0, $4lTFP.headingSizes).h100.lineHeight;
const $4c8b6b0ed3e98f7b$var$itemHeadingFontSize = (0, $4lTFP.headingSizes).h100.size;
const $4c8b6b0ed3e98f7b$var$headingStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text-subtle, ${(0, $PdmhA.N300)})`,
    fontSize: $4c8b6b0ed3e98f7b$var$itemHeadingFontSize,
    fontWeight: "var(--ds-font-weight-bold, 700)",
    lineHeight: $4c8b6b0ed3e98f7b$var$itemHeadingContentHeight / $4c8b6b0ed3e98f7b$var$itemHeadingFontSize,
    paddingBlock: "var(--ds-space-0, 0px)",
    paddingInline: "var(--ds-space-200, 16px)",
    textTransform: 'uppercase'
});
/**
 * __Group title__
 *
 * Used to visually represent the title for DropdownMenu groups
 *
 * @internal
 */ const $4c8b6b0ed3e98f7b$var$GroupTitle = ({ id: id, title: title })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "data-ds--menu--heading-item": true,
        role: "menuitem",
        id: id,
        "aria-hidden": "true",
        css: $4c8b6b0ed3e98f7b$var$headingStyles
    }, title);
var $4c8b6b0ed3e98f7b$export$2e2bcd8739ae039 = $4c8b6b0ed3e98f7b$var$GroupTitle;

});


parcelRegister("ffiyv", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee4547c882ae1a52$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");
function $ee4547c882ae1a52$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ee4547c882ae1a52$var$baseStyles = (0, $1ZAYh.xcss)({
    display: 'inline-flex',
    borderRadius: 'border.radius',
    blockSize: 'min-content',
    position: 'static',
    overflow: 'hidden'
});
const $ee4547c882ae1a52$var$textStyles = {
    name: "30odxn",
    styles: "font:var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);font-weight:var(--ds-font-weight-bold, 700);overflow:hidden;text-overflow:ellipsis;text-transform:uppercase;white-space:nowrap"
};
/**
 * __Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 *
 * - [Examples](https://atlassian.design/components/lozenge/examples)
 * - [Code](https://atlassian.design/components/lozenge/code)
 * - [Usage](https://atlassian.design/components/lozenge/usage)
 */ const $ee4547c882ae1a52$var$Lozenge = /*#__PURE__*/ (0, $eUqFw.memo)(({ children: children, testId: testId, isBold: isBold = false, appearance: appearance = 'default', maxWidth: maxWidth = 200, style: style })=>{
    const appearanceStyle = isBold ? 'bold' : 'subtle';
    const appearanceType = appearance in $ee4547c882ae1a52$var$backgroundColors[appearanceStyle] ? appearance : 'default';
    const maxWidthValue = typeof maxWidth === 'string' ? maxWidth : `${maxWidth}px`;
    const maxWidthIsPc = typeof maxWidth === 'string' && /%$/.test(maxWidth);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        as: "span",
        backgroundColor: $ee4547c882ae1a52$var$backgroundColors[appearanceStyle][appearanceType],
        style: {
            backgroundColor: style?.backgroundColor,
            maxWidth: maxWidthIsPc ? maxWidth : '100%'
        },
        paddingInline: "space.050",
        xcss: $ee4547c882ae1a52$var$baseStyles,
        testId: testId
    }, /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: [
            $ee4547c882ae1a52$var$textStyles,
            $ee4547c882ae1a52$var$textColors[appearanceStyle][appearanceType]
        ],
        style: {
            color: style?.color,
            // to negate paddingInline specified on Box above
            maxWidth: maxWidthIsPc ? '100%' : `calc(${maxWidthValue} - ${"var(--ds-space-100, 8px)"})`
        },
        "data-testid": testId && `${testId}--text`
    }, children));
});
$ee4547c882ae1a52$var$Lozenge.displayName = 'Lozenge';
var $ee4547c882ae1a52$export$2e2bcd8739ae039 = $ee4547c882ae1a52$var$Lozenge;
const $ee4547c882ae1a52$var$backgroundColors = {
    bold: {
        default: 'color.background.neutral.bold',
        inprogress: 'color.background.information.bold',
        moved: 'color.background.warning.bold',
        new: 'color.background.discovery.bold',
        removed: 'color.background.danger.bold',
        success: 'color.background.success.bold'
    },
    subtle: {
        default: 'color.background.neutral',
        inprogress: 'color.background.information',
        moved: 'color.background.warning',
        new: 'color.background.discovery',
        removed: 'color.background.danger',
        success: 'color.background.success'
    }
};
const $ee4547c882ae1a52$var$textColors = {
    bold: {
        default: {
            name: "1wvsb8v",
            styles: "color:var(--ds-text-inverse, #FFFFFF)"
        },
        inprogress: {
            name: "1wvsb8v",
            styles: "color:var(--ds-text-inverse, #FFFFFF)"
        },
        moved: {
            name: "tgubtb",
            styles: "color:var(--ds-text-warning-inverse, #172B4D)"
        },
        new: {
            name: "1wvsb8v",
            styles: "color:var(--ds-text-inverse, #FFFFFF)"
        },
        removed: {
            name: "1wvsb8v",
            styles: "color:var(--ds-text-inverse, #FFFFFF)"
        },
        success: {
            name: "1wvsb8v",
            styles: "color:var(--ds-text-inverse, #FFFFFF)"
        }
    },
    subtle: {
        default: {
            name: "kmxsjg",
            styles: "color:var(--ds-text-subtle, #42526E)"
        },
        inprogress: {
            name: "3j31nl",
            styles: "color:var(--ds-text-information, #0052CC)"
        },
        moved: {
            name: "1g2i1rp",
            styles: "color:var(--ds-text-warning, #974F0C)"
        },
        new: {
            name: "3juofh",
            styles: "color:var(--ds-text-discovery, #403294)"
        },
        removed: {
            name: "18zo14t",
            styles: "color:var(--ds-text-danger, #DE350B)"
        },
        success: {
            name: "1ychrch",
            styles: "color:var(--ds-text-success, #006644)"
        }
    }
};

});

parcelRegister("aVkzK", function(module, exports) {

$parcel$export(module.exports, "default", () => $cde2ba376b255ed5$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $1Ivg5 = parcelRequire("1Ivg5");

var $5Q9wj = parcelRequire("5Q9wj");

var $XHGTv = parcelRequire("XHGTv");

var $PdmhA = parcelRequire("PdmhA");

var $lcnyw = parcelRequire("lcnyw");

var $73N4g = parcelRequire("73N4g");
function $cde2ba376b255ed5$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $cde2ba376b255ed5$var$gridSize = (0, $lcnyw.gridSize)();
const $cde2ba376b255ed5$var$borderRadius = (0, $lcnyw.borderRadius)();
const $cde2ba376b255ed5$var$itemElemSpacing = $cde2ba376b255ed5$var$gridSize * 1.5;
const $cde2ba376b255ed5$var$itemExpectedElemSize = $cde2ba376b255ed5$var$gridSize * 3;
const $cde2ba376b255ed5$var$itemMinHeight = $cde2ba376b255ed5$var$gridSize * 5;
const $cde2ba376b255ed5$var$skeletonItemElemSize = $cde2ba376b255ed5$var$gridSize * 2.5;
const $cde2ba376b255ed5$var$itemElemSkeletonOffset = ($cde2ba376b255ed5$var$itemExpectedElemSize - $cde2ba376b255ed5$var$skeletonItemElemSize) / 2;
const $cde2ba376b255ed5$var$skeletonTextBorderRadius = 100;
const $cde2ba376b255ed5$var$skeletonContentHeight = 9;
const $cde2ba376b255ed5$var$skeletonColor = `var(--ds-skeleton, ${(0, $PdmhA.N20A)})`;
const $cde2ba376b255ed5$var$skeletonStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    minHeight: $cde2ba376b255ed5$var$itemMinHeight,
    padding: `0 ${"var(--ds-space-250, 20px)"}`,
    alignItems: 'center',
    pointerEvents: 'none',
    '::after': {
        height: $cde2ba376b255ed5$var$skeletonContentHeight,
        backgroundColor: $cde2ba376b255ed5$var$skeletonColor,
        borderRadius: $cde2ba376b255ed5$var$skeletonTextBorderRadius,
        content: '""',
        // This is a little bespoke but we need to push everything down 1px
        // because the skeleton content should align to the bottom of the text.
        // Confirm VR test failures before accepting a change.
        marginBlockStart: 1
    }
});
const $cde2ba376b255ed5$var$defaultWidthStyles = {
    name: "sljcv5",
    styles: ":nth-of-type(1n)::after{flex-basis:70%;}:nth-of-type(2n)::after{flex-basis:50%;}:nth-of-type(3n)::after{flex-basis:60%;}:nth-of-type(4n)::after{flex-basis:90%;}:nth-of-type(5n)::after{flex-basis:35%;}:nth-of-type(6n)::after{flex-basis:77%;}"
};
const $cde2ba376b255ed5$var$customWidthStyles = {
    name: "nsk3fe",
    styles: "::after{flex-basis:var(--width);}"
};
const $cde2ba376b255ed5$var$beforeElementStyles = /*#__PURE__*/ (0, $byn9U.css)({
    '::before': {
        width: $cde2ba376b255ed5$var$skeletonItemElemSize,
        height: $cde2ba376b255ed5$var$skeletonItemElemSize,
        flexShrink: 0,
        backgroundColor: $cde2ba376b255ed5$var$skeletonColor,
        content: '""',
        marginInlineEnd: $cde2ba376b255ed5$var$itemElemSpacing + $cde2ba376b255ed5$var$itemElemSkeletonOffset,
        marginInlineStart: "var(--ds-space-025, 2px)"
    }
});
const $cde2ba376b255ed5$var$avatarStyles = {
    name: "lz1zvf",
    styles: "::before{border-radius:100%;}"
};
const $cde2ba376b255ed5$var$iconStyles = /*#__PURE__*/ (0, $byn9U.css)({
    '::before': {
        borderRadius: $cde2ba376b255ed5$var$borderRadius
    }
});
/**
 * __Skeleton item__
 *
 * A skeleton item is used in place of an item when its contents it not ready.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/skeleton-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $cde2ba376b255ed5$var$SkeletonItem = ({ hasAvatar: hasAvatar, hasIcon: hasIcon, isShimmering: isShimmering = false, testId: testId, width: width, cssFn: cssFn = (0, $5Q9wj.default) })=>{
    (0, $1Ivg5.propDeprecationWarning)('', 'cssFn', cssFn !== (0, $5Q9wj.default), '' // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    const UNSAFE_overrides = (0, $XHGTv.getBooleanFF)('platform.design-system-team.unsafe-overrides-killswitch_c8j9m') ? undefined : /*#__PURE__*/ (0, $byn9U.css)(cssFn());
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $73N4g.default), {
        isShimmering: isShimmering
    }, ({ className: className })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                '--width': width
            },
            css: [
                $cde2ba376b255ed5$var$skeletonStyles,
                (hasAvatar || hasIcon) && $cde2ba376b255ed5$var$beforeElementStyles,
                hasAvatar && $cde2ba376b255ed5$var$avatarStyles,
                hasIcon && $cde2ba376b255ed5$var$iconStyles,
                width ? $cde2ba376b255ed5$var$customWidthStyles : $cde2ba376b255ed5$var$defaultWidthStyles,
                // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
                UNSAFE_overrides
            ],
            "data-testid": testId
        }));
};
var $cde2ba376b255ed5$export$2e2bcd8739ae039 = $cde2ba376b255ed5$var$SkeletonItem;

});
parcelRegister("73N4g", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1c3e4cd190ecc73$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $PdmhA = parcelRequire("PdmhA");
/**
 * These keyframes are mirrored in:
 * packages/design-system/theme/src/constants.tsx
 *
 * Please update both.
 */ const $c1c3e4cd190ecc73$var$shimmerKeyframes = (0, $byn9U.keyframes)({
    from: {
        backgroundColor: `var(--ds-skeleton, ${(0, $PdmhA.N20A)})`
    },
    to: {
        backgroundColor: `var(--ds-skeleton-subtle, ${(0, $PdmhA.N30A)})`
    }
});
/**
 * These styles are mirrored in:
 * packages/design-system/theme/src/constants.tsx
 *
 * Please update both.
 */ const $c1c3e4cd190ecc73$var$shimmerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    '::before, ::after': {
        animationDirection: 'alternate',
        animationDuration: '1.5s',
        animationIterationCount: 'infinite',
        animationName: `${$c1c3e4cd190ecc73$var$shimmerKeyframes}`,
        animationTimingFunction: 'linear',
        backgroundColor: `var(--ds-skeleton, ${(0, $PdmhA.N20A)})`
    }
});
/**
 * __Skeleton shimmer__
 *
 * A skeleton shimmer is the animation shown on loading skeletons for
 * perceived performance and user satisfaction.
 *
 * This component provides a `className` through render props. This value will
 * have type:
 * + `string`, when `isShimmering={true}`.
 * + `undefined`, when `isShimmering={false}`.
 *
 * @internal
 */ const $c1c3e4cd190ecc73$var$SkeletonShimmer = ({ children: children, isShimmering: isShimmering = false })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $byn9U.ClassNames), null, ({ css: css })=>children({
            className: isShimmering ? css($c1c3e4cd190ecc73$var$shimmerStyles) : undefined
        }));
};
var $c1c3e4cd190ecc73$export$2e2bcd8739ae039 = $c1c3e4cd190ecc73$var$SkeletonShimmer;

});


parcelRegister("bgY86", function(module, exports) {

$parcel$export(module.exports, "default", () => $36c7adfaa99dd93b$export$2e2bcd8739ae039);

var $XHGTv = parcelRequire("XHGTv");

var $kyri3 = parcelRequire("kyri3");

var $31snR = parcelRequire("31snR");

var $iednx = parcelRequire("iednx");

var $fw2Om = parcelRequire("fw2Om");

var $1UQcZ = parcelRequire("1UQcZ");
const $36c7adfaa99dd93b$var$defaultColorMode = 'light';
const $36c7adfaa99dd93b$var$defaultContrastMode = 'no-preference';
/**
 * Server-side rendering utility. Generates the valid HTML attributes for a given theme.
 * Note: this utility does not handle automatic theme switching.
 *
 * @param {Object<string, string>} themeOptions - Theme options object
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 *
 * @returns {Object} Object of HTML attributes to be applied to the document root
 */ const $36c7adfaa99dd93b$var$getThemeHtmlAttrs = ({ colorMode: colorMode = (0, $31snR.themeStateDefaults)['colorMode'], dark: dark = (0, $31snR.themeStateDefaults)['dark'], light: light = (0, $31snR.themeStateDefaults)['light'], contrastMode: contrastMode = (0, $31snR.themeStateDefaults)['contrastMode'], shape: shape = (0, $31snR.themeStateDefaults)['shape'], spacing: spacing = (0, $31snR.themeStateDefaults)['spacing'], typography: typography = (0, $31snR.themeStateDefaults)['typography'], UNSAFE_themeOptions: UNSAFE_themeOptions = (0, $31snR.themeStateDefaults)['UNSAFE_themeOptions'] } = {})=>{
    const themeAttribute = (0, $iednx.themeObjectToString)({
        dark: dark,
        light: light,
        shape: shape,
        spacing: spacing,
        typography: typography
    });
    let result = {
        [(0, $kyri3.THEME_DATA_ATTRIBUTE)]: themeAttribute,
        [(0, $kyri3.COLOR_MODE_ATTRIBUTE)]: colorMode === 'auto' ? $36c7adfaa99dd93b$var$defaultColorMode : colorMode
    };
    if ((0, $XHGTv.getBooleanFF)('platform.design-system-team.increased-contrast-themes')) result = {
        ...result,
        // CLEANUP: Move this to the initial `result` assignment above
        [(0, $kyri3.CONTRAST_MODE_ATTRIBUTE)]: contrastMode === 'auto' ? $36c7adfaa99dd93b$var$defaultContrastMode : contrastMode
    };
    if (UNSAFE_themeOptions && (0, $fw2Om.isValidBrandHex)(UNSAFE_themeOptions.brandColor)) {
        const optionString = JSON.stringify(UNSAFE_themeOptions);
        const uniqueId = (0, $1UQcZ.hash)(optionString);
        result[0, $kyri3.CUSTOM_THEME_ATTRIBUTE] = uniqueId;
    }
    return result;
};
var $36c7adfaa99dd93b$export$2e2bcd8739ae039 = $36c7adfaa99dd93b$var$getThemeHtmlAttrs;

});
parcelRegister("fw2Om", function(module, exports) {

$parcel$export(module.exports, "isValidBrandHex", () => $2174d67c292df557$export$53031ac1ecb71f44);
$parcel$export(module.exports, "rgbToHex", () => $2174d67c292df557$export$34d09c4a771c46ef);
$parcel$export(module.exports, "hexToRgbA", () => $2174d67c292df557$export$b36dbdb4f463f05c);
$parcel$export(module.exports, "hexToRgb", () => $2174d67c292df557$export$5a544e13ad4e1fa5);
$parcel$export(module.exports, "hexToHSL", () => $2174d67c292df557$export$47ea145a83f50dc0);
$parcel$export(module.exports, "HSLToRGB", () => $2174d67c292df557$export$1ff93e992dd58bec);
$parcel$export(module.exports, "relativeLuminanceW3C", () => $2174d67c292df557$export$e770b01b744f3745);
$parcel$export(module.exports, "getContrastRatio", () => $2174d67c292df557$export$d061e26956a60b0a);
$parcel$export(module.exports, "deltaE", () => $2174d67c292df557$export$e8ddad763b4bebf9);
// valid hex color with 6 digits
const $2174d67c292df557$export$53031ac1ecb71f44 = (hex)=>/^#[0-9A-F]{6}$/i.test(hex);
// valid hex color with 4, 6 or 8 digits
const $2174d67c292df557$var$isValidHex = (hex)=>/^#([A-Fa-f0-9]{3,4}){1,2}$/.test(hex);
function $2174d67c292df557$export$34d09c4a771c46ef(r, g, b) {
    return '#' + (16777216 + (r << 16) + (g << 8) + b).toString(16).slice(1);
}
function $2174d67c292df557$export$1212645cf40ebf71(hex) {
    if (hex.length === 9) {
        const int = parseInt(hex.slice(7, 9), 16) / 255;
        return Number(parseFloat(int.toString()).toFixed(2));
    }
    return 1;
}
function $2174d67c292df557$export$b36dbdb4f463f05c(hex) {
    if (!$2174d67c292df557$var$isValidHex(hex)) throw new Error('Invalid HEX');
    let c;
    c = hex.substring(1).split('');
    if (c.length === 3) c = [
        c[0],
        c[0],
        c[1],
        c[1],
        c[2],
        c[2]
    ];
    c = '0x' + c.join('');
    return [
        c >> 16 & 255,
        c >> 8 & 255,
        c & 255,
        $2174d67c292df557$export$1212645cf40ebf71(hex)
    ];
}
function $2174d67c292df557$export$5a544e13ad4e1fa5(hex) {
    if (!$2174d67c292df557$var$isValidHex(hex)) throw new Error('Invalid HEX');
    let c;
    c = hex.substring(1).split('');
    if (c.length === 3) c = [
        c[0],
        c[0],
        c[1],
        c[1],
        c[2],
        c[2]
    ];
    c = '0x' + c.join('');
    return [
        c >> 16 & 255,
        c >> 8 & 255,
        c & 255
    ];
}
function $2174d67c292df557$export$47ea145a83f50dc0(hex) {
    if (!$2174d67c292df557$var$isValidHex(hex)) throw new Error('Invalid HEX');
    let r = 0, g = 0, b = 0;
    if (hex.length === 4) {
        r = '0x' + hex[1] + hex[1];
        g = '0x' + hex[2] + hex[2];
        b = '0x' + hex[3] + hex[3];
    } else if (hex.length === 7) {
        r = '0x' + hex[1] + hex[2];
        g = '0x' + hex[3] + hex[4];
        b = '0x' + hex[5] + hex[6];
    }
    // Then to HSL
    r /= 255;
    g /= 255;
    b /= 255;
    let cmin = Math.min(r, g, b), cmax = Math.max(r, g, b), delta = cmax - cmin, h = 0, s = 0, l = 0;
    if (delta === 0) h = 0;
    else if (cmax === r) h = (g - b) / delta % 6;
    else if (cmax === g) h = (b - r) / delta + 2;
    else h = (r - g) / delta + 4;
    h = Math.round(h * 60);
    if (h < 0) h += 360;
    l = (cmax + cmin) / 2;
    s = delta === 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
    s = +(s * 100).toFixed(1);
    l = +(l * 100).toFixed(1);
    return [
        h,
        s,
        l
    ];
}
function $2174d67c292df557$export$1ff93e992dd58bec(h, s, l) {
    s /= 100;
    l /= 100;
    const k = (n)=>(n + h / 30) % 12;
    const a = s * Math.min(l, 1 - l);
    const f = (n)=>l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)));
    return [
        255 * f(0),
        255 * f(8),
        255 * f(4)
    ];
}
function $2174d67c292df557$export$e770b01b744f3745(r, g, b) {
    const RsRGB = r / 255;
    const GsRGB = g / 255;
    const BsRGB = b / 255;
    const R = RsRGB <= 0.03928 ? RsRGB / 12.92 : Math.pow((RsRGB + 0.055) / 1.055, 2.4);
    const G = GsRGB <= 0.03928 ? GsRGB / 12.92 : Math.pow((GsRGB + 0.055) / 1.055, 2.4);
    const B = BsRGB <= 0.03928 ? BsRGB / 12.92 : Math.pow((BsRGB + 0.055) / 1.055, 2.4);
    // For the sRGB colorspace, the relative luminance of a color is defined as:
    const L = 0.2126 * R + 0.7152 * G + 0.0722 * B;
    return L;
}
function $2174d67c292df557$export$d061e26956a60b0a(foreground, background) {
    if (!$2174d67c292df557$var$isValidHex(foreground) || !$2174d67c292df557$var$isValidHex(background)) throw new Error('Invalid HEX');
    const foregroundRgb = $2174d67c292df557$export$5a544e13ad4e1fa5(foreground);
    const backgroundRgb = $2174d67c292df557$export$5a544e13ad4e1fa5(background);
    const foregroundLuminance = $2174d67c292df557$export$e770b01b744f3745(foregroundRgb[0], foregroundRgb[1], foregroundRgb[2]);
    const backgroundLuminance = $2174d67c292df557$export$e770b01b744f3745(backgroundRgb[0], backgroundRgb[1], backgroundRgb[2]);
    // calculate the color contrast ratio
    var brightest = Math.max(foregroundLuminance, backgroundLuminance);
    var darkest = Math.min(foregroundLuminance, backgroundLuminance);
    return (brightest + 0.05) / (darkest + 0.05);
}
function $2174d67c292df557$export$e8ddad763b4bebf9(rgbA, rgbB) {
    let labA = $2174d67c292df557$var$rgbToLab(rgbA);
    let labB = $2174d67c292df557$var$rgbToLab(rgbB);
    let deltaL = labA[0] - labB[0];
    let deltaA = labA[1] - labB[1];
    let deltaB = labA[2] - labB[2];
    let c1 = Math.sqrt(labA[1] * labA[1] + labA[2] * labA[2]);
    let c2 = Math.sqrt(labB[1] * labB[1] + labB[2] * labB[2]);
    let deltaC = c1 - c2;
    let deltaH = deltaA * deltaA + deltaB * deltaB - deltaC * deltaC;
    deltaH = deltaH < 0 ? 0 : Math.sqrt(deltaH);
    let sc = 1.0 + 0.045 * c1;
    let sh = 1.0 + 0.015 * c1;
    let deltaLKlsl = deltaL / 1.0;
    let deltaCkcsc = deltaC / sc;
    let deltaHkhsh = deltaH / sh;
    let i = deltaLKlsl * deltaLKlsl + deltaCkcsc * deltaCkcsc + deltaHkhsh * deltaHkhsh;
    return i < 0 ? 0 : Math.sqrt(i);
}
function $2174d67c292df557$var$rgbToLab(rgb) {
    let r = rgb[0] / 255, g = rgb[1] / 255, b = rgb[2] / 255, x, y, z;
    r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
    g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
    b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
    x = (r * 0.4124 + g * 0.3576 + b * 0.1805) / 0.95047;
    y = (r * 0.2126 + g * 0.7152 + b * 0.0722) / 1.0;
    z = (r * 0.0193 + g * 0.1192 + b * 0.9505) / 1.08883;
    x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
    y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
    z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
    return [
        116 * y - 16,
        500 * (x - y),
        200 * (y - z)
    ];
}

});

parcelRegister("1UQcZ", function(module, exports) {

$parcel$export(module.exports, "hash", () => $64b7133bcbaaaeb2$export$d6af199866bfb566);
const $64b7133bcbaaaeb2$export$d6af199866bfb566 = (str)=>{
    let hash = 0;
    for(let i = 0; i < str.length; i++){
        const char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash &= hash; // Convert to 32bit integer
    }
    return new Uint32Array([
        hash
    ])[0].toString(36);
};

});


parcelRegister("hjabr", function(module, exports) {

$parcel$export(module.exports, "getThemePreferences", () => $3abf8d5c3a2ef22f$export$dd6aeb7c823fc03d);
$parcel$export(module.exports, "getThemeOverridePreferences", () => $3abf8d5c3a2ef22f$export$5d76d7014f4a5d08);

var $XHGTv = parcelRequire("XHGTv");

var $iXSlm = parcelRequire("iXSlm");
const $3abf8d5c3a2ef22f$export$dd6aeb7c823fc03d = (themeState)=>{
    const { colorMode: colorMode, contrastMode: contrastMode, dark: dark, light: light, shape: shape, spacing: spacing, typography: typography } = themeState;
    const autoColorModeThemes = [
        light,
        dark
    ];
    const themePreferences = [];
    if (colorMode === 'auto') {
        if (contrastMode !== 'no-preference' && (0, $XHGTv.getBooleanFF)('platform.design-system-team.increased-contrast-themes')) autoColorModeThemes.forEach((normalTheme)=>{
            const increasedContrastTheme = (0, $iXSlm.default)(normalTheme);
            if (increasedContrastTheme) autoColorModeThemes.push(increasedContrastTheme);
        });
        themePreferences.push(...autoColorModeThemes);
    } else {
        themePreferences.push(themeState[colorMode]);
        if (contrastMode !== 'no-preference' && (0, $XHGTv.getBooleanFF)('platform.design-system-team.increased-contrast-themes')) {
            const increasedContrastTheme = (0, $iXSlm.default)(themeState[colorMode]);
            if (increasedContrastTheme) themePreferences.push(increasedContrastTheme);
        }
    }
    [
        shape,
        spacing,
        typography
    ].forEach((themeId)=>{
        if (themeId) themePreferences.push(themeId);
    });
    return [
        ...new Set(themePreferences)
    ];
};
const $3abf8d5c3a2ef22f$export$5d76d7014f4a5d08 = (themeState)=>{
    const themeOverridePreferences = [];
    return [
        ...new Set(themeOverridePreferences)
    ];
};

});
parcelRegister("iXSlm", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb1e7547266d0674$export$2e2bcd8739ae039);

var $31snR = parcelRequire("31snR");
function $fb1e7547266d0674$export$2e2bcd8739ae039(themeId) {
    return Object.entries((0, $31snR.default)).find(([, { increasesContrastFor: increasesContrastFor }])=>{
        return increasesContrastFor === themeId;
    })?.[1].id;
}

});


parcelRegister("2Mf9s", function(module, exports) {

$parcel$export(module.exports, "loadAndAppendThemeCss", () => $318d44fe11a01223$export$26cd7ae85c7144e5);
$parcel$export(module.exports, "loadThemeCss", () => $318d44fe11a01223$export$8a48286ed7df6720);
$parcel$export(module.exports, "darkModeMediaQuery", () => $318d44fe11a01223$export$bb1e815119d30f8b);
$parcel$export(module.exports, "moreContrastMediaQuery", () => $318d44fe11a01223$export$8662df6937d86fcb);

var $luyTl = parcelRequire("luyTl");

var $kyri3 = parcelRequire("kyri3");
const $318d44fe11a01223$export$26cd7ae85c7144e5 = async (themeId)=>{
    if (document.head.querySelector(`style[${(0, $kyri3.THEME_DATA_ATTRIBUTE)}="${themeId}"]:not([${(0, $kyri3.CUSTOM_THEME_ATTRIBUTE)}])`)) return;
    // Gracefully handles falsy values like `null` and `undefined` when maker ignore TS
    // to avoid loading default themes.
    if (!themeId) return;
    const themeCss = await $318d44fe11a01223$export$8a48286ed7df6720(themeId);
    const style = document.createElement('style');
    style.textContent = themeCss;
    style.dataset.theme = themeId;
    document.head.appendChild(style);
};
const $318d44fe11a01223$export$8a48286ed7df6720 = async (themeId)=>{
    const { default: themeCss } = await (0, $luyTl.default)[themeId]();
    return themeCss;
};
const $318d44fe11a01223$export$bb1e815119d30f8b = '(prefers-color-scheme: dark)';
const $318d44fe11a01223$export$8662df6937d86fcb = '(prefers-contrast: more)';

});
parcelRegister("luyTl", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d324c79f1f06e69$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * This file contains a dynamic import for each theme this package exports.
 * Themes are loaded asynchronously at runtime to minimise the amount of CSS we send to the client.
 * This allows users to compose their themes and only use the tokens that are requested.
 * When a new theme is created, the import should automatically be added to the map
 *
 * @codegen <<SignedSource::b40de5ef0f17e1889f99be077c365e02>>
 * @codegenCommand yarn build tokens
 */ 











const $7d324c79f1f06e69$var$themeImportsMap = {
    'light': ()=>(parcelRequire("hvw40")),
    'light-future': ()=>(parcelRequire("iaUUt")),
    'light-increased-contrast': ()=>(parcelRequire("hMOJ2")),
    'dark': ()=>(parcelRequire("jRtSp")),
    'dark-future': ()=>(parcelRequire("86j4U")),
    'dark-increased-contrast': ()=>(parcelRequire("hXNOO")),
    'legacy-light': ()=>(parcelRequire("6FI2x")),
    'legacy-dark': ()=>(parcelRequire("5YiOb")),
    'spacing': ()=>(parcelRequire("jWDAg")),
    'typography-adg3': ()=>(parcelRequire("lKOxc")),
    'shape': ()=>(parcelRequire("gYJYi")),
    'typography-minor3': ()=>(parcelRequire("8sfJ6"))
};
var $7d324c79f1f06e69$export$2e2bcd8739ae039 = $7d324c79f1f06e69$var$themeImportsMap;

});
parcelRegister("hvw40", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('fu4Ju');
        const value = parcelRequire('IqkkX');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("fu4Ju").then(()=>parcelRequire('IqkkX'));
}

});
parcelRegister("chRvw", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    const retry_state = {};
    module.exports = async function(id) {
        if (!globalThis.navigator.onLine) await new Promise((res)=>{
            const callback = ()=>(globalThis.removeEventListener('online', callback), res());
            globalThis.addEventListener('online', callback);
        });
        let bundle_src = (parcelRequire("bjqNS")).resolve(id);
        let src = bundle_src;
        retry_state[bundle_src] = retry_state[bundle_src] || {
            should_retry: false,
            param: undefined
        };
        if (retry_state[bundle_src].should_retry) retry_state[bundle_src].param = Date.now();
        if (retry_state[bundle_src].param) src = src + "?retry=" + retry_state[bundle_src].param;
        try {
            retry_state[bundle_src].should_retry = false;
            return await import(src);
        } catch (error) {
            retry_state[bundle_src].should_retry = true;
            throw error;
        }
    };
} else {
    "use strict";
    function load(id) {
        // eslint-disable-next-line no-undef
        return import((parcelRequire("bjqNS")).resolve(id));
    }
    module.exports = load;
}

});
parcelRegister("bjqNS", function(module, exports) {

$parcel$export(module.exports, "register", () => $83c642ad29ddccba$export$6503ec6e8aabbaf, (v) => $83c642ad29ddccba$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $83c642ad29ddccba$export$f7ad0328861e2f03, (v) => $83c642ad29ddccba$export$f7ad0328861e2f03 = v);
var $83c642ad29ddccba$export$6503ec6e8aabbaf;
var $83c642ad29ddccba$export$f7ad0328861e2f03;
"use strict";
var $83c642ad29ddccba$var$mapping = new Map();
function $83c642ad29ddccba$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$83c642ad29ddccba$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $83c642ad29ddccba$var$resolve(id) {
    var resolved = $83c642ad29ddccba$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$83c642ad29ddccba$export$6503ec6e8aabbaf = $83c642ad29ddccba$var$register;
$83c642ad29ddccba$export$f7ad0328861e2f03 = $83c642ad29ddccba$var$resolve;

});



parcelRegister("iaUUt", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('dgsHK');
        const value = parcelRequire('aAqzu');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("dgsHK").then(()=>parcelRequire('aAqzu'));
}

});

parcelRegister("hMOJ2", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('bWPWA');
        const value = parcelRequire('5C2sE');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("bWPWA").then(()=>parcelRequire('5C2sE'));
}

});

parcelRegister("jRtSp", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('deyYz');
        const value = parcelRequire('4oSgK');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("deyYz").then(()=>parcelRequire('4oSgK'));
}

});

parcelRegister("86j4U", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('gSwR6');
        const value = parcelRequire('6Bhb7');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("gSwR6").then(()=>parcelRequire('6Bhb7'));
}

});

parcelRegister("hXNOO", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('2TWkc');
        const value = parcelRequire('6pLwM');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("2TWkc").then(()=>parcelRequire('6pLwM'));
}

});

parcelRegister("6FI2x", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('bcp5i');
        const value = parcelRequire('kp7mA');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("bcp5i").then(()=>parcelRequire('kp7mA'));
}

});

parcelRegister("5YiOb", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('gPFC2');
        const value = parcelRequire('bImqC');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("gPFC2").then(()=>parcelRequire('bImqC'));
}

});

parcelRegister("jWDAg", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('fkg0O');
        const value = parcelRequire('bq3w1');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("fkg0O").then(()=>parcelRequire('bq3w1'));
}

});

parcelRegister("lKOxc", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('gaxrs');
        const value = parcelRequire('hFNZG');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("gaxrs").then(()=>parcelRequire('hFNZG'));
}

});

parcelRegister("gYJYi", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('lvh4t');
        const value = parcelRequire('14YNO');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("lvh4t").then(()=>parcelRequire('14YNO'));
}

});

parcelRegister("8sfJ6", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('4kyBs');
        const value = parcelRequire('4hPNA');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("4kyBs").then(()=>parcelRequire('4hPNA'));
}

});



parcelRegister("IlKAE", function(module, exports) {

$parcel$export(module.exports, "findMissingCustomStyleElements", () => $be3afd95cc5f332e$export$bd1ac9300b0e885a);
$parcel$export(module.exports, "limitSizeOfCustomStyleElements", () => $be3afd95cc5f332e$export$e7ae172320e03461);
$parcel$export(module.exports, "reduceTokenMap", () => $be3afd95cc5f332e$export$e673f367da2ff23e);

var $h6fut = parcelRequire("h6fut");

var $kyri3 = parcelRequire("kyri3");

var $1UQcZ = parcelRequire("1UQcZ");
function $be3afd95cc5f332e$export$bd1ac9300b0e885a(UNSAFE_themeOptions, mode) {
    const optionString = JSON.stringify(UNSAFE_themeOptions);
    const uniqueId = (0, $1UQcZ.hash)(optionString);
    const attrOfMissingCustomStyles = [];
    (mode === 'auto' ? [
        'light',
        'dark'
    ] : [
        mode
    ]).forEach((themeId)=>{
        const element = document.head.querySelector(`style[${(0, $kyri3.CUSTOM_THEME_ATTRIBUTE)}="${uniqueId}"][${(0, $kyri3.THEME_DATA_ATTRIBUTE)}="${themeId}"]`);
        if (element) // Append the existing custom styles to take precedence over others
        document.head.appendChild(element);
        else attrOfMissingCustomStyles.push(themeId);
    });
    return attrOfMissingCustomStyles;
}
function $be3afd95cc5f332e$export$e7ae172320e03461(sizeThreshold) {
    const styleTags = [
        ...Array.from(document.head.querySelectorAll(`style[${(0, $kyri3.CUSTOM_THEME_ATTRIBUTE)}][${(0, $kyri3.THEME_DATA_ATTRIBUTE)}]`))
    ];
    if (styleTags.length < sizeThreshold) return;
    styleTags.slice(0, styleTags.length - (sizeThreshold - 1)).forEach((element)=>element.remove());
}
function $be3afd95cc5f332e$export$e673f367da2ff23e(tokenMap, themeRamp) {
    return Object.entries(tokenMap).reduce((acc, [key, value])=>{
        const cssVar = (0, $h6fut.default)[key];
        return cssVar ? `${acc}\n  ${cssVar}: ${typeof value === 'string' ? value : themeRamp[value]};` : acc;
    }, '');
}

});
parcelRegister("h6fut", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e8cf667c414b31b$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::25d54efb80cdfa2dff073292bd28bbcb>>
 * @codegenCommand yarn build tokens
 */ const $1e8cf667c414b31b$var$tokens = {
    'color.text': '--ds-text',
    'color.text.accent.lime': '--ds-text-accent-lime',
    'color.text.accent.lime.bolder': '--ds-text-accent-lime-bolder',
    'color.text.accent.red': '--ds-text-accent-red',
    'color.text.accent.red.bolder': '--ds-text-accent-red-bolder',
    'color.text.accent.orange': '--ds-text-accent-orange',
    'color.text.accent.orange.bolder': '--ds-text-accent-orange-bolder',
    'color.text.accent.yellow': '--ds-text-accent-yellow',
    'color.text.accent.yellow.bolder': '--ds-text-accent-yellow-bolder',
    'color.text.accent.green': '--ds-text-accent-green',
    'color.text.accent.green.bolder': '--ds-text-accent-green-bolder',
    'color.text.accent.teal': '--ds-text-accent-teal',
    'color.text.accent.teal.bolder': '--ds-text-accent-teal-bolder',
    'color.text.accent.blue': '--ds-text-accent-blue',
    'color.text.accent.blue.bolder': '--ds-text-accent-blue-bolder',
    'color.text.accent.purple': '--ds-text-accent-purple',
    'color.text.accent.purple.bolder': '--ds-text-accent-purple-bolder',
    'color.text.accent.magenta': '--ds-text-accent-magenta',
    'color.text.accent.magenta.bolder': '--ds-text-accent-magenta-bolder',
    'color.text.accent.gray': '--ds-text-accent-gray',
    'color.text.accent.gray.bolder': '--ds-text-accent-gray-bolder',
    'color.text.disabled': '--ds-text-disabled',
    'color.text.inverse': '--ds-text-inverse',
    'color.text.selected': '--ds-text-selected',
    'color.text.brand': '--ds-text-brand',
    'color.text.danger': '--ds-text-danger',
    'color.text.warning': '--ds-text-warning',
    'color.text.warning.inverse': '--ds-text-warning-inverse',
    'color.text.success': '--ds-text-success',
    'color.text.discovery': '--ds-text-discovery',
    'color.text.information': '--ds-text-information',
    'color.text.subtlest': '--ds-text-subtlest',
    'color.text.subtle': '--ds-text-subtle',
    'color.link': '--ds-link',
    'color.link.pressed': '--ds-link-pressed',
    'color.link.visited': '--ds-link-visited',
    'color.link.visited.pressed': '--ds-link-visited-pressed',
    'color.icon': '--ds-icon',
    'color.icon.accent.lime': '--ds-icon-accent-lime',
    'color.icon.accent.red': '--ds-icon-accent-red',
    'color.icon.accent.orange': '--ds-icon-accent-orange',
    'color.icon.accent.yellow': '--ds-icon-accent-yellow',
    'color.icon.accent.green': '--ds-icon-accent-green',
    'color.icon.accent.teal': '--ds-icon-accent-teal',
    'color.icon.accent.blue': '--ds-icon-accent-blue',
    'color.icon.accent.purple': '--ds-icon-accent-purple',
    'color.icon.accent.magenta': '--ds-icon-accent-magenta',
    'color.icon.accent.gray': '--ds-icon-accent-gray',
    'color.icon.disabled': '--ds-icon-disabled',
    'color.icon.inverse': '--ds-icon-inverse',
    'color.icon.selected': '--ds-icon-selected',
    'color.icon.brand': '--ds-icon-brand',
    'color.icon.danger': '--ds-icon-danger',
    'color.icon.warning': '--ds-icon-warning',
    'color.icon.warning.inverse': '--ds-icon-warning-inverse',
    'color.icon.success': '--ds-icon-success',
    'color.icon.discovery': '--ds-icon-discovery',
    'color.icon.information': '--ds-icon-information',
    'color.icon.subtle': '--ds-icon-subtle',
    'color.border': '--ds-border',
    'color.border.accent.lime': '--ds-border-accent-lime',
    'color.border.accent.red': '--ds-border-accent-red',
    'color.border.accent.orange': '--ds-border-accent-orange',
    'color.border.accent.yellow': '--ds-border-accent-yellow',
    'color.border.accent.green': '--ds-border-accent-green',
    'color.border.accent.teal': '--ds-border-accent-teal',
    'color.border.accent.blue': '--ds-border-accent-blue',
    'color.border.accent.purple': '--ds-border-accent-purple',
    'color.border.accent.magenta': '--ds-border-accent-magenta',
    'color.border.accent.gray': '--ds-border-accent-gray',
    'color.border.disabled': '--ds-border-disabled',
    'color.border.focused': '--ds-border-focused',
    'color.border.input': '--ds-border-input',
    'color.border.inverse': '--ds-border-inverse',
    'color.border.selected': '--ds-border-selected',
    'color.border.brand': '--ds-border-brand',
    'color.border.danger': '--ds-border-danger',
    'color.border.warning': '--ds-border-warning',
    'color.border.success': '--ds-border-success',
    'color.border.discovery': '--ds-border-discovery',
    'color.border.information': '--ds-border-information',
    'color.border.bold': '--ds-border-bold',
    'color.background.accent.lime.subtlest': '--ds-background-accent-lime-subtlest',
    'color.background.accent.lime.subtlest.hovered': '--ds-background-accent-lime-subtlest-hovered',
    'color.background.accent.lime.subtlest.pressed': '--ds-background-accent-lime-subtlest-pressed',
    'color.background.accent.lime.subtler': '--ds-background-accent-lime-subtler',
    'color.background.accent.lime.subtler.hovered': '--ds-background-accent-lime-subtler-hovered',
    'color.background.accent.lime.subtler.pressed': '--ds-background-accent-lime-subtler-pressed',
    'color.background.accent.lime.subtle': '--ds-background-accent-lime-subtle',
    'color.background.accent.lime.subtle.hovered': '--ds-background-accent-lime-subtle-hovered',
    'color.background.accent.lime.subtle.pressed': '--ds-background-accent-lime-subtle-pressed',
    'color.background.accent.lime.bolder': '--ds-background-accent-lime-bolder',
    'color.background.accent.lime.bolder.hovered': '--ds-background-accent-lime-bolder-hovered',
    'color.background.accent.lime.bolder.pressed': '--ds-background-accent-lime-bolder-pressed',
    'color.background.accent.red.subtlest': '--ds-background-accent-red-subtlest',
    'color.background.accent.red.subtlest.hovered': '--ds-background-accent-red-subtlest-hovered',
    'color.background.accent.red.subtlest.pressed': '--ds-background-accent-red-subtlest-pressed',
    'color.background.accent.red.subtler': '--ds-background-accent-red-subtler',
    'color.background.accent.red.subtler.hovered': '--ds-background-accent-red-subtler-hovered',
    'color.background.accent.red.subtler.pressed': '--ds-background-accent-red-subtler-pressed',
    'color.background.accent.red.subtle': '--ds-background-accent-red-subtle',
    'color.background.accent.red.subtle.hovered': '--ds-background-accent-red-subtle-hovered',
    'color.background.accent.red.subtle.pressed': '--ds-background-accent-red-subtle-pressed',
    'color.background.accent.red.bolder': '--ds-background-accent-red-bolder',
    'color.background.accent.red.bolder.hovered': '--ds-background-accent-red-bolder-hovered',
    'color.background.accent.red.bolder.pressed': '--ds-background-accent-red-bolder-pressed',
    'color.background.accent.orange.subtlest': '--ds-background-accent-orange-subtlest',
    'color.background.accent.orange.subtlest.hovered': '--ds-background-accent-orange-subtlest-hovered',
    'color.background.accent.orange.subtlest.pressed': '--ds-background-accent-orange-subtlest-pressed',
    'color.background.accent.orange.subtler': '--ds-background-accent-orange-subtler',
    'color.background.accent.orange.subtler.hovered': '--ds-background-accent-orange-subtler-hovered',
    'color.background.accent.orange.subtler.pressed': '--ds-background-accent-orange-subtler-pressed',
    'color.background.accent.orange.subtle': '--ds-background-accent-orange-subtle',
    'color.background.accent.orange.subtle.hovered': '--ds-background-accent-orange-subtle-hovered',
    'color.background.accent.orange.subtle.pressed': '--ds-background-accent-orange-subtle-pressed',
    'color.background.accent.orange.bolder': '--ds-background-accent-orange-bolder',
    'color.background.accent.orange.bolder.hovered': '--ds-background-accent-orange-bolder-hovered',
    'color.background.accent.orange.bolder.pressed': '--ds-background-accent-orange-bolder-pressed',
    'color.background.accent.yellow.subtlest': '--ds-background-accent-yellow-subtlest',
    'color.background.accent.yellow.subtlest.hovered': '--ds-background-accent-yellow-subtlest-hovered',
    'color.background.accent.yellow.subtlest.pressed': '--ds-background-accent-yellow-subtlest-pressed',
    'color.background.accent.yellow.subtler': '--ds-background-accent-yellow-subtler',
    'color.background.accent.yellow.subtler.hovered': '--ds-background-accent-yellow-subtler-hovered',
    'color.background.accent.yellow.subtler.pressed': '--ds-background-accent-yellow-subtler-pressed',
    'color.background.accent.yellow.subtle': '--ds-background-accent-yellow-subtle',
    'color.background.accent.yellow.subtle.hovered': '--ds-background-accent-yellow-subtle-hovered',
    'color.background.accent.yellow.subtle.pressed': '--ds-background-accent-yellow-subtle-pressed',
    'color.background.accent.yellow.bolder': '--ds-background-accent-yellow-bolder',
    'color.background.accent.yellow.bolder.hovered': '--ds-background-accent-yellow-bolder-hovered',
    'color.background.accent.yellow.bolder.pressed': '--ds-background-accent-yellow-bolder-pressed',
    'color.background.accent.green.subtlest': '--ds-background-accent-green-subtlest',
    'color.background.accent.green.subtlest.hovered': '--ds-background-accent-green-subtlest-hovered',
    'color.background.accent.green.subtlest.pressed': '--ds-background-accent-green-subtlest-pressed',
    'color.background.accent.green.subtler': '--ds-background-accent-green-subtler',
    'color.background.accent.green.subtler.hovered': '--ds-background-accent-green-subtler-hovered',
    'color.background.accent.green.subtler.pressed': '--ds-background-accent-green-subtler-pressed',
    'color.background.accent.green.subtle': '--ds-background-accent-green-subtle',
    'color.background.accent.green.subtle.hovered': '--ds-background-accent-green-subtle-hovered',
    'color.background.accent.green.subtle.pressed': '--ds-background-accent-green-subtle-pressed',
    'color.background.accent.green.bolder': '--ds-background-accent-green-bolder',
    'color.background.accent.green.bolder.hovered': '--ds-background-accent-green-bolder-hovered',
    'color.background.accent.green.bolder.pressed': '--ds-background-accent-green-bolder-pressed',
    'color.background.accent.teal.subtlest': '--ds-background-accent-teal-subtlest',
    'color.background.accent.teal.subtlest.hovered': '--ds-background-accent-teal-subtlest-hovered',
    'color.background.accent.teal.subtlest.pressed': '--ds-background-accent-teal-subtlest-pressed',
    'color.background.accent.teal.subtler': '--ds-background-accent-teal-subtler',
    'color.background.accent.teal.subtler.hovered': '--ds-background-accent-teal-subtler-hovered',
    'color.background.accent.teal.subtler.pressed': '--ds-background-accent-teal-subtler-pressed',
    'color.background.accent.teal.subtle': '--ds-background-accent-teal-subtle',
    'color.background.accent.teal.subtle.hovered': '--ds-background-accent-teal-subtle-hovered',
    'color.background.accent.teal.subtle.pressed': '--ds-background-accent-teal-subtle-pressed',
    'color.background.accent.teal.bolder': '--ds-background-accent-teal-bolder',
    'color.background.accent.teal.bolder.hovered': '--ds-background-accent-teal-bolder-hovered',
    'color.background.accent.teal.bolder.pressed': '--ds-background-accent-teal-bolder-pressed',
    'color.background.accent.blue.subtlest': '--ds-background-accent-blue-subtlest',
    'color.background.accent.blue.subtlest.hovered': '--ds-background-accent-blue-subtlest-hovered',
    'color.background.accent.blue.subtlest.pressed': '--ds-background-accent-blue-subtlest-pressed',
    'color.background.accent.blue.subtler': '--ds-background-accent-blue-subtler',
    'color.background.accent.blue.subtler.hovered': '--ds-background-accent-blue-subtler-hovered',
    'color.background.accent.blue.subtler.pressed': '--ds-background-accent-blue-subtler-pressed',
    'color.background.accent.blue.subtle': '--ds-background-accent-blue-subtle',
    'color.background.accent.blue.subtle.hovered': '--ds-background-accent-blue-subtle-hovered',
    'color.background.accent.blue.subtle.pressed': '--ds-background-accent-blue-subtle-pressed',
    'color.background.accent.blue.bolder': '--ds-background-accent-blue-bolder',
    'color.background.accent.blue.bolder.hovered': '--ds-background-accent-blue-bolder-hovered',
    'color.background.accent.blue.bolder.pressed': '--ds-background-accent-blue-bolder-pressed',
    'color.background.accent.purple.subtlest': '--ds-background-accent-purple-subtlest',
    'color.background.accent.purple.subtlest.hovered': '--ds-background-accent-purple-subtlest-hovered',
    'color.background.accent.purple.subtlest.pressed': '--ds-background-accent-purple-subtlest-pressed',
    'color.background.accent.purple.subtler': '--ds-background-accent-purple-subtler',
    'color.background.accent.purple.subtler.hovered': '--ds-background-accent-purple-subtler-hovered',
    'color.background.accent.purple.subtler.pressed': '--ds-background-accent-purple-subtler-pressed',
    'color.background.accent.purple.subtle': '--ds-background-accent-purple-subtle',
    'color.background.accent.purple.subtle.hovered': '--ds-background-accent-purple-subtle-hovered',
    'color.background.accent.purple.subtle.pressed': '--ds-background-accent-purple-subtle-pressed',
    'color.background.accent.purple.bolder': '--ds-background-accent-purple-bolder',
    'color.background.accent.purple.bolder.hovered': '--ds-background-accent-purple-bolder-hovered',
    'color.background.accent.purple.bolder.pressed': '--ds-background-accent-purple-bolder-pressed',
    'color.background.accent.magenta.subtlest': '--ds-background-accent-magenta-subtlest',
    'color.background.accent.magenta.subtlest.hovered': '--ds-background-accent-magenta-subtlest-hovered',
    'color.background.accent.magenta.subtlest.pressed': '--ds-background-accent-magenta-subtlest-pressed',
    'color.background.accent.magenta.subtler': '--ds-background-accent-magenta-subtler',
    'color.background.accent.magenta.subtler.hovered': '--ds-background-accent-magenta-subtler-hovered',
    'color.background.accent.magenta.subtler.pressed': '--ds-background-accent-magenta-subtler-pressed',
    'color.background.accent.magenta.subtle': '--ds-background-accent-magenta-subtle',
    'color.background.accent.magenta.subtle.hovered': '--ds-background-accent-magenta-subtle-hovered',
    'color.background.accent.magenta.subtle.pressed': '--ds-background-accent-magenta-subtle-pressed',
    'color.background.accent.magenta.bolder': '--ds-background-accent-magenta-bolder',
    'color.background.accent.magenta.bolder.hovered': '--ds-background-accent-magenta-bolder-hovered',
    'color.background.accent.magenta.bolder.pressed': '--ds-background-accent-magenta-bolder-pressed',
    'color.background.accent.gray.subtlest': '--ds-background-accent-gray-subtlest',
    'color.background.accent.gray.subtlest.hovered': '--ds-background-accent-gray-subtlest-hovered',
    'color.background.accent.gray.subtlest.pressed': '--ds-background-accent-gray-subtlest-pressed',
    'color.background.accent.gray.subtler': '--ds-background-accent-gray-subtler',
    'color.background.accent.gray.subtler.hovered': '--ds-background-accent-gray-subtler-hovered',
    'color.background.accent.gray.subtler.pressed': '--ds-background-accent-gray-subtler-pressed',
    'color.background.accent.gray.subtle': '--ds-background-accent-gray-subtle',
    'color.background.accent.gray.subtle.hovered': '--ds-background-accent-gray-subtle-hovered',
    'color.background.accent.gray.subtle.pressed': '--ds-background-accent-gray-subtle-pressed',
    'color.background.accent.gray.bolder': '--ds-background-accent-gray-bolder',
    'color.background.accent.gray.bolder.hovered': '--ds-background-accent-gray-bolder-hovered',
    'color.background.accent.gray.bolder.pressed': '--ds-background-accent-gray-bolder-pressed',
    'color.background.disabled': '--ds-background-disabled',
    'color.background.input': '--ds-background-input',
    'color.background.input.hovered': '--ds-background-input-hovered',
    'color.background.input.pressed': '--ds-background-input-pressed',
    'color.background.inverse.subtle': '--ds-background-inverse-subtle',
    'color.background.inverse.subtle.hovered': '--ds-background-inverse-subtle-hovered',
    'color.background.inverse.subtle.pressed': '--ds-background-inverse-subtle-pressed',
    'color.background.neutral': '--ds-background-neutral',
    'color.background.neutral.hovered': '--ds-background-neutral-hovered',
    'color.background.neutral.pressed': '--ds-background-neutral-pressed',
    'color.background.neutral.subtle': '--ds-background-neutral-subtle',
    'color.background.neutral.subtle.hovered': '--ds-background-neutral-subtle-hovered',
    'color.background.neutral.subtle.pressed': '--ds-background-neutral-subtle-pressed',
    'color.background.neutral.bold': '--ds-background-neutral-bold',
    'color.background.neutral.bold.hovered': '--ds-background-neutral-bold-hovered',
    'color.background.neutral.bold.pressed': '--ds-background-neutral-bold-pressed',
    'color.background.selected': '--ds-background-selected',
    'color.background.selected.hovered': '--ds-background-selected-hovered',
    'color.background.selected.pressed': '--ds-background-selected-pressed',
    'color.background.selected.bold': '--ds-background-selected-bold',
    'color.background.selected.bold.hovered': '--ds-background-selected-bold-hovered',
    'color.background.selected.bold.pressed': '--ds-background-selected-bold-pressed',
    'color.background.brand.subtlest': '--ds-background-brand-subtlest',
    'color.background.brand.subtlest.hovered': '--ds-background-brand-subtlest-hovered',
    'color.background.brand.subtlest.pressed': '--ds-background-brand-subtlest-pressed',
    'color.background.brand.bold': '--ds-background-brand-bold',
    'color.background.brand.bold.hovered': '--ds-background-brand-bold-hovered',
    'color.background.brand.bold.pressed': '--ds-background-brand-bold-pressed',
    'color.background.brand.boldest': '--ds-background-brand-boldest',
    'color.background.brand.boldest.hovered': '--ds-background-brand-boldest-hovered',
    'color.background.brand.boldest.pressed': '--ds-background-brand-boldest-pressed',
    'color.background.danger': '--ds-background-danger',
    'color.background.danger.hovered': '--ds-background-danger-hovered',
    'color.background.danger.pressed': '--ds-background-danger-pressed',
    'color.background.danger.bold': '--ds-background-danger-bold',
    'color.background.danger.bold.hovered': '--ds-background-danger-bold-hovered',
    'color.background.danger.bold.pressed': '--ds-background-danger-bold-pressed',
    'color.background.warning': '--ds-background-warning',
    'color.background.warning.hovered': '--ds-background-warning-hovered',
    'color.background.warning.pressed': '--ds-background-warning-pressed',
    'color.background.warning.bold': '--ds-background-warning-bold',
    'color.background.warning.bold.hovered': '--ds-background-warning-bold-hovered',
    'color.background.warning.bold.pressed': '--ds-background-warning-bold-pressed',
    'color.background.success': '--ds-background-success',
    'color.background.success.hovered': '--ds-background-success-hovered',
    'color.background.success.pressed': '--ds-background-success-pressed',
    'color.background.success.bold': '--ds-background-success-bold',
    'color.background.success.bold.hovered': '--ds-background-success-bold-hovered',
    'color.background.success.bold.pressed': '--ds-background-success-bold-pressed',
    'color.background.discovery': '--ds-background-discovery',
    'color.background.discovery.hovered': '--ds-background-discovery-hovered',
    'color.background.discovery.pressed': '--ds-background-discovery-pressed',
    'color.background.discovery.bold': '--ds-background-discovery-bold',
    'color.background.discovery.bold.hovered': '--ds-background-discovery-bold-hovered',
    'color.background.discovery.bold.pressed': '--ds-background-discovery-bold-pressed',
    'color.background.information': '--ds-background-information',
    'color.background.information.hovered': '--ds-background-information-hovered',
    'color.background.information.pressed': '--ds-background-information-pressed',
    'color.background.information.bold': '--ds-background-information-bold',
    'color.background.information.bold.hovered': '--ds-background-information-bold-hovered',
    'color.background.information.bold.pressed': '--ds-background-information-bold-pressed',
    'color.blanket': '--ds-blanket',
    'color.blanket.selected': '--ds-blanket-selected',
    'color.blanket.danger': '--ds-blanket-danger',
    'color.interaction.hovered': '--ds-interaction-hovered',
    'color.interaction.pressed': '--ds-interaction-pressed',
    'color.skeleton': '--ds-skeleton',
    'color.skeleton.subtle': '--ds-skeleton-subtle',
    'color.chart.categorical.1': '--ds-chart-categorical-1',
    'color.chart.categorical.1.hovered': '--ds-chart-categorical-1-hovered',
    'color.chart.categorical.2': '--ds-chart-categorical-2',
    'color.chart.categorical.2.hovered': '--ds-chart-categorical-2-hovered',
    'color.chart.categorical.3': '--ds-chart-categorical-3',
    'color.chart.categorical.3.hovered': '--ds-chart-categorical-3-hovered',
    'color.chart.categorical.4': '--ds-chart-categorical-4',
    'color.chart.categorical.4.hovered': '--ds-chart-categorical-4-hovered',
    'color.chart.categorical.5': '--ds-chart-categorical-5',
    'color.chart.categorical.5.hovered': '--ds-chart-categorical-5-hovered',
    'color.chart.categorical.6': '--ds-chart-categorical-6',
    'color.chart.categorical.6.hovered': '--ds-chart-categorical-6-hovered',
    'color.chart.categorical.7': '--ds-chart-categorical-7',
    'color.chart.categorical.7.hovered': '--ds-chart-categorical-7-hovered',
    'color.chart.categorical.8': '--ds-chart-categorical-8',
    'color.chart.categorical.8.hovered': '--ds-chart-categorical-8-hovered',
    'color.chart.lime.bold': '--ds-chart-lime-bold',
    'color.chart.lime.bold.hovered': '--ds-chart-lime-bold-hovered',
    'color.chart.lime.bolder': '--ds-chart-lime-bolder',
    'color.chart.lime.bolder.hovered': '--ds-chart-lime-bolder-hovered',
    'color.chart.lime.boldest': '--ds-chart-lime-boldest',
    'color.chart.lime.boldest.hovered': '--ds-chart-lime-boldest-hovered',
    'color.chart.neutral': '--ds-chart-neutral',
    'color.chart.neutral.hovered': '--ds-chart-neutral-hovered',
    'color.chart.red.bold': '--ds-chart-red-bold',
    'color.chart.red.bold.hovered': '--ds-chart-red-bold-hovered',
    'color.chart.red.bolder': '--ds-chart-red-bolder',
    'color.chart.red.bolder.hovered': '--ds-chart-red-bolder-hovered',
    'color.chart.red.boldest': '--ds-chart-red-boldest',
    'color.chart.red.boldest.hovered': '--ds-chart-red-boldest-hovered',
    'color.chart.orange.bold': '--ds-chart-orange-bold',
    'color.chart.orange.bold.hovered': '--ds-chart-orange-bold-hovered',
    'color.chart.orange.bolder': '--ds-chart-orange-bolder',
    'color.chart.orange.bolder.hovered': '--ds-chart-orange-bolder-hovered',
    'color.chart.orange.boldest': '--ds-chart-orange-boldest',
    'color.chart.orange.boldest.hovered': '--ds-chart-orange-boldest-hovered',
    'color.chart.yellow.bold': '--ds-chart-yellow-bold',
    'color.chart.yellow.bold.hovered': '--ds-chart-yellow-bold-hovered',
    'color.chart.yellow.bolder': '--ds-chart-yellow-bolder',
    'color.chart.yellow.bolder.hovered': '--ds-chart-yellow-bolder-hovered',
    'color.chart.yellow.boldest': '--ds-chart-yellow-boldest',
    'color.chart.yellow.boldest.hovered': '--ds-chart-yellow-boldest-hovered',
    'color.chart.green.bold': '--ds-chart-green-bold',
    'color.chart.green.bold.hovered': '--ds-chart-green-bold-hovered',
    'color.chart.green.bolder': '--ds-chart-green-bolder',
    'color.chart.green.bolder.hovered': '--ds-chart-green-bolder-hovered',
    'color.chart.green.boldest': '--ds-chart-green-boldest',
    'color.chart.green.boldest.hovered': '--ds-chart-green-boldest-hovered',
    'color.chart.teal.bold': '--ds-chart-teal-bold',
    'color.chart.teal.bold.hovered': '--ds-chart-teal-bold-hovered',
    'color.chart.teal.bolder': '--ds-chart-teal-bolder',
    'color.chart.teal.bolder.hovered': '--ds-chart-teal-bolder-hovered',
    'color.chart.teal.boldest': '--ds-chart-teal-boldest',
    'color.chart.teal.boldest.hovered': '--ds-chart-teal-boldest-hovered',
    'color.chart.blue.bold': '--ds-chart-blue-bold',
    'color.chart.blue.bold.hovered': '--ds-chart-blue-bold-hovered',
    'color.chart.blue.bolder': '--ds-chart-blue-bolder',
    'color.chart.blue.bolder.hovered': '--ds-chart-blue-bolder-hovered',
    'color.chart.blue.boldest': '--ds-chart-blue-boldest',
    'color.chart.blue.boldest.hovered': '--ds-chart-blue-boldest-hovered',
    'color.chart.purple.bold': '--ds-chart-purple-bold',
    'color.chart.purple.bold.hovered': '--ds-chart-purple-bold-hovered',
    'color.chart.purple.bolder': '--ds-chart-purple-bolder',
    'color.chart.purple.bolder.hovered': '--ds-chart-purple-bolder-hovered',
    'color.chart.purple.boldest': '--ds-chart-purple-boldest',
    'color.chart.purple.boldest.hovered': '--ds-chart-purple-boldest-hovered',
    'color.chart.magenta.bold': '--ds-chart-magenta-bold',
    'color.chart.magenta.bold.hovered': '--ds-chart-magenta-bold-hovered',
    'color.chart.magenta.bolder': '--ds-chart-magenta-bolder',
    'color.chart.magenta.bolder.hovered': '--ds-chart-magenta-bolder-hovered',
    'color.chart.magenta.boldest': '--ds-chart-magenta-boldest',
    'color.chart.magenta.boldest.hovered': '--ds-chart-magenta-boldest-hovered',
    'color.chart.gray.bold': '--ds-chart-gray-bold',
    'color.chart.gray.bold.hovered': '--ds-chart-gray-bold-hovered',
    'color.chart.gray.bolder': '--ds-chart-gray-bolder',
    'color.chart.gray.bolder.hovered': '--ds-chart-gray-bolder-hovered',
    'color.chart.gray.boldest': '--ds-chart-gray-boldest',
    'color.chart.gray.boldest.hovered': '--ds-chart-gray-boldest-hovered',
    'color.chart.brand': '--ds-chart-brand',
    'color.chart.brand.hovered': '--ds-chart-brand-hovered',
    'color.chart.danger': '--ds-chart-danger',
    'color.chart.danger.hovered': '--ds-chart-danger-hovered',
    'color.chart.danger.bold': '--ds-chart-danger-bold',
    'color.chart.danger.bold.hovered': '--ds-chart-danger-bold-hovered',
    'color.chart.warning': '--ds-chart-warning',
    'color.chart.warning.hovered': '--ds-chart-warning-hovered',
    'color.chart.warning.bold': '--ds-chart-warning-bold',
    'color.chart.warning.bold.hovered': '--ds-chart-warning-bold-hovered',
    'color.chart.success': '--ds-chart-success',
    'color.chart.success.hovered': '--ds-chart-success-hovered',
    'color.chart.success.bold': '--ds-chart-success-bold',
    'color.chart.success.bold.hovered': '--ds-chart-success-bold-hovered',
    'color.chart.discovery': '--ds-chart-discovery',
    'color.chart.discovery.hovered': '--ds-chart-discovery-hovered',
    'color.chart.discovery.bold': '--ds-chart-discovery-bold',
    'color.chart.discovery.bold.hovered': '--ds-chart-discovery-bold-hovered',
    'color.chart.information': '--ds-chart-information',
    'color.chart.information.hovered': '--ds-chart-information-hovered',
    'color.chart.information.bold': '--ds-chart-information-bold',
    'color.chart.information.bold.hovered': '--ds-chart-information-bold-hovered',
    'elevation.surface': '--ds-surface',
    'elevation.surface.hovered': '--ds-surface-hovered',
    'elevation.surface.pressed': '--ds-surface-pressed',
    'elevation.surface.overlay': '--ds-surface-overlay',
    'elevation.surface.overlay.hovered': '--ds-surface-overlay-hovered',
    'elevation.surface.overlay.pressed': '--ds-surface-overlay-pressed',
    'elevation.surface.raised': '--ds-surface-raised',
    'elevation.surface.raised.hovered': '--ds-surface-raised-hovered',
    'elevation.surface.raised.pressed': '--ds-surface-raised-pressed',
    'elevation.surface.sunken': '--ds-surface-sunken',
    'elevation.shadow.overflow': '--ds-shadow-overflow',
    'elevation.shadow.overflow.perimeter': '--ds-shadow-overflow-perimeter',
    'elevation.shadow.overflow.spread': '--ds-shadow-overflow-spread',
    'elevation.shadow.overlay': '--ds-shadow-overlay',
    'elevation.shadow.raised': '--ds-shadow-raised',
    'opacity.disabled': '--ds-opacity-disabled',
    'opacity.loading': '--ds-opacity-loading',
    'utility.UNSAFE.textTransformUppercase': '--ds-UNSAFE-textTransformUppercase',
    'utility.UNSAFE.transparent': '--ds-UNSAFE-transparent',
    'utility.elevation.surface.current': '--ds-elevation-surface-current',
    'border.radius.050': '--ds-border-radius-050',
    'border.radius': '--ds-border-radius',
    'border.radius.100': '--ds-border-radius-100',
    'border.radius.200': '--ds-border-radius-200',
    'border.radius.300': '--ds-border-radius-300',
    'border.radius.400': '--ds-border-radius-400',
    'border.radius.circle': '--ds-border-radius-circle',
    'border.width': '--ds-border-width',
    'border.width.0': '--ds-border-width-0',
    'border.width.indicator': '--ds-border-width-indicator',
    'border.width.outline': '--ds-border-width-outline',
    'space.0': '--ds-space-0',
    'space.025': '--ds-space-025',
    'space.050': '--ds-space-050',
    'space.075': '--ds-space-075',
    'space.100': '--ds-space-100',
    'space.150': '--ds-space-150',
    'space.200': '--ds-space-200',
    'space.250': '--ds-space-250',
    'space.300': '--ds-space-300',
    'space.400': '--ds-space-400',
    'space.500': '--ds-space-500',
    'space.600': '--ds-space-600',
    'space.800': '--ds-space-800',
    'space.1000': '--ds-space-1000',
    'space.negative.025': '--ds-space-negative-025',
    'space.negative.050': '--ds-space-negative-050',
    'space.negative.075': '--ds-space-negative-075',
    'space.negative.100': '--ds-space-negative-100',
    'space.negative.150': '--ds-space-negative-150',
    'space.negative.200': '--ds-space-negative-200',
    'space.negative.250': '--ds-space-negative-250',
    'space.negative.300': '--ds-space-negative-300',
    'space.negative.400': '--ds-space-negative-400',
    'font.letterSpacing.0': '--ds-font-letterSpacing-0',
    'font.letterSpacing.100': '--ds-font-letterSpacing-100',
    'font.letterSpacing.200': '--ds-font-letterSpacing-200',
    'font.letterSpacing.300': '--ds-font-letterSpacing-300',
    'font.letterSpacing.400': '--ds-font-letterSpacing-400',
    'font.heading.xxlarge': '--ds-font-heading-xxlarge',
    'font.heading.xlarge': '--ds-font-heading-xlarge',
    'font.heading.large': '--ds-font-heading-large',
    'font.heading.medium': '--ds-font-heading-medium',
    'font.heading.small': '--ds-font-heading-small',
    'font.heading.xsmall': '--ds-font-heading-xsmall',
    'font.heading.xxsmall': '--ds-font-heading-xxsmall',
    'font.body.large': '--ds-font-body-large',
    'font.body': '--ds-font-body',
    'font.body.small': '--ds-font-body-small',
    'font.body.UNSAFE_small': '--ds-font-body-UNSAFE_small',
    'font.code': '--ds-font-code',
    'font.weight.regular': '--ds-font-weight-regular',
    'font.weight.medium': '--ds-font-weight-medium',
    'font.weight.semibold': '--ds-font-weight-semibold',
    'font.weight.bold': '--ds-font-weight-bold',
    'font.family.heading': '--ds-font-family-heading',
    'font.family.body': '--ds-font-family-body',
    'font.family.code': '--ds-font-family-code',
    'font.family.monospace': '--ds-font-family-monospace',
    'font.family.sans': '--ds-font-family-sans',
    'font.family.brand.heading': '--ds-font-family-brand-heading',
    'font.family.brand.body': '--ds-font-family-brand-body',
    'font.size.050': '--ds-font-size-050',
    'font.size.075': '--ds-font-size-075',
    'font.size.100': '--ds-font-size-100',
    'font.size.200': '--ds-font-size-200',
    'font.size.300': '--ds-font-size-300',
    'font.size.400': '--ds-font-size-400',
    'font.size.500': '--ds-font-size-500',
    'font.size.600': '--ds-font-size-600',
    'font.lineHeight.1': '--ds-font-lineHeight-1',
    'font.lineHeight.100': '--ds-font-lineHeight-100',
    'font.lineHeight.200': '--ds-font-lineHeight-200',
    'font.lineHeight.300': '--ds-font-lineHeight-300',
    'font.lineHeight.400': '--ds-font-lineHeight-400',
    'font.lineHeight.500': '--ds-font-lineHeight-500',
    'font.lineHeight.600': '--ds-font-lineHeight-600'
};
var $1e8cf667c414b31b$export$2e2bcd8739ae039 = $1e8cf667c414b31b$var$tokens;

});


parcelRegister("8hqCp", function(module, exports) {

$parcel$export(module.exports, "default", () => $33d87c26b453d66d$export$2e2bcd8739ae039);

var $XHGTv = parcelRequire("XHGTv");

var $31snR = parcelRequire("31snR");

var $fw2Om = parcelRequire("fw2Om");

var $7FsR2 = parcelRequire("7FsR2");

var $IlKAE = parcelRequire("IlKAE");

var $hjabr = parcelRequire("hjabr");

var $2Mf9s = parcelRequire("2Mf9s");

/**
 * Sets the theme globally at runtime. This updates the `data-theme` and `data-color-mode` attributes on your page's <html> tag.
 *
 * @param {Object<string, string>} themeState The themes and color mode that should be applied.
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.contrastMode The contrast mode theme to be applied. If set to `auto`, the theme applied will be determined by the OS setting.set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.shape The shape theme to be applied.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 * @param {function} themeLoader Callback function used to override the default theme loading functionality.
 *
 * @returns A Promise of an unbind function, that can be used to stop listening for changes to system theme.
 *
 * @example
 * ```
 * setGlobalTheme({colorMode: 'auto', light: 'light', dark: 'dark', spacing: 'spacing'});
 * ```
 */ const $33d87c26b453d66d$var$setGlobalTheme = async ({ colorMode: colorMode = (0, $31snR.themeStateDefaults)['colorMode'], contrastMode: contrastMode = (0, $31snR.themeStateDefaults)['contrastMode'], dark: dark = (0, $31snR.themeStateDefaults)['dark'], light: light = (0, $31snR.themeStateDefaults)['light'], shape: shape = (0, $31snR.themeStateDefaults)['shape'], spacing: spacing = (0, $31snR.themeStateDefaults)['spacing'], typography: typography = (0, $31snR.themeStateDefaults)['typography'], UNSAFE_themeOptions: UNSAFE_themeOptions = (0, $31snR.themeStateDefaults)['UNSAFE_themeOptions'] } = {}, themeLoader)=>{
    // CLEANUP: Remove. This blocks application of increased contrast themes
    // without the feature flag enabled.
    if (!(0, $XHGTv.getBooleanFF)('platform.design-system-team.increased-contrast-themes')) {
        if (light === 'light-increased-contrast') light = 'light';
        if (dark === 'dark-increased-contrast') dark = 'dark';
    }
    const themeState = {
        colorMode: colorMode,
        contrastMode: contrastMode,
        dark: dark,
        light: light,
        shape: shape,
        spacing: spacing,
        typography: typography,
        UNSAFE_themeOptions: themeLoader ? undefined : UNSAFE_themeOptions
    };
    // Determine what to load and loading strategy
    let themePreferences = (0, $hjabr.getThemePreferences)(themeState);
    const loadingStrategy = themeLoader ? themeLoader : (0, $2Mf9s.loadAndAppendThemeCss);
    // Load standard themes
    const loadingTasks = themePreferences.map(async (themeId)=>await loadingStrategy(themeId));
    // Load custom themes if needed
    if (!themeLoader && UNSAFE_themeOptions && (0, $fw2Om.isValidBrandHex)(UNSAFE_themeOptions?.brandColor)) {
        const mode = colorMode || (0, $31snR.themeStateDefaults)['colorMode'];
        const attrOfMissingCustomStyles = (0, $IlKAE.findMissingCustomStyleElements)(UNSAFE_themeOptions, mode);
        if (attrOfMissingCustomStyles.length > 0) // Load custom theme styles
        loadingTasks.push((async ()=>{
            const { loadAndAppendCustomThemeCss: loadAndAppendCustomThemeCss } = await (parcelRequire("2qx7E"));
            loadAndAppendCustomThemeCss({
                colorMode: attrOfMissingCustomStyles.length === 2 ? 'auto' : attrOfMissingCustomStyles[0],
                UNSAFE_themeOptions: UNSAFE_themeOptions
            });
        })());
    }
    await Promise.all(loadingTasks);
    // Load override themes after standard themes
    const themeOverridePreferences = (0, $hjabr.getThemeOverridePreferences)(themeState);
    for (const themeId of themeOverridePreferences)await loadingStrategy(themeId);
    const autoUnbind = (0, $7FsR2.default)(themeState);
    return autoUnbind;
};
var $33d87c26b453d66d$export$2e2bcd8739ae039 = $33d87c26b453d66d$var$setGlobalTheme;

});
parcelRegister("7FsR2", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe8ad4c9c8a5ee06$export$2e2bcd8739ae039);

var $XHGTv = parcelRequire("XHGTv");

var $bgY86 = parcelRequire("bgY86");

var $IANmN = parcelRequire("IANmN");

var $hU16G = parcelRequire("hU16G");
function $fe8ad4c9c8a5ee06$export$2e2bcd8739ae039(themeState) {
    if (themeState.colorMode === 'auto') {
        // Set colorMode based on the user preference
        themeState.colorMode = (0, $IANmN.default).getColorMode();
        // Bind a listener (if one doesn't already exist) to keep colorMode updated
        (0, $IANmN.default).bind();
    } else (0, $IANmN.default).unbind();
    if ((0, $XHGTv.getBooleanFF)('platform.design-system-team.increased-contrast-themes')) {
        if (themeState.contrastMode === 'auto') {
            // Set contrastMode based on the user preference
            themeState.contrastMode = (0, $hU16G.default).getContrastMode();
            // Bind a listener (if one doesn't already exist) to keep contrastMode updated
            (0, $hU16G.default).bind();
        } else (0, $hU16G.default).unbind();
    }
    const themeAttributes = (0, $bgY86.default)(themeState);
    Object.entries(themeAttributes).forEach(([key, value])=>{
        document.documentElement.setAttribute(key, value);
    });
    return ()=>{
        (0, $IANmN.default).unbind();
        if ((0, $XHGTv.getBooleanFF)('platform.design-system-team.increased-contrast-themes')) (0, $hU16G.default).unbind();
    };
}

});
parcelRegister("IANmN", function(module, exports) {

$parcel$export(module.exports, "default", () => $412ce3ddd2f56cdc$export$2e2bcd8739ae039);

var $74BVL = parcelRequire("74BVL");

var $kyri3 = parcelRequire("kyri3");

var $2Mf9s = parcelRequire("2Mf9s");
const $412ce3ddd2f56cdc$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
/**
 * Updates the current theme when the system theme changes. Should be bound
 * to an event listener listening on the '(prefers-color-scheme: dark)' query
 * @param e The event representing a change in system theme.
 */ function $412ce3ddd2f56cdc$var$checkNativeListener(e) {
    const element = document.documentElement;
    element.setAttribute((0, $kyri3.COLOR_MODE_ATTRIBUTE), e.matches ? 'dark' : 'light');
}
const $412ce3ddd2f56cdc$var$darkModeMql = $412ce3ddd2f56cdc$var$isMatchMediaAvailable && window.matchMedia((0, $2Mf9s.darkModeMediaQuery));
class $412ce3ddd2f56cdc$var$ColorModeObserver {
    getColorMode() {
        if (!$412ce3ddd2f56cdc$var$darkModeMql) return 'light';
        return $412ce3ddd2f56cdc$var$darkModeMql?.matches ? 'dark' : 'light';
    }
    bind() {
        if ($412ce3ddd2f56cdc$var$darkModeMql && this.unbindThemeChangeListener === null) this.unbindThemeChangeListener = (0, $74BVL.bind)($412ce3ddd2f56cdc$var$darkModeMql, {
            type: 'change',
            listener: $412ce3ddd2f56cdc$var$checkNativeListener
        });
    }
    unbind() {
        if (this.unbindThemeChangeListener) {
            this.unbindThemeChangeListener();
            this.unbindThemeChangeListener = null;
        }
    }
    constructor(){
        this.unbindThemeChangeListener = null;
    }
}
/**
 * A singleton color mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ const $412ce3ddd2f56cdc$var$SingletonColorModeObserver = new $412ce3ddd2f56cdc$var$ColorModeObserver();
var $412ce3ddd2f56cdc$export$2e2bcd8739ae039 = $412ce3ddd2f56cdc$var$SingletonColorModeObserver;

});

parcelRegister("hU16G", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a1603c7b460b130$export$2e2bcd8739ae039);

var $74BVL = parcelRequire("74BVL");

var $kyri3 = parcelRequire("kyri3");

var $2Mf9s = parcelRequire("2Mf9s");
const $0a1603c7b460b130$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
/**
 * Updates the current theme when the system contrast preference changes. Should be bound
 * to an event listener listening on the '(prefers-contrast: more)' query
 * @param e The event representing a change in system theme.
 */ function $0a1603c7b460b130$var$checkNativeListener(e) {
    const element = document.documentElement;
    element.setAttribute((0, $kyri3.CONTRAST_MODE_ATTRIBUTE), e.matches ? 'more' : 'no-preference');
}
const $0a1603c7b460b130$var$contrastModeMql = $0a1603c7b460b130$var$isMatchMediaAvailable && window.matchMedia((0, $2Mf9s.moreContrastMediaQuery));
class $0a1603c7b460b130$var$ContrastModeObserver {
    getContrastMode() {
        if (!$0a1603c7b460b130$var$contrastModeMql) return 'no-preference';
        return $0a1603c7b460b130$var$contrastModeMql?.matches ? 'more' : 'no-preference';
    }
    bind() {
        if ($0a1603c7b460b130$var$contrastModeMql && this.unbindContrastChangeListener === null) this.unbindContrastChangeListener = (0, $74BVL.bind)($0a1603c7b460b130$var$contrastModeMql, {
            type: 'change',
            listener: $0a1603c7b460b130$var$checkNativeListener
        });
    }
    unbind() {
        if (this.unbindContrastChangeListener) {
            this.unbindContrastChangeListener();
            this.unbindContrastChangeListener = null;
        }
    }
    constructor(){
        this.unbindContrastChangeListener = null;
    }
}
/**
 * A singleton contrast mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ const $0a1603c7b460b130$var$SingletonContrastModeObserver = new $0a1603c7b460b130$var$ContrastModeObserver();
var $0a1603c7b460b130$export$2e2bcd8739ae039 = $0a1603c7b460b130$var$SingletonContrastModeObserver;

});


parcelRegister("2qx7E", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('4n7Rc');
        const value = parcelRequire('9EX02');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("4n7Rc").then(()=>parcelRequire('9EX02'));
}

});


parcelRegister("5YfXa", function(module, exports) {

$parcel$export(module.exports, "default", () => $458eee58a2e9fc4b$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $5RNXK = parcelRequire("5RNXK");

var $equnS = parcelRequire("equnS");

var $27DxH = parcelRequire("27DxH");
const $458eee58a2e9fc4b$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: Component = 'div', children: children, backgroundColor: backgroundColor, padding: padding, paddingBlock: paddingBlock, paddingBlockStart: paddingBlockStart, paddingBlockEnd: paddingBlockEnd, paddingInline: paddingInline, paddingInlineStart: paddingInlineStart, paddingInlineEnd: paddingInlineEnd, style: style, testId: testId, xcss: xcss, ...htmlAttributes }, ref)=>{
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const resolvedStyles = (0, $equnS.parseXcss)(xcss);
    const node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    (0, $byn9U.jsx)(Component, (0, $kU09D.default)({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        css: [
            $458eee58a2e9fc4b$var$baseStyles,
            backgroundColor && (0, $5RNXK.backgroundColorStylesMap)[backgroundColor],
            (0, $5RNXK.isSurfaceColorToken)(backgroundColor) && (0, $5RNXK.surfaceColorStylesMap)[backgroundColor],
            padding && (0, $5RNXK.paddingStylesMap).padding[padding],
            paddingBlock && (0, $5RNXK.paddingStylesMap).paddingBlock[paddingBlock],
            paddingBlockStart && (0, $5RNXK.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            paddingBlockEnd && (0, $5RNXK.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            paddingInline && (0, $5RNXK.paddingStylesMap).paddingInline[paddingInline],
            paddingInlineStart && (0, $5RNXK.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            paddingInlineEnd && (0, $5RNXK.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }), children);
    return backgroundColor ? (0, $byn9U.jsx)((0, $27DxH.SurfaceContext).Provider, {
        value: backgroundColor
    }, node) : node;
});
var $458eee58a2e9fc4b$export$2e2bcd8739ae039 = $458eee58a2e9fc4b$export$e71c4d32a2263218;
const $458eee58a2e9fc4b$var$baseStyles = (0, $byn9U.css)({
    boxSizing: 'border-box',
    appearance: 'none',
    border: 'none'
});

});
parcelRegister("5RNXK", function(module, exports) {

$parcel$export(module.exports, "dimensionMap", () => $4458a88cd7a417d2$export$6ccdbebca2ee545f);
$parcel$export(module.exports, "positiveSpaceMap", () => $4458a88cd7a417d2$export$958d0ae7f2977ae4);
$parcel$export(module.exports, "allSpaceMap", () => $4458a88cd7a417d2$export$632685d741f3dbbf);
$parcel$export(module.exports, "inverseColorMap", () => $4458a88cd7a417d2$export$2185ce37f9bdd963);
$parcel$export(module.exports, "opacityMap", () => $4458a88cd7a417d2$export$daf94a976c798b4f);
$parcel$export(module.exports, "shadowMap", () => $4458a88cd7a417d2$export$7aff6e7ba39bb774);
$parcel$export(module.exports, "borderColorMap", () => $4458a88cd7a417d2$export$1531ad5bb3fbedac);
$parcel$export(module.exports, "backgroundColorMap", () => $4458a88cd7a417d2$export$d1d79bf68ac056bd);
$parcel$export(module.exports, "textColorMap", () => $4458a88cd7a417d2$export$8473307aa00d6ea1);
$parcel$export(module.exports, "layerMap", () => $4458a88cd7a417d2$export$b5f31a7e431d2eab);
$parcel$export(module.exports, "borderWidthMap", () => $4458a88cd7a417d2$export$e1b83c5210c471b8);
$parcel$export(module.exports, "borderRadiusMap", () => $4458a88cd7a417d2$export$3c0a6c3e64bb180d);
$parcel$export(module.exports, "paddingStylesMap", () => $4458a88cd7a417d2$export$e615f061ca585a6c);
$parcel$export(module.exports, "spaceStylesMap", () => $4458a88cd7a417d2$export$bf46c3f9eeafc71f);
$parcel$export(module.exports, "backgroundColorStylesMap", () => $4458a88cd7a417d2$export$e7af83bafe7f9e63);
$parcel$export(module.exports, "textColorStylesMap", () => $4458a88cd7a417d2$export$3a1bcba60b23d7f0);
$parcel$export(module.exports, "fontWeightStylesMap", () => $4458a88cd7a417d2$export$45f3f4fe16f9f7d5);
$parcel$export(module.exports, "fontStylesMap", () => $4458a88cd7a417d2$export$128f10c238242f83);
$parcel$export(module.exports, "surfaceColorStylesMap", () => $4458a88cd7a417d2$export$ff257d957d48c421);
$parcel$export(module.exports, "isSurfaceColorToken", () => $4458a88cd7a417d2$export$5e65a44e5b6ecadb);

var $byn9U = parcelRequire("byn9U");

var $kyri3 = parcelRequire("kyri3");
const $4458a88cd7a417d2$export$6ccdbebca2ee545f = {
    '100%': '100%',
    'size.100': '1rem',
    'size.200': '1.5rem',
    'size.300': '2rem',
    'size.400': '2.5rem',
    'size.500': '3rem',
    'size.600': '6rem',
    'size.1000': '12rem'
};
const $4458a88cd7a417d2$export$958d0ae7f2977ae4 = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)"
};
const $4458a88cd7a417d2$export$d2dc61f58390201c = {
    'space.negative.025': "var(--ds-space-negative-025, -2px)",
    'space.negative.050': "var(--ds-space-negative-050, -4px)",
    'space.negative.075': "var(--ds-space-negative-075, -6px)",
    'space.negative.100': "var(--ds-space-negative-100, -8px)",
    'space.negative.150': "var(--ds-space-negative-150, -12px)",
    'space.negative.200': "var(--ds-space-negative-200, -16px)",
    'space.negative.250': "var(--ds-space-negative-250, -20px)",
    'space.negative.300': "var(--ds-space-negative-300, -24px)",
    'space.negative.400': "var(--ds-space-negative-400, -32px)"
};
const $4458a88cd7a417d2$export$632685d741f3dbbf = {
    ...$4458a88cd7a417d2$export$958d0ae7f2977ae4,
    ...$4458a88cd7a417d2$export$d2dc61f58390201c
};
const $4458a88cd7a417d2$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
const $4458a88cd7a417d2$export$daf94a976c798b4f = {
    'opacity.disabled': "var(--ds-opacity-disabled, 0.4)",
    'opacity.loading': "var(--ds-opacity-loading, 0.2)"
};
const $4458a88cd7a417d2$export$7aff6e7ba39bb774 = {
    'elevation.shadow.overflow': "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.overflow.perimeter': "var(--ds-shadow-overflow-perimeter, #091e421f)",
    'elevation.shadow.overflow.spread': "var(--ds-shadow-overflow-spread, #091e4229)",
    'elevation.shadow.overlay': "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.raised': "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
const $4458a88cd7a417d2$export$41a358c9c2356760 = {
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)"
};
const $4458a88cd7a417d2$export$1531ad5bb3fbedac = {
    'color.border': "var(--ds-border, #091e4221)",
    'color.border.accent.lime': "var(--ds-border-accent-lime, #6A9A23)",
    'color.border.accent.red': "var(--ds-border-accent-red, #FF5630)",
    'color.border.accent.orange': "var(--ds-border-accent-orange, #D94008)",
    'color.border.accent.yellow': "var(--ds-border-accent-yellow, #FFAB00)",
    'color.border.accent.green': "var(--ds-border-accent-green, #36B37E)",
    'color.border.accent.teal': "var(--ds-border-accent-teal, #00B8D9)",
    'color.border.accent.blue': "var(--ds-border-accent-blue, #0065FF)",
    'color.border.accent.purple': "var(--ds-border-accent-purple, #6554C0)",
    'color.border.accent.magenta': "var(--ds-border-accent-magenta, #CD519D)",
    'color.border.accent.gray': "var(--ds-border-accent-gray, #5E6C84)",
    'color.border.disabled': "var(--ds-border-disabled, #FAFBFC)",
    'color.border.focused': "var(--ds-border-focused, #2684FF)",
    'color.border.input': "var(--ds-border-input, #FAFBFC)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #0052CC)",
    'color.border.brand': "var(--ds-border-brand, #0052CC)",
    'color.border.danger': "var(--ds-border-danger, #FF5630)",
    'color.border.warning': "var(--ds-border-warning, #FFC400)",
    'color.border.success': "var(--ds-border-success, #00875A)",
    'color.border.discovery': "var(--ds-border-discovery, #998DD9)",
    'color.border.information': "var(--ds-border-information, #0065FF)",
    'color.border.bold': "var(--ds-border-bold, #344563)"
};
const $4458a88cd7a417d2$export$d1d79bf68ac056bd = {
    'color.background.accent.lime.subtlest': "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    'color.background.accent.lime.subtlest.hovered': "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    'color.background.accent.lime.subtlest.pressed': "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    'color.background.accent.lime.subtler': "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    'color.background.accent.lime.subtler.hovered': "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    'color.background.accent.lime.subtler.pressed': "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    'color.background.accent.lime.subtle': "var(--ds-background-accent-lime-subtle, #94C748)",
    'color.background.accent.lime.subtle.hovered': "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    'color.background.accent.lime.subtle.pressed': "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    'color.background.accent.lime.bolder': "var(--ds-background-accent-lime-bolder, #5B7F24)",
    'color.background.accent.lime.bolder.hovered': "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    'color.background.accent.lime.bolder.pressed': "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    'color.background.accent.red.subtlest': "var(--ds-background-accent-red-subtlest, #FF8F73)",
    'color.background.accent.red.subtlest.hovered': "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    'color.background.accent.red.subtlest.pressed': "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    'color.background.accent.red.subtler': "var(--ds-background-accent-red-subtler, #FF7452)",
    'color.background.accent.red.subtler.hovered': "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    'color.background.accent.red.subtler.pressed': "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    'color.background.accent.red.subtle': "var(--ds-background-accent-red-subtle, #DE350B)",
    'color.background.accent.red.subtle.hovered': "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    'color.background.accent.red.subtle.pressed': "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    'color.background.accent.red.bolder': "var(--ds-background-accent-red-bolder, #DE350B)",
    'color.background.accent.red.bolder.hovered': "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    'color.background.accent.red.bolder.pressed': "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    'color.background.accent.orange.subtlest': "var(--ds-background-accent-orange-subtlest, #F18D13)",
    'color.background.accent.orange.subtlest.hovered': "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    'color.background.accent.orange.subtlest.pressed': "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    'color.background.accent.orange.subtler': "var(--ds-background-accent-orange-subtler, #B65C02)",
    'color.background.accent.orange.subtler.hovered': "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    'color.background.accent.orange.subtler.pressed': "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    'color.background.accent.orange.subtle': "var(--ds-background-accent-orange-subtle, #5F3811)",
    'color.background.accent.orange.subtle.hovered': "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    'color.background.accent.orange.subtle.pressed': "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    'color.background.accent.orange.bolder': "var(--ds-background-accent-orange-bolder, #43290F)",
    'color.background.accent.orange.bolder.hovered': "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    'color.background.accent.orange.bolder.pressed': "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    'color.background.accent.yellow.subtlest': "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    'color.background.accent.yellow.subtlest.hovered': "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    'color.background.accent.yellow.subtlest.pressed': "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    'color.background.accent.yellow.subtler': "var(--ds-background-accent-yellow-subtler, #FFC400)",
    'color.background.accent.yellow.subtler.hovered': "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    'color.background.accent.yellow.subtler.pressed': "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    'color.background.accent.yellow.subtle': "var(--ds-background-accent-yellow-subtle, #FF991F)",
    'color.background.accent.yellow.subtle.hovered': "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    'color.background.accent.yellow.subtle.pressed': "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    'color.background.accent.yellow.bolder': "var(--ds-background-accent-yellow-bolder, #FF991F)",
    'color.background.accent.yellow.bolder.hovered': "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    'color.background.accent.yellow.bolder.pressed': "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    'color.background.accent.green.subtlest': "var(--ds-background-accent-green-subtlest, #79F2C0)",
    'color.background.accent.green.subtlest.hovered': "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    'color.background.accent.green.subtlest.pressed': "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    'color.background.accent.green.subtler': "var(--ds-background-accent-green-subtler, #57D9A3)",
    'color.background.accent.green.subtler.hovered': "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    'color.background.accent.green.subtler.pressed': "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    'color.background.accent.green.subtle': "var(--ds-background-accent-green-subtle, #00875A)",
    'color.background.accent.green.subtle.hovered': "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    'color.background.accent.green.subtle.pressed': "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    'color.background.accent.green.bolder': "var(--ds-background-accent-green-bolder, #00875A)",
    'color.background.accent.green.bolder.hovered': "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    'color.background.accent.green.bolder.pressed': "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    'color.background.accent.teal.subtlest': "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    'color.background.accent.teal.subtlest.hovered': "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    'color.background.accent.teal.subtlest.pressed': "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    'color.background.accent.teal.subtler': "var(--ds-background-accent-teal-subtler, #00C7E6)",
    'color.background.accent.teal.subtler.hovered': "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    'color.background.accent.teal.subtler.pressed': "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    'color.background.accent.teal.subtle': "var(--ds-background-accent-teal-subtle, #00A3BF)",
    'color.background.accent.teal.subtle.hovered': "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    'color.background.accent.teal.subtle.pressed': "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    'color.background.accent.teal.bolder': "var(--ds-background-accent-teal-bolder, #00A3BF)",
    'color.background.accent.teal.bolder.hovered': "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    'color.background.accent.teal.bolder.pressed': "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    'color.background.accent.blue.subtlest': "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    'color.background.accent.blue.subtlest.hovered': "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    'color.background.accent.blue.subtlest.pressed': "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    'color.background.accent.blue.subtler': "var(--ds-background-accent-blue-subtler, #2684FF)",
    'color.background.accent.blue.subtler.hovered': "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    'color.background.accent.blue.subtler.pressed': "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    'color.background.accent.blue.subtle': "var(--ds-background-accent-blue-subtle, #0052CC)",
    'color.background.accent.blue.subtle.hovered': "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    'color.background.accent.blue.subtle.pressed': "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    'color.background.accent.blue.bolder': "var(--ds-background-accent-blue-bolder, #0052CC)",
    'color.background.accent.blue.bolder.hovered': "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    'color.background.accent.blue.bolder.pressed': "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    'color.background.accent.purple.subtlest': "var(--ds-background-accent-purple-subtlest, #998DD9)",
    'color.background.accent.purple.subtlest.hovered': "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    'color.background.accent.purple.subtlest.pressed': "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    'color.background.accent.purple.subtler': "var(--ds-background-accent-purple-subtler, #8777D9)",
    'color.background.accent.purple.subtler.hovered': "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    'color.background.accent.purple.subtler.pressed': "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    'color.background.accent.purple.subtle': "var(--ds-background-accent-purple-subtle, #5243AA)",
    'color.background.accent.purple.subtle.hovered': "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    'color.background.accent.purple.subtle.pressed': "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    'color.background.accent.purple.bolder': "var(--ds-background-accent-purple-bolder, #5243AA)",
    'color.background.accent.purple.bolder.hovered': "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    'color.background.accent.purple.bolder.pressed': "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    'color.background.accent.magenta.subtlest': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    'color.background.accent.magenta.subtlest.hovered': "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    'color.background.accent.magenta.subtlest.pressed': "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    'color.background.accent.magenta.subtler': "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    'color.background.accent.magenta.subtler.hovered': "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    'color.background.accent.magenta.subtler.pressed': "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    'color.background.accent.magenta.subtle': "var(--ds-background-accent-magenta-subtle, #E774BB)",
    'color.background.accent.magenta.subtle.hovered': "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    'color.background.accent.magenta.subtle.pressed': "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    'color.background.accent.magenta.bolder': "var(--ds-background-accent-magenta-bolder, #AE4787)",
    'color.background.accent.magenta.bolder.hovered': "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    'color.background.accent.magenta.bolder.pressed': "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    'color.background.accent.gray.subtlest': "var(--ds-background-accent-gray-subtlest, #6B778C)",
    'color.background.accent.gray.subtlest.hovered': "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    'color.background.accent.gray.subtlest.pressed': "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    'color.background.accent.gray.subtler': "var(--ds-background-accent-gray-subtler, #5E6C84)",
    'color.background.accent.gray.subtler.hovered': "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    'color.background.accent.gray.subtler.pressed': "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    'color.background.accent.gray.subtle': "var(--ds-background-accent-gray-subtle, #505F79)",
    'color.background.accent.gray.subtle.hovered': "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    'color.background.accent.gray.subtle.pressed': "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    'color.background.accent.gray.bolder': "var(--ds-background-accent-gray-bolder, #42526E)",
    'color.background.accent.gray.bolder.hovered': "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    'color.background.accent.gray.bolder.pressed': "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    'color.background.disabled': "var(--ds-background-disabled, #091e4289)",
    'color.background.input': "var(--ds-background-input, #FAFBFC)",
    'color.background.input.hovered': "var(--ds-background-input-hovered, #EBECF0)",
    'color.background.input.pressed': "var(--ds-background-input-pressed, #FFFFFF)",
    'color.background.inverse.subtle': "var(--ds-background-inverse-subtle, #00000029)",
    'color.background.inverse.subtle.hovered': "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    'color.background.inverse.subtle.pressed': "var(--ds-background-inverse-subtle-pressed, #00000052)",
    'color.background.neutral': "var(--ds-background-neutral, #DFE1E6)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #091e4214)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #B3D4FF)",
    'color.background.neutral.subtle': "var(--ds-background-neutral-subtle, transparent)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    'color.background.neutral.bold': "var(--ds-background-neutral-bold, #42526E)",
    'color.background.neutral.bold.hovered': "var(--ds-background-neutral-bold-hovered, #505F79)",
    'color.background.neutral.bold.pressed': "var(--ds-background-neutral-bold-pressed, #344563)",
    'color.background.selected': "var(--ds-background-selected, #DEEBFF)",
    'color.background.selected.hovered': "var(--ds-background-selected-hovered, #B3D4FF)",
    'color.background.selected.pressed': "var(--ds-background-selected-pressed, #4C9AFF)",
    'color.background.selected.bold': "var(--ds-background-selected-bold, #0052CC)",
    'color.background.selected.bold.hovered': "var(--ds-background-selected-bold-hovered, #2684FF)",
    'color.background.selected.bold.pressed': "var(--ds-background-selected-bold-pressed, #0052CC)",
    'color.background.brand.subtlest': "var(--ds-background-brand-subtlest, #B3D4FF)",
    'color.background.brand.subtlest.hovered': "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    'color.background.brand.subtlest.pressed': "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    'color.background.brand.bold': "var(--ds-background-brand-bold, #0052CC)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #0065FF)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #0747A6)",
    'color.background.brand.boldest': "var(--ds-background-brand-boldest, #0747A6)",
    'color.background.brand.boldest.hovered': "var(--ds-background-brand-boldest-hovered, #0052CC)",
    'color.background.brand.boldest.pressed': "var(--ds-background-brand-boldest-pressed, #0747A6)",
    'color.background.danger': "var(--ds-background-danger, #FFEBE6)",
    'color.background.danger.hovered': "var(--ds-background-danger-hovered, #FFBDAD)",
    'color.background.danger.pressed': "var(--ds-background-danger-pressed, #FF8F73)",
    'color.background.danger.bold': "var(--ds-background-danger-bold, #DE350B)",
    'color.background.danger.bold.hovered': "var(--ds-background-danger-bold-hovered, #FF5630)",
    'color.background.danger.bold.pressed': "var(--ds-background-danger-bold-pressed, #BF2600)",
    'color.background.warning': "var(--ds-background-warning, #FFFAE6)",
    'color.background.warning.hovered': "var(--ds-background-warning-hovered, #FFF0B3)",
    'color.background.warning.pressed': "var(--ds-background-warning-pressed, #FFE380)",
    'color.background.warning.bold': "var(--ds-background-warning-bold, #FFAB00)",
    'color.background.warning.bold.hovered': "var(--ds-background-warning-bold-hovered, #FFC400)",
    'color.background.warning.bold.pressed': "var(--ds-background-warning-bold-pressed, #FF991F)",
    'color.background.success': "var(--ds-background-success, #E3FCEF)",
    'color.background.success.hovered': "var(--ds-background-success-hovered, #ABF5D1)",
    'color.background.success.pressed': "var(--ds-background-success-pressed, #79F2C0)",
    'color.background.success.bold': "var(--ds-background-success-bold, #00875A)",
    'color.background.success.bold.hovered': "var(--ds-background-success-bold-hovered, #57D9A3)",
    'color.background.success.bold.pressed': "var(--ds-background-success-bold-pressed, #00875A)",
    'color.background.discovery': "var(--ds-background-discovery, #EAE6FF)",
    'color.background.discovery.hovered': "var(--ds-background-discovery-hovered, #C0B6F2)",
    'color.background.discovery.pressed': "var(--ds-background-discovery-pressed, #998DD9)",
    'color.background.discovery.bold': "var(--ds-background-discovery-bold, #5243AA)",
    'color.background.discovery.bold.hovered': "var(--ds-background-discovery-bold-hovered, #8777D9)",
    'color.background.discovery.bold.pressed': "var(--ds-background-discovery-bold-pressed, #5243AA)",
    'color.background.information': "var(--ds-background-information, #DEEBFF)",
    'color.background.information.hovered': "var(--ds-background-information-hovered, #B3D4FF)",
    'color.background.information.pressed': "var(--ds-background-information-pressed, #4C9AFF)",
    'color.background.information.bold': "var(--ds-background-information-bold, #0052CC)",
    'color.background.information.bold.hovered': "var(--ds-background-information-bold-hovered, #2684FF)",
    'color.background.information.bold.pressed': "var(--ds-background-information-bold-pressed, #0052CC)",
    'color.blanket': "var(--ds-blanket, #091e4289)",
    'color.blanket.selected': "var(--ds-blanket-selected, #388BFF14)",
    'color.blanket.danger': "var(--ds-blanket-danger, #EF5C4814)",
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)",
    'utility.elevation.surface.current': "var(--ds-elevation-surface-current, #FFFFFF)"
};
const $4458a88cd7a417d2$export$8473307aa00d6ea1 = {
    'color.text': "var(--ds-text, #172B4D)",
    'color.text.accent.lime': "var(--ds-text-accent-lime, #4C6B1F)",
    'color.text.accent.lime.bolder': "var(--ds-text-accent-lime-bolder, #37471F)",
    'color.text.accent.red': "var(--ds-text-accent-red, #DE350B)",
    'color.text.accent.red.bolder': "var(--ds-text-accent-red-bolder, #BF2600)",
    'color.text.accent.orange': "var(--ds-text-accent-orange, #F18D13)",
    'color.text.accent.orange.bolder': "var(--ds-text-accent-orange-bolder, #B65C02)",
    'color.text.accent.yellow': "var(--ds-text-accent-yellow, #FF991F)",
    'color.text.accent.yellow.bolder': "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    'color.text.accent.green': "var(--ds-text-accent-green, #00875A)",
    'color.text.accent.green.bolder': "var(--ds-text-accent-green-bolder, #006644)",
    'color.text.accent.teal': "var(--ds-text-accent-teal, #00A3BF)",
    'color.text.accent.teal.bolder': "var(--ds-text-accent-teal-bolder, #008DA6)",
    'color.text.accent.blue': "var(--ds-text-accent-blue, #0052CC)",
    'color.text.accent.blue.bolder': "var(--ds-text-accent-blue-bolder, #0747A6)",
    'color.text.accent.purple': "var(--ds-text-accent-purple, #5243AA)",
    'color.text.accent.purple.bolder': "var(--ds-text-accent-purple-bolder, #403294)",
    'color.text.accent.magenta': "var(--ds-text-accent-magenta, #E774BB)",
    'color.text.accent.magenta.bolder': "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    'color.text.accent.gray': "var(--ds-text-accent-gray, #505F79)",
    'color.text.accent.gray.bolder': "var(--ds-text-accent-gray-bolder, #172B4D)",
    'color.text.disabled': "var(--ds-text-disabled, #A5ADBA)",
    'color.text.inverse': "var(--ds-text-inverse, #FFFFFF)",
    'color.text.selected': "var(--ds-text-selected, #0052CC)",
    'color.text.brand': "var(--ds-text-brand, #0065FF)",
    'color.text.danger': "var(--ds-text-danger, #DE350B)",
    'color.text.warning': "var(--ds-text-warning, #974F0C)",
    'color.text.warning.inverse': "var(--ds-text-warning-inverse, #172B4D)",
    'color.text.success': "var(--ds-text-success, #006644)",
    'color.text.discovery': "var(--ds-text-discovery, #403294)",
    'color.text.information': "var(--ds-text-information, #0052CC)",
    'color.text.subtlest': "var(--ds-text-subtlest, #7A869A)",
    'color.text.subtle': "var(--ds-text-subtle, #42526E)",
    'color.link': "var(--ds-link, #0052CC)",
    'color.link.pressed': "var(--ds-link-pressed, #0747A6)",
    'color.link.visited': "var(--ds-link-visited, #403294)",
    'color.link.visited.pressed': "var(--ds-link-visited-pressed, #403294)"
};
const $4458a88cd7a417d2$export$498780f74be9af68 = {
    'color.icon': "var(--ds-icon, #505F79)",
    'color.icon.accent.lime': "var(--ds-icon-accent-lime, #6A9A23)",
    'color.icon.accent.red': "var(--ds-icon-accent-red, #FF5630)",
    'color.icon.accent.orange': "var(--ds-icon-accent-orange, #D94008)",
    'color.icon.accent.yellow': "var(--ds-icon-accent-yellow, #FFAB00)",
    'color.icon.accent.green': "var(--ds-icon-accent-green, #36B37E)",
    'color.icon.accent.teal': "var(--ds-icon-accent-teal, #00B8D9)",
    'color.icon.accent.blue': "var(--ds-icon-accent-blue, #0065FF)",
    'color.icon.accent.purple': "var(--ds-icon-accent-purple, #6554C0)",
    'color.icon.accent.magenta': "var(--ds-icon-accent-magenta, #CD519D)",
    'color.icon.accent.gray': "var(--ds-icon-accent-gray, #5E6C84)",
    'color.icon.disabled': "var(--ds-icon-disabled, #8993A4)",
    'color.icon.inverse': "var(--ds-icon-inverse, #FFFFFF)",
    'color.icon.selected': "var(--ds-icon-selected, #0052CC)",
    'color.icon.brand': "var(--ds-icon-brand, #0065FF)",
    'color.icon.danger': "var(--ds-icon-danger, #DE350B)",
    'color.icon.warning': "var(--ds-icon-warning, #FFC400)",
    'color.icon.warning.inverse': "var(--ds-icon-warning-inverse, #253858)",
    'color.icon.success': "var(--ds-icon-success, #00875A)",
    'color.icon.discovery': "var(--ds-icon-discovery, #8777D9)",
    'color.icon.information': "var(--ds-icon-information, #0747A6)",
    'color.icon.subtle': "var(--ds-icon-subtle, #6B778C)"
};
const $4458a88cd7a417d2$export$b5f31a7e431d2eab = {
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
const $4458a88cd7a417d2$export$e1b83c5210c471b8 = {
    'border.width': "var(--ds-border-width, 1px)",
    'border.width.0': "var(--ds-border-width-0, 0px)",
    'border.width.indicator': "var(--ds-border-width-indicator, 3px)",
    'border.width.outline': "var(--ds-border-width-outline, 2px)"
};
const $4458a88cd7a417d2$export$3c0a6c3e64bb180d = {
    'border.radius.050': "var(--ds-border-radius-050, 2px)",
    'border.radius': "var(--ds-border-radius, 3px)",
    'border.radius.100': "var(--ds-border-radius-100, 3px)",
    'border.radius.200': "var(--ds-border-radius-200, 8px)",
    'border.radius.300': "var(--ds-border-radius-300, 12px)",
    'border.radius.400': "var(--ds-border-radius-400, 16px)",
    'border.radius.circle': "var(--ds-border-radius-circle, 32032px)"
};
const $4458a88cd7a417d2$export$6cc560b4dedf3816 = {
    medium: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    UNSAFE_small: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    large: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
const $4458a88cd7a417d2$export$303e322c6b1ed114 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
const $4458a88cd7a417d2$export$3c7e9587132614b4 = {
    'font.family.body': "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.body': "var(--ds-font-family-brand-body, \"Charlie Text\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.heading': "var(--ds-font-family-brand-heading, \"Charlie Display\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.family.code': "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.family.heading': "var(--ds-font-family-heading, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
/**
 * @codegenEnd
 */ // Generate maps for Box props. backgroundColor, padding, etc
const $4458a88cd7a417d2$var$spacingProperties = [
    // Used by Box
    'padding',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    // Used by Inline and Stack
    'gap',
    'rowGap',
    'columnGap'
];
const $4458a88cd7a417d2$var$getSerializedStylesMap = (cssProperty, tokenMap)=>{
    return Object.keys(tokenMap).reduce((emotionSpacingMap, token)=>{
        emotionSpacingMap[token] = (0, $byn9U.css)({
            [cssProperty]: tokenMap[token]
        });
        return emotionSpacingMap;
    }, {});
};
const $4458a88cd7a417d2$export$e615f061ca585a6c = $4458a88cd7a417d2$var$spacingProperties.reduce((styleMap, spacingProperty)=>{
    styleMap[spacingProperty] = $4458a88cd7a417d2$var$getSerializedStylesMap(spacingProperty, $4458a88cd7a417d2$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
const $4458a88cd7a417d2$export$bf46c3f9eeafc71f = $4458a88cd7a417d2$var$spacingProperties.reduce((styleMap, spacingProperty)=>{
    styleMap[spacingProperty] = $4458a88cd7a417d2$var$getSerializedStylesMap(spacingProperty, $4458a88cd7a417d2$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
const $4458a88cd7a417d2$export$e7af83bafe7f9e63 = $4458a88cd7a417d2$var$getSerializedStylesMap('backgroundColor', $4458a88cd7a417d2$export$d1d79bf68ac056bd);
const $4458a88cd7a417d2$export$3a1bcba60b23d7f0 = $4458a88cd7a417d2$var$getSerializedStylesMap('color', $4458a88cd7a417d2$export$8473307aa00d6ea1);
const $4458a88cd7a417d2$export$45f3f4fe16f9f7d5 = $4458a88cd7a417d2$var$getSerializedStylesMap('fontWeight', $4458a88cd7a417d2$export$303e322c6b1ed114);
const $4458a88cd7a417d2$export$68cc305da27dbaa4 = $4458a88cd7a417d2$var$getSerializedStylesMap('fontFamily', $4458a88cd7a417d2$export$3c7e9587132614b4);
const $4458a88cd7a417d2$export$128f10c238242f83 = $4458a88cd7a417d2$var$getSerializedStylesMap('font', $4458a88cd7a417d2$export$6cc560b4dedf3816);
const $4458a88cd7a417d2$export$ff257d957d48c421 = $4458a88cd7a417d2$var$getSerializedStylesMap((0, $kyri3.CURRENT_SURFACE_CSS_VAR), $4458a88cd7a417d2$export$41a358c9c2356760);
const $4458a88cd7a417d2$export$5e65a44e5b6ecadb = (color)=>$4458a88cd7a417d2$export$41a358c9c2356760[color] !== undefined;

});

parcelRegister("equnS", function(module, exports) {

$parcel$export(module.exports, "tokensMap", () => $a80b100c67714cb7$export$9a199fbafee0014e);
$parcel$export(module.exports, "parseXcss", () => $a80b100c67714cb7$export$a9c84988c8f81f2d);
$parcel$export(module.exports, "xcss", () => $a80b100c67714cb7$export$f6c783d06584602c);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $byn9U = parcelRequire("byn9U");

var $5RNXK = parcelRequire("5RNXK");

var $2fFJv = parcelRequire("2fFJv");
const $a80b100c67714cb7$export$9a199fbafee0014e = {
    backgroundColor: (0, $5RNXK.backgroundColorMap),
    blockSize: (0, $5RNXK.dimensionMap),
    borderBlockColor: (0, $5RNXK.borderColorMap),
    borderBlockEndColor: (0, $5RNXK.borderColorMap),
    borderBlockEndWidth: (0, $5RNXK.borderWidthMap),
    borderBlockStartColor: (0, $5RNXK.borderColorMap),
    borderBlockStartWidth: (0, $5RNXK.borderWidthMap),
    borderBlockWidth: (0, $5RNXK.borderWidthMap),
    borderBottomColor: (0, $5RNXK.borderColorMap),
    borderBottomLeftRadius: (0, $5RNXK.borderRadiusMap),
    borderBottomRightRadius: (0, $5RNXK.borderRadiusMap),
    borderBottomWidth: (0, $5RNXK.borderWidthMap),
    borderColor: (0, $5RNXK.borderColorMap),
    borderEndEndRadius: (0, $5RNXK.borderRadiusMap),
    borderEndStartRadius: (0, $5RNXK.borderRadiusMap),
    borderInlineColor: (0, $5RNXK.borderColorMap),
    borderInlineEndColor: (0, $5RNXK.borderColorMap),
    borderInlineEndWidth: (0, $5RNXK.borderWidthMap),
    borderInlineStartColor: (0, $5RNXK.borderColorMap),
    borderInlineStartWidth: (0, $5RNXK.borderWidthMap),
    borderInlineWidth: (0, $5RNXK.borderWidthMap),
    borderLeftColor: (0, $5RNXK.borderColorMap),
    borderLeftWidth: (0, $5RNXK.borderWidthMap),
    borderRadius: (0, $5RNXK.borderRadiusMap),
    borderRightColor: (0, $5RNXK.borderColorMap),
    borderRightWidth: (0, $5RNXK.borderWidthMap),
    borderStartEndRadius: (0, $5RNXK.borderRadiusMap),
    borderStartStartRadius: (0, $5RNXK.borderRadiusMap),
    borderTopColor: (0, $5RNXK.borderColorMap),
    borderTopLeftRadius: (0, $5RNXK.borderRadiusMap),
    borderTopRightRadius: (0, $5RNXK.borderRadiusMap),
    borderTopWidth: (0, $5RNXK.borderWidthMap),
    borderWidth: (0, $5RNXK.borderWidthMap),
    bottom: (0, $5RNXK.allSpaceMap),
    boxShadow: (0, $5RNXK.shadowMap),
    color: (0, $5RNXK.textColorMap),
    columnGap: (0, $5RNXK.positiveSpaceMap),
    gap: (0, $5RNXK.positiveSpaceMap),
    height: (0, $5RNXK.dimensionMap),
    inlineSize: (0, $5RNXK.dimensionMap),
    inset: (0, $5RNXK.allSpaceMap),
    insetBlock: (0, $5RNXK.allSpaceMap),
    insetBlockEnd: (0, $5RNXK.allSpaceMap),
    insetBlockStart: (0, $5RNXK.allSpaceMap),
    insetInline: (0, $5RNXK.allSpaceMap),
    insetInlineEnd: (0, $5RNXK.allSpaceMap),
    insetInlineStart: (0, $5RNXK.allSpaceMap),
    left: (0, $5RNXK.allSpaceMap),
    margin: (0, $5RNXK.allSpaceMap),
    marginBlock: (0, $5RNXK.allSpaceMap),
    marginBlockEnd: (0, $5RNXK.allSpaceMap),
    marginBlockStart: (0, $5RNXK.allSpaceMap),
    marginBottom: (0, $5RNXK.allSpaceMap),
    marginInline: (0, $5RNXK.allSpaceMap),
    marginInlineEnd: (0, $5RNXK.allSpaceMap),
    marginInlineStart: (0, $5RNXK.allSpaceMap),
    marginLeft: (0, $5RNXK.allSpaceMap),
    marginRight: (0, $5RNXK.allSpaceMap),
    marginTop: (0, $5RNXK.allSpaceMap),
    maxBlockSize: (0, $5RNXK.dimensionMap),
    maxHeight: (0, $5RNXK.dimensionMap),
    maxInlineSize: (0, $5RNXK.dimensionMap),
    maxWidth: (0, $5RNXK.dimensionMap),
    minBlockSize: (0, $5RNXK.dimensionMap),
    minHeight: (0, $5RNXK.dimensionMap),
    minInlineSize: (0, $5RNXK.dimensionMap),
    minWidth: (0, $5RNXK.dimensionMap),
    opacity: (0, $5RNXK.opacityMap),
    outlineColor: (0, $5RNXK.borderColorMap),
    outlineOffset: (0, $5RNXK.positiveSpaceMap),
    outlineWidth: (0, $5RNXK.borderWidthMap),
    padding: (0, $5RNXK.positiveSpaceMap),
    paddingBlock: (0, $5RNXK.positiveSpaceMap),
    paddingBlockEnd: (0, $5RNXK.positiveSpaceMap),
    paddingBlockStart: (0, $5RNXK.positiveSpaceMap),
    paddingBottom: (0, $5RNXK.positiveSpaceMap),
    paddingInline: (0, $5RNXK.positiveSpaceMap),
    paddingInlineEnd: (0, $5RNXK.positiveSpaceMap),
    paddingInlineStart: (0, $5RNXK.positiveSpaceMap),
    paddingLeft: (0, $5RNXK.positiveSpaceMap),
    paddingRight: (0, $5RNXK.positiveSpaceMap),
    paddingTop: (0, $5RNXK.positiveSpaceMap),
    right: (0, $5RNXK.allSpaceMap),
    rowGap: (0, $5RNXK.positiveSpaceMap),
    top: (0, $5RNXK.allSpaceMap),
    width: (0, $5RNXK.dimensionMap),
    zIndex: (0, $5RNXK.layerMap)
};
const $a80b100c67714cb7$var$uniqueSymbol = Symbol('UNSAFE_INTERNAL_styles');
const $a80b100c67714cb7$var$isSafeEnvToThrow = ()=>typeof $2fFJv === 'object' && typeof $2fFJv.env === 'object' && false;
const $a80b100c67714cb7$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
const $a80b100c67714cb7$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
const $a80b100c67714cb7$var$transformStyles = (styleObj)=>{
    if (!styleObj || typeof styleObj !== 'object') return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map($a80b100c67714cb7$var$transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(([key, value])=>{
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if (typeof value === 'object' && $a80b100c67714cb7$var$safeSelectors.test(key)) {
            styleObj[key] = $a80b100c67714cb7$var$transformStyles(value);
            return;
        }
        if ($a80b100c67714cb7$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($a80b100c67714cb7$var$reNestedSelectors.test(key)) throw new Error(`Styles not supported for key '${key}'.`);
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $a80b100c67714cb7$export$9a199fbafee0014e)) return;
        const tokenValue = $a80b100c67714cb7$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
const $a80b100c67714cb7$var$baseXcss = (style)=>{
    const transformedStyles = $a80b100c67714cb7$var$transformStyles(style);
    return {
        [$a80b100c67714cb7$var$uniqueSymbol]: (0, $byn9U.css)(transformedStyles)
    };
};
const $a80b100c67714cb7$export$a9c84988c8f81f2d = (args)=>{
    if (Array.isArray(args)) {
        const emotion = [];
        const staticArr = [];
        for (const arg of args){
            const result = $a80b100c67714cb7$export$a9c84988c8f81f2d(arg);
            if (result.emotion) emotion.push(...result.emotion);
            if (result.static) staticArr.push(result.static);
        }
        return {
            emotion: emotion,
            static: staticArr.join(' ')
        };
    }
    const objArgs = args;
    const { [$a80b100c67714cb7$var$uniqueSymbol]: styles } = objArgs || {};
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        const stringifiedArgs = `${args}`;
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $a80b100c67714cb7$export$f6c783d06584602c(style) {
    return $a80b100c67714cb7$var$baseXcss(style);
}

});

parcelRegister("27DxH", function(module, exports) {

$parcel$export(module.exports, "SurfaceContext", () => $18bae889c21c399e$export$1ca2a26fecb070ae);
$parcel$export(module.exports, "useSurface", () => $18bae889c21c399e$export$1aeb4f6b93c4540d);

var $eUqFw = parcelRequire("eUqFw");
const $18bae889c21c399e$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $eUqFw.createContext)('elevation.surface');
const $18bae889c21c399e$export$1aeb4f6b93c4540d = ()=>{
    return (0, $eUqFw.useContext)($18bae889c21c399e$export$1ca2a26fecb070ae);
};
$18bae889c21c399e$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';

});


parcelRegister("j9fWg", function(module, exports) {

$parcel$export(module.exports, "default", () => $882a7c49c57eabf3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4ZL0y = parcelRequire("4ZL0y");

var $8cU5f = parcelRequire("8cU5f");

var $cxipd = parcelRequire("cxipd");
/**
 * __Icon Button__
 *
 * TODO: Description
 *
 * - [Examples](https://atlassian.design/components/icon-button/examples)
 * - [Code](https://atlassian.design/components/icon-button/code)
 * - [Usage](https://atlassian.design/components/icon-button/usage)
 */ const $882a7c49c57eabf3$var$IconButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef(function Button({ // Prevent duplicate labels being added.
'aria-label': preventedAriaLabel, analyticsContext: analyticsContext, appearance: appearance, autoFocus: autoFocus, icon: icon, interactionName: interactionName, isDisabled: isDisabled, isLoading: isLoading, isSelected: isSelected, isTooltipDisabled: isTooltipDisabled = true, label: label, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, overlay: overlay, shape: shape, spacing: spacing, testId: testId, tooltip: tooltip, type: type = 'button', UNSAFE_size: UNSAFE_size, ...rest }, ref) {
    /**
		 * TODO: At some stage I'll look into re-using more logic across 'default' and 'icon'
		 * buttons. It's currently duplicated and mostly the same.
		 */ const baseProps = (0, $cxipd.default)({
        analyticsContext: analyticsContext,
        appearance: appearance,
        autoFocus: autoFocus,
        buttonType: 'button',
        icon: icon,
        interactionName: interactionName,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        label: label,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchEndCapture: onTouchEndCapture,
        onTouchStartCapture: onTouchStartCapture,
        overlay: overlay,
        ref: ref,
        shape: shape,
        spacing: spacing,
        UNSAFE_size: UNSAFE_size
    });
    if (!isTooltipDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: tooltip?.content ?? label,
        testId: tooltip?.testId,
        position: tooltip?.position,
        delay: tooltip?.delay,
        onShow: tooltip?.onShow,
        onHide: tooltip?.onHide,
        mousePosition: tooltip?.mousePosition,
        analyticsContext: tooltip?.analyticsContext,
        strategy: tooltip?.strategy,
        tag: tooltip?.tag,
        truncate: tooltip?.truncate,
        component: tooltip?.component,
        hideTooltipOnClick: tooltip?.hideTooltipOnClick,
        hideTooltipOnMouseDown: tooltip?.hideTooltipOnMouseDown
    }, (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ZL0y.default), {
            ...rest,
            type: type,
            testId: testId,
            componentName: "IconButton",
            analyticsContext: analyticsContext,
            interactionName: interactionName,
            // Shared between tooltip and native props
            onMouseOver: (e)=>{
                triggerProps.onMouseOver?.(e);
                rest.onMouseOver?.(e);
            },
            onMouseOut: (e)=>{
                triggerProps.onMouseOut?.(e);
                rest.onMouseOut?.(e);
            },
            onMouseMove: (e)=>{
                triggerProps.onMouseMove?.(e);
                rest.onMouseMove?.(e);
            },
            onMouseDown: (e)=>{
                triggerProps.onMouseDown?.(e);
                rest.onMouseDown?.(e);
            },
            onFocus: (e)=>{
                triggerProps.onFocus?.(e);
                rest.onFocus?.(e);
            },
            onBlur: (e)=>{
                triggerProps.onBlur?.(e);
                rest.onBlur?.(e);
            },
            // Shared between tooltip and base props
            onClick: (event, analyticsEvent)=>{
                baseProps?.onClick?.(event, analyticsEvent);
                triggerProps?.onClick?.(event);
            },
            ref: (ref)=>{
                baseProps.ref(ref);
                triggerProps?.ref?.(ref);
            },
            // Base props only
            xcss: baseProps.xcss,
            isDisabled: baseProps.isDisabled,
            onMouseDownCapture: baseProps.onMouseDownCapture,
            onMouseUpCapture: baseProps.onMouseUpCapture,
            onKeyDownCapture: baseProps.onKeyDownCapture,
            onKeyUpCapture: baseProps.onKeyUpCapture,
            onTouchStartCapture: baseProps.onTouchStartCapture,
            onTouchEndCapture: baseProps.onTouchEndCapture,
            onPointerDownCapture: baseProps.onPointerDownCapture,
            onPointerUpCapture: baseProps.onPointerUpCapture,
            onClickCapture: baseProps.onClickCapture
        }, baseProps.children));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ZL0y.default), {
        ...rest,
        ref: baseProps.ref,
        xcss: baseProps.xcss,
        isDisabled: baseProps.isDisabled,
        onClick: baseProps.onClick,
        onMouseDownCapture: baseProps.onMouseDownCapture,
        onMouseUpCapture: baseProps.onMouseUpCapture,
        onKeyDownCapture: baseProps.onKeyDownCapture,
        onKeyUpCapture: baseProps.onKeyUpCapture,
        onTouchStartCapture: baseProps.onTouchStartCapture,
        onTouchEndCapture: baseProps.onTouchEndCapture,
        onPointerDownCapture: baseProps.onPointerDownCapture,
        onPointerUpCapture: baseProps.onPointerUpCapture,
        onClickCapture: baseProps.onClickCapture,
        type: type,
        testId: testId,
        componentName: "IconButton",
        analyticsContext: analyticsContext,
        interactionName: interactionName
    }, baseProps.children);
}));
$882a7c49c57eabf3$var$IconButton.displayName = 'IconButton';
var $882a7c49c57eabf3$export$2e2bcd8739ae039 = $882a7c49c57eabf3$var$IconButton;

});
parcelRegister("cxipd", function(module, exports) {

$parcel$export(module.exports, "default", () => $0dc8402cbeff77f2$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lkPEe = parcelRequire("lkPEe");

var $3ICHT = parcelRequire("3ICHT");

var $byjW4 = parcelRequire("byjW4");

var $fE1y3 = parcelRequire("fE1y3");
/**
 * __Use icon button__
 *
 * A React hook that accepts a set of icon Button props,
 * and processes them to return consistent base props for usage
 * across IconButton and LinkIconButton variants.
 *
 * @private
 */ const $0dc8402cbeff77f2$var$useIconButton = ({ analyticsContext: analyticsContext, appearance: appearance, autoFocus: autoFocus, buttonType: buttonType, icon: Icon, interactionName: interactionName, isDisabled: isDisabled, isLoading: isLoading, isSelected: isSelected, label: label, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, overlay: overlay, ref: ref, shape: shape, shouldFitContainer: shouldFitContainer, spacing: spacing, UNSAFE_size: UNSAFE_size })=>{
    const hasOverlay = Boolean(overlay || isLoading);
    const isCircle = shape === 'circle';
    const baseProps = (0, $fE1y3.default)({
        analyticsContext: analyticsContext,
        appearance: appearance,
        autoFocus: autoFocus,
        buttonType: buttonType,
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3ICHT.default), {
            type: "icon",
            hasOverlay: hasOverlay
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Icon, {
            label: "",
            size: UNSAFE_size,
            color: 'currentColor'
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lkPEe.default), null, label)),
        interactionName: interactionName,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        isIconButton: true,
        isCircle: isCircle,
        onClick: onClick,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture,
        overlay: isLoading ? (0, $byjW4.default)({
            spacing: spacing,
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }) : overlay,
        ref: ref,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing
    });
    return baseProps;
};
var $0dc8402cbeff77f2$export$2e2bcd8739ae039 = $0dc8402cbeff77f2$var$useIconButton;

});


parcelRegister("aO9bw", function(module, exports) {

$parcel$export(module.exports, "default", () => $7de5b2d385591169$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $dKQcC = parcelRequire("dKQcC");

var $1U6Rx = parcelRequire("1U6Rx");
/**
 * __Spotlight__
 *
 * An onboarding spotlight introduces new features to users through focused messages or multi-step tours.
 *
 * - [Examples](https://atlassian.design/components/onboarding/examples)
 * - [Code](https://atlassian.design/components/onboarding/code)
 * - [Usage](https://atlassian.design/components/onboarding/usage)
 */ const $7de5b2d385591169$var$Spotlight = ({ dialogWidth: dialogWidth = 400, pulse: pulse = true, testId: testId = 'spotlight', targetNode: targetNode, target: target, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1U6Rx.SpotlightConsumer), null, ({ opened: opened, closed: closed, targets: targets })=>{
        // use the targetNode prop or try get the target from context targets using name
        const actualTargetNode = targetNode || (typeof target === 'string' ? targets[target] : undefined);
        return actualTargetNode ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dKQcC.default), (0, $kU09D.default)({}, rest, {
            targetNode: actualTargetNode,
            target: target,
            onOpened: opened,
            onClosed: closed,
            testId: testId,
            dialogWidth: dialogWidth,
            pulse: pulse
        })) : null;
    });
var $7de5b2d385591169$export$2e2bcd8739ae039 = $7de5b2d385591169$var$Spotlight;

});
parcelRegister("dKQcC", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0381090fc3349fb$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $5zQU9 = parcelRequire("5zQU9");

var $eUqFw = parcelRequire("eUqFw");

var $kQ44K = parcelRequire("kQ44K");

var $lbDTY = parcelRequire("lbDTY");

var $8MHxr = parcelRequire("8MHxr");

var $k7cZh = parcelRequire("k7cZh");

var $gmZvv = parcelRequire("gmZvv");

var $lcnyw = parcelRequire("lcnyw");

var $g35Uh = parcelRequire("g35Uh");

var $kZ9to = parcelRequire("kZ9to");

var $9kgV1 = parcelRequire("9kgV1");

var $igukp = parcelRequire("igukp");

var $8NdH4 = parcelRequire("8NdH4");
/**
 * __Spotlight inner__
 *
 * Renders the spotlight target clone and dialog.
 *
 * @internal
 */ class $a0381090fc3349fb$var$SpotlightInner extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    constructor(...args){
        super(...args);
        (0, $5zQU9.default)(this, "state", {
            // This is only used when targetReplacement is specified.
            // In this case, we have to render the targetReplacement component,
            // get a dom reference from that component, then render again passing
            // that reference into SpotlightDialog (Popper).
            replacementElement: null
        });
        (0, $5zQU9.default)(this, "getTargetNodeStyle", (box)=>{
            if (!(0, $kQ44K.canUseDOM)) return {};
            return {
                ...box,
                position: 'fixed'
            };
        });
    }
    componentDidUpdate(prevProps) {
        if (prevProps.targetNode !== this.props.targetNode) (0, $k7cZh.default)(this.props.targetNode, {
            scrollMode: 'if-needed'
        });
    }
    componentDidMount() {
        (0, $k7cZh.default)(this.props.targetNode, {
            scrollMode: 'if-needed'
        });
        this.props.onOpened();
    }
    componentWillUnmount() {
        this.props.onClosed();
    }
    render() {
        const { pulse: pulse, target: target, targetNode: targetNode, targetBgColor: targetBgColor, targetOnClick: targetOnClick, targetRadius: targetRadius, testId: testId, targetReplacement: TargetReplacement } = this.props;
        const { replacementElement: replacementElement } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8NdH4.SpotlightTransitionConsumer), null, ({ isOpen: isOpen, onExited: onExited })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gmZvv.default), {
                zIndex: (0, $lcnyw.layers).spotlight() + 1
            }, TargetReplacement ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lbDTY))), {
                innerRef: (elem)=>this.setState({
                        replacementElement: elem
                    })
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g35Uh.ElementBox), {
                element: targetNode
            }, (box)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(TargetReplacement, (0, $kU09D.default)({
                    "data-testid": `${testId}--target`
                }, this.getTargetNodeStyle(box))))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g35Uh.ElementBox), {
                element: targetNode
            }, (box)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9kgV1.default), {
                    testId: `${testId}--target`,
                    pulse: pulse,
                    target: target,
                    style: this.getTargetNodeStyle(box),
                    targetBgColor: targetBgColor,
                    targetNode: targetNode,
                    targetOnClick: targetOnClick,
                    targetRadius: targetRadius
                })), TargetReplacement && !replacementElement ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kZ9to.Fade), {
                hasEntered: isOpen,
                onExited: onExited
            }, (animationStyles)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $igukp.default), {
                    testId: `${testId}--dialog`,
                    actions: this.props.actions,
                    actionsBeforeElement: this.props.actionsBeforeElement,
                    children: this.props.children,
                    dialogPlacement: this.props.dialogPlacement,
                    dialogWidth: this.props.dialogWidth,
                    footer: this.props.footer,
                    header: this.props.header,
                    heading: this.props.heading,
                    headingAfterElement: this.props.headingAfterElement,
                    image: this.props.image,
                    targetNode: replacementElement || targetNode,
                    animationStyles: animationStyles
                })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8MHxr))), null)));
    }
}
(0, $5zQU9.default)($a0381090fc3349fb$var$SpotlightInner, "defaultProps", {
    dialogWidth: 400,
    pulse: true
});
var $a0381090fc3349fb$export$2e2bcd8739ae039 = $a0381090fc3349fb$var$SpotlightInner;

});
parcelRegister("g35Uh", function(module, exports) {

$parcel$export(module.exports, "ElementBox", () => $baf182181616af5a$export$1b6719bd7aff3c00);

var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");
const $baf182181616af5a$var$getElementRect = (element)=>{
    const { height: height, left: left, top: top, width: width } = element.getBoundingClientRect();
    return {
        height: height,
        left: left,
        top: top,
        width: width
    };
};
const $baf182181616af5a$export$54f449d89c9b029a = (element)=>{
    const [box, setBox] = (0, $eUqFw.useState)({
        width: 0,
        height: 0,
        left: 0,
        top: 0
    });
    (0, $eUqFw.useLayoutEffect)(()=>{
        setBox($baf182181616af5a$var$getElementRect(element));
    }, [
        element
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const onResize = ()=>{
            requestAnimationFrame(()=>{
                setBox($baf182181616af5a$var$getElementRect(element));
            });
        };
        return (0, $74BVL.bind)(window, {
            type: 'resize',
            listener: onResize
        });
    }, [
        element
    ]);
    return box;
};
const $baf182181616af5a$export$1b6719bd7aff3c00 = (props)=>{
    const box = $baf182181616af5a$export$54f449d89c9b029a(props.element);
    return props.children(box);
};

});

parcelRegister("kZ9to", function(module, exports) {

$parcel$export(module.exports, "Fade", () => $f470da4dac9b21bc$export$c983850c6c9d8b0e);

var $eUqFw = parcelRequire("eUqFw");

var $247XK = parcelRequire("247XK");
const $f470da4dac9b21bc$var$duration = {
    enter: 0,
    exit: 100
};
const $f470da4dac9b21bc$export$c983850c6c9d8b0e = ({ hasEntered: hasEntered, children: children, onExited: onExited })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $247XK.default), {
        in: hasEntered,
        timeout: $f470da4dac9b21bc$var$duration,
        onExited: onExited,
        unmountOnExit: true,
        appear: true
    }, (status)=>{
        const base = {
            transition: `opacity ${$f470da4dac9b21bc$var$duration.exit}ms`,
            opacity: 0
        };
        const anim = {
            entered: {
                opacity: 1
            },
            exiting: {
                opacity: 0
            }
        };
        const style = {
            ...base,
            ...anim[status]
        };
        return children(style);
    });

});

parcelRegister("9kgV1", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ca31b03ed0f6ce3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $fY29z = parcelRequire("fY29z");
const $6ca31b03ed0f6ce3$var$computedStyleAttributesToClone = [
    'fontSize',
    'fontWeight',
    'lineHeight',
    'padding',
    'color',
    'textOverflow'
];
function $6ca31b03ed0f6ce3$var$cloneAndOverrideStyles(node) {
    const shouldCloneChildren = true;
    const clonedNode = node.cloneNode(shouldCloneChildren);
    const computedStyles = getComputedStyle(node);
    $6ca31b03ed0f6ce3$var$computedStyleAttributesToClone.forEach((attribute)=>{
        clonedNode.style[attribute] = computedStyles[attribute];
    });
    clonedNode.style.margin = '0';
    clonedNode.style.position = 'static';
    // The target may have other transforms applied. Avoid unintended side effects
    // by zeroing out "translate" rather than applying a value of "none".
    clonedNode.style.transform = 'translate(0, 0) translate3d(0, 0, 0)';
    return clonedNode;
}
/**
 * __Clone__
 *
 * Used for cloning spotlight targets. The clone is positioned on top of the spotlight target with
 * a pulsing animation.
 *
 * @internal
 */ const $6ca31b03ed0f6ce3$var$Clone = (props)=>{
    const { pulse: pulse, style: style, target: target, targetBgColor: targetBgColor, targetOnClick: targetOnClick, targetNode: targetNode, targetRadius: targetRadius, testId: testId } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fY29z.TargetInner), {
        "data-testid": testId,
        pulse: pulse,
        bgColor: targetBgColor,
        radius: targetRadius,
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: $6ca31b03ed0f6ce3$var$cloneAndOverrideStyles(targetNode).outerHTML
        },
        style: {
            height: '100%',
            pointerEvents: 'none'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fY29z.TargetOverlay), {
        onClick: targetOnClick ? (event)=>targetOnClick({
                event: event,
                target: target
            }) : undefined
    }));
};
var $6ca31b03ed0f6ce3$export$2e2bcd8739ae039 = $6ca31b03ed0f6ce3$var$Clone;

});
parcelRegister("fY29z", function(module, exports) {

$parcel$export(module.exports, "TargetInner", () => $b9fe213afb4f5ed7$export$b1542cc928b93af);
$parcel$export(module.exports, "TargetOverlay", () => $b9fe213afb4f5ed7$export$a28a07e0025d709d);
$parcel$export(module.exports, "Pulse", () => $b9fe213afb4f5ed7$export$927d63e2511364c0);

var $kU09D = parcelRequire("kU09D");

var $byn9U = parcelRequire("byn9U");

var $8YJjX = parcelRequire("8YJjX");

var $PdmhA = parcelRequire("PdmhA");
// NOTE:
// Pulse color "rgb(101, 84, 192)" derived from "colors.P300"
const $b9fe213afb4f5ed7$var$baseShadow = `0 0 0 2px ${`var(--ds-border-discovery, ${(0, $PdmhA.P300)})`}`;
const $b9fe213afb4f5ed7$var$easing = 'cubic-bezier(0.55, 0.055, 0.675, 0.19)';
const $b9fe213afb4f5ed7$var$pulseKeyframes = (0, $byn9U.keyframes)({
    '0%, 33%': {
        boxShadow: `${$b9fe213afb4f5ed7$var$baseShadow}, 0 0 0 ${"var(--ds-border-discovery, rgba(101, 84, 192, 1))"}`
    },
    '66%, 100%': {
        boxShadow: `${$b9fe213afb4f5ed7$var$baseShadow}, 0 0 0 10px rgba(101, 84, 192, 0.01)`
    }
});
const $b9fe213afb4f5ed7$export$9fd1cab52ce14fd5 = $b9fe213afb4f5ed7$var$pulseKeyframes.name;
const $b9fe213afb4f5ed7$var$animationStyles = (0, $byn9U.css)({
    animation: `${$b9fe213afb4f5ed7$var$pulseKeyframes} 3000ms ${$b9fe213afb4f5ed7$var$easing} infinite`,
    // Keep a purple boxshadow on the Pulse component if `prefers-reduced-motion`
    // is applied so we still have a functioning semantic affordance.
    boxShadow: $b9fe213afb4f5ed7$var$baseShadow
});
const $b9fe213afb4f5ed7$var$Base = ({ children: children, bgColor: bgColor, radius: radius, style: style, testId: testId, ...props })=>(0, $byn9U.jsx)("div", (0, $kU09D.default)({
        "data-testid": testId,
        style: {
            ...style,
            backgroundColor: bgColor,
            borderRadius: radius ? `${radius}px` : undefined
        }
    }, props), children);
const $b9fe213afb4f5ed7$export$b1542cc928b93af = ({ children: children, pulse: pulse, ...props })=>(0, $byn9U.jsx)($b9fe213afb4f5ed7$var$Base, (0, $kU09D.default)({}, props, {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: [
            pulse && $b9fe213afb4f5ed7$var$animationStyles,
            (0, $8YJjX.reduceMotionAsPerUserPreference)
        ]
    }), children);
const $b9fe213afb4f5ed7$var$targetOverlayStyles = (0, $byn9U.css)({
    width: '100%',
    height: '100%',
    position: 'absolute',
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    insetBlockStart: 0,
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    insetInlineStart: 0
});
const $b9fe213afb4f5ed7$export$a28a07e0025d709d = (props)=>(0, $byn9U.jsx)("div", (0, $kU09D.default)({}, props, {
        css: $b9fe213afb4f5ed7$var$targetOverlayStyles,
        style: {
            cursor: props.onClick ? 'pointer' : 'auto'
        }
    }));
const $b9fe213afb4f5ed7$export$927d63e2511364c0 = ({ children: children, pulse: pulse = true, testId: testId, ...props })=>(0, $byn9U.jsx)($b9fe213afb4f5ed7$var$Base, (0, $kU09D.default)({}, props, {
        css: [
            pulse && $b9fe213afb4f5ed7$var$animationStyles,
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            (0, $8YJjX.reduceMotionAsPerUserPreference)
        ],
        testId: testId
    }), children);

});


parcelRegister("igukp", function(module, exports) {

$parcel$export(module.exports, "default", () => $d4c13f25764ed8dd$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $eUqFw = parcelRequire("eUqFw");

var $6Pq2D = parcelRequire("6Pq2D");

var $hM7RE = parcelRequire("hM7RE");
var $1ngde = parcelRequire("1ngde");
var $2jDha = parcelRequire("2jDha");

var $i6BC8 = parcelRequire("i6BC8");

var $5uz8y = parcelRequire("5uz8y");

var $iAwJB = parcelRequire("iAwJB");

var $c2bTZ = parcelRequire("c2bTZ");
const $d4c13f25764ed8dd$var$packageName = "@atlaskit/onboarding";
const $d4c13f25764ed8dd$var$packageVersion = "11.5.7";
class $d4c13f25764ed8dd$var$SpotlightDialog extends (0, $eUqFw.Component) {
    constructor(...args){
        super(...args);
        (0, $5zQU9.default)(this, "state", {
            focusLockDisabled: true
        });
    }
    componentDidMount() {
        this.focusLockTimeoutId = window.setTimeout(()=>{
            // we delay the enabling of the focus lock to avoid the scroll position
            // jumping around in some situations
            this.setState({
                focusLockDisabled: false
            });
        }, 200);
    }
    componentWillUnmount() {
        window.clearTimeout(this.focusLockTimeoutId);
    }
    render() {
        const { actions: actions, actionsBeforeElement: actionsBeforeElement, animationStyles: animationStyles, children: children, dialogPlacement: dialogPlacement, dialogWidth: dialogWidth, footer: footer, header: header, heading: heading, headingAfterElement: headingAfterElement, image: image, targetNode: targetNode, testId: testId } = this.props;
        const { focusLockDisabled: focusLockDisabled } = this.state;
        const translatedPlacement = dialogPlacement ? ({
            'top left': 'top-start',
            'top center': 'top',
            'top right': 'top-end',
            'right top': 'right-start',
            'right middle': 'right',
            'right bottom': 'right-end',
            'bottom left': 'bottom-start',
            'bottom center': 'bottom',
            'bottom right': 'bottom-end',
            'left top': 'left-start',
            'left middle': 'left',
            'left bottom': 'left-end'
        })[dialogPlacement] : undefined;
        // If there's no room on either side of the popper, it will extend off-screen.
        //  This looks buggy when scroll-lock and focus is placed on the dialog, so we
        //  customise popper so it overflows the spotlight instead with altAxis=true.
        const modifiers = [
            {
                name: 'preventOverflow',
                options: {
                    padding: 5,
                    rootBoundary: 'document',
                    altAxis: true,
                    tether: false
                }
            }
        ];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i6BC8.Popper), {
            modifiers: modifiers,
            referenceElement: targetNode,
            placement: translatedPlacement
        }, ({ ref: ref, style: style, update: update })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c2bTZ.default), {
                value: dialogWidth,
                onChange: update
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6Pq2D.default), {
                disabled: focusLockDisabled,
                returnFocus: false,
                autoFocus: true
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                ref: ref,
                style: {
                    ...style,
                    ...animationStyles
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iAwJB.default), {
                testId: testId,
                width: dialogWidth,
                actions: actions,
                actionsBeforeElement: actionsBeforeElement,
                image: image && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5uz8y.DialogImage), {
                    alt: heading,
                    src: image
                }),
                components: {
                    Header: header,
                    Footer: footer
                },
                heading: heading,
                headingAfterElement: headingAfterElement,
                headingLevel: 2
            }, children)))));
    }
}
const $d4c13f25764ed8dd$var$createAndFireEventOnAtlaskit = (0, $hM7RE.default)('atlaskit');
var $d4c13f25764ed8dd$export$2e2bcd8739ae039 = (0, $1ngde.default)({
    componentName: 'spotlight',
    packageName: $d4c13f25764ed8dd$var$packageName,
    packageVersion: $d4c13f25764ed8dd$var$packageVersion
})((0, $2jDha.default)({
    targetOnClick: $d4c13f25764ed8dd$var$createAndFireEventOnAtlaskit({
        action: 'clicked',
        actionSubject: 'spotlight',
        attributes: {
            componentName: 'spotlight',
            packageName: $d4c13f25764ed8dd$var$packageName,
            packageVersion: $d4c13f25764ed8dd$var$packageVersion
        }
    })
})($d4c13f25764ed8dd$var$SpotlightDialog));

});
parcelRegister("5uz8y", function(module, exports) {

$parcel$export(module.exports, "DialogImage", () => $3ffb0293c060f2cd$export$855e1a47874d6b81);
$parcel$export(module.exports, "DialogActionItemContainer", () => $3ffb0293c060f2cd$export$ed9b6b50bbed5f27);
$parcel$export(module.exports, "DialogActionItem", () => $3ffb0293c060f2cd$export$6ae54e00f59e1f33);

var $kU09D = parcelRequire("kU09D");

var $byn9U = parcelRequire("byn9U");
const $3ffb0293c060f2cd$var$imageStyles = (0, $byn9U.css)({
    maxWidth: '100%',
    height: 'auto'
});
const $3ffb0293c060f2cd$var$actionItemContainerStyles = (0, $byn9U.css)({
    display: 'flex',
    margin: `${"var(--ds-space-0, 0px)"} -4px`,
    /* When there is more than one action, place primary action visually on the
  right, but keep it's position as the first focusable element in the DOM */ flexDirection: 'row-reverse'
});
const $3ffb0293c060f2cd$var$actionItemStyles = (0, $byn9U.css)({
    margin: `${"var(--ds-space-0, 0px)"} ${"var(--ds-space-050, 4px)"}`
});
const $3ffb0293c060f2cd$export$855e1a47874d6b81 = ({ alt: alt, ...props })=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    (0, $byn9U.jsx)("img", (0, $kU09D.default)({
        css: $3ffb0293c060f2cd$var$imageStyles,
        alt: alt
    }, props));
const $3ffb0293c060f2cd$export$ed9b6b50bbed5f27 = ({ children: children })=>(0, $byn9U.jsx)("div", {
        css: $3ffb0293c060f2cd$var$actionItemContainerStyles
    }, children);
const $3ffb0293c060f2cd$export$6ae54e00f59e1f33 = ({ children: children })=>(0, $byn9U.jsx)("div", {
        css: $3ffb0293c060f2cd$var$actionItemStyles
    }, children);

});

parcelRegister("iAwJB", function(module, exports) {

$parcel$export(module.exports, "default", () => $d884fb2f30365870$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $bbaTG = parcelRequire("bbaTG");
var $Sibrq = parcelRequire("Sibrq");

var $hI5oG = parcelRequire("hI5oG");

var $5YfXa = parcelRequire("5YfXa");
var $4nYsa = parcelRequire("4nYsa");
var $equnS = parcelRequire("equnS");

var $5uz8y = parcelRequire("5uz8y");

var $1VTNc = parcelRequire("1VTNc");
const $d884fb2f30365870$var$bodyStyles = (0, $byn9U.css)({
    display: 'flex',
    padding: `${"var(--ds-space-200, 16px)"} ${"var(--ds-space-250, 20px)"}`,
    flexDirection: 'column'
});
const $d884fb2f30365870$var$imageStyles = (0, $byn9U.css)({
    display: 'block'
});
const $d884fb2f30365870$var$defaultHeaderStyles = (0, $byn9U.css)({
    display: 'flex',
    alignItems: 'baseline',
    justifyContent: 'space-between',
    paddingBlockEnd: "var(--ds-space-100, 8px)"
});
const $d884fb2f30365870$var$DefaultHeader = ({ children: children })=>(0, $byn9U.jsx)("div", {
        css: $d884fb2f30365870$var$defaultHeaderStyles
    }, children);
const $d884fb2f30365870$var$defaultFooterStyles = (0, $byn9U.css)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingBlockStart: "var(--ds-space-100, 8px)"
});
const $d884fb2f30365870$var$DefaultFooter = ({ children: children })=>(0, $byn9U.jsx)("div", {
        css: $d884fb2f30365870$var$defaultFooterStyles
    }, children);
const $d884fb2f30365870$var$containerStyles = (0, $equnS.xcss)({
    height: 'fit-content',
    zIndex: 'spotlight',
    borderRadius: 'border.radius',
    color: 'color.text.inverse',
    overflow: 'auto',
    minWidth: '160px',
    maxWidth: '600px'
});
const $d884fb2f30365870$var$containerShadowStyles = (0, $equnS.xcss)({
    boxShadow: 'elevation.shadow.raised'
});
/**
 * __Spotlight card__
 *
 * A spotlight card is for onboarding messages that need a more flexible layout, or don't require a dialog.
 *
 * - [Examples](https://atlassian.design/components/onboarding/spotlight-card/examples)
 * - [Code](https://atlassian.design/components/onboarding/spotlight-card/code)
 * - [Usage](https://atlassian.design/components/onboarding/spotlight-card/usage)
 */ const $d884fb2f30365870$var$SpotlightCard = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { actions: actions = [], actionsBeforeElement: actionsBeforeElement, children: children, components: components = {}, heading: heading, headingLevel: headingLevel = 4, headingAfterElement: headingAfterElement, image: image, innerRef: innerRef, isFlat: isFlat, testId: testId, width: width = 400, headingId: headingId } = props;
    const { Header: Header = $d884fb2f30365870$var$DefaultHeader, Footer: Footer = $d884fb2f30365870$var$DefaultFooter } = components;
    return (0, $byn9U.jsx)((0, $Sibrq.default).Provider, {
        value: (0, $1VTNc.spotlightButtonTheme)
    }, (0, $byn9U.jsx)((0, $5YfXa.default), {
        backgroundColor: "color.background.discovery.bold",
        xcss: [
            $d884fb2f30365870$var$containerStyles,
            !isFlat && $d884fb2f30365870$var$containerShadowStyles
        ],
        style: {
            width: width
        },
        ref: ref || innerRef,
        testId: testId
    }, typeof image === 'string' ? (0, $byn9U.jsx)("img", {
        css: $d884fb2f30365870$var$imageStyles,
        src: image,
        alt: ""
    }) : image, (0, $byn9U.jsx)("div", {
        css: $d884fb2f30365870$var$bodyStyles
    }, heading || headingAfterElement ? (0, $byn9U.jsx)(Header, null, (0, $byn9U.jsx)((0, $hI5oG.default), {
        id: headingId,
        size: "medium",
        as: `h${headingLevel}`
    }, heading), headingAfterElement) : null, (0, $byn9U.jsx)((0, $4nYsa.default), null, children), actions.length > 0 || actionsBeforeElement ? (0, $byn9U.jsx)(Footer, null, actionsBeforeElement || (0, $byn9U.jsx)("span", null), (0, $byn9U.jsx)((0, $5uz8y.DialogActionItemContainer), null, actions.map(({ text: text, key: key, ...rest }, idx)=>{
        return (0, $byn9U.jsx)((0, $5uz8y.DialogActionItem), {
            key: key || (typeof text === 'string' ? text : `${idx}`)
        }, (0, $byn9U.jsx)((0, $bbaTG.default), rest, text));
    }))) : null)));
});
$d884fb2f30365870$var$SpotlightCard.displayName = 'SpotlightCard';
var $d884fb2f30365870$export$2e2bcd8739ae039 = $d884fb2f30365870$var$SpotlightCard;

});
parcelRegister("4nYsa", function(module, exports) {

$parcel$export(module.exports, "default", () => $331834266206e739$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $8ynlC = parcelRequire("8ynlC");

var $5RNXK = parcelRequire("5RNXK");

var $27DxH = parcelRequire("27DxH");
const $331834266206e739$var$asAllowlist = [
    'span',
    'p',
    'strong',
    'em'
];
// We're doing this because our CSS reset can add top margins to elements such as `p` which is totally insane.
// Long term we should remove those instances from the reset - it should be a reset to 0.
// For now, at least we know <Text> will be unaffected by this.
const $331834266206e739$var$resetStyles = (0, $byn9U.css)({
    margin: 0
});
const $331834266206e739$var$strongStyles = (0, $byn9U.css)({
    fontWeight: 'bold'
});
const $331834266206e739$var$emStyles = (0, $byn9U.css)({
    fontStyle: 'italic'
});
const $331834266206e739$var$textAlignMap = {
    center: (0, $byn9U.css)({
        textAlign: 'center'
    }),
    end: (0, $byn9U.css)({
        textAlign: 'end'
    }),
    start: (0, $byn9U.css)({
        textAlign: 'start'
    })
};
const $331834266206e739$var$truncationStyles = (0, $byn9U.css)({
    display: '-webkit-box',
    overflow: 'hidden',
    WebkitBoxOrient: 'vertical'
});
const $331834266206e739$var$wordBreakMap = {
    breakAll: (0, $byn9U.css)({
        wordBreak: 'break-all'
    })
};
const $331834266206e739$var$HasTextAncestorContext = /*#__PURE__*/ (0, $eUqFw.createContext)(false);
const $331834266206e739$var$useHasTextAncestor = ()=>(0, $eUqFw.useContext)($331834266206e739$var$HasTextAncestorContext);
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ const $331834266206e739$var$useColor = (colorProp, hasTextAncestor)=>{
    const surface = (0, $27DxH.useSurface)();
    /**
   * Where the color of the surface is inverted we always override the color
   * as there is no valid choice that is not covered by the override.
   */ if ((0, $5RNXK.inverseColorMap).hasOwnProperty(surface)) return (0, $5RNXK.inverseColorMap)[surface];
    if (colorProp === 'inherit') return undefined;
    if (!colorProp && hasTextAncestor) return undefined;
    return colorProp || 'color.text';
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ const $331834266206e739$var$Text = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: Component = 'span', color: colorProp, align: align, testId: testId, id: id, size: size = 'medium', weight: weight, maxLines: maxLines, children: children }, ref)=>{
    (0, $8ynlC.default)($331834266206e739$var$asAllowlist.includes(Component), `@atlaskit/primitives: Text received an invalid "as" value of "${Component}"`);
    const hasTextAncestor = $331834266206e739$var$useHasTextAncestor();
    const color = $331834266206e739$var$useColor(colorProp, hasTextAncestor);
    const component = (0, $byn9U.jsx)(Component, {
        ref: ref,
        css: [
            $331834266206e739$var$resetStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $5RNXK.fontStylesMap)[size],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            color && (0, $5RNXK.textColorStylesMap)[color],
            maxLines && $331834266206e739$var$truncationStyles,
            maxLines === 1 && $331834266206e739$var$wordBreakMap.breakAll,
            align && $331834266206e739$var$textAlignMap[align],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            weight && (0, $5RNXK.fontWeightStylesMap)[weight],
            Component === 'em' && $331834266206e739$var$emStyles,
            Component === 'strong' && $331834266206e739$var$strongStyles
        ],
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        id: id
    }, children);
    return hasTextAncestor ? // no need to re-apply context if the text is already wrapped
    component : (0, $byn9U.jsx)($331834266206e739$var$HasTextAncestorContext.Provider, {
        value: true
    }, component);
});
var $331834266206e739$export$2e2bcd8739ae039 = $331834266206e739$var$Text;

});


parcelRegister("c2bTZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c2ee76b3957c38e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
class $8c2ee76b3957c38e$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    componentDidUpdate(prevProps) {
        if (prevProps.value !== this.props.value) this.props.onChange();
    }
    render() {
        return this.props.children;
    }
}

});


parcelRegister("8NdH4", function(module, exports) {

$parcel$export(module.exports, "SpotlightTransitionConsumer", () => $666d859a41a45f82$export$7d63b19b854c2fe8);
$parcel$export(module.exports, "default", () => $666d859a41a45f82$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $eUqFw = parcelRequire("eUqFw");

var $5Q9wj = parcelRequire("5Q9wj");
const $666d859a41a45f82$var$SpotlightTransitionContext = /*#__PURE__*/ (0, $eUqFw.createContext)({
    isOpen: true,
    onExited: (0, $5Q9wj.default)
});
// checks if children exist and are truthy
const $666d859a41a45f82$var$hasChildren = (children)=>{
    var _React$Children$map, _React$Children$map$f;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.count(children) > 0 && (((_React$Children$map = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.map(children || false, (child)=>!!child)) === null || _React$Children$map === void 0 ? void 0 : (_React$Children$map$f = _React$Children$map.filter(Boolean)) === null || _React$Children$map$f === void 0 ? void 0 : _React$Children$map$f.length) || 0) > 0;
};
/**
 * __Spotlight transition__
 *
 * A spotlight transition holds onto spotlights so they can fade out when exiting the viewport.
 *
 * - [Examples](https://atlassian.design/components/onboarding/examples)
 * - [Code](https://atlassian.design/components/onboarding/code)
 * - [Usage](https://atlassian.design/components/onboarding/usage)
 */ class $666d859a41a45f82$var$SpotlightTransition extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    constructor(...args){
        super(...args);
        (0, $5zQU9.default)(this, "state", {
            currentChildren: undefined
        });
        (0, $5zQU9.default)(this, "onExited", ()=>{
            this.setState({
                currentChildren: this.props.children
            });
        });
    }
    static getDerivedStateFromProps(props, state) {
        const { currentChildren: previousChildren } = state;
        const exiting = $666d859a41a45f82$var$hasChildren(previousChildren) && !$666d859a41a45f82$var$hasChildren(props.children);
        return {
            currentChildren: exiting ? previousChildren : props.children
        };
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($666d859a41a45f82$var$SpotlightTransitionContext.Provider, {
            value: {
                onExited: this.onExited,
                isOpen: $666d859a41a45f82$var$hasChildren(this.props.children)
            }
        }, this.state.currentChildren);
    }
}
const $666d859a41a45f82$export$7d63b19b854c2fe8 = $666d859a41a45f82$var$SpotlightTransitionContext.Consumer;
var $666d859a41a45f82$export$2e2bcd8739ae039 = $666d859a41a45f82$var$SpotlightTransition;

});


parcelRegister("1U6Rx", function(module, exports) {

$parcel$export(module.exports, "TargetConsumer", () => $1630582bb982980f$export$f643dd64c1952cc8);
$parcel$export(module.exports, "SpotlightContext", () => $1630582bb982980f$export$7b5aa0f5b37a336d);
$parcel$export(module.exports, "SpotlightConsumer", () => $1630582bb982980f$export$3503199acd121708);
$parcel$export(module.exports, "default", () => $1630582bb982980f$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $eUqFw = parcelRequire("eUqFw");

var $5iWql = parcelRequire("5iWql");

var $5Q9wj = parcelRequire("5Q9wj");

var $gmZvv = parcelRequire("gmZvv");

var $lcnyw = parcelRequire("lcnyw");

var $3oEuc = parcelRequire("3oEuc");

var $kZ9to = parcelRequire("kZ9to");

var $2fFJv = parcelRequire("2fFJv");
const { Consumer: $1630582bb982980f$export$f643dd64c1952cc8, Provider: $1630582bb982980f$var$TargetProvider } = /*#__PURE__*/ (0, $eUqFw.createContext)(undefined);
const $1630582bb982980f$export$7b5aa0f5b37a336d = /*#__PURE__*/ (0, $eUqFw.createContext)({
    opened: (0, $5Q9wj.default),
    closed: (0, $5Q9wj.default),
    targets: {}
});
const { Consumer: $1630582bb982980f$export$3503199acd121708, Provider: $1630582bb982980f$var$SpotlightStateProvider } = $1630582bb982980f$export$7b5aa0f5b37a336d;
const $1630582bb982980f$var$Container = ({ component: Wrapper, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Wrapper, null, children);
class $1630582bb982980f$export$2e2bcd8739ae039 extends (0, $eUqFw.PureComponent) {
    constructor(...args){
        super(...args);
        (0, $5zQU9.default)(this, "state", {
            spotlightCount: 0,
            targets: {}
        });
        (0, $5zQU9.default)(this, "targetRef", (name)=>(element)=>{
                this.setState((state)=>({
                        targets: {
                            ...state.targets,
                            [name]: element || undefined
                        }
                    }));
            });
        (0, $5zQU9.default)(this, "spotlightOpen", ()=>{
            this.setState((state)=>({
                    spotlightCount: state.spotlightCount + 1
                }));
        });
        (0, $5zQU9.default)(this, "spotlightClose", ()=>{
            this.setState((state)=>({
                    spotlightCount: state.spotlightCount - 1
                }));
        });
        (0, $5zQU9.default)(this, "getStateProviderValue", (0, $5iWql.default)((targets)=>({
                opened: this.spotlightOpen,
                closed: this.spotlightClose,
                targets: targets
            })));
    }
    componentDidMount() {
        typeof $2fFJv;
    }
    render() {
        const { blanketIsTinted: blanketIsTinted, children: children, component: Tag } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1630582bb982980f$var$SpotlightStateProvider, {
            value: this.getStateProviderValue(this.state.targets)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1630582bb982980f$var$TargetProvider, {
            value: this.targetRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1630582bb982980f$var$Container, {
            component: Tag || (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kZ9to.Fade), {
            hasEntered: this.state.spotlightCount > 0
        }, (animationStyles)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gmZvv.default), {
                zIndex: (0, $lcnyw.layers).spotlight()
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3oEuc.default), {
                style: animationStyles,
                isTinted: blanketIsTinted
            }))), children)));
    }
}
(0, $5zQU9.default)($1630582bb982980f$export$2e2bcd8739ae039, "defaultProps", {
    blanketIsTinted: true
});

});
parcelRegister("3oEuc", function(module, exports) {

$parcel$export(module.exports, "default", () => $279304afc4081cfc$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $PdmhA = parcelRequire("PdmhA");

var $lcnyw = parcelRequire("lcnyw");
// IE11 and Edge: z-index needed because fixed position calculates z-index relative
// to body instead of nearest stacking context (Portal in our case).
const $279304afc4081cfc$var$blanketStyles = (0, $byn9U.css)({
    position: 'fixed',
    zIndex: (0, $lcnyw.layers).spotlight(),
    inset: 0,
    transition: 'opacity 220ms'
});
/**
 * __Blanket__
 *
 * A replacement for `@atlaskit/blanket`.
 *
 * We use this for spotlights instead of `@atlaskit/blanket`
 * because spotlights must sit on top of other layered elements,
 * such as modals, which have their own blankets.
 *
 * @internal
 */ const $279304afc4081cfc$var$Blanket = (props)=>{
    return (0, $byn9U.jsx)("div", {
        css: $279304afc4081cfc$var$blanketStyles,
        style: {
            ...props.style,
            backgroundColor: props.isTinted ? `var(--ds-blanket, ${0, $PdmhA.N100A})` : 'transparent'
        }
    });
};
var $279304afc4081cfc$export$2e2bcd8739ae039 = $279304afc4081cfc$var$Blanket;

});



parcelRegister("5qTKr", function(module, exports) {

$parcel$export(module.exports, "WidthObserver", () => $c6f750a76324ffb4$export$b2ad68b9bc407b80);

var $eUqFw = parcelRequire("eUqFw");

var $fcMY9 = parcelRequire("fcMY9");
const $c6f750a76324ffb4$export$b2ad68b9bc407b80 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).memo((props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fcMY9.WidthDetectorObserver), {
        setWidth: props.setWidth,
        offscreen: props.offscreen
    });
});
var $c6f750a76324ffb4$export$2e2bcd8739ae039 = $c6f750a76324ffb4$export$b2ad68b9bc407b80;

});
parcelRegister("fcMY9", function(module, exports) {

$parcel$export(module.exports, "WidthDetectorObserver", () => $6aaee5d21d622db3$export$ff983d2a2b6112ea);

var $eUqFw = parcelRequire("eUqFw");

var $5SGY2 = parcelRequire("5SGY2");
const $6aaee5d21d622db3$export$ff983d2a2b6112ea = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).memo(({ setWidth: setWidth, offscreen: offscreen })=>{
    const [inViewRef, inView, target] = (0, $5SGY2.useInView)({
        /* Optional options */ threshold: 0
    });
    const observer = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useRef(()=>{
        if (typeof window === 'undefined') return null;
        // https://github.com/DefinitelyTyped/DefinitelyTyped/pull/40909
        // @ts-ignore
        return new ResizeObserver((entries)=>{
            if (!Array.isArray(entries) || !entries.length) return;
            const { width: width } = entries[0].contentRect;
            setWidth(Math.round(width));
        });
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useEffect(()=>{
        const { current: currentObserver } = observer;
        const resizeObserver = currentObserver();
        if (resizeObserver === null) return;
        if (target) {
            if (inView || offscreen) resizeObserver.observe(target);
            else resizeObserver.unobserve(target);
        }
        return ()=>{
            resizeObserver.disconnect();
        };
    }, [
        target,
        inView,
        offscreen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: '100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute'
        },
        ref: inViewRef
    });
});

});
parcelRegister("5SGY2", function(module, exports) {

$parcel$export(module.exports, "useInView", () => $7aaf8da200479bd8$export$2f62ee6831462844);

var $eUqFw = parcelRequire("eUqFw");
function $7aaf8da200479bd8$export$2f62ee6831462844(options = {}) {
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useRef();
    const observerInstance = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useRef();
    const [state, setState] = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useState({
        inView: false,
        entry: undefined,
        target: undefined
    });
    const { threshold: threshold, root: root, rootMargin: rootMargin } = options;
    const setRef = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useCallback((node)=>{
        observerInstance.current = new IntersectionObserver((entries)=>{
            if (entries && entries.length) {
                const intersection = entries[0];
                const { isIntersecting: isIntersecting, intersectionRatio: intersectionRatio } = intersection;
                if (intersectionRatio >= 0) {
                    // Note: `0` will be used here when an array of numbers is passed as the threshold, which doesn't feel right
                    const numericThreshold = typeof threshold === 'number' ? threshold : 0;
                    let inView = intersectionRatio >= numericThreshold;
                    if (isIntersecting !== undefined) inView = inView && isIntersecting;
                    setState({
                        inView: inView,
                        entry: intersection,
                        target: node
                    });
                }
            }
        }, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin
        });
        if (ref.current) observerInstance.current.unobserve(ref.current);
        if (node) observerInstance.current.observe(node);
        // Store a reference to the node
        ref.current = node;
    }, [
        threshold,
        root,
        rootMargin
    ]);
    /**
	 * Unsubscribe IntersectionObserver before unmounting a component.
	 */ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useEffect(()=>{
        return ()=>{
            if (observerInstance.current && ref.current) observerInstance.current.unobserve(ref.current);
        };
    }, []);
    return [
        setRef,
        state.inView,
        state.target,
        state.entry
    ];
}

});



parcelRegister("4Tr8x", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bindAll = module.exports.bind = void 0;

var $63HmA = parcelRequire("63HmA");
Object.defineProperty(module.exports, "bind", {
    enumerable: true,
    get: function() {
        return $63HmA.bind;
    }
});

var $kihc3 = parcelRequire("kihc3");
Object.defineProperty(module.exports, "bindAll", {
    enumerable: true,
    get: function() {
        return $kihc3.bindAll;
    }
});

});
parcelRegister("63HmA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bind = void 0;
function $4694a8f2310b4968$var$bind(target, _a) {
    var type = _a.type, listener = _a.listener, options = _a.options;
    target.addEventListener(type, listener, options);
    return function unbind() {
        target.removeEventListener(type, listener, options);
    };
}
module.exports.bind = $4694a8f2310b4968$var$bind;

});

parcelRegister("kihc3", function(module, exports) {
"use strict";
var $ec62d358a47532ca$var$__assign = module.exports && module.exports.__assign || function() {
    $ec62d358a47532ca$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ec62d358a47532ca$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bindAll = void 0;

var $63HmA = parcelRequire("63HmA");
function $ec62d358a47532ca$var$toOptions(value) {
    if (typeof value === 'undefined') return undefined;
    if (typeof value === 'boolean') return {
        capture: value
    };
    return value;
}
function $ec62d358a47532ca$var$getBinding(original, sharedOptions) {
    if (sharedOptions == null) return original;
    var binding = $ec62d358a47532ca$var$__assign($ec62d358a47532ca$var$__assign({}, original), {
        options: $ec62d358a47532ca$var$__assign($ec62d358a47532ca$var$__assign({}, $ec62d358a47532ca$var$toOptions(sharedOptions)), $ec62d358a47532ca$var$toOptions(original.options))
    });
    return binding;
}
function $ec62d358a47532ca$var$bindAll(target, bindings, sharedOptions) {
    var unbinds = bindings.map(function(original) {
        var binding = $ec62d358a47532ca$var$getBinding(original, sharedOptions);
        return (0, $63HmA.bind)(target, binding);
    });
    return function unbindAll() {
        unbinds.forEach(function(unbind) {
            return unbind();
        });
    };
}
module.exports.bindAll = $ec62d358a47532ca$var$bindAll;

});


parcelRegister("d3fGG", function(module, exports) {

$parcel$export(module.exports, "JiraProductDiscoveryIcon", () => $a14dd8b44b444cc0$export$21bfbeb62fdcce8d);
/* eslint-disable max-len */ 
var $eUqFw = parcelRequire("eUqFw");

var $4q38b = parcelRequire("4q38b");

var $lpzFL = parcelRequire("lpzFL");

var $9m0Eq = parcelRequire("9m0Eq");

var $urYMl = parcelRequire("urYMl");
const $a14dd8b44b444cc0$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $9m0Eq.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M17.655 5.884a15.3 15.3 0 0 0 8.75 0c.257-.056.428.114.37.37-.826 2.985-.826 5.742 0 8.727.058.228-.113.427-.37.342a16.33 16.33 0 0 0-8.75 0c-.228.085-.428-.114-.342-.342.77-2.985.77-5.742 0-8.727-.086-.256.114-.426.342-.37m1.169 10.576v.483c0 2.246-1.568 3.894-3.506 3.894a3.474 3.474 0 0 1-3.477-3.496c0-1.933 1.567-3.468 3.762-3.468h.57V7.078c-.285-.028-.57-.028-.855-.028C9.618 7.05 5 11.655 5 17.37c0 5.713 4.617 10.29 10.318 10.29s10.346-4.605 10.346-10.29v-.91z"/>
    </svg>`;
};
const $a14dd8b44b444cc0$export$21bfbeb62fdcce8d = ({ appearance: appearance, label: label = 'Jira Product Discovery', size: size = (0, $lpzFL.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $lpzFL.defaultLogoParams).iconColor, textColor: textColor = (0, $lpzFL.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $4q38b.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $urYMl.default), {
        appearance: appearance,
        label: label,
        svg: $a14dd8b44b444cc0$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("ecIoc", function(module, exports) {

$parcel$export(module.exports, "JiraServiceManagementIcon", () => $03f4c1478d7047c7$export$3c6158790f5e01c4);
/* eslint-disable max-len */ 
var $eUqFw = parcelRequire("eUqFw");

var $4q38b = parcelRequire("4q38b");

var $lpzFL = parcelRequire("lpzFL");

var $9m0Eq = parcelRequire("9m0Eq");

var $urYMl = parcelRequire("urYMl");
const $03f4c1478d7047c7$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $9m0Eq.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill=${colors.iconColor} d="M18.79 13.257h7.325c1.1 0 1.476 1.046.805 1.878L15.464 29.274c-3.702-2.951-3.353-7.62-.644-11.027zm-5.66 5.634H5.806c-1.1 0-1.476-1.046-.805-1.878L16.457 2.874c3.702 2.951 3.3 7.566.617 11z"/>
    </svg>`;
};
const $03f4c1478d7047c7$export$3c6158790f5e01c4 = ({ appearance: appearance, label: label = 'Jira Service Management', size: size = (0, $lpzFL.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $lpzFL.defaultLogoParams).iconColor, textColor: textColor = (0, $lpzFL.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $4q38b.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $urYMl.default), {
        appearance: appearance,
        label: label,
        svg: $03f4c1478d7047c7$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("eT0WN", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_useMediaQuery", () => $a1f7fbebb8f5db6b$export$49e55ae2c03d6045);

var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

var $4Ywu9 = parcelRequire("4Ywu9");
const $a1f7fbebb8f5db6b$var$queries = {
    'above.xxs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $4Ywu9.UNSAFE_media).above.xxs.replace('@media ', '').trim()),
    'above.xs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $4Ywu9.UNSAFE_media).above.xs.replace('@media ', '').trim()),
    'above.sm': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $4Ywu9.UNSAFE_media).above.sm.replace('@media ', '').trim()),
    'above.md': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $4Ywu9.UNSAFE_media).above.md.replace('@media ', '').trim()),
    'above.lg': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $4Ywu9.UNSAFE_media).above.lg.replace('@media ', '').trim()),
    'above.xl': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $4Ywu9.UNSAFE_media).above.xl.replace('@media ', '').trim()),
    'below.xs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $4Ywu9.UNSAFE_media).below.xs.replace('@media ', '').trim()),
    'below.sm': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $4Ywu9.UNSAFE_media).below.sm.replace('@media ', '').trim()),
    'below.md': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $4Ywu9.UNSAFE_media).below.md.replace('@media ', '').trim()),
    'below.lg': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $4Ywu9.UNSAFE_media).below.lg.replace('@media ', '').trim()),
    'below.xl': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $4Ywu9.UNSAFE_media).below.xl.replace('@media ', '').trim())
};
const $a1f7fbebb8f5db6b$export$49e55ae2c03d6045 = (queryString, listener)=>{
    const listenerRef = (0, $eUqFw.useRef)(listener);
    (0, $eUqFw.useEffect)(()=>{
        // Bind the listener if changed so it's called on the next change event; no guarantee on timing.
        listenerRef.current = listener;
    }, [
        listener
    ]);
    /**
	 * We explicitly only react to boolean changes for binding our listener
	 * Changes to the functional reference are ignored.
	 */ const hasListener = !!listener;
    /**
	 * The `matchMedia(…)` return value for our breakpoint query.
	 */ const mq = $a1f7fbebb8f5db6b$var$queries[queryString];
    (0, $eUqFw.useLayoutEffect)(()=>{
        listenerRef.current = listener; // Bind the listener now in case the `useEffect` hasn't fired above yet
        if (!mq || !hasListener || !listenerRef.current) return;
        return (0, $74BVL.bind)(mq, {
            type: 'change',
            listener: (event)=>{
                // We explicitly call the current version of the function
                return listenerRef.current(event);
            }
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- explicitly do not trigger the effect on `listener` reference change, only on a boolean representation of it.
    [
        mq,
        hasListener
    ]);
    return mq || null;
};

});

parcelRegister("4kMup", function(module, exports) {

$parcel$export(module.exports, "default", () => $78e97c7fa17b82aa$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8ynlC = parcelRequire("8ynlC");

var $lUFyV = parcelRequire("lUFyV");

var $9ENjd = parcelRequire("9ENjd");

var $5Q9wj = parcelRequire("5Q9wj");

var $jsCXU = parcelRequire("jsCXU");

var $lkPEe = parcelRequire("lkPEe");

var $1ZAYh = parcelRequire("1ZAYh");

var $b5IAe = parcelRequire("b5IAe");
// TODO: Duplicated FocusRing styles due to lack of `xcss` support
// and to prevent additional dependency
const $78e97c7fa17b82aa$var$baseFocusRingStyles = {
    outlineColor: 'color.border.focused',
    outlineWidth: 'border.width.outline',
    outlineStyle: 'solid',
    outlineOffset: 'space.025'
};
const $78e97c7fa17b82aa$var$defaultStyles = (0, $1ZAYh.xcss)({
    textDecoration: 'underline'
});
const $78e97c7fa17b82aa$var$focusRingStyles = (0, $1ZAYh.xcss)({
    ':focus-visible': $78e97c7fa17b82aa$var$baseFocusRingStyles,
    '@supports not selector(*:focus-visible)': {
        ':focus': $78e97c7fa17b82aa$var$baseFocusRingStyles
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        ':focus-visible': {
            outline: '1px solid'
        }
    }
});
const $78e97c7fa17b82aa$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
const $78e97c7fa17b82aa$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms):)|(#))/;
const $78e97c7fa17b82aa$var$AnchorNoRef = ({ href: href, children: children, backgroundColor: backgroundColor, padding: padding, paddingBlock: paddingBlock, paddingBlockStart: paddingBlockStart, paddingBlockEnd: paddingBlockEnd, paddingInline: paddingInline, paddingInlineStart: paddingInlineStart, paddingInlineEnd: paddingInlineEnd, testId: testId, xcss: xcssStyles, target: target, onClick: providedOnClick = (0, $5Q9wj.default), interactionName: interactionName, componentName: componentName, analyticsContext: analyticsContext, ...htmlAttributes }, ref)=>{
    const interactionContext = (0, $eUqFw.useContext)((0, $jsCXU.default));
    const handleClick = (0, $eUqFw.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const onClick = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Anchor',
        packageName: undefined,
        packageVersion: undefined,
        analyticsData: analyticsContext,
        actionSubject: 'link'
    });
    const RouterLink = (0, $9ENjd.default)();
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    const styles = Array.isArray(xcssStyles) ? [
        $78e97c7fa17b82aa$var$defaultStyles,
        $78e97c7fa17b82aa$var$focusRingStyles,
        ...xcssStyles
    ] : [
        $78e97c7fa17b82aa$var$defaultStyles,
        $78e97c7fa17b82aa$var$focusRingStyles,
        xcssStyles
    ];
    const isExternal = typeof href === 'string' && $78e97c7fa17b82aa$var$IS_EXTERNAL_LINK_REGEX.test(href);
    const isNonHttpBased = typeof href === 'string' && $78e97c7fa17b82aa$var$IS_NON_HTTP_BASED.test(href);
    /**
	 * Renders a router link if:
	 *
	 * - a link component is set in the app provider
	 * - it's not an external link (starting with `http://` or `https://`)
	 * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.).
	 */ const isRouterLink = RouterLink && !isExternal && !isNonHttpBased;
    const hrefObjectUsedWithoutRouterLink = RouterLink === undefined && typeof href === 'object';
    (0, $8ynlC.default)(!hrefObjectUsedWithoutRouterLink, `@atlaskit/primitives: Anchor primitive cannot pass an object to 'href' unless a router link is configured in the AppProvider`);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        ...htmlAttributes,
        // @ts-expect-error (TODO: Box doesn't allow `as` components)
        as: isRouterLink ? RouterLink : 'a',
        ref: ref,
        testId: testId,
        "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined,
        href: !isRouterLink && typeof href !== 'string' ? undefined : href,
        target: target,
        backgroundColor: backgroundColor,
        padding: padding,
        paddingBlock: paddingBlock,
        paddingBlockStart: paddingBlockStart,
        paddingBlockEnd: paddingBlockEnd,
        paddingInline: paddingInline,
        paddingInlineStart: paddingInlineStart,
        paddingInlineEnd: paddingInlineEnd,
        onClick: onClick,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        xcss: styles
    }, children, target === '_blank' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lkPEe.default), null, "(opens new window)"));
};
// Workarounds to support generic types with forwardRef
/**
 * __Anchor__
 *
 * @internal Still under development. Do not use.
 *
 * Anchor is a primitive for building custom anchor links. It's a wrapper around the HTML `<a>` element that provides a consistent API for handling client-side routing and Atlassian Design System styling.
 *
 * This component is mostly used by other design system components, such as the [link component](/components/link/usage).
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ const $78e97c7fa17b82aa$var$Anchor = /*#__PURE__*/ (0, $eUqFw.forwardRef)($78e97c7fa17b82aa$var$AnchorNoRef);
var $78e97c7fa17b82aa$export$2e2bcd8739ae039 = $78e97c7fa17b82aa$var$Anchor;

});
parcelRegister("9ENjd", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d596fc4650924ea$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1SoQa = parcelRequire("1SoQa");
/**
 * __useRouterLink()__
 *
 * Hook: Returns app-configured router link component.
 *
 * A generic can be passed to define advanced link configuration:
 * ```
 * type MyRouterLinkConfig = {
 *  to: string;
 *  replace?: boolean;
 * }
 *
 * const RouterLink = useRouterLink<MyRouterLinkConfig>();
 * ```
 */ const $6d596fc4650924ea$var$useRouterLink = ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $eUqFw.useContext)((0, $1SoQa.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
};
var $6d596fc4650924ea$export$2e2bcd8739ae039 = $6d596fc4650924ea$var$useRouterLink;

});
parcelRegister("1SoQa", function(module, exports) {

$parcel$export(module.exports, "RouterLinkProviderContext", () => $a7efb4f013bfd7bf$export$2931e0ee690eee88);
$parcel$export(module.exports, "default", () => $a7efb4f013bfd7bf$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $a7efb4f013bfd7bf$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $eUqFw.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ const $a7efb4f013bfd7bf$var$RouterLinkProvider = ({ routerLinkComponent: routerLinkComponent, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a7efb4f013bfd7bf$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        }
    }, children);
};
var $a7efb4f013bfd7bf$export$2e2bcd8739ae039 = $a7efb4f013bfd7bf$var$RouterLinkProvider;

});



parcelRegister("27KYr", function(module, exports) {

$parcel$export(module.exports, "default", () => $bff125957ff3df11$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $9seLS = parcelRequire("9seLS");

var $1ZAYh = parcelRequire("1ZAYh");
function $bff125957ff3df11$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $bff125957ff3df11$var$gridTemplateAreasVar = '--ds-grid--grid-template-areas';
const $bff125957ff3df11$var$gridTemplateColumnsVar = '--ds-grid--grid-template-columns';
const $bff125957ff3df11$var$gridTemplateRowsVar = '--ds-grid--grid-template-rows';
const $bff125957ff3df11$var$justifyContentMap = {
    start: {
        name: "j1lm6p",
        styles: "justify-content:start"
    },
    center: {
        name: "f7ay7b",
        styles: "justify-content:center"
    },
    end: {
        name: "jab4lt",
        styles: "justify-content:end"
    },
    'space-between': {
        name: "2o6p8u",
        styles: "justify-content:space-between"
    },
    'space-around': {
        name: "46cjum",
        styles: "justify-content:space-around"
    },
    'space-evenly': {
        name: "16166rn",
        styles: "justify-content:space-evenly"
    },
    stretch: {
        name: "11z2bqs",
        styles: "justify-content:stretch"
    }
};
const $bff125957ff3df11$var$justifyItemsMap = {
    start: {
        name: "lno2ya",
        styles: "justify-items:start"
    },
    center: {
        name: "1wg53za",
        styles: "justify-items:center"
    },
    end: {
        name: "3f7lhf",
        styles: "justify-items:end"
    },
    stretch: {
        name: "16hnylu",
        styles: "justify-items:stretch"
    }
};
const $bff125957ff3df11$var$alignContentMap = {
    start: {
        name: "iqu4as",
        styles: "align-content:start"
    },
    center: {
        name: "13vy23x",
        styles: "align-content:center"
    },
    end: {
        name: "1fj2toh",
        styles: "align-content:end"
    },
    'space-between': {
        name: "1pem0lx",
        styles: "align-content:space-between"
    },
    'space-around': {
        name: "127p7gk",
        styles: "align-content:space-around"
    },
    'space-evenly': {
        name: "kcqjal",
        styles: "align-content:space-evenly"
    },
    stretch: {
        name: "1f8yzab",
        styles: "align-content:stretch"
    }
};
const $bff125957ff3df11$var$alignItemsMap = {
    start: {
        name: "yvwru5",
        styles: "align-items:start"
    },
    center: {
        name: "1h3rtzg",
        styles: "align-items:center"
    },
    baseline: {
        name: "fzr848",
        styles: "align-items:baseline"
    },
    end: {
        name: "uj5xqj",
        styles: "align-items:end"
    }
};
const $bff125957ff3df11$var$baseStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'grid',
    boxSizing: 'border-box',
    gridTemplateAreas: `var(${$bff125957ff3df11$var$gridTemplateAreasVar})`,
    gridTemplateColumns: `var(${$bff125957ff3df11$var$gridTemplateColumnsVar})`,
    gridTemplateRows: `var(${$bff125957ff3df11$var$gridTemplateRowsVar})`
});
const $bff125957ff3df11$var$gridAutoFlowMap = {
    row: {
        name: "k3yepi",
        styles: "grid-auto-flow:row"
    },
    column: {
        name: "qu4z1d",
        styles: "grid-auto-flow:column"
    },
    dense: {
        name: "mgx7bc",
        styles: "grid-auto-flow:dense"
    },
    'row dense': {
        name: "1u50cee",
        styles: "grid-auto-flow:row dense"
    },
    'column dense': {
        name: "5ak4pc",
        styles: "grid-auto-flow:column dense"
    }
};
/**
 * __Grid__
 *
 * `Grid` is a primitive component that implements the CSS Grid API.
 *
 * - [Examples](https://atlassian.design/components/primitives/grid/examples)
 * - [Code](https://atlassian.design/components/primitives/grid/code)
 *
 * @example
 * ```tsx
 * import { Grid, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Grid gap="space.100" gridColumns="1fr 1fr">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Grid>
 * )
 * ```
 */ const $bff125957ff3df11$var$Grid = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: as, alignItems: alignItems, alignContent: alignContent, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, id: id, role: role, testId: testId, autoFlow: autoFlow, templateAreas: gridTemplateAreas, templateRows: gridTemplateRows, templateColumns: gridTemplateColumns, xcss: xcss }, ref)=>{
    const Component = as || 'div';
    const resolvedStyles = (0, $1ZAYh.parseXcss)(xcss);
    /**
   * We use CSS variables to allow for dynamic grid templates instead of dynamically setting to `props.style`
   * This allows `props.xcss` to override them as `style={{ gridTemplateAreas }}` would have higher specificity.
   *
   * This must be reset to `initial` if `gridTemplateAreas` is not set, otherwise nested grids will break!
   *
   * NOTE: If we disallow `grid-template-areas` (etc) to be set via `props.xcss`, we can remove this.
   */ const style = (0, $eUqFw.useMemo)(()=>({
            [$bff125957ff3df11$var$gridTemplateAreasVar]: gridTemplateAreas ? gridTemplateAreas.map((str)=>`"${str}"`).join('\n') || 'initial' : 'initial',
            [$bff125957ff3df11$var$gridTemplateColumnsVar]: gridTemplateColumns || 'initial',
            [$bff125957ff3df11$var$gridTemplateRowsVar]: gridTemplateRows || 'initial'
        }), [
        gridTemplateAreas,
        gridTemplateColumns,
        gridTemplateRows
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)(Component, {
        id: id,
        role: role,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            $bff125957ff3df11$var$baseStyles,
            gap && (0, $9seLS.spaceStylesMap).gap[gap],
            columnGap && (0, $9seLS.spaceStylesMap).columnGap[columnGap],
            rowGap && (0, $9seLS.spaceStylesMap).rowGap[rowGap],
            alignItems && $bff125957ff3df11$var$alignItemsMap[alignItems],
            alignContent && $bff125957ff3df11$var$alignContentMap[alignContent],
            justifyContent && $bff125957ff3df11$var$justifyContentMap[justifyContent],
            autoFlow && $bff125957ff3df11$var$gridAutoFlowMap[autoFlow],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            resolvedStyles.emotion
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$bff125957ff3df11$var$Grid.displayName = 'Grid';
var $bff125957ff3df11$export$2e2bcd8739ae039 = $bff125957ff3df11$var$Grid;

});

parcelRegister("8sN8t", function(module, exports) {

$parcel$export(module.exports, "default", () => $62970d98d091cf14$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lbDTY = parcelRequire("lbDTY");

var $1U6Rx = parcelRequire("1U6Rx");
/**
 * __Spotlight target__
 *
 * A spotlight target marks a component to be used for introducing new features to users through focused messages or multi-step tours.
 *
 * - [Examples](https://atlassian.design/components/onboarding/examples)
 * - [Code](https://atlassian.design/components/onboarding/code)
 * - [Usage](https://atlassian.design/components/onboarding/usage)
 */ const $62970d98d091cf14$var$SpotlightTarget = ({ children: children, name: name })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1U6Rx.TargetConsumer), null, (targetRef)=>targetRef ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lbDTY))), {
            innerRef: targetRef(name)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children)) : children);
var $62970d98d091cf14$export$2e2bcd8739ae039 = $62970d98d091cf14$var$SpotlightTarget;

});

parcelRegister("kGoGz", function(module, exports) {

$parcel$export(module.exports, "JiraServiceManagementLogo", () => $70a39fd4831fabac$export$dabef2be6cd28c20);
/* eslint-disable max-len */ 
var $eUqFw = parcelRequire("eUqFw");

var $4q38b = parcelRequire("4q38b");

var $lpzFL = parcelRequire("lpzFL");

var $9m0Eq = parcelRequire("9m0Eq");

var $urYMl = parcelRequire("urYMl");
const $70a39fd4831fabac$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $9m0Eq.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 362 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill=${colors.iconColor} d="M14.124 13.257h7.325c1.1 0 1.475 1.046.804 1.878L10.798 29.274c-3.702-2.951-3.353-7.62-.644-11.027zm-5.66 5.634H1.138c-1.1 0-1.476-1.046-.805-1.878L11.79 2.874c3.703 2.951 3.3 7.566.617 11z" />
      <path fill=${colors.textColor} d="M357.074 20.787c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545c-.46.123-.981.245-1.778.245-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zm-7.327-4.231v8.985h-2.638V16.28c0-2.76-1.104-3.987-3.618-3.987-2.454 0-4.14 1.625-4.14 4.723v8.525h-2.638V10.208h2.638v2.514c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.423 5.551 6.655m-22.921-4.263c-2.791 0-4.201 1.81-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.631 2.576-7.943 7.238-7.943 4.722 0 6.624 3.281 6.624 7.943v1.196h-11.194c.368 2.606 2.055 4.293 5.674 4.293 1.778 0 3.281-.337 4.661-.828zm-26.152-7.912v8.525h-2.637V16.28c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.625-4.14 4.723v8.525h-2.637V10.208h2.637v2.514c.981-1.81 2.79-2.821 4.845-2.821 2.607 0 4.385 1.319 5.152 3.741.859-2.361 2.913-3.741 5.459-3.741 3.434 0 5.336 2.33 5.336 6.655v8.985h-2.638v-8.525c0-3.16-1.104-4.723-3.618-4.723-2.454 0-4.14 1.625-4.14 4.723m-22.921-4.723c-2.79 0-4.201 1.81-4.477 4.477h8.556c-.153-2.852-1.441-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.631 2.577-7.943 7.238-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zm-18.638-.614v-1.533c-.982 2.024-2.822 3.067-5.183 3.067-4.048 0-6.072-3.466-6.072-7.974 0-4.324 2.116-7.973 6.379-7.973 2.238 0 3.956 1.012 4.876 3.005v-2.698h2.576V24.16c0 4.508-2.116 7.544-7.606 7.544-2.576 0-3.986-.337-5.458-.828V28.3c1.686.552 3.434.92 5.336.92 3.833 0 5.152-2.055 5.152-4.907m-8.679-6.44c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.975 0-4.508 1.963-4.508 5.52m-16.949.001c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.508 1.963-4.508 5.52m8.678 7.667v-2.76c-.981 2.024-2.821 3.066-5.182 3.066-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.638V25.54zm-14.073-8.984v8.985h-2.638V16.28c0-2.76-1.104-3.987-3.618-3.987-2.454 0-4.14 1.625-4.14 4.723v8.525h-2.638V10.208h2.638v2.514c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.423 5.551 6.655m-28.327 1.318c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.974 0-4.508 1.963-4.508 5.52m8.679 7.667v-2.76c-.981 2.024-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zm-31.445-11.009-2.76-7.482V25.54h-2.76V5.393h4.784l4.569 11.56 1.871 5.552 1.87-5.551 4.6-11.561h4.447V25.54h-2.76V7.263l-2.361 7.268-4.447 11.01h-2.668zm-21.511-2.238c-2.791 0-4.202 1.81-4.478 4.477h8.556c-.153-2.852-1.441-4.477-4.078-4.477m5.888 12.635c-1.258.674-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.055 4.293 5.673 4.293 1.779 0 3.282-.337 4.662-.828zm-15.094-2.148v2.362c-.92.49-2.33.705-3.741.705-5.459 0-8.004-3.312-8.004-8.004 0-4.63 2.545-7.942 8.004-7.942 1.38 0 2.453.184 3.649.736v2.453c-.981-.46-2.024-.736-3.465-.736-3.987 0-5.612 2.515-5.612 5.49s1.656 5.489 5.673 5.489c1.564 0 2.546-.215 3.496-.552M140.124 6.16c0-1.166.766-1.84 1.84-1.84 1.073 0 1.84.674 1.84 1.84S143.037 8 141.964 8c-1.074 0-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334zm-8.233 0h-3.527l-5.949-15.332h2.76l4.968 13.094 4.937-13.094h2.76zm-15.455-9.046v9.047h-2.576V10.207h2.576v2.699c.889-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925m-12.463-4.201c-2.791 0-4.202 1.81-4.478 4.477h8.556c-.153-2.852-1.441-4.477-4.078-4.477m5.888 12.635c-1.258.674-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.055 4.293 5.673 4.293 1.779 0 3.282-.337 4.662-.828zM95.024 19.99c0 3.496-2.085 5.857-7.084 5.857-3.894 0-5.704-.766-7.268-1.564v-2.821c1.87.981 4.754 1.687 7.422 1.687 3.036 0 4.17-1.196 4.17-2.975s-1.104-2.73-4.937-3.65c-4.539-1.103-6.563-2.667-6.563-5.98 0-3.127 2.392-5.458 7.084-5.458 2.914 0 4.784.705 6.164 1.472v2.76c-2.024-1.165-4.201-1.533-6.286-1.533-2.638 0-4.202.92-4.202 2.76 0 1.656 1.288 2.484 4.845 3.373 4.263 1.073 6.655 2.453 6.655 6.072m-34.001-2.116c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.509 1.963-4.509 5.52m8.679 7.667v-2.76c-.981 2.024-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zM51.91 16.494v9.047h-2.577V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925M42.224 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S45.137 8 44.064 8s-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334zm-6.427-5.949V5.393h2.76v14.014c0 3.71-1.626 6.256-5.428 6.256-1.442 0-2.546-.245-3.312-.521v-2.668c.828.337 1.84.521 2.852.521 2.33 0 3.128-1.41 3.128-3.404" />
    </svg>`;
};
const $70a39fd4831fabac$export$dabef2be6cd28c20 = ({ appearance: appearance, label: label = 'Jira Service Management', size: size = (0, $lpzFL.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $lpzFL.defaultLogoParams).iconColor, textColor: textColor = (0, $lpzFL.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $4q38b.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $urYMl.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $70a39fd4831fabac$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("iFmgL", function(module, exports) {

$parcel$export(module.exports, "default", () => $69346126ecba512c$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $kk8oa = parcelRequire("kk8oa");

var $4q38b = parcelRequire("4q38b");
function $69346126ecba512c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $69346126ecba512c$var$baseImageStyles = {
    name: "1hyxgad",
    styles: "max-width:100%;height:auto"
};
const $69346126ecba512c$var$themedImageStyles = /*#__PURE__*/ (0, $byn9U.css)({
    content: `var(--img-source)`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    'html[data-color-mode=dark] &': {
        content: `var(--img-source-dark)`
    }
});
function $69346126ecba512c$export$2e2bcd8739ae039({ src: src, srcDark: srcDark, alt: alt, testId: testId, ...props }) {
    const imgRef = (0, $eUqFw.useRef)(null);
    const providedColorMode = (0, $kk8oa.UNSAFE_useColorModeForMigration)();
    const { colorMode: observedColorMode } = (0, $4q38b.default)();
    const colorMode = providedColorMode || observedColorMode;
    (0, $eUqFw.useEffect)(()=>{
        if (imgRef === null || imgRef.current === null) return;
        if (srcDark && colorMode === 'dark') imgRef.current.src = srcDark;
        else if (src) imgRef.current.src = src;
    }, [
        src,
        srcDark,
        colorMode
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)("img", {
        alt: alt,
        "data-testid": testId,
        src: src,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            '--img-source': `url(${src})`,
            '--img-source-dark': `url(${srcDark || src})`
        },
        css: [
            $69346126ecba512c$var$baseImageStyles,
            $69346126ecba512c$var$themedImageStyles
        ],
        ref: imgRef,
        ...props
    });
}

});
parcelRegister("kk8oa", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_useColorModeForMigration", () => $4c5a5058c6e3c5b3$export$ce91654eb9fea460);
$parcel$export(module.exports, "default", () => $4c5a5058c6e3c5b3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

var $8hqCp = parcelRequire("8hqCp");
const $4c5a5058c6e3c5b3$var$defaultThemeSettings = {
    dark: 'dark',
    light: 'light',
    spacing: 'spacing'
};
const $4c5a5058c6e3c5b3$var$ColorModeContext = /*#__PURE__*/ (0, $eUqFw.createContext)(undefined);
const $4c5a5058c6e3c5b3$var$SetColorModeContext = /*#__PURE__*/ (0, $eUqFw.createContext)(undefined);
const $4c5a5058c6e3c5b3$var$ThemeContext = /*#__PURE__*/ (0, $eUqFw.createContext)(undefined);
const $4c5a5058c6e3c5b3$var$SetThemeContext = /*#__PURE__*/ (0, $eUqFw.createContext)(undefined);
function $4c5a5058c6e3c5b3$export$ce91654eb9fea460() {
    const value = (0, $eUqFw.useContext)($4c5a5058c6e3c5b3$var$ColorModeContext);
    return value;
}
function $4c5a5058c6e3c5b3$export$20f3076712c8dfa() {
    const value = (0, $eUqFw.useContext)($4c5a5058c6e3c5b3$var$ColorModeContext);
    if (!value) throw new Error('useColorMode must be used within AppProvider.');
    return value;
}
function $4c5a5058c6e3c5b3$export$e2afe7397c3d11c7() {
    const value = (0, $eUqFw.useContext)($4c5a5058c6e3c5b3$var$SetColorModeContext);
    if (!value) throw new Error('useSetColorMode must be used within AppProvider.');
    return value;
}
function $4c5a5058c6e3c5b3$export$93d4e7f90805808f() {
    const value = (0, $eUqFw.useContext)($4c5a5058c6e3c5b3$var$ThemeContext);
    if (!value) throw new Error('useTheme must be used within AppProvider.');
    return value;
}
function $4c5a5058c6e3c5b3$export$501aa0dcd5527a48() {
    const value = (0, $eUqFw.useContext)($4c5a5058c6e3c5b3$var$SetThemeContext);
    if (!value) throw new Error('useSetTheme must be used within AppProvider.');
    return value;
}
const $4c5a5058c6e3c5b3$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
const $4c5a5058c6e3c5b3$var$prefersDarkModeMql = $4c5a5058c6e3c5b3$var$isMatchMediaAvailable ? window.matchMedia('(prefers-color-scheme: dark)') : undefined;
// TODO: currently 'auto' color mode will always return 'light' in SSR.
// Additional work required: https://product-fabric.atlassian.net/browse/DSP-9781
function $4c5a5058c6e3c5b3$var$getReconciledColorMode(colorMode) {
    if (colorMode === 'auto') return $4c5a5058c6e3c5b3$var$prefersDarkModeMql?.matches ? 'dark' : 'light';
    return colorMode;
}
function $4c5a5058c6e3c5b3$export$d8964aec282183a3({ children: children, defaultColorMode: defaultColorMode, defaultTheme: { dark: dark = 'dark', light: light = 'light', spacing: spacing = 'spacing', typography: typography, shape: shape } = $4c5a5058c6e3c5b3$var$defaultThemeSettings }) {
    const [chosenColorMode, setChosenColorMode] = (0, $eUqFw.useState)(defaultColorMode);
    const [reconciledColorMode, setReconciledColorMode] = (0, $eUqFw.useState)($4c5a5058c6e3c5b3$var$getReconciledColorMode(defaultColorMode));
    const [theme, setTheme] = (0, $eUqFw.useState)({
        dark: dark,
        light: light,
        spacing: spacing,
        typography: typography,
        shape: shape
    });
    const setColorMode = (0, $eUqFw.useCallback)((colorMode)=>{
        setChosenColorMode(colorMode);
        setReconciledColorMode($4c5a5058c6e3c5b3$var$getReconciledColorMode(colorMode));
    }, []);
    const setPartialTheme = (0, $eUqFw.useCallback)((nextTheme)=>{
        setTheme((theme)=>({
                ...theme,
                ...nextTheme
            }));
    }, []);
    (0, $eUqFw.useEffect)(()=>{
        (0, $8hqCp.default)({
            ...theme,
            colorMode: reconciledColorMode
        });
    }, [
        theme,
        reconciledColorMode
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!$4c5a5058c6e3c5b3$var$prefersDarkModeMql) return;
        const unbindListener = (0, $74BVL.bind)($4c5a5058c6e3c5b3$var$prefersDarkModeMql, {
            type: 'change',
            listener: (event)=>{
                if (chosenColorMode === 'auto') setReconciledColorMode(event.matches ? 'dark' : 'light');
            }
        });
        return unbindListener;
    }, [
        chosenColorMode
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4c5a5058c6e3c5b3$var$ColorModeContext.Provider, {
        value: reconciledColorMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4c5a5058c6e3c5b3$var$SetColorModeContext.Provider, {
        value: setColorMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4c5a5058c6e3c5b3$var$ThemeContext.Provider, {
        value: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4c5a5058c6e3c5b3$var$SetThemeContext.Provider, {
        value: setPartialTheme
    }, children))));
}
var $4c5a5058c6e3c5b3$export$2e2bcd8739ae039 = $4c5a5058c6e3c5b3$export$d8964aec282183a3;

});


parcelRegister("82CV1", function(module, exports) {

$parcel$export(module.exports, "JiraLogo", () => $f879c0390ad93f32$export$17d3acb0b4379d02);
/* eslint-disable max-len */ 
var $eUqFw = parcelRequire("eUqFw");

var $4q38b = parcelRequire("4q38b");

var $lpzFL = parcelRequire("lpzFL");

var $9m0Eq = parcelRequire("9m0Eq");

var $urYMl = parcelRequire("urYMl");
const $f879c0390ad93f32$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $9m0Eq.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 77 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M7.967 21.323H5.748C2.401 21.323 0 19.273 0 16.271h11.933c.618 0 1.018.44 1.018 1.062V29.34c-2.983 0-4.984-2.416-4.984-5.784zm5.894-5.967h-2.22c-3.346 0-5.747-2.013-5.747-5.015h11.932c.618 0 1.055.402 1.055 1.025v12.007c-2.983 0-5.02-2.416-5.02-5.784zm5.93-5.93h-2.22c-3.347 0-5.748-2.05-5.748-5.052h11.933c.618 0 1.019.439 1.019 1.025v12.007c-2.983 0-4.984-2.416-4.984-5.784z"/>
      <path fill="${colors.textColor}" d="M65.023 17.874c0 3.68 1.472 5.52 4.202 5.52 2.36 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.932-4.906-4.17-4.906-2.975 0-4.509 1.962-4.509 5.52m8.679 7.666v-2.76c-.981 2.024-2.821 3.067-5.183 3.067-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006v-2.699h2.637V25.54zM55.91 16.493v9.047h-2.577V10.207h2.576v2.698c.89-1.809 2.423-3.097 5.428-2.913v2.576c-3.373-.337-5.428.675-5.428 3.925M46.224 6.159c0-1.165.767-1.84 1.84-1.84s1.84.675 1.84 1.84-.767 1.84-1.84 1.84-1.84-.675-1.84-1.84m.49 19.381V10.207h2.638V25.54zm-6.427-5.95V5.393h2.76v14.015c0 3.71-1.626 6.256-5.428 6.256-1.442 0-2.546-.246-3.312-.522v-2.668c.828.338 1.84.522 2.852.522 2.33 0 3.128-1.41 3.128-3.404"/>
    </svg>`;
};
const $f879c0390ad93f32$export$17d3acb0b4379d02 = ({ appearance: appearance, label: label = 'Jira', size: size = (0, $lpzFL.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $lpzFL.defaultLogoParams).iconColor, textColor: textColor = (0, $lpzFL.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $4q38b.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $urYMl.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $f879c0390ad93f32$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("fI650", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7b28527f26e4865$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4kMup = parcelRequire("4kMup");

var $3Ucf8 = parcelRequire("3Ucf8");
const $f7b28527f26e4865$var$LinkButtonBase = ({ analyticsContext: analyticsContext, appearance: appearance, autoFocus: autoFocus, children: children, href: href, iconAfter: iconAfter, iconBefore: iconBefore, interactionName: interactionName, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, overlay: overlay, shouldFitContainer: shouldFitContainer, spacing: spacing, testId: testId, UNSAFE_iconAfter_size: UNSAFE_iconAfter_size, UNSAFE_iconBefore_size: UNSAFE_iconBefore_size, ...rest }, ref)=>{
    const baseProps = (0, $3Ucf8.default)({
        analyticsContext: analyticsContext,
        appearance: appearance,
        autoFocus: autoFocus,
        buttonType: 'link',
        children: children,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        interactionName: interactionName,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchEndCapture: onTouchEndCapture,
        onTouchStartCapture: onTouchStartCapture,
        overlay: overlay,
        ref: ref,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        UNSAFE_iconAfter_size: UNSAFE_iconAfter_size,
        UNSAFE_iconBefore_size: UNSAFE_iconBefore_size
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4kMup.default), {
        ...rest,
        ref: baseProps.ref,
        xcss: baseProps.xcss,
        onClick: baseProps.onClick,
        onMouseDownCapture: baseProps.onMouseDownCapture,
        onMouseUpCapture: baseProps.onMouseUpCapture,
        onKeyDownCapture: baseProps.onKeyDownCapture,
        onKeyUpCapture: baseProps.onKeyUpCapture,
        onTouchStartCapture: baseProps.onTouchStartCapture,
        onTouchEndCapture: baseProps.onTouchEndCapture,
        onPointerDownCapture: baseProps.onPointerDownCapture,
        onPointerUpCapture: baseProps.onPointerUpCapture,
        onClickCapture: baseProps.onClickCapture,
        testId: testId,
        /**
			 * Disable link in an accessible way using `href`, `role`, and `aria-disabled`.
			 * @see https://a11y-guidelines.orange.com/en/articles/disable-elements/#disable-a-link
			 */ // @ts-expect-error (`href` is required, we could make it optional but don't want to encourage this pattern elsewhere)
        href: baseProps.isDisabled ? undefined : href,
        role: baseProps.isDisabled ? 'link' : undefined,
        "aria-disabled": baseProps.isDisabled === true ? true : undefined,
        analyticsContext: analyticsContext,
        interactionName: interactionName,
        componentName: "LinkButton"
    }, baseProps.children);
};
// Workarounds to support generic types with forwardRef + memo
const $f7b28527f26e4865$var$WithRef = /*#__PURE__*/ (0, $eUqFw.forwardRef)($f7b28527f26e4865$var$LinkButtonBase);
/**
 * __Link Button__
 *
 * Renders a link in the style of a button.
 *
 * - [Examples](https://atlassian.design/components/link-button/examples)
 * - [Code](https://atlassian.design/components/link-button/code)
 * - [Usage](https://atlassian.design/components/link-button/usage)
 */ const $f7b28527f26e4865$var$LinkButton = /*#__PURE__*/ (0, $eUqFw.memo)($f7b28527f26e4865$var$WithRef);
var $f7b28527f26e4865$export$2e2bcd8739ae039 = $f7b28527f26e4865$var$LinkButton;

});

parcelRegister("lkO3b", function(module, exports) {

$parcel$export(module.exports, "JiraProductDiscoveryLogo", () => $b60a688757c87c05$export$c49a2b642fe9eef4);
/* eslint-disable max-len */ 
var $eUqFw = parcelRequire("eUqFw");

var $4q38b = parcelRequire("4q38b");

var $lpzFL = parcelRequire("lpzFL");

var $9m0Eq = parcelRequire("9m0Eq");

var $urYMl = parcelRequire("urYMl");
const $b60a688757c87c05$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $9m0Eq.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 318 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M12.655 5.218a15.3 15.3 0 0 0 8.75 0c.257-.057.428.114.37.37-.826 2.984-.826 5.742 0 8.727.058.227-.113.426-.37.341a16.33 16.33 0 0 0-8.75 0c-.228.085-.428-.114-.342-.341.77-2.985.77-5.743 0-8.727-.086-.256.114-.427.342-.37m1.169 10.575v.483c0 2.246-1.568 3.895-3.506 3.895a3.474 3.474 0 0 1-3.478-3.497c0-1.933 1.568-3.468 3.763-3.468h.57V6.412c-.285-.028-.57-.028-.855-.028C4.618 6.384 0 10.989 0 16.703s4.617 10.29 10.318 10.29 10.346-4.605 10.346-10.29v-.91z" />
      <path fill="${colors.textColor}" d="M308.551 24.559h-1.718l-5.55-14.352h2.821l4.907 13.125 4.906-13.125h2.822l-5.796 14.843c-1.718 4.385-2.699 6.654-6.594 6.654-1.318 0-2.054-.122-2.821-.429v-2.27c.889.277 1.901.369 2.668.369 2.147 0 3.097-1.472 4.355-4.815m-13.247-8.065v9.047h-2.576V10.207h2.576v2.699c.889-1.81 2.422-3.097 5.428-2.913v2.576c-3.374-.338-5.428.674-5.428 3.925m-12.464-4.202c-2.79 0-4.201 1.81-4.477 4.478h8.556c-.153-2.852-1.441-4.478-4.079-4.478m5.888 12.635c-1.257.675-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.63 2.576-7.943 7.237-7.943 4.723 0 6.624 3.282 6.624 7.943v1.196h-11.193c.368 2.607 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zm-19.717.613h-3.527l-5.949-15.333h2.76l4.968 13.095 4.937-13.095h2.76zm-17.462.307c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.943 7.299-7.943c4.569 0 7.237 3.343 7.237 7.943s-2.668 8.004-7.237 8.004m0-13.493c-3.281 0-4.723 2.576-4.723 5.49 0 2.912 1.442 5.55 4.723 5.55 3.251 0 4.661-2.638 4.661-5.55 0-2.914-1.41-5.49-4.661-5.49M242.16 22.78v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.943 8.004-7.943 1.38 0 2.454.184 3.65.736v2.454c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.514-5.612 5.49 0 2.974 1.656 5.488 5.674 5.488 1.564 0 2.545-.214 3.496-.552m-13.872-1.41c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.521-5.336-1.135v-2.79c1.319.766 3.527 1.502 5.459 1.502 2.024 0 3.066-.828 3.066-2.024 0-1.165-.889-1.84-3.802-2.545-3.404-.828-4.846-2.147-4.846-4.661 0-2.668 2.055-4.294 5.551-4.294 1.993 0 3.803.491 4.937 1.104v2.73c-1.84-.92-3.342-1.41-4.968-1.41-1.932 0-2.974.674-2.974 1.87 0 1.073.736 1.748 3.557 2.422 3.404.828 5.121 2.086 5.121 4.754M210.599 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84-.767 1.84-1.84 1.84-1.84-.675-1.84-1.84m.491 19.38V10.208h2.637v15.334zM198.344 8.03h-4.539v14.873h4.692c4.6 0 6.9-2.422 6.9-7.298 0-4.907-2.177-7.575-7.053-7.575m-7.299 17.51V5.394h7.422c6.532 0 9.69 4.078 9.69 10.12 0 6.102-3.189 10.028-9.69 10.028zm-13.411-4.753c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545c-.46.123-.981.245-1.778.245-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zm-6.66 1.993v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.943 8.004-7.943 1.38 0 2.454.184 3.65.736v2.454c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.514-5.612 5.49 0 2.974 1.656 5.488 5.674 5.488 1.564 0 2.545-.214 3.496-.552m-27.843-3.588v-8.985h2.637v9.261c0 2.76 1.104 3.987 3.619 3.987 2.453 0 4.14-1.625 4.14-4.723v-8.525h2.637V25.54h-2.637v-2.514c-.982 1.809-2.791 2.821-4.846 2.821-3.526 0-5.55-2.423-5.55-6.655m-14.987-1.318c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.932-4.906-4.171-4.906-2.974 0-4.508 1.962-4.508 5.52m8.679 7.667v-2.76c-.981 2.023-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005V3.798h2.637V25.54zm-20.698.306c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.943 7.299-7.943c4.569 0 7.237 3.343 7.237 7.943s-2.668 8.004-7.237 8.004m0-13.493c-3.282 0-4.723 2.576-4.723 5.49 0 2.912 1.441 5.55 4.723 5.55 3.25 0 4.661-2.638 4.661-5.55 0-2.914-1.411-5.49-4.661-5.49m-13.776 4.14v9.047h-2.576V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925m-5.002-4.385c0 4.385-2.454 6.838-7.483 6.838h-4.017v6.594h-2.76V5.393h6.777c5.03 0 7.483 2.576 7.483 6.716m-7.79 4.2c3.558.124 4.938-1.563 4.938-4.14 0-2.452-1.38-4.14-4.938-4.14h-3.71v8.28zM61.69 17.874c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.931-4.906-4.17-4.906-2.975 0-4.508 1.962-4.508 5.52m8.679 7.666v-2.76c-.982 2.024-2.822 3.067-5.183 3.067-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.974 6.44-7.974 2.24 0 3.957 1.012 4.877 3.006v-2.699h2.637V25.54zm-17.793-9.046v9.047H50V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925M42.89 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S45.805 8 44.73 8s-1.84-.675-1.84-1.84m.491 19.38V10.208h2.638v15.334zm-6.428-5.949V5.393h2.76v14.014c0 3.71-1.625 6.256-5.428 6.256-1.441 0-2.545-.245-3.312-.521v-2.668c.828.337 1.84.521 2.852.521 2.331 0 3.128-1.41 3.128-3.404" />
    </svg>`;
};
const $b60a688757c87c05$export$c49a2b642fe9eef4 = ({ appearance: appearance, label: label = 'Jira Product Discovery', size: size = (0, $lpzFL.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $lpzFL.defaultLogoParams).iconColor, textColor: textColor = (0, $lpzFL.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $4q38b.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $urYMl.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $b60a688757c87c05$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("iX87Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $88f6ea40791e81a2$export$2e2bcd8739ae039);


var $h6fut = parcelRequire("h6fut");

var $2fFJv = parcelRequire("2fFJv");
/**
 * Takes a dot-separated token name and and an optional fallback, and returns the current computed CSS value for the
 * resulting CSS Custom Property.
 * This should be used for when the CSS cascade isn't available, eg. `<canvas>` elements, JS charting libraries, etc.
 *
 * Note: these values change depending on the theme so consider pairing them with `useThemeObserver` in React, or the
 * `ThemeMutationObserver` class elsewhere.
 *
 * @param {string} path - A dot-separated token name (example: `'color.background.brand'` or `'spacing.scale.100'`).
 * @param {string} [fallback] - The fallback value that should render when token CSS is not present in your app.
 *
 * @example
 * ```
 * const theme = useThemeObserver();
 *
 * useEffect(() => {
 *  const lineColor = getTokenValue('color.background.accent.blue.subtle', B400);
 * }, [theme]);
 * ```
 *
 */ function $88f6ea40791e81a2$var$getTokenValue(tokenId, fallback = '') {
    let token = (0, $h6fut.default)[tokenId];
    let tokenValue = fallback;
    typeof $2fFJv;
    if (typeof window === 'undefined') return tokenValue;
    tokenValue = window.getComputedStyle(document.documentElement).getPropertyValue(token).trim();
    tokenValue = tokenValue || fallback;
    return tokenValue;
}
var $88f6ea40791e81a2$export$2e2bcd8739ae039 = $88f6ea40791e81a2$var$getTokenValue;

});

parcelRegister("jT7oX", function(module, exports) {

$parcel$export(module.exports, "Box", () => $e7a8e52464e1e776$export$e71c4d32a2263218);
$parcel$export(module.exports, "default", () => $e7a8e52464e1e776$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $aZhfd = parcelRequire("aZhfd");

var $leyMq = parcelRequire("leyMq");

var $2WeA4 = parcelRequire("2WeA4");
const $e7a8e52464e1e776$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: Component = 'div', children: children, backgroundColor: backgroundColor, padding: padding, paddingBlock: paddingBlock, paddingBlockStart: paddingBlockStart, paddingBlockEnd: paddingBlockEnd, paddingInline: paddingInline, paddingInlineStart: paddingInlineStart, paddingInlineEnd: paddingInlineEnd, style: style, testId: testId, xcss: xcss, ...htmlAttributes }, ref)=>{
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const resolvedStyles = (0, $leyMq.parseXcss)(xcss);
    const node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    (0, $byn9U.jsx)(Component, (0, $kU09D.default)({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        css: [
            $e7a8e52464e1e776$var$baseStyles,
            backgroundColor && (0, $aZhfd.backgroundColorStylesMap)[backgroundColor],
            (0, $aZhfd.isSurfaceColorToken)(backgroundColor) && (0, $aZhfd.surfaceColorStylesMap)[backgroundColor],
            padding && (0, $aZhfd.paddingStylesMap).padding[padding],
            paddingBlock && (0, $aZhfd.paddingStylesMap).paddingBlock[paddingBlock],
            paddingBlockStart && (0, $aZhfd.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            paddingBlockEnd && (0, $aZhfd.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            paddingInline && (0, $aZhfd.paddingStylesMap).paddingInline[paddingInline],
            paddingInlineStart && (0, $aZhfd.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            paddingInlineEnd && (0, $aZhfd.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }), children);
    return backgroundColor ? (0, $byn9U.jsx)((0, $2WeA4.SurfaceContext).Provider, {
        value: backgroundColor
    }, node) : node;
});
var $e7a8e52464e1e776$export$2e2bcd8739ae039 = $e7a8e52464e1e776$export$e71c4d32a2263218;
const $e7a8e52464e1e776$var$baseStyles = (0, $byn9U.css)({
    boxSizing: 'border-box',
    appearance: 'none',
    border: 'none'
});

});
parcelRegister("aZhfd", function(module, exports) {

$parcel$export(module.exports, "dimensionMap", () => $7ffcfa47820ec2af$export$6ccdbebca2ee545f);
$parcel$export(module.exports, "positiveSpaceMap", () => $7ffcfa47820ec2af$export$958d0ae7f2977ae4);
$parcel$export(module.exports, "allSpaceMap", () => $7ffcfa47820ec2af$export$632685d741f3dbbf);
$parcel$export(module.exports, "inverseColorMap", () => $7ffcfa47820ec2af$export$2185ce37f9bdd963);
$parcel$export(module.exports, "opacityMap", () => $7ffcfa47820ec2af$export$daf94a976c798b4f);
$parcel$export(module.exports, "shadowMap", () => $7ffcfa47820ec2af$export$7aff6e7ba39bb774);
$parcel$export(module.exports, "borderColorMap", () => $7ffcfa47820ec2af$export$1531ad5bb3fbedac);
$parcel$export(module.exports, "backgroundColorMap", () => $7ffcfa47820ec2af$export$d1d79bf68ac056bd);
$parcel$export(module.exports, "textColorMap", () => $7ffcfa47820ec2af$export$8473307aa00d6ea1);
$parcel$export(module.exports, "layerMap", () => $7ffcfa47820ec2af$export$b5f31a7e431d2eab);
$parcel$export(module.exports, "borderWidthMap", () => $7ffcfa47820ec2af$export$e1b83c5210c471b8);
$parcel$export(module.exports, "borderRadiusMap", () => $7ffcfa47820ec2af$export$3c0a6c3e64bb180d);
$parcel$export(module.exports, "paddingStylesMap", () => $7ffcfa47820ec2af$export$e615f061ca585a6c);
$parcel$export(module.exports, "spaceStylesMap", () => $7ffcfa47820ec2af$export$bf46c3f9eeafc71f);
$parcel$export(module.exports, "backgroundColorStylesMap", () => $7ffcfa47820ec2af$export$e7af83bafe7f9e63);
$parcel$export(module.exports, "textColorStylesMap", () => $7ffcfa47820ec2af$export$3a1bcba60b23d7f0);
$parcel$export(module.exports, "fontWeightStylesMap", () => $7ffcfa47820ec2af$export$45f3f4fe16f9f7d5);
$parcel$export(module.exports, "fontStylesMap", () => $7ffcfa47820ec2af$export$128f10c238242f83);
$parcel$export(module.exports, "surfaceColorStylesMap", () => $7ffcfa47820ec2af$export$ff257d957d48c421);
$parcel$export(module.exports, "isSurfaceColorToken", () => $7ffcfa47820ec2af$export$5e65a44e5b6ecadb);

var $byn9U = parcelRequire("byn9U");

var $kyri3 = parcelRequire("kyri3");
const $7ffcfa47820ec2af$export$6ccdbebca2ee545f = {
    '100%': '100%',
    'size.100': '1rem',
    'size.200': '1.5rem',
    'size.300': '2rem',
    'size.400': '2.5rem',
    'size.500': '3rem',
    'size.600': '6rem',
    'size.1000': '12rem'
};
const $7ffcfa47820ec2af$export$958d0ae7f2977ae4 = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)"
};
const $7ffcfa47820ec2af$export$d2dc61f58390201c = {
    'space.negative.025': "var(--ds-space-negative-025, -2px)",
    'space.negative.050': "var(--ds-space-negative-050, -4px)",
    'space.negative.075': "var(--ds-space-negative-075, -6px)",
    'space.negative.100': "var(--ds-space-negative-100, -8px)",
    'space.negative.150': "var(--ds-space-negative-150, -12px)",
    'space.negative.200': "var(--ds-space-negative-200, -16px)",
    'space.negative.250': "var(--ds-space-negative-250, -20px)",
    'space.negative.300': "var(--ds-space-negative-300, -24px)",
    'space.negative.400': "var(--ds-space-negative-400, -32px)"
};
const $7ffcfa47820ec2af$export$632685d741f3dbbf = {
    ...$7ffcfa47820ec2af$export$958d0ae7f2977ae4,
    ...$7ffcfa47820ec2af$export$d2dc61f58390201c
};
const $7ffcfa47820ec2af$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
const $7ffcfa47820ec2af$export$daf94a976c798b4f = {
    'opacity.disabled': "var(--ds-opacity-disabled, 0.4)",
    'opacity.loading': "var(--ds-opacity-loading, 0.2)"
};
const $7ffcfa47820ec2af$export$7aff6e7ba39bb774 = {
    'elevation.shadow.overflow': "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.overflow.perimeter': "var(--ds-shadow-overflow-perimeter, #091e421f)",
    'elevation.shadow.overflow.spread': "var(--ds-shadow-overflow-spread, #091e4229)",
    'elevation.shadow.overlay': "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.raised': "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
const $7ffcfa47820ec2af$export$41a358c9c2356760 = {
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)"
};
const $7ffcfa47820ec2af$export$1531ad5bb3fbedac = {
    'color.border': "var(--ds-border, #091e4221)",
    'color.border.accent.lime': "var(--ds-border-accent-lime, #6A9A23)",
    'color.border.accent.red': "var(--ds-border-accent-red, #FF5630)",
    'color.border.accent.orange': "var(--ds-border-accent-orange, #D94008)",
    'color.border.accent.yellow': "var(--ds-border-accent-yellow, #FFAB00)",
    'color.border.accent.green': "var(--ds-border-accent-green, #36B37E)",
    'color.border.accent.teal': "var(--ds-border-accent-teal, #00B8D9)",
    'color.border.accent.blue': "var(--ds-border-accent-blue, #0065FF)",
    'color.border.accent.purple': "var(--ds-border-accent-purple, #6554C0)",
    'color.border.accent.magenta': "var(--ds-border-accent-magenta, #CD519D)",
    'color.border.accent.gray': "var(--ds-border-accent-gray, #5E6C84)",
    'color.border.disabled': "var(--ds-border-disabled, #FAFBFC)",
    'color.border.focused': "var(--ds-border-focused, #2684FF)",
    'color.border.input': "var(--ds-border-input, #FAFBFC)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #0052CC)",
    'color.border.brand': "var(--ds-border-brand, #0052CC)",
    'color.border.danger': "var(--ds-border-danger, #FF5630)",
    'color.border.warning': "var(--ds-border-warning, #FFC400)",
    'color.border.success': "var(--ds-border-success, #00875A)",
    'color.border.discovery': "var(--ds-border-discovery, #998DD9)",
    'color.border.information': "var(--ds-border-information, #0065FF)",
    'color.border.bold': "var(--ds-border-bold, #344563)"
};
const $7ffcfa47820ec2af$export$d1d79bf68ac056bd = {
    'color.background.accent.lime.subtlest': "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    'color.background.accent.lime.subtlest.hovered': "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    'color.background.accent.lime.subtlest.pressed': "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    'color.background.accent.lime.subtler': "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    'color.background.accent.lime.subtler.hovered': "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    'color.background.accent.lime.subtler.pressed': "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    'color.background.accent.lime.subtle': "var(--ds-background-accent-lime-subtle, #94C748)",
    'color.background.accent.lime.subtle.hovered': "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    'color.background.accent.lime.subtle.pressed': "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    'color.background.accent.lime.bolder': "var(--ds-background-accent-lime-bolder, #5B7F24)",
    'color.background.accent.lime.bolder.hovered': "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    'color.background.accent.lime.bolder.pressed': "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    'color.background.accent.red.subtlest': "var(--ds-background-accent-red-subtlest, #FF8F73)",
    'color.background.accent.red.subtlest.hovered': "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    'color.background.accent.red.subtlest.pressed': "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    'color.background.accent.red.subtler': "var(--ds-background-accent-red-subtler, #FF7452)",
    'color.background.accent.red.subtler.hovered': "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    'color.background.accent.red.subtler.pressed': "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    'color.background.accent.red.subtle': "var(--ds-background-accent-red-subtle, #DE350B)",
    'color.background.accent.red.subtle.hovered': "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    'color.background.accent.red.subtle.pressed': "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    'color.background.accent.red.bolder': "var(--ds-background-accent-red-bolder, #DE350B)",
    'color.background.accent.red.bolder.hovered': "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    'color.background.accent.red.bolder.pressed': "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    'color.background.accent.orange.subtlest': "var(--ds-background-accent-orange-subtlest, #F18D13)",
    'color.background.accent.orange.subtlest.hovered': "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    'color.background.accent.orange.subtlest.pressed': "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    'color.background.accent.orange.subtler': "var(--ds-background-accent-orange-subtler, #B65C02)",
    'color.background.accent.orange.subtler.hovered': "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    'color.background.accent.orange.subtler.pressed': "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    'color.background.accent.orange.subtle': "var(--ds-background-accent-orange-subtle, #5F3811)",
    'color.background.accent.orange.subtle.hovered': "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    'color.background.accent.orange.subtle.pressed': "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    'color.background.accent.orange.bolder': "var(--ds-background-accent-orange-bolder, #43290F)",
    'color.background.accent.orange.bolder.hovered': "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    'color.background.accent.orange.bolder.pressed': "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    'color.background.accent.yellow.subtlest': "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    'color.background.accent.yellow.subtlest.hovered': "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    'color.background.accent.yellow.subtlest.pressed': "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    'color.background.accent.yellow.subtler': "var(--ds-background-accent-yellow-subtler, #FFC400)",
    'color.background.accent.yellow.subtler.hovered': "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    'color.background.accent.yellow.subtler.pressed': "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    'color.background.accent.yellow.subtle': "var(--ds-background-accent-yellow-subtle, #FF991F)",
    'color.background.accent.yellow.subtle.hovered': "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    'color.background.accent.yellow.subtle.pressed': "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    'color.background.accent.yellow.bolder': "var(--ds-background-accent-yellow-bolder, #FF991F)",
    'color.background.accent.yellow.bolder.hovered': "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    'color.background.accent.yellow.bolder.pressed': "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    'color.background.accent.green.subtlest': "var(--ds-background-accent-green-subtlest, #79F2C0)",
    'color.background.accent.green.subtlest.hovered': "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    'color.background.accent.green.subtlest.pressed': "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    'color.background.accent.green.subtler': "var(--ds-background-accent-green-subtler, #57D9A3)",
    'color.background.accent.green.subtler.hovered': "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    'color.background.accent.green.subtler.pressed': "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    'color.background.accent.green.subtle': "var(--ds-background-accent-green-subtle, #00875A)",
    'color.background.accent.green.subtle.hovered': "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    'color.background.accent.green.subtle.pressed': "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    'color.background.accent.green.bolder': "var(--ds-background-accent-green-bolder, #00875A)",
    'color.background.accent.green.bolder.hovered': "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    'color.background.accent.green.bolder.pressed': "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    'color.background.accent.teal.subtlest': "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    'color.background.accent.teal.subtlest.hovered': "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    'color.background.accent.teal.subtlest.pressed': "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    'color.background.accent.teal.subtler': "var(--ds-background-accent-teal-subtler, #00C7E6)",
    'color.background.accent.teal.subtler.hovered': "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    'color.background.accent.teal.subtler.pressed': "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    'color.background.accent.teal.subtle': "var(--ds-background-accent-teal-subtle, #00A3BF)",
    'color.background.accent.teal.subtle.hovered': "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    'color.background.accent.teal.subtle.pressed': "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    'color.background.accent.teal.bolder': "var(--ds-background-accent-teal-bolder, #00A3BF)",
    'color.background.accent.teal.bolder.hovered': "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    'color.background.accent.teal.bolder.pressed': "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    'color.background.accent.blue.subtlest': "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    'color.background.accent.blue.subtlest.hovered': "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    'color.background.accent.blue.subtlest.pressed': "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    'color.background.accent.blue.subtler': "var(--ds-background-accent-blue-subtler, #2684FF)",
    'color.background.accent.blue.subtler.hovered': "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    'color.background.accent.blue.subtler.pressed': "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    'color.background.accent.blue.subtle': "var(--ds-background-accent-blue-subtle, #0052CC)",
    'color.background.accent.blue.subtle.hovered': "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    'color.background.accent.blue.subtle.pressed': "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    'color.background.accent.blue.bolder': "var(--ds-background-accent-blue-bolder, #0052CC)",
    'color.background.accent.blue.bolder.hovered': "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    'color.background.accent.blue.bolder.pressed': "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    'color.background.accent.purple.subtlest': "var(--ds-background-accent-purple-subtlest, #998DD9)",
    'color.background.accent.purple.subtlest.hovered': "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    'color.background.accent.purple.subtlest.pressed': "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    'color.background.accent.purple.subtler': "var(--ds-background-accent-purple-subtler, #8777D9)",
    'color.background.accent.purple.subtler.hovered': "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    'color.background.accent.purple.subtler.pressed': "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    'color.background.accent.purple.subtle': "var(--ds-background-accent-purple-subtle, #5243AA)",
    'color.background.accent.purple.subtle.hovered': "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    'color.background.accent.purple.subtle.pressed': "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    'color.background.accent.purple.bolder': "var(--ds-background-accent-purple-bolder, #5243AA)",
    'color.background.accent.purple.bolder.hovered': "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    'color.background.accent.purple.bolder.pressed': "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    'color.background.accent.magenta.subtlest': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    'color.background.accent.magenta.subtlest.hovered': "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    'color.background.accent.magenta.subtlest.pressed': "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    'color.background.accent.magenta.subtler': "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    'color.background.accent.magenta.subtler.hovered': "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    'color.background.accent.magenta.subtler.pressed': "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    'color.background.accent.magenta.subtle': "var(--ds-background-accent-magenta-subtle, #E774BB)",
    'color.background.accent.magenta.subtle.hovered': "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    'color.background.accent.magenta.subtle.pressed': "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    'color.background.accent.magenta.bolder': "var(--ds-background-accent-magenta-bolder, #AE4787)",
    'color.background.accent.magenta.bolder.hovered': "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    'color.background.accent.magenta.bolder.pressed': "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    'color.background.accent.gray.subtlest': "var(--ds-background-accent-gray-subtlest, #6B778C)",
    'color.background.accent.gray.subtlest.hovered': "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    'color.background.accent.gray.subtlest.pressed': "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    'color.background.accent.gray.subtler': "var(--ds-background-accent-gray-subtler, #5E6C84)",
    'color.background.accent.gray.subtler.hovered': "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    'color.background.accent.gray.subtler.pressed': "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    'color.background.accent.gray.subtle': "var(--ds-background-accent-gray-subtle, #505F79)",
    'color.background.accent.gray.subtle.hovered': "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    'color.background.accent.gray.subtle.pressed': "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    'color.background.accent.gray.bolder': "var(--ds-background-accent-gray-bolder, #42526E)",
    'color.background.accent.gray.bolder.hovered': "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    'color.background.accent.gray.bolder.pressed': "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    'color.background.disabled': "var(--ds-background-disabled, #091e4289)",
    'color.background.input': "var(--ds-background-input, #FAFBFC)",
    'color.background.input.hovered': "var(--ds-background-input-hovered, #EBECF0)",
    'color.background.input.pressed': "var(--ds-background-input-pressed, #FFFFFF)",
    'color.background.inverse.subtle': "var(--ds-background-inverse-subtle, #00000029)",
    'color.background.inverse.subtle.hovered': "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    'color.background.inverse.subtle.pressed': "var(--ds-background-inverse-subtle-pressed, #00000052)",
    'color.background.neutral': "var(--ds-background-neutral, #DFE1E6)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #091e4214)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #B3D4FF)",
    'color.background.neutral.subtle': "var(--ds-background-neutral-subtle, transparent)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    'color.background.neutral.bold': "var(--ds-background-neutral-bold, #42526E)",
    'color.background.neutral.bold.hovered': "var(--ds-background-neutral-bold-hovered, #505F79)",
    'color.background.neutral.bold.pressed': "var(--ds-background-neutral-bold-pressed, #344563)",
    'color.background.selected': "var(--ds-background-selected, #DEEBFF)",
    'color.background.selected.hovered': "var(--ds-background-selected-hovered, #B3D4FF)",
    'color.background.selected.pressed': "var(--ds-background-selected-pressed, #4C9AFF)",
    'color.background.selected.bold': "var(--ds-background-selected-bold, #0052CC)",
    'color.background.selected.bold.hovered': "var(--ds-background-selected-bold-hovered, #2684FF)",
    'color.background.selected.bold.pressed': "var(--ds-background-selected-bold-pressed, #0052CC)",
    'color.background.brand.subtlest': "var(--ds-background-brand-subtlest, #B3D4FF)",
    'color.background.brand.subtlest.hovered': "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    'color.background.brand.subtlest.pressed': "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    'color.background.brand.bold': "var(--ds-background-brand-bold, #0052CC)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #0065FF)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #0747A6)",
    'color.background.brand.boldest': "var(--ds-background-brand-boldest, #0747A6)",
    'color.background.brand.boldest.hovered': "var(--ds-background-brand-boldest-hovered, #0052CC)",
    'color.background.brand.boldest.pressed': "var(--ds-background-brand-boldest-pressed, #0747A6)",
    'color.background.danger': "var(--ds-background-danger, #FFEBE6)",
    'color.background.danger.hovered': "var(--ds-background-danger-hovered, #FFBDAD)",
    'color.background.danger.pressed': "var(--ds-background-danger-pressed, #FF8F73)",
    'color.background.danger.bold': "var(--ds-background-danger-bold, #DE350B)",
    'color.background.danger.bold.hovered': "var(--ds-background-danger-bold-hovered, #FF5630)",
    'color.background.danger.bold.pressed': "var(--ds-background-danger-bold-pressed, #BF2600)",
    'color.background.warning': "var(--ds-background-warning, #FFFAE6)",
    'color.background.warning.hovered': "var(--ds-background-warning-hovered, #FFF0B3)",
    'color.background.warning.pressed': "var(--ds-background-warning-pressed, #FFE380)",
    'color.background.warning.bold': "var(--ds-background-warning-bold, #FFAB00)",
    'color.background.warning.bold.hovered': "var(--ds-background-warning-bold-hovered, #FFC400)",
    'color.background.warning.bold.pressed': "var(--ds-background-warning-bold-pressed, #FF991F)",
    'color.background.success': "var(--ds-background-success, #E3FCEF)",
    'color.background.success.hovered': "var(--ds-background-success-hovered, #ABF5D1)",
    'color.background.success.pressed': "var(--ds-background-success-pressed, #79F2C0)",
    'color.background.success.bold': "var(--ds-background-success-bold, #00875A)",
    'color.background.success.bold.hovered': "var(--ds-background-success-bold-hovered, #57D9A3)",
    'color.background.success.bold.pressed': "var(--ds-background-success-bold-pressed, #00875A)",
    'color.background.discovery': "var(--ds-background-discovery, #EAE6FF)",
    'color.background.discovery.hovered': "var(--ds-background-discovery-hovered, #C0B6F2)",
    'color.background.discovery.pressed': "var(--ds-background-discovery-pressed, #998DD9)",
    'color.background.discovery.bold': "var(--ds-background-discovery-bold, #5243AA)",
    'color.background.discovery.bold.hovered': "var(--ds-background-discovery-bold-hovered, #8777D9)",
    'color.background.discovery.bold.pressed': "var(--ds-background-discovery-bold-pressed, #5243AA)",
    'color.background.information': "var(--ds-background-information, #DEEBFF)",
    'color.background.information.hovered': "var(--ds-background-information-hovered, #B3D4FF)",
    'color.background.information.pressed': "var(--ds-background-information-pressed, #4C9AFF)",
    'color.background.information.bold': "var(--ds-background-information-bold, #0052CC)",
    'color.background.information.bold.hovered': "var(--ds-background-information-bold-hovered, #2684FF)",
    'color.background.information.bold.pressed': "var(--ds-background-information-bold-pressed, #0052CC)",
    'color.blanket': "var(--ds-blanket, #091e4289)",
    'color.blanket.selected': "var(--ds-blanket-selected, #388BFF14)",
    'color.blanket.danger': "var(--ds-blanket-danger, #EF5C4814)",
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)",
    'utility.elevation.surface.current': "var(--ds-elevation-surface-current, #FFFFFF)"
};
const $7ffcfa47820ec2af$export$8473307aa00d6ea1 = {
    'color.text': "var(--ds-text, #172B4D)",
    'color.text.accent.lime': "var(--ds-text-accent-lime, #4C6B1F)",
    'color.text.accent.lime.bolder': "var(--ds-text-accent-lime-bolder, #37471F)",
    'color.text.accent.red': "var(--ds-text-accent-red, #DE350B)",
    'color.text.accent.red.bolder': "var(--ds-text-accent-red-bolder, #BF2600)",
    'color.text.accent.orange': "var(--ds-text-accent-orange, #F18D13)",
    'color.text.accent.orange.bolder': "var(--ds-text-accent-orange-bolder, #B65C02)",
    'color.text.accent.yellow': "var(--ds-text-accent-yellow, #FF991F)",
    'color.text.accent.yellow.bolder': "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    'color.text.accent.green': "var(--ds-text-accent-green, #00875A)",
    'color.text.accent.green.bolder': "var(--ds-text-accent-green-bolder, #006644)",
    'color.text.accent.teal': "var(--ds-text-accent-teal, #00A3BF)",
    'color.text.accent.teal.bolder': "var(--ds-text-accent-teal-bolder, #008DA6)",
    'color.text.accent.blue': "var(--ds-text-accent-blue, #0052CC)",
    'color.text.accent.blue.bolder': "var(--ds-text-accent-blue-bolder, #0747A6)",
    'color.text.accent.purple': "var(--ds-text-accent-purple, #5243AA)",
    'color.text.accent.purple.bolder': "var(--ds-text-accent-purple-bolder, #403294)",
    'color.text.accent.magenta': "var(--ds-text-accent-magenta, #E774BB)",
    'color.text.accent.magenta.bolder': "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    'color.text.accent.gray': "var(--ds-text-accent-gray, #505F79)",
    'color.text.accent.gray.bolder': "var(--ds-text-accent-gray-bolder, #172B4D)",
    'color.text.disabled': "var(--ds-text-disabled, #A5ADBA)",
    'color.text.inverse': "var(--ds-text-inverse, #FFFFFF)",
    'color.text.selected': "var(--ds-text-selected, #0052CC)",
    'color.text.brand': "var(--ds-text-brand, #0065FF)",
    'color.text.danger': "var(--ds-text-danger, #DE350B)",
    'color.text.warning': "var(--ds-text-warning, #974F0C)",
    'color.text.warning.inverse': "var(--ds-text-warning-inverse, #172B4D)",
    'color.text.success': "var(--ds-text-success, #006644)",
    'color.text.discovery': "var(--ds-text-discovery, #403294)",
    'color.text.information': "var(--ds-text-information, #0052CC)",
    'color.text.subtlest': "var(--ds-text-subtlest, #7A869A)",
    'color.text.subtle': "var(--ds-text-subtle, #42526E)",
    'color.link': "var(--ds-link, #0052CC)",
    'color.link.pressed': "var(--ds-link-pressed, #0747A6)",
    'color.link.visited': "var(--ds-link-visited, #403294)",
    'color.link.visited.pressed': "var(--ds-link-visited-pressed, #403294)"
};
const $7ffcfa47820ec2af$export$498780f74be9af68 = {
    'color.icon': "var(--ds-icon, #505F79)",
    'color.icon.accent.lime': "var(--ds-icon-accent-lime, #6A9A23)",
    'color.icon.accent.red': "var(--ds-icon-accent-red, #FF5630)",
    'color.icon.accent.orange': "var(--ds-icon-accent-orange, #D94008)",
    'color.icon.accent.yellow': "var(--ds-icon-accent-yellow, #FFAB00)",
    'color.icon.accent.green': "var(--ds-icon-accent-green, #36B37E)",
    'color.icon.accent.teal': "var(--ds-icon-accent-teal, #00B8D9)",
    'color.icon.accent.blue': "var(--ds-icon-accent-blue, #0065FF)",
    'color.icon.accent.purple': "var(--ds-icon-accent-purple, #6554C0)",
    'color.icon.accent.magenta': "var(--ds-icon-accent-magenta, #CD519D)",
    'color.icon.accent.gray': "var(--ds-icon-accent-gray, #5E6C84)",
    'color.icon.disabled': "var(--ds-icon-disabled, #8993A4)",
    'color.icon.inverse': "var(--ds-icon-inverse, #FFFFFF)",
    'color.icon.selected': "var(--ds-icon-selected, #0052CC)",
    'color.icon.brand': "var(--ds-icon-brand, #0065FF)",
    'color.icon.danger': "var(--ds-icon-danger, #DE350B)",
    'color.icon.warning': "var(--ds-icon-warning, #FFC400)",
    'color.icon.warning.inverse': "var(--ds-icon-warning-inverse, #253858)",
    'color.icon.success': "var(--ds-icon-success, #00875A)",
    'color.icon.discovery': "var(--ds-icon-discovery, #8777D9)",
    'color.icon.information': "var(--ds-icon-information, #0747A6)",
    'color.icon.subtle': "var(--ds-icon-subtle, #6B778C)"
};
const $7ffcfa47820ec2af$export$b5f31a7e431d2eab = {
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
const $7ffcfa47820ec2af$export$e1b83c5210c471b8 = {
    'border.width': "var(--ds-border-width, 1px)",
    'border.width.0': "var(--ds-border-width-0, 0px)",
    'border.width.indicator': "var(--ds-border-width-indicator, 3px)",
    'border.width.outline': "var(--ds-border-width-outline, 2px)"
};
const $7ffcfa47820ec2af$export$3c0a6c3e64bb180d = {
    'border.radius.050': "var(--ds-border-radius-050, 2px)",
    'border.radius': "var(--ds-border-radius, 3px)",
    'border.radius.100': "var(--ds-border-radius-100, 3px)",
    'border.radius.200': "var(--ds-border-radius-200, 8px)",
    'border.radius.300': "var(--ds-border-radius-300, 12px)",
    'border.radius.400': "var(--ds-border-radius-400, 16px)",
    'border.radius.circle': "var(--ds-border-radius-circle, 32032px)"
};
const $7ffcfa47820ec2af$export$6cc560b4dedf3816 = {
    medium: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    UNSAFE_small: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    large: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
const $7ffcfa47820ec2af$export$303e322c6b1ed114 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
const $7ffcfa47820ec2af$export$3c7e9587132614b4 = {
    'font.family.brand.body': "var(--ds-font-family-brand-body, \"Charlie Text\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.heading': "var(--ds-font-family-brand-heading, \"Charlie Display\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
/**
 * @codegenEnd
 */ // Generate maps for Box props. backgroundColor, padding, etc
const $7ffcfa47820ec2af$var$spacingProperties = [
    // Used by Box
    'padding',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    // Used by Inline and Stack
    'gap',
    'rowGap',
    'columnGap'
];
const $7ffcfa47820ec2af$var$getSerializedStylesMap = (cssProperty, tokenMap)=>{
    return Object.keys(tokenMap).reduce((emotionSpacingMap, token)=>{
        emotionSpacingMap[token] = (0, $byn9U.css)({
            [cssProperty]: tokenMap[token]
        });
        return emotionSpacingMap;
    }, {});
};
const $7ffcfa47820ec2af$export$e615f061ca585a6c = $7ffcfa47820ec2af$var$spacingProperties.reduce((styleMap, spacingProperty)=>{
    styleMap[spacingProperty] = $7ffcfa47820ec2af$var$getSerializedStylesMap(spacingProperty, $7ffcfa47820ec2af$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
const $7ffcfa47820ec2af$export$bf46c3f9eeafc71f = $7ffcfa47820ec2af$var$spacingProperties.reduce((styleMap, spacingProperty)=>{
    styleMap[spacingProperty] = $7ffcfa47820ec2af$var$getSerializedStylesMap(spacingProperty, $7ffcfa47820ec2af$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
const $7ffcfa47820ec2af$export$e7af83bafe7f9e63 = $7ffcfa47820ec2af$var$getSerializedStylesMap('backgroundColor', $7ffcfa47820ec2af$export$d1d79bf68ac056bd);
const $7ffcfa47820ec2af$export$3a1bcba60b23d7f0 = $7ffcfa47820ec2af$var$getSerializedStylesMap('color', $7ffcfa47820ec2af$export$8473307aa00d6ea1);
const $7ffcfa47820ec2af$export$45f3f4fe16f9f7d5 = $7ffcfa47820ec2af$var$getSerializedStylesMap('fontWeight', $7ffcfa47820ec2af$export$303e322c6b1ed114);
const $7ffcfa47820ec2af$export$68cc305da27dbaa4 = $7ffcfa47820ec2af$var$getSerializedStylesMap('fontFamily', $7ffcfa47820ec2af$export$3c7e9587132614b4);
const $7ffcfa47820ec2af$export$128f10c238242f83 = $7ffcfa47820ec2af$var$getSerializedStylesMap('font', $7ffcfa47820ec2af$export$6cc560b4dedf3816);
const $7ffcfa47820ec2af$export$ff257d957d48c421 = $7ffcfa47820ec2af$var$getSerializedStylesMap((0, $kyri3.CURRENT_SURFACE_CSS_VAR), $7ffcfa47820ec2af$export$41a358c9c2356760);
const $7ffcfa47820ec2af$export$5e65a44e5b6ecadb = (color)=>$7ffcfa47820ec2af$export$41a358c9c2356760[color] !== undefined;

});

parcelRegister("leyMq", function(module, exports) {

$parcel$export(module.exports, "parseXcss", () => $f755e26639251cf7$export$a9c84988c8f81f2d);
$parcel$export(module.exports, "xcss", () => $f755e26639251cf7$export$f6c783d06584602c);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $byn9U = parcelRequire("byn9U");

var $aZhfd = parcelRequire("aZhfd");

var $2fFJv = parcelRequire("2fFJv");
const $f755e26639251cf7$export$9a199fbafee0014e = {
    backgroundColor: (0, $aZhfd.backgroundColorMap),
    blockSize: (0, $aZhfd.dimensionMap),
    borderBlockColor: (0, $aZhfd.borderColorMap),
    borderBlockEndColor: (0, $aZhfd.borderColorMap),
    borderBlockEndWidth: (0, $aZhfd.borderWidthMap),
    borderBlockStartColor: (0, $aZhfd.borderColorMap),
    borderBlockStartWidth: (0, $aZhfd.borderWidthMap),
    borderBlockWidth: (0, $aZhfd.borderWidthMap),
    borderBottomColor: (0, $aZhfd.borderColorMap),
    borderBottomLeftRadius: (0, $aZhfd.borderRadiusMap),
    borderBottomRightRadius: (0, $aZhfd.borderRadiusMap),
    borderBottomWidth: (0, $aZhfd.borderWidthMap),
    borderColor: (0, $aZhfd.borderColorMap),
    borderEndEndRadius: (0, $aZhfd.borderRadiusMap),
    borderEndStartRadius: (0, $aZhfd.borderRadiusMap),
    borderInlineColor: (0, $aZhfd.borderColorMap),
    borderInlineEndColor: (0, $aZhfd.borderColorMap),
    borderInlineEndWidth: (0, $aZhfd.borderWidthMap),
    borderInlineStartColor: (0, $aZhfd.borderColorMap),
    borderInlineStartWidth: (0, $aZhfd.borderWidthMap),
    borderInlineWidth: (0, $aZhfd.borderWidthMap),
    borderLeftColor: (0, $aZhfd.borderColorMap),
    borderLeftWidth: (0, $aZhfd.borderWidthMap),
    borderRadius: (0, $aZhfd.borderRadiusMap),
    borderRightColor: (0, $aZhfd.borderColorMap),
    borderRightWidth: (0, $aZhfd.borderWidthMap),
    borderStartEndRadius: (0, $aZhfd.borderRadiusMap),
    borderStartStartRadius: (0, $aZhfd.borderRadiusMap),
    borderTopColor: (0, $aZhfd.borderColorMap),
    borderTopLeftRadius: (0, $aZhfd.borderRadiusMap),
    borderTopRightRadius: (0, $aZhfd.borderRadiusMap),
    borderTopWidth: (0, $aZhfd.borderWidthMap),
    borderWidth: (0, $aZhfd.borderWidthMap),
    bottom: (0, $aZhfd.allSpaceMap),
    boxShadow: (0, $aZhfd.shadowMap),
    color: (0, $aZhfd.textColorMap),
    columnGap: (0, $aZhfd.positiveSpaceMap),
    gap: (0, $aZhfd.positiveSpaceMap),
    height: (0, $aZhfd.dimensionMap),
    inlineSize: (0, $aZhfd.dimensionMap),
    inset: (0, $aZhfd.allSpaceMap),
    insetBlock: (0, $aZhfd.allSpaceMap),
    insetBlockEnd: (0, $aZhfd.allSpaceMap),
    insetBlockStart: (0, $aZhfd.allSpaceMap),
    insetInline: (0, $aZhfd.allSpaceMap),
    insetInlineEnd: (0, $aZhfd.allSpaceMap),
    insetInlineStart: (0, $aZhfd.allSpaceMap),
    left: (0, $aZhfd.allSpaceMap),
    margin: (0, $aZhfd.allSpaceMap),
    marginBlock: (0, $aZhfd.allSpaceMap),
    marginBlockEnd: (0, $aZhfd.allSpaceMap),
    marginBlockStart: (0, $aZhfd.allSpaceMap),
    marginBottom: (0, $aZhfd.allSpaceMap),
    marginInline: (0, $aZhfd.allSpaceMap),
    marginInlineEnd: (0, $aZhfd.allSpaceMap),
    marginInlineStart: (0, $aZhfd.allSpaceMap),
    marginLeft: (0, $aZhfd.allSpaceMap),
    marginRight: (0, $aZhfd.allSpaceMap),
    marginTop: (0, $aZhfd.allSpaceMap),
    maxBlockSize: (0, $aZhfd.dimensionMap),
    maxHeight: (0, $aZhfd.dimensionMap),
    maxInlineSize: (0, $aZhfd.dimensionMap),
    maxWidth: (0, $aZhfd.dimensionMap),
    minBlockSize: (0, $aZhfd.dimensionMap),
    minHeight: (0, $aZhfd.dimensionMap),
    minInlineSize: (0, $aZhfd.dimensionMap),
    minWidth: (0, $aZhfd.dimensionMap),
    opacity: (0, $aZhfd.opacityMap),
    outlineColor: (0, $aZhfd.borderColorMap),
    outlineOffset: (0, $aZhfd.positiveSpaceMap),
    outlineWidth: (0, $aZhfd.borderWidthMap),
    padding: (0, $aZhfd.positiveSpaceMap),
    paddingBlock: (0, $aZhfd.positiveSpaceMap),
    paddingBlockEnd: (0, $aZhfd.positiveSpaceMap),
    paddingBlockStart: (0, $aZhfd.positiveSpaceMap),
    paddingBottom: (0, $aZhfd.positiveSpaceMap),
    paddingInline: (0, $aZhfd.positiveSpaceMap),
    paddingInlineEnd: (0, $aZhfd.positiveSpaceMap),
    paddingInlineStart: (0, $aZhfd.positiveSpaceMap),
    paddingLeft: (0, $aZhfd.positiveSpaceMap),
    paddingRight: (0, $aZhfd.positiveSpaceMap),
    paddingTop: (0, $aZhfd.positiveSpaceMap),
    right: (0, $aZhfd.allSpaceMap),
    rowGap: (0, $aZhfd.positiveSpaceMap),
    top: (0, $aZhfd.allSpaceMap),
    width: (0, $aZhfd.dimensionMap),
    zIndex: (0, $aZhfd.layerMap)
};
const $f755e26639251cf7$var$uniqueSymbol = Symbol('UNSAFE_INTERNAL_styles');
const $f755e26639251cf7$var$isSafeEnvToThrow = ()=>typeof $2fFJv === 'object' && typeof $2fFJv.env === 'object' && false;
const $f755e26639251cf7$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
const $f755e26639251cf7$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
const $f755e26639251cf7$var$transformStyles = (styleObj)=>{
    if (!styleObj || typeof styleObj !== 'object') return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map($f755e26639251cf7$var$transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(([key, value])=>{
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if (typeof value === 'object' && $f755e26639251cf7$var$safeSelectors.test(key)) {
            styleObj[key] = $f755e26639251cf7$var$transformStyles(value);
            return;
        }
        if ($f755e26639251cf7$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($f755e26639251cf7$var$reNestedSelectors.test(key)) throw new Error(`Styles not supported for key '${key}'.`);
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $f755e26639251cf7$export$9a199fbafee0014e)) return;
        const tokenValue = $f755e26639251cf7$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
const $f755e26639251cf7$var$baseXcss = (style)=>{
    const transformedStyles = $f755e26639251cf7$var$transformStyles(style);
    return {
        [$f755e26639251cf7$var$uniqueSymbol]: (0, $byn9U.css)(transformedStyles)
    };
};
const $f755e26639251cf7$export$a9c84988c8f81f2d = (args)=>{
    if (Array.isArray(args)) {
        const emotion = [];
        const staticArr = [];
        for (const arg of args){
            const result = $f755e26639251cf7$export$a9c84988c8f81f2d(arg);
            if (result.emotion) emotion.push(...result.emotion);
            if (result.static) staticArr.push(result.static);
        }
        return {
            emotion: emotion,
            static: staticArr.join(' ')
        };
    }
    const objArgs = args;
    const { [$f755e26639251cf7$var$uniqueSymbol]: styles } = objArgs || {};
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        const stringifiedArgs = `${args}`;
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $f755e26639251cf7$export$f6c783d06584602c(style) {
    return $f755e26639251cf7$var$baseXcss(style);
}

});

parcelRegister("2WeA4", function(module, exports) {

$parcel$export(module.exports, "SurfaceContext", () => $223c4ef986998e34$export$1ca2a26fecb070ae);
$parcel$export(module.exports, "useSurface", () => $223c4ef986998e34$export$1aeb4f6b93c4540d);

var $eUqFw = parcelRequire("eUqFw");
const $223c4ef986998e34$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $eUqFw.createContext)('elevation.surface');
const $223c4ef986998e34$export$1aeb4f6b93c4540d = ()=>{
    return (0, $eUqFw.useContext)($223c4ef986998e34$export$1ca2a26fecb070ae);
};
$223c4ef986998e34$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';

});


parcelRegister("lSK6X", function(module, exports) {

$parcel$export(module.exports, "default", () => $fee268d2dc3fa37c$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $aZhfd = parcelRequire("aZhfd");

var $leyMq = parcelRequire("leyMq");
const $fee268d2dc3fa37c$var$justifyContentMap = {
    start: (0, $byn9U.css)({
        justifyContent: 'start'
    }),
    center: (0, $byn9U.css)({
        justifyContent: 'center'
    }),
    end: (0, $byn9U.css)({
        justifyContent: 'end'
    }),
    'space-between': (0, $byn9U.css)({
        justifyContent: 'space-between'
    }),
    'space-around': (0, $byn9U.css)({
        justifyContent: 'space-around'
    }),
    'space-evenly': (0, $byn9U.css)({
        justifyContent: 'space-evenly'
    }),
    stretch: (0, $byn9U.css)({
        justifyContent: 'stretch'
    })
};
const $fee268d2dc3fa37c$var$flexDirectionMap = {
    column: (0, $byn9U.css)({
        flexDirection: 'column'
    }),
    row: (0, $byn9U.css)({
        flexDirection: 'row'
    })
};
const $fee268d2dc3fa37c$var$flexWrapMap = {
    wrap: (0, $byn9U.css)({
        flexWrap: 'wrap'
    }),
    nowrap: (0, $byn9U.css)({
        flexWrap: 'nowrap'
    })
};
const $fee268d2dc3fa37c$var$alignItemsMap = {
    start: (0, $byn9U.css)({
        alignItems: 'start'
    }),
    center: (0, $byn9U.css)({
        alignItems: 'center'
    }),
    baseline: (0, $byn9U.css)({
        alignItems: 'baseline'
    }),
    end: (0, $byn9U.css)({
        alignItems: 'end'
    }),
    stretch: (0, $byn9U.css)({
        alignItems: 'stretch'
    })
};
const $fee268d2dc3fa37c$var$baseStyles = (0, $byn9U.css)({
    display: 'flex',
    boxSizing: 'border-box'
});
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ const $fee268d2dc3fa37c$var$Flex = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: Component = 'div', role: role, alignItems: alignItems, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, testId: testId, direction: direction, wrap: wrap, xcss: xcss }, ref)=>{
    const resolvedStyles = (0, $leyMq.parseXcss)(xcss);
    return (0, $byn9U.jsx)(Component, {
        role: role,
        className: resolvedStyles.static,
        css: [
            $fee268d2dc3fa37c$var$baseStyles,
            gap && (0, $aZhfd.spaceStylesMap).gap[gap],
            columnGap && (0, $aZhfd.spaceStylesMap).columnGap[columnGap],
            rowGap && (0, $aZhfd.spaceStylesMap).rowGap[rowGap],
            alignItems && $fee268d2dc3fa37c$var$alignItemsMap[alignItems],
            direction && $fee268d2dc3fa37c$var$flexDirectionMap[direction],
            justifyContent && $fee268d2dc3fa37c$var$justifyContentMap[justifyContent],
            wrap && $fee268d2dc3fa37c$var$flexWrapMap[wrap],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            resolvedStyles.emotion
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$fee268d2dc3fa37c$var$Flex.displayName = 'Flex';
var $fee268d2dc3fa37c$export$2e2bcd8739ae039 = $fee268d2dc3fa37c$var$Flex;

});

parcelRegister("341Qr", function(module, exports) {

$parcel$export(module.exports, "default", () => $23b32d2f9f39626a$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/styles/no-exported-styles */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $leyMq = parcelRequire("leyMq");

var $lSK6X = parcelRequire("lSK6X");
const $23b32d2f9f39626a$var$flexGrowMap = {
    hug: (0, $leyMq.xcss)({
        flexGrow: 0
    }),
    fill: (0, $leyMq.xcss)({
        width: '100%',
        flexGrow: 1
    })
};
/**
 * __Stack__
 *
 * Stack is a primitive component based on flexbox that manages the block layout of direct children.
 *
 * @example
 * ```tsx
 *  <Stack>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Stack>
 * ```
 *
 */ const $23b32d2f9f39626a$var$Stack = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: as, alignInline: alignItems, alignBlock: alignBlock = 'stretch', spread: spread, grow: grow, space: space, children: children, testId: testId, xcss: xcss, role: role }, ref)=>{
    const justifyContent = spread || alignBlock;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    const styles = grow ? [
        $23b32d2f9f39626a$var$flexGrowMap[grow],
        ...Array.isArray(xcss) ? xcss : [
            xcss
        ]
    ] : xcss;
    return (0, $byn9U.jsx)((0, $lSK6X.default), {
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: justifyContent,
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$23b32d2f9f39626a$var$Stack.displayName = 'Stack';
var $23b32d2f9f39626a$export$2e2bcd8739ae039 = $23b32d2f9f39626a$var$Stack;

});

parcelRegister("cnPHV", function(module, exports) {

$parcel$export(module.exports, "default", () => $47227269f9075bad$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $1ZAYh = parcelRequire("1ZAYh");
function $47227269f9075bad$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $47227269f9075bad$var$baseStyles = {
    name: "1khn195",
    styles: "box-sizing:border-box"
};
const $47227269f9075bad$var$blockBleedMap = {
    'space.025': {
        name: "9w2fxh",
        styles: "margin-block:var(--ds-space-negative-025, -0.125rem)"
    },
    'space.050': {
        name: "1qhe0y6",
        styles: "margin-block:var(--ds-space-negative-050, -0.25rem)"
    },
    'space.100': {
        name: "s0o2nz",
        styles: "margin-block:var(--ds-space-negative-100, -0.5rem)"
    },
    'space.150': {
        name: "151e4o3",
        styles: "margin-block:var(--ds-space-negative-150, -0.75rem)"
    },
    'space.200': {
        name: "16sn062",
        styles: "margin-block:var(--ds-space-negative-200, -1rem)"
    }
};
const $47227269f9075bad$var$inlineBleedMap = {
    'space.025': {
        name: "16oxh68",
        styles: "margin-inline:var(--ds-space-negative-025, -0.125rem)"
    },
    'space.050': {
        name: "tdc6fz",
        styles: "margin-inline:var(--ds-space-negative-050, -0.25rem)"
    },
    'space.100': {
        name: "crujrn",
        styles: "margin-inline:var(--ds-space-negative-100, -0.5rem)"
    },
    'space.150': {
        name: "y28d58",
        styles: "margin-inline:var(--ds-space-negative-150, -0.75rem)"
    },
    'space.200': {
        name: "1vfkteg",
        styles: "margin-inline:var(--ds-space-negative-200, -1rem)"
    }
};
/**
 * __Bleed__
 *
 * `Bleed` is a primitive layout component that controls negative whitespace.
 *
 * - [Examples](https://atlassian.design/components/primitives/bleed/examples)
 * - [Code](https://atlassian.design/components/primitives/bleed/code)
 */ const $47227269f9075bad$var$Bleed = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).memo(({ children: children, testId: testId, inline: inline, block: block, all: all, xcss: xcss })=>{
    const resolvedStyles = (0, $1ZAYh.parseXcss)(xcss);
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            $47227269f9075bad$var$baseStyles,
            (inline || all) && $47227269f9075bad$var$inlineBleedMap[inline || all],
            (block || all) && $47227269f9075bad$var$blockBleedMap[block || all],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }, children);
});
$47227269f9075bad$var$Bleed.displayName = 'Bleed';
var $47227269f9075bad$export$2e2bcd8739ae039 = $47227269f9075bad$var$Bleed;

});

parcelRegister("lV9rH", function(module, exports) {

$parcel$export(module.exports, "default", () => $08c9fdfb00b3c9dc$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $1Ivg5 = parcelRequire("1Ivg5");

var $5Q9wj = parcelRequire("5Q9wj");

var $XHGTv = parcelRequire("XHGTv");

var $PdmhA = parcelRequire("PdmhA");

var $73N4g = parcelRequire("73N4g");
function $08c9fdfb00b3c9dc$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $08c9fdfb00b3c9dc$var$skeletonStyles = /*#__PURE__*/ (0, $byn9U.css)({
    paddingBlock: "var(--ds-space-0, 0px)",
    paddingInline: "var(--ds-space-200, 16px)",
    '::after': {
        display: 'block',
        width: '30%',
        height: "var(--ds-space-100, 8px)",
        backgroundColor: `var(--ds-skeleton, ${(0, $PdmhA.N20A)})`,
        borderRadius: 100,
        content: '""'
    }
});
const $08c9fdfb00b3c9dc$var$defaultWidthStyles = {
    name: "me8tg7",
    styles: "::after{width:30%;}"
};
const $08c9fdfb00b3c9dc$var$customWidthStyles = {
    name: "ms0ivw",
    styles: "::after{width:var(--width);}"
};
/**
 * __Skeleton heading item__
 *
 * A skeleton heading item is used in place of a heading item when its contents it not ready.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/skeleton-heading-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $08c9fdfb00b3c9dc$var$SkeletonHeadingItem = ({ isShimmering: isShimmering = false, testId: testId, width: width, cssFn: cssFn = (0, $5Q9wj.default) })=>{
    (0, $1Ivg5.propDeprecationWarning)('', 'cssFn', cssFn !== (0, $5Q9wj.default), '' // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    const UNSAFE_overrides = (0, $XHGTv.getBooleanFF)('platform.design-system-team.unsafe-overrides-killswitch_c8j9m') ? undefined : /*#__PURE__*/ (0, $byn9U.css)(cssFn(undefined));
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $73N4g.default), {
        isShimmering: isShimmering
    }, ({ className: className })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                '--width': width
            },
            css: [
                $08c9fdfb00b3c9dc$var$skeletonStyles,
                width ? $08c9fdfb00b3c9dc$var$customWidthStyles : $08c9fdfb00b3c9dc$var$defaultWidthStyles,
                // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
                UNSAFE_overrides
            ],
            "data-ds--menu--skeleton-heading-item": true,
            "data-testid": testId
        }));
};
var $08c9fdfb00b3c9dc$export$2e2bcd8739ae039 = $08c9fdfb00b3c9dc$var$SkeletonHeadingItem;

});

parcelRegister("3VeBC", function(module, exports) {

$parcel$export(module.exports, "AtlassianNavigation", () => $da3cafce4e49cea8$export$f66ccb39f60980e5);
/** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $dcbVh = parcelRequire("dcbVh");

var $XHGTv = parcelRequire("XHGTv");

var $PdmhA = parcelRequire("PdmhA");


var $iMTf6 = parcelRequire("iMTf6");
var $g668r = parcelRequire("g668r");

var $gAfsE = parcelRequire("gAfsE");

var $8yw9O = parcelRequire("8yw9O");
function $da3cafce4e49cea8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $da3cafce4e49cea8$var$containerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    boxSizing: 'border-box',
    height: (0, $cbe92d4f348ad4dd$export$30fa7cc5f2690a43),
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexShrink: 0,
    borderBlockEnd: `1px solid ${`var(--ds-border, ${(0, $PdmhA.N30)})`}`,
    paddingInlineEnd: "var(--ds-space-150, 12px)",
    paddingInlineStart: "var(--ds-space-150, 12px)"
});
const $da3cafce4e49cea8$var$leftStyles = {
    name: "vtikxo",
    styles: "display:flex;min-width:0;height:inherit;align-items:center;flex-grow:1;& > *{flex-shrink:0;}"
};
const $da3cafce4e49cea8$var$rightStyles = {
    name: "1mwlrd6",
    styles: "display:flex;align-items:center;flex-shrink:0;& > *{flex-shrink:0;margin-inline-end:var(--ds-space-050, 4px);}"
};
const $da3cafce4e49cea8$var$noRightMarginStyles = {
    name: "1oo7nc3",
    styles: "margin-inline-end:0"
};
const $da3cafce4e49cea8$var$analyticsData = {
    attributes: {
        navigationLayer: 'global'
    },
    componentName: 'atlassianNavigation'
};
const $da3cafce4e49cea8$export$f66ccb39f60980e5 = (props)=>{
    const { label: label, primaryItems: primaryItems = [], renderAppSwitcher: AppSwitcher, renderCreate: create, renderHelp: Help, renderNotifications: Notifications, renderProductHome: ProductHome, renderProfile: Profile, renderSearch: Search, renderSignIn: SignIn, renderSettings: Settings, moreLabel: moreLabel = "\u2026", theme: theme = (0, $iMTf6.defaultTheme), testId: testId } = props;
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $g668r.ThemeProvider), {
        value: theme
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $dcbVh.NavigationAnalyticsContext), {
        data: $da3cafce4e49cea8$var$analyticsData
    }, /*#__PURE__*/ (0, $byn9U.jsx)("header", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: theme.mode.navigation,
        css: $da3cafce4e49cea8$var$containerStyles,
        "data-testid": testId && `${testId}-header`,
        role: "banner"
    }, /*#__PURE__*/ (0, $byn9U.jsx)("nav", {
        css: $da3cafce4e49cea8$var$leftStyles,
        "aria-label": label
    }, AppSwitcher && /*#__PURE__*/ (0, $byn9U.jsx)(AppSwitcher, null), ProductHome && /*#__PURE__*/ (0, $byn9U.jsx)(ProductHome, null), (0, $XHGTv.getBooleanFF)('platform.design-system-team.navigation-v2-no-jank_5yhbd') ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $8yw9O.PrimaryItemsContainer), {
        testId: testId,
        moreLabel: moreLabel,
        items: primaryItems,
        create: create,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        theme: theme
    }) : /*#__PURE__*/ (0, $byn9U.jsx)((0, $gAfsE.PrimaryItemsContainer), {
        testId: testId,
        moreLabel: moreLabel,
        items: primaryItems,
        create: create,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        theme: theme
    })), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $da3cafce4e49cea8$var$rightStyles,
        "data-testid": testId && `${testId}-secondary-actions`
    }, Search && /*#__PURE__*/ (0, $byn9U.jsx)(Search, null), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        role: "list",
        css: [
            $da3cafce4e49cea8$var$rightStyles,
            $da3cafce4e49cea8$var$noRightMarginStyles
        ]
    }, Notifications && /*#__PURE__*/ (0, $byn9U.jsx)(Notifications, null), Help && /*#__PURE__*/ (0, $byn9U.jsx)(Help, null), Settings && /*#__PURE__*/ (0, $byn9U.jsx)(Settings, null), SignIn && /*#__PURE__*/ (0, $byn9U.jsx)(SignIn, null), Profile && /*#__PURE__*/ (0, $byn9U.jsx)(Profile, null))))));
};
var $da3cafce4e49cea8$export$2e2bcd8739ae039 = $da3cafce4e49cea8$export$f66ccb39f60980e5;

});
const $cbe92d4f348ad4dd$export$30fa7cc5f2690a43 = 56;
const $cbe92d4f348ad4dd$export$4033a111ca79977d = 1280;
const $cbe92d4f348ad4dd$export$24ec62cee78b7042 = 1130;
const $cbe92d4f348ad4dd$export$d8bde68ac946124f = '--ds--ans--fbc';
const $cbe92d4f348ad4dd$export$73e44f54603a0964 = '--ds--ans--hbgc';
const $cbe92d4f348ad4dd$export$13f8aa8f663f4c99 = '--ds--ans--bgc';
const $cbe92d4f348ad4dd$export$d81606c1fc5119bc = '--ds--ans--c';
const $cbe92d4f348ad4dd$export$65f656ad520ea71 = '--ds--ans--bc';

parcelRegister("iMTf6", function(module, exports) {

$parcel$export(module.exports, "defaultTheme", () => $442823d140399238$export$164de7ab8df77ef0);

var $PdmhA = parcelRequire("PdmhA");

var $i6ige = parcelRequire("i6ige");

var $7slJv = parcelRequire("7slJv");
const $442823d140399238$export$eeee8619e1b91cb0 = (0, $7slJv.generateTheme)({
    name: (0, $i6ige.DEFAULT_THEME_NAME),
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    backgroundColor: (0, $PdmhA.N0),
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    highlightColor: (0, $PdmhA.B400)
});
const $442823d140399238$export$164de7ab8df77ef0 = $442823d140399238$export$eeee8619e1b91cb0;

});
parcelRegister("i6ige", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_THEME_NAME", () => $643b966426f86ee9$export$2491e13b198e597d);
$parcel$export(module.exports, "default", () => $643b966426f86ee9$export$2e2bcd8739ae039);

var $PdmhA = parcelRequire("PdmhA");

var $ldbAc = parcelRequire("ldbAc");
const $643b966426f86ee9$var$defaultTheme = {
    mode: {
        create: {
            active: {
                color: `var(--ds-text-inverse, ${(0, $PdmhA.N0)})`,
                backgroundColor: `var(--ds-background-brand-bold-pressed, ${(0, $ldbAc.hexToRGBA)((0, $PdmhA.B400), 0.8)})`,
                boxShadow: ''
            },
            default: {
                color: `var(--ds-text-inverse, ${(0, $PdmhA.N0)})`,
                backgroundColor: `var(--ds-background-brand-bold, ${(0, $PdmhA.B400)})`,
                boxShadow: ''
            },
            focus: {
                color: `var(--ds-text-inverse, ${(0, $PdmhA.N0)})`,
                backgroundColor: '',
                boxShadow: ''
            },
            hover: {
                color: `var(--ds-text-inverse, ${(0, $PdmhA.N0)})`,
                backgroundColor: `var(--ds-background-brand-bold-hovered, ${(0, $ldbAc.hexToRGBA)((0, $PdmhA.B400), 0.9)})`,
                boxShadow: ''
            },
            selected: {
                color: '',
                backgroundColor: '',
                boxShadow: ''
            }
        },
        iconButton: {
            active: {
                color: `var(--ds-text-subtle, ${(0, $PdmhA.B400)})`,
                backgroundColor: `var(--ds-background-neutral-pressed, ${(0, $ldbAc.hexToRGBA)((0, $PdmhA.B50), 0.6)})`,
                boxShadow: ''
            },
            default: {
                color: `var(--ds-text-subtle, ${(0, $PdmhA.N600)})`,
                backgroundColor: 'transparent',
                boxShadow: ''
            },
            focus: {
                color: `var(--ds-text-subtle, ${(0, $PdmhA.N600)})`,
                backgroundColor: '',
                boxShadow: ''
            },
            hover: {
                color: `var(--ds-text-subtle, ${(0, $PdmhA.B400)})`,
                backgroundColor: `var(--ds-background-neutral-hovered, ${(0, $ldbAc.hexToRGBA)((0, $PdmhA.B50), 0.9)})`,
                boxShadow: ''
            },
            selected: {
                color: `var(--ds-text-selected, ${(0, $PdmhA.B400)})`,
                backgroundColor: `var(--ds-background-selected, ${(0, $ldbAc.hexToRGBA)((0, $PdmhA.B50), 0.6)})`,
                boxShadow: ''
            },
            selectedHover: {
                color: `var(--ds-text-selected, ${(0, $PdmhA.B400)})`,
                backgroundColor: `var(--ds-background-selected-hovered, ${(0, $ldbAc.hexToRGBA)((0, $PdmhA.B50), 0.6)})`,
                boxShadow: ''
            }
        },
        navigation: {
            backgroundColor: `var(--ds-surface, ${(0, $PdmhA.N0)})`,
            color: `var(--ds-text-subtlest, ${(0, $PdmhA.N200)})`
        },
        productHome: {
            backgroundColor: `var(--ds-text-brand, ${(0, $PdmhA.B400)})`,
            color: `var(--ds-text, ${(0, $PdmhA.N700)})`,
            borderRight: `1px solid ${`var(--ds-border, ${(0, $ldbAc.hexToRGBA)((0, $PdmhA.N200), 0.3)})`}`,
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
            iconColor: '#357DE8' // TODO: replace with token after brand refresh
        },
        primaryButton: {
            active: {
                color: `var(--ds-text-subtle, ${(0, $PdmhA.B400)})`,
                backgroundColor: `var(--ds-background-neutral-pressed, ${(0, $ldbAc.hexToRGBA)((0, $PdmhA.B50), 0.7)})`,
                boxShadow: ''
            },
            default: {
                color: `var(--ds-text-subtle, ${(0, $PdmhA.N600)})`,
                backgroundColor: 'transparent',
                boxShadow: ''
            },
            focus: {
                color: `var(--ds-text-subtle, ${(0, $PdmhA.N600)})`,
                backgroundColor: '',
                boxShadow: ''
            },
            hover: {
                color: `var(--ds-text-subtle, ${(0, $PdmhA.B400)})`,
                backgroundColor: `var(--ds-background-neutral-hovered, ${(0, $ldbAc.hexToRGBA)((0, $PdmhA.B50), 0.9)})`,
                boxShadow: ''
            },
            selected: {
                color: `var(--ds-text-selected, ${(0, $PdmhA.B400)})`,
                backgroundColor: `var(--ds-background-selected, ${(0, $ldbAc.hexToRGBA)((0, $PdmhA.B50), 0.7)})`,
                boxShadow: '',
                borderColor: `var(--ds-border-selected, ${(0, $PdmhA.B400)})`
            },
            selectedHover: {
                color: `var(--ds-text-selected, ${(0, $PdmhA.B400)})`,
                backgroundColor: `var(--ds-background-selected-hovered, ${(0, $ldbAc.hexToRGBA)((0, $PdmhA.B50), 0.6)})`,
                boxShadow: '',
                borderColor: `var(--ds-border-selected, ${(0, $PdmhA.B400)})`
            }
        },
        search: {
            default: {
                backgroundColor: `var(--ds-background-input, ${(0, $PdmhA.N0)})`,
                color: `var(--ds-text-subtlest, ${(0, $PdmhA.N200)})`,
                borderColor: `var(--ds-border-input, ${(0, $PdmhA.N100)})`
            },
            focus: {
                borderColor: `var(--ds-border-focused, ${(0, $PdmhA.B200)})`
            },
            hover: {
                backgroundColor: `var(--ds-background-input-hovered, ${(0, $PdmhA.N0)})`
            }
        },
        skeleton: {
            backgroundColor: `var(--ds-background-neutral, ${(0, $PdmhA.N20)})`,
            opacity: 1
        }
    }
};
const $643b966426f86ee9$export$2491e13b198e597d = 'atlassian';
var $643b966426f86ee9$export$2e2bcd8739ae039 = $643b966426f86ee9$var$defaultTheme;

});
parcelRegister("ldbAc", function(module, exports) {

$parcel$export(module.exports, "hexToRGBA", () => $673b351980c7e420$export$7229be6d7219ee6a);
$parcel$export(module.exports, "getBoxShadow", () => $673b351980c7e420$export$bba5a971afe05444);
$parcel$export(module.exports, "generateTextColor", () => $673b351980c7e420$export$10a10e7cd1193377);
$parcel$export(module.exports, "getContrastColor", () => $673b351980c7e420$export$77a1051494882576);

var $taXj4 = parcelRequire("taXj4");
const $673b351980c7e420$export$7229be6d7219ee6a = (hex, opacity = 1)=>{
    const rgba = {
        ...(0, $taXj4.default).convert(hex).rgb,
        a: opacity
    };
    return `rgba(${Object.values(rgba).join(', ')})`;
};
const $673b351980c7e420$export$bba5a971afe05444 = (color)=>`0 0 0 2px ${color}`;
const $673b351980c7e420$var$hex = '[a-z0-9]';
const $673b351980c7e420$var$shortHandHexColorPattern = new RegExp(`#(${$673b351980c7e420$var$hex})(${$673b351980c7e420$var$hex})(${$673b351980c7e420$var$hex})`, 'i');
const $673b351980c7e420$var$repeat = (str, times)=>[
        ...Array(times)
    ].map(()=>str).join('');
const $673b351980c7e420$var$isShortHexColor = (color)=>color && color.length === 4;
const $673b351980c7e420$var$completeHexColor = (colors)=>{
    const hex = colors.map((color)=>$673b351980c7e420$var$repeat(color, 2)).join('');
    return `#${hex}`;
};
const $673b351980c7e420$var$completeTriplet = (colors)=>`#${$673b351980c7e420$var$repeat(colors[1], 6)}`;
const $673b351980c7e420$var$isTriplet = (colors)=>colors[0] === colors[1] && colors[1] === colors[2];
const $673b351980c7e420$export$db8d2130677f868c = (color)=>{
    if ($673b351980c7e420$var$isShortHexColor(color)) {
        // when color = '#ccc', matches is structured as ['#ccc', 'c', 'c', 'c', ...]
        const matches = color.match($673b351980c7e420$var$shortHandHexColorPattern);
        if (matches) {
            const colors = matches.slice(1, 4);
            if ($673b351980c7e420$var$isTriplet(colors)) return $673b351980c7e420$var$completeTriplet(colors);
            else return $673b351980c7e420$var$completeHexColor(colors);
        }
    }
    // return the color as is when it's not hex color shorthand
    return color;
};
const $673b351980c7e420$export$10a10e7cd1193377 = (color)=>{
    const converted = $673b351980c7e420$export$db8d2130677f868c(color);
    return (0, $taXj4.default).contrastRatio(converted).hex;
};
const $673b351980c7e420$export$77a1051494882576 = (contrastValue, opacityValue, color)=>$673b351980c7e420$export$7229be6d7219ee6a((0, $taXj4.default).contrast(contrastValue, color).hex, opacityValue);

});


parcelRegister("7slJv", function(module, exports) {

$parcel$export(module.exports, "generateTheme", () => $bd4aea7b5824a84d$export$2e4ecffaca289a18);

var $i6ige = parcelRequire("i6ige");

var $ldbAc = parcelRequire("ldbAc");
const $bd4aea7b5824a84d$var$generateOpacityValue = (color)=>color === '#000000' ? 0.3 : 0.6;
const $bd4aea7b5824a84d$var$generateButtonCSSStates = (colors, buttonType)=>{
    const { backgroundColor: backgroundColor, color: color, highlightColor: highlightColor } = colors;
    // Add less opacity for white text so it is still legible.
    const opacityValue = $bd4aea7b5824a84d$var$generateOpacityValue(color);
    const isCreateButton = buttonType === 'create';
    return {
        active: {
            backgroundColor: isCreateButton ? (0, $ldbAc.hexToRGBA)(backgroundColor, 0.65) : (0, $ldbAc.getContrastColor)(0.3, opacityValue, backgroundColor),
            boxShadow: (0, $ldbAc.getBoxShadow)('transparent'),
            color: color
        },
        default: {
            backgroundColor: backgroundColor,
            boxShadow: (0, $ldbAc.getBoxShadow)('transparent'),
            color: color
        },
        focus: {
            boxShadow: 'none',
            color: color,
            backgroundColor: backgroundColor
        },
        hover: {
            backgroundColor: isCreateButton ? (0, $ldbAc.hexToRGBA)(backgroundColor, 0.8) : (0, $ldbAc.getContrastColor)(0.1, opacityValue, backgroundColor),
            boxShadow: (0, $ldbAc.getBoxShadow)('transparent'),
            color: color
        },
        selected: {
            color: color,
            backgroundColor: (0, $ldbAc.getContrastColor)(0.3, opacityValue, backgroundColor),
            borderColor: highlightColor,
            boxShadow: (0, $ldbAc.getBoxShadow)('transparent')
        },
        selectedHover: {
            color: color,
            backgroundColor: (0, $ldbAc.getContrastColor)(0.3, opacityValue, backgroundColor),
            borderColor: highlightColor,
            boxShadow: (0, $ldbAc.getBoxShadow)('transparent')
        }
    };
};
const $bd4aea7b5824a84d$var$generateCreateButtonColors = (themeBackground, themeHighlight)=>({
        backgroundColor: themeHighlight,
        color: (0, $ldbAc.generateTextColor)(themeHighlight),
        highlightColor: themeHighlight
    });
const $bd4aea7b5824a84d$export$2e4ecffaca289a18 = (themeColors)=>{
    const { backgroundColor: backgroundColor, highlightColor: highlightColor, name: name } = themeColors;
    const color = (0, $ldbAc.generateTextColor)(backgroundColor);
    const colors = {
        ...themeColors,
        color: color
    };
    if (name === (0, $i6ige.DEFAULT_THEME_NAME)) return 0, $i6ige.default;
    return {
        mode: {
            create: $bd4aea7b5824a84d$var$generateButtonCSSStates($bd4aea7b5824a84d$var$generateCreateButtonColors(backgroundColor, highlightColor), 'create'),
            iconButton: $bd4aea7b5824a84d$var$generateButtonCSSStates(colors, 'iconButton'),
            primaryButton: $bd4aea7b5824a84d$var$generateButtonCSSStates(colors, 'primaryButton'),
            navigation: {
                backgroundColor: backgroundColor,
                color: color
            },
            productHome: {
                color: color,
                backgroundColor: highlightColor,
                borderRight: `1px solid ${(0, $ldbAc.hexToRGBA)(color, 0.5)}`
            },
            search: {
                default: {
                    backgroundColor: backgroundColor,
                    color: color,
                    borderColor: (0, $ldbAc.hexToRGBA)(color, 0.5)
                },
                focus: {
                    borderColor: (0, $ldbAc.hexToRGBA)(highlightColor, 0.8),
                    boxShadow: (0, $ldbAc.getBoxShadow)((0, $ldbAc.hexToRGBA)(highlightColor, 0.5))
                },
                hover: {
                    backgroundColor: (0, $ldbAc.getContrastColor)(0.1, $bd4aea7b5824a84d$var$generateOpacityValue(color), backgroundColor),
                    color: color
                }
            },
            skeleton: {
                backgroundColor: color,
                opacity: 0.08
            }
        }
    };
};
var $bd4aea7b5824a84d$export$2e2bcd8739ae039 = $bd4aea7b5824a84d$export$2e4ecffaca289a18;

});


parcelRegister("g668r", function(module, exports) {

$parcel$export(module.exports, "ThemeContext", () => $6bc18f940f437c27$export$2c657da244d00bd6);
$parcel$export(module.exports, "ThemeProvider", () => $6bc18f940f437c27$export$d8964aec282183a3);

var $eUqFw = parcelRequire("eUqFw");

var $iMTf6 = parcelRequire("iMTf6");
const $6bc18f940f437c27$export$2c657da244d00bd6 = /*#__PURE__*/ (0, $eUqFw.createContext)((0, $iMTf6.defaultTheme));
const $6bc18f940f437c27$export$d8964aec282183a3 = $6bc18f940f437c27$export$2c657da244d00bd6.Provider;

});

parcelRegister("gAfsE", function(module, exports) {

$parcel$export(module.exports, "PrimaryItemsContainer", () => $73c01b7a2db8a3a0$export$43e704064d596a9e);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $3MV1G = parcelRequire("3MV1G");

var $PdmhA = parcelRequire("PdmhA");

var $5qTKr = parcelRequire("5qTKr");

var $cTgSO = parcelRequire("cTgSO");

var $hTs14 = parcelRequire("hTs14");
function $73c01b7a2db8a3a0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $73c01b7a2db8a3a0$var$containerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    height: '100%',
    position: 'relative',
    alignItems: 'stretch',
    flexBasis: 0,
    flexGrow: 1,
    flexShrink: 0,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    '& > *': {
        margin: `0 ${"var(--ds-space-050, 4px)"}`,
        flexShrink: 0
    }
});
const $73c01b7a2db8a3a0$var$widthObserverContainerStyles = {
    name: "o1tvrz",
    styles: "width:100%;min-width:1px;margin:0px;position:relative;flex-shrink:1"
};
const $73c01b7a2db8a3a0$var$overflowItemsStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text, ${(0, $PdmhA.N700)})`
});
const $73c01b7a2db8a3a0$export$43e704064d596a9e = ({ moreLabel: moreLabel, items: items, create: Create, theme: theme, testId: testId })=>{
    const [isMoreOpen, setIsMoreOpen] = (0, $eUqFw.useState)(false);
    const { updateWidth: updateWidth, visibleItems: visibleItems, overflowItems: overflowItems } = (0, $cTgSO.useOverflowController)(items);
    const onMoreClick = (0, $eUqFw.useCallback)(()=>{
        setIsMoreOpen(!isMoreOpen);
    }, [
        isMoreOpen,
        setIsMoreOpen
    ]);
    const onMoreClose = (0, $eUqFw.useCallback)(()=>{
        setIsMoreOpen(false);
    }, []);
    const openOverflowMenu = (0, $eUqFw.useCallback)(()=>{
        setIsMoreOpen(true);
    }, []);
    const trigger = (0, $eUqFw.useCallback)((triggerProps)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $hTs14.PrimaryDropdownButton), {
            onClick: onMoreClick,
            isSelected: isMoreOpen,
            testId: testId ? `${testId}-overflow-menu-trigger` : 'overflow-menu-trigger',
            ...triggerProps
        }, moreLabel), [
        moreLabel,
        onMoreClick,
        isMoreOpen,
        testId
    ]);
    const content = (0, $eUqFw.useCallback)(()=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $cTgSO.OverflowProvider), {
            isVisible: false,
            openOverflowMenu: openOverflowMenu,
            closeOverflowMenu: onMoreClose
        }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: $73c01b7a2db8a3a0$var$overflowItemsStyles
        }, overflowItems)), // Overflow items has an unstable reference - so we will only recalculate
    // content if `overflowItems` length changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        overflowItems.length,
        openOverflowMenu,
        onMoreClose
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $73c01b7a2db8a3a0$var$containerStyles,
        "data-testid": testId && `${testId}-primary-actions`,
        role: "list"
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $cTgSO.OverflowProvider), {
        isVisible: true,
        openOverflowMenu: openOverflowMenu,
        closeOverflowMenu: onMoreClose
    }, visibleItems), overflowItems.length > 0 && /*#__PURE__*/ (0, $byn9U.jsx)((0, $3MV1G.default), {
        shouldRenderToParent: true,
        placement: "bottom-start",
        content: content,
        isOpen: isMoreOpen,
        onClose: onMoreClose,
        trigger: trigger,
        testId: testId ? `${testId}-overflow-menu-popup` : 'overflow-menu-popup'
    }), Create && /*#__PURE__*/ (0, $byn9U.jsx)(Create, null), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $73c01b7a2db8a3a0$var$widthObserverContainerStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $5qTKr.WidthObserver), {
        offscreen: true,
        setWidth: updateWidth
    })));
};

});
parcelRegister("cTgSO", function(module, exports) {

$parcel$export(module.exports, "OverflowProvider", () => $b860eec20ab2684d$export$a3a2def3937905a0);
$parcel$export(module.exports, "useOverflowStatus", () => $b860eec20ab2684d$export$3fcfc71fab3314f2);
$parcel$export(module.exports, "useOverflowController", () => $b860eec20ab2684d$export$705aa66a39c35bf7);

var $eUqFw = parcelRequire("eUqFw");

var $a576Y = parcelRequire("a576Y");

var $5Q9wj = parcelRequire("5Q9wj");
// Prevent width detector from triggering too many re-renders
const $b860eec20ab2684d$var$THROTTLE_INTERVAL = 64;
// Approx min width of items (based of "More" size)
const $b860eec20ab2684d$var$ITEM_APPROX_MINWIDTH = 70;
const $b860eec20ab2684d$var$calculateHash = (w, n)=>w + '#' + n;
const $b860eec20ab2684d$var$updateHashRef = (currentRef, value)=>{
    currentRef.unshift(value);
    currentRef.length = 3;
};
const $b860eec20ab2684d$var$OverflowContext = /*#__PURE__*/ (0, $eUqFw.createContext)({
    isVisible: true,
    openOverflowMenu: (0, $5Q9wj.default),
    closeOverflowMenu: (0, $5Q9wj.default)
});
const $b860eec20ab2684d$export$a3a2def3937905a0 = ({ children: children, isVisible: isVisible, openOverflowMenu: openOverflowMenu, closeOverflowMenu: closeOverflowMenu })=>{
    const { Provider: Provider } = $b860eec20ab2684d$var$OverflowContext;
    const value = (0, $eUqFw.useMemo)(()=>({
            isVisible: isVisible,
            openOverflowMenu: openOverflowMenu,
            closeOverflowMenu: closeOverflowMenu
        }), [
        isVisible,
        openOverflowMenu,
        closeOverflowMenu
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Provider, {
        value: value
    }, children);
};
const $b860eec20ab2684d$export$3fcfc71fab3314f2 = ()=>(0, $eUqFw.useContext)($b860eec20ab2684d$var$OverflowContext);
const $b860eec20ab2684d$export$705aa66a39c35bf7 = (nodes)=>{
    const items = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.toArray(nodes);
    const [width, setWidth] = (0, $eUqFw.useState)(9999);
    const [itemsLimit, setItemsLimit] = (0, $eUqFw.useState)(items.length);
    const [forceEffectValue, triggerForceEffect] = (0, $eUqFw.useState)({});
    // Storing items approximate width so we can try expanding when there is enough room
    const itemsWidths = (0, $eUqFw.useRef)([]).current;
    // Storing a couple of width + items count in order to stabilize
    const hashRef = (0, $eUqFw.useRef)([]);
    // AFP-2511 TODO: Fix automatic suppressions below
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const throttleSetWidth = (0, $eUqFw.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($a576Y)))(setWidth, $b860eec20ab2684d$var$THROTTLE_INTERVAL), [
        setWidth
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const lastItemWidth = itemsWidths[itemsLimit] || 0;
        const wasJustLimited = lastItemWidth < 0;
        const currentHash = $b860eec20ab2684d$var$calculateHash(width, itemsLimit);
        if (hashRef.current[0] === currentHash) {
            // After removing an item, if width has not changed yet we schedule a force update
            // to handle case where removing an item does not actually trigger width change
            const t = setTimeout(()=>{
                $b860eec20ab2684d$var$updateHashRef(hashRef.current, '');
                triggerForceEffect({});
            }, $b860eec20ab2684d$var$THROTTLE_INTERVAL * 1.5);
            return ()=>clearTimeout(t);
        }
        if (wasJustLimited) {
            // Width was updated either via resize or after changing the limit
            // we cap the width between ITEM_APPROX_MINWIDTH and 2*ITEM_APPROX_MINWIDTH
            // because width is throttled as when fast expanding/resizing partialWidth
            // will not be reliable (edge case)
            const partialWidth = Math.max(Math.min(width + lastItemWidth, $b860eec20ab2684d$var$ITEM_APPROX_MINWIDTH * 2), $b860eec20ab2684d$var$ITEM_APPROX_MINWIDTH);
            itemsWidths[itemsLimit] = partialWidth;
        }
        if (width < $b860eec20ab2684d$var$ITEM_APPROX_MINWIDTH * 0.9 && itemsLimit) {
            // If current width is less than an item approx width we remove an item
            // marking the width as negative so we will calculate it on width update
            // plus we set the hash to stabilise and not removing more than one element
            // until we are sure width was updated
            const nextHash = $b860eec20ab2684d$var$calculateHash(width, itemsLimit - 1);
            if (hashRef.current.indexOf(nextHash) === -1) {
                setItemsLimit(itemsLimit - 1);
                itemsWidths[itemsLimit - 1] = -(width || 1);
                $b860eec20ab2684d$var$updateHashRef(hashRef.current, nextHash);
            }
            return;
        }
        /**
		 * This is not necessarily equal to `lastItemWidth` because the
		 * ```js
		 * if (wasJustLimited) {}
		 * ```
		 * branch above modifies `itemsWidths`.
		 *
		 * Using `lastItemWidth` here can cause collapsing behavior to fail,
		 * such as the issue reported in DSP-7329.
		 */ const currentLastItemWidth = itemsWidths[itemsLimit] || 0;
        if (width - currentLastItemWidth > $b860eec20ab2684d$var$ITEM_APPROX_MINWIDTH * 1.1 && itemsLimit < items.length) {
            // If we have enough room to accomodate next item width we increase the limit
            // unless it has been recently removed
            const nextHash = $b860eec20ab2684d$var$calculateHash(width, itemsLimit + 1);
            if (hashRef.current.indexOf(nextHash) === -1) {
                setItemsLimit(itemsLimit + 1);
                $b860eec20ab2684d$var$updateHashRef(hashRef.current, nextHash);
            }
            return;
        }
    }, [
        width,
        hashRef,
        itemsLimit,
        itemsWidths,
        forceEffectValue,
        items.length
    ]);
    return {
        visibleItems: items.slice(0, itemsLimit),
        overflowItems: items.slice(itemsLimit),
        updateWidth: throttleSetWidth
    };
};
var // Used to extract props for useOverflowStatus();
// eslint-disable-next-line @repo/internal/react/use-noop
$b860eec20ab2684d$export$2e2bcd8739ae039 = (props)=>{};

});

parcelRegister("hTs14", function(module, exports) {

$parcel$export(module.exports, "PrimaryDropdownButton", () => $1cc932bd377d0f16$export$bb3af89fb196520d);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $86Ndv = parcelRequire("86Ndv");

var $cnPHV = parcelRequire("cnPHV");
var $1ZAYh = parcelRequire("1ZAYh");

var $dA9yl = parcelRequire("dA9yl");
const $1cc932bd377d0f16$var$chevronIconStylesWithSpacingFixStyles = (0, $1ZAYh.xcss)({
    marginInlineEnd: 'space.negative.050'
});
const $1cc932bd377d0f16$export$bb3af89fb196520d = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $dA9yl.PrimaryButton), {
        iconAfter: /*#__PURE__*/ (0, $byn9U.jsx)((0, $cnPHV.default), {
            xcss: $1cc932bd377d0f16$var$chevronIconStylesWithSpacingFixStyles,
            inline: "space.100"
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
            label: ""
        })),
        ref: ref,
        ...props
    });
});
var $1cc932bd377d0f16$export$2e2bcd8739ae039 = $1cc932bd377d0f16$export$bb3af89fb196520d;

});
parcelRegister("dA9yl", function(module, exports) {

$parcel$export(module.exports, "PrimaryButton", () => $217256b33c00b585$export$ac16a6a04d9b7c84);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $bbaTG = parcelRequire("bbaTG");

var $8cU5f = parcelRequire("8cU5f");

var $9JmWF = parcelRequire("9JmWF");

var $2FG3A = parcelRequire("2FG3A");
function $217256b33c00b585$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $217256b33c00b585$var$VAR_BUTTON_SELECTED_COLOR = '--button-selected-color';
const $217256b33c00b585$var$VAR_BUTTON_SELECTED_BORDER_COLOR = '--button-selected-border-color';
const $217256b33c00b585$var$buttonBaseStyles = {
    name: "8cx1fx",
    styles: "display:flex;height:100%;position:relative;align-items:center;justify-content:center;flex-direction:column"
};
const $217256b33c00b585$var$buttonHighlightedStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    '&& > *': {
        color: `var(${$217256b33c00b585$var$VAR_BUTTON_SELECTED_COLOR})`
    },
    '&:after': {
        height: 3,
        position: 'absolute',
        backgroundColor: `var(${$217256b33c00b585$var$VAR_BUTTON_SELECTED_BORDER_COLOR})`,
        borderStartEndRadius: "var(--ds-border-radius-050, 1px)",
        borderStartStartRadius: "var(--ds-border-radius-050, 1px)",
        content: '""',
        insetBlockEnd: 0,
        insetInlineEnd: "var(--ds-space-050, 4px)",
        insetInlineStart: "var(--ds-space-050, 4px)"
    }
});
const $217256b33c00b585$export$ac16a6a04d9b7c84 = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { children: children, testId: testId, tooltip: tooltip, isSelected: isSelected, isHighlighted: isHighlighted, ...buttonProps } = props;
    const theme = (0, $9JmWF.useTheme)();
    const button = /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            [$217256b33c00b585$var$VAR_BUTTON_SELECTED_COLOR]: theme.mode.primaryButton.selected.color,
            [$217256b33c00b585$var$VAR_BUTTON_SELECTED_BORDER_COLOR]: theme.mode.primaryButton.selected.borderColor
        },
        css: [
            $217256b33c00b585$var$buttonBaseStyles,
            isHighlighted && $217256b33c00b585$var$buttonHighlightedStyles
        ],
        role: "listitem"
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $bbaTG.default), {
        appearance: "primary",
        testId: testId,
        ref: ref,
        isSelected: isSelected,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        theme: (0, $2FG3A.getPrimaryButtonTheme)(theme),
        ...buttonProps
    }, children));
    if (tooltip) return /*#__PURE__*/ (0, $byn9U.jsx)((0, $8cU5f.default), {
        content: tooltip,
        hideTooltipOnClick: true
    }, button);
    return button;
});
var $217256b33c00b585$export$2e2bcd8739ae039 = $217256b33c00b585$export$ac16a6a04d9b7c84;

});
parcelRegister("9JmWF", function(module, exports) {

$parcel$export(module.exports, "useTheme", () => $154fed23e1052565$export$93d4e7f90805808f);

var $eUqFw = parcelRequire("eUqFw");

var $g668r = parcelRequire("g668r");
const $154fed23e1052565$export$93d4e7f90805808f = ()=>(0, $eUqFw.useContext)((0, $g668r.ThemeContext));

});

parcelRegister("2FG3A", function(module, exports) {

$parcel$export(module.exports, "getPrimaryButtonTheme", () => $60a6b0f596b8ed55$export$14dd6915caf431fe);
const $60a6b0f596b8ed55$export$14dd6915caf431fe = ({ mode: { primaryButton: primaryButton } })=>(current, props)=>{
        const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = current(props);
        return {
            buttonStyles: {
                ...buttonStyles,
                ...primaryButton.default,
                ...props.isSelected && primaryButton.selected,
                fontWeight: "var(--ds-font-weight-medium, 500)",
                padding: `0 ${"var(--ds-space-050, 4px)"}`,
                marginLeft: 0,
                marginRight: 0,
                ':hover': props.isSelected ? primaryButton.selectedHover : primaryButton.hover,
                ':focus': primaryButton.focus,
                // :active doesn't work in FF, because we do a
                // e.preventDefault() on mouse down in Button.
                // '&&' is required to add more CSS specificity
                // && it not a valid CSSObject property
                // @ts-ignore
                '&&': {
                    ...props.state === 'active' && primaryButton.active
                }
            },
            spinnerStyles: spinnerStyles
        };
    };

});




parcelRegister("8yw9O", function(module, exports) {

$parcel$export(module.exports, "PrimaryItemsContainer", () => $c873e6b515a01150$export$43e704064d596a9e);

var $eUqFw = parcelRequire("eUqFw");

var $3MV1G = parcelRequire("3MV1G");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1ZAYh = parcelRequire("1ZAYh");

var $4Ywu9 = parcelRequire("4Ywu9");
var $eT0WN = parcelRequire("eT0WN");

var $cTgSO = parcelRequire("cTgSO");

var $hTs14 = parcelRequire("hTs14");
const $c873e6b515a01150$var$containerWrapperStyles = (0, $1ZAYh.xcss)({
    height: '100%'
});
const $c873e6b515a01150$var$sharedContainerStyles = (0, $1ZAYh.xcss)({
    height: '100%',
    alignItems: 'stretch',
    paddingInlineEnd: 'space.050',
    gap: 'space.100'
});
const $c873e6b515a01150$var$smallContainerStyles = (0, $1ZAYh.xcss)({
    [(0, $4Ywu9.media).above.sm]: {
        display: 'none'
    }
});
const $c873e6b515a01150$var$mediumContainerStyles = (0, $1ZAYh.xcss)({
    display: 'none',
    [(0, $4Ywu9.media).above.sm]: {
        display: 'flex'
    },
    [(0, $4Ywu9.media).above.lg]: {
        display: 'none'
    }
});
const $c873e6b515a01150$var$largeContainerStyles = (0, $1ZAYh.xcss)({
    display: 'none',
    [(0, $4Ywu9.media).above.lg]: {
        display: 'flex'
    }
});
const $c873e6b515a01150$var$overflowItemsStyles = (0, $1ZAYh.xcss)({
    color: 'color.text'
});
const $c873e6b515a01150$var$MoreItemsPopup = ({ moreLabel: moreLabel, testId: testId, items: items })=>{
    const [isMoreOpen, setIsMoreOpen] = (0, $eUqFw.useState)(false);
    const onMoreClose = (0, $eUqFw.useCallback)(()=>setIsMoreOpen(false), []);
    const onMoreClick = (0, $eUqFw.useCallback)(()=>setIsMoreOpen((current)=>!current), []);
    const openOverflowMenu = (0, $eUqFw.useCallback)(()=>setIsMoreOpen(true), []);
    const trigger = (0, $eUqFw.useCallback)((triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hTs14.PrimaryDropdownButton), {
            onClick: onMoreClick,
            isSelected: isMoreOpen,
            testId: testId ? `${testId}-overflow-menu-trigger` : 'overflow-menu-trigger',
            ...triggerProps
        }, moreLabel), [
        moreLabel,
        onMoreClick,
        isMoreOpen,
        testId
    ]);
    const content = (0, $eUqFw.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cTgSO.OverflowProvider), {
            isVisible: false,
            openOverflowMenu: openOverflowMenu,
            closeOverflowMenu: onMoreClose
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $c873e6b515a01150$var$overflowItemsStyles
        }, items)), [
        items,
        openOverflowMenu,
        onMoreClose
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        shouldRenderToParent: true,
        placement: "bottom-start",
        isOpen: isMoreOpen,
        onClose: onMoreClose,
        trigger: trigger,
        content: content,
        testId: testId ? `${testId}-overflow-menu-popup` : 'overflow-menu-popup'
    });
};
const $c873e6b515a01150$export$43e704064d596a9e = /*#__PURE__*/ (0, $eUqFw.memo)(({ moreLabel: moreLabel, items: items, create: Create, theme: theme, testId: testId })=>{
    // We render a CSS media query based nav at first to handle SSR, then use
    // our useMediaQuery hook once we are hydrated so there is only one set of nav items
    const [isClient, setIsClient] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useEffect)(()=>{
        setIsClient(true);
    }, []);
    // Setting up our media queries to use once app is hydrated
    const mqSm = (0, $eT0WN.UNSAFE_useMediaQuery)('above.sm', (event)=>setIsAboveSm(event.matches));
    const [isAboveSm, setIsAboveSm] = (0, $eUqFw.useState)(mqSm?.matches);
    const mqLg = (0, $eT0WN.UNSAFE_useMediaQuery)('above.lg', (event)=>setIsAboveLg(event.matches));
    const [isAboveLg, setIsAboveLg] = (0, $eUqFw.useState)(mqLg?.matches);
    // Filter out any falsy items passed in
    const filteredItems = (0, $eUqFw.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.toArray(items).filter((item)=>!!item), [
        items
    ]);
    // NOTE: we could make these max items configurable in the future. For now
    // we are using sensible defaults. Anything over the max gets put in the
    // overflow menu for that screen size.
    // While it may be tempting to use more than 3 items for the medium nav when
    // you see the available space, you need to consider internationalistion.
    // 3 is the safe, defensive choice across many languages and scripts.
    const smallMaxItems = 0;
    const mediumMaxItems = 3;
    const largeMaxItems = 8;
    // We re-use this in both the CSS media query nav that loads in for SSR,
    // and the JS/hook media query nav that is used once hydrated
    const navItems = (0, $eUqFw.useMemo)(()=>{
        return {
            small: {
                navBarItems: [],
                overflowItems: filteredItems
            },
            medium: {
                navBarItems: filteredItems.slice(0, mediumMaxItems),
                overflowItems: filteredItems.slice(mediumMaxItems, filteredItems.length)
            },
            large: {
                navBarItems: filteredItems.slice(0, largeMaxItems),
                overflowItems: filteredItems.slice(largeMaxItems, filteredItems.length)
            }
        };
    }, [
        filteredItems
    ]);
    const hydratedNavItems = (0, $eUqFw.useMemo)(()=>{
        if (isAboveLg) return navItems.large;
        if (isAboveSm && !isAboveLg) return navItems.medium;
        return navItems.small;
    }, [
        isAboveLg,
        isAboveSm,
        navItems.large,
        navItems.medium,
        navItems.small
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, isClient ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        role: "list",
        xcss: $c873e6b515a01150$var$containerWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        testId: testId && `${testId}-primary-actions`,
        xcss: $c873e6b515a01150$var$sharedContainerStyles
    }, hydratedNavItems.navBarItems, hydratedNavItems.overflowItems.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c873e6b515a01150$var$MoreItemsPopup, {
        moreLabel: moreLabel,
        items: hydratedNavItems.overflowItems,
        testId: testId
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        role: "list",
        xcss: $c873e6b515a01150$var$containerWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        xcss: [
            $c873e6b515a01150$var$sharedContainerStyles,
            $c873e6b515a01150$var$smallContainerStyles
        ]
    }, filteredItems.length > smallMaxItems && // We don't need to pass items into popup, it won't be interactive (SSR only)
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c873e6b515a01150$var$MoreItemsPopup, {
        moreLabel: moreLabel,
        testId: testId
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        xcss: [
            $c873e6b515a01150$var$sharedContainerStyles,
            $c873e6b515a01150$var$mediumContainerStyles
        ]
    }, navItems.medium.navBarItems, navItems.medium.overflowItems.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c873e6b515a01150$var$MoreItemsPopup, {
        moreLabel: moreLabel,
        testId: testId
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        xcss: [
            $c873e6b515a01150$var$sharedContainerStyles,
            $c873e6b515a01150$var$largeContainerStyles
        ]
    }, navItems.large.navBarItems, navItems.large.overflowItems.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c873e6b515a01150$var$MoreItemsPopup, {
        moreLabel: moreLabel,
        testId: testId
    }))), Create && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Create, null));
});

});


parcelRegister("eYynb", function(module, exports) {

$parcel$export(module.exports, "AppSwitcher", () => $f4c8f2ec6ed8b3c5$export$9923361bd43fa030);

var $eUqFw = parcelRequire("eUqFw");

var $eLhcP = parcelRequire("eLhcP");

var $iMRBA = parcelRequire("iMRBA");
const $f4c8f2ec6ed8b3c5$export$9923361bd43fa030 = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { tooltip: tooltip, ...iconButtonProps } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iMRBA.IconButton), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eLhcP))), {
            label: typeof tooltip === 'string' ? tooltip : 'Appswitcher Icon'
        }),
        tooltip: tooltip,
        ref: ref,
        ...iconButtonProps
    });
});
var // exists only to extract props
// eslint-disable-next-line @repo/internal/react/use-noop
$f4c8f2ec6ed8b3c5$export$2e2bcd8739ae039 = (props)=>{};

});
parcelRegister("iMRBA", function(module, exports) {

$parcel$export(module.exports, "IconButton", () => $bfb303b126efaaf7$export$c25acd513dcc8062);

var $eUqFw = parcelRequire("eUqFw");

var $bbaTG = parcelRequire("bbaTG");

var $8cU5f = parcelRequire("8cU5f");

var $9JmWF = parcelRequire("9JmWF");

var $lvs6t = parcelRequire("lvs6t");
const $bfb303b126efaaf7$export$c25acd513dcc8062 = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { icon: icon, label: label, testId: testId, tooltip: tooltip, ...buttonProps } = props;
    const theme = (0, $9JmWF.useTheme)();
    const button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bbaTG.default), {
        appearance: "primary",
        "aria-label": label,
        testId: testId,
        iconBefore: icon,
        ref: ref,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        theme: (0, $lvs6t.getIconButtonTheme)(theme),
        ...buttonProps
    });
    if (tooltip) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: tooltip,
        hideTooltipOnClick: true
    }, button);
    return button;
});

});
parcelRegister("lvs6t", function(module, exports) {

$parcel$export(module.exports, "getIconButtonTheme", () => $e115731cfc5173be$export$f32bddcb857301f3);
const $e115731cfc5173be$export$f32bddcb857301f3 = ({ mode: { iconButton: iconButton } })=>(current, props)=>{
        const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = current(props);
        return {
            buttonStyles: {
                ...buttonStyles,
                borderRadius: "var(--ds-border-radius-circle, 100%)",
                display: 'flex',
                margin: `0 ${"var(--ds-space-025, 2px)"}`,
                // TODO Delete this comment after verifying space token -> previous value `4`
                padding: "var(--ds-space-050, 4px)",
                height: 'auto',
                fontWeight: "var(--ds-font-weight-medium, 500)",
                ...iconButton.default,
                ':hover': iconButton.hover,
                ':focus': iconButton.focus,
                // :active doesn't work in FF, because we do a
                // e.preventDefault() on mouse down in Button.
                // '&&' is required to add more CSS specificity
                // && it not a valid CSSObject property
                // @ts-ignore
                '&&': {
                    ...props.state === 'active' && iconButton.active
                },
                ...props.state === 'selected' && iconButton.selected,
                '> span': {
                    margin: 0
                }
            },
            spinnerStyles: spinnerStyles
        };
    };

});



parcelRegister("9KTWV", function(module, exports) {

$parcel$export(module.exports, "Notifications", () => $ce1123f26f884b7c$export$36ba2f559d49a8f6);

var $eUqFw = parcelRequire("eUqFw");

var $aLjrh = parcelRequire("aLjrh");

var $3aZfW = parcelRequire("3aZfW");

var $iMRBA = parcelRequire("iMRBA");
const $ce1123f26f884b7c$var$NOTIFICATIONS_BADGE_ID = 'atlassian-navigation-notification-count';
const $ce1123f26f884b7c$export$36ba2f559d49a8f6 = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { badge: badge, tooltip: tooltip, ...iconButtonProps } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3aZfW.BadgeContainer), {
        id: $ce1123f26f884b7c$var$NOTIFICATIONS_BADGE_ID,
        badge: badge,
        role: "listitem"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iMRBA.IconButton), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aLjrh))), {
            label: typeof tooltip === 'string' ? tooltip : 'Notification Icon'
        }),
        tooltip: tooltip,
        ref: ref,
        "aria-describedby": $ce1123f26f884b7c$var$NOTIFICATIONS_BADGE_ID,
        ...iconButtonProps
    }));
});
var $ce1123f26f884b7c$export$2e2bcd8739ae039 = $ce1123f26f884b7c$export$36ba2f559d49a8f6;

});
parcelRegister("3aZfW", function(module, exports) {

$parcel$export(module.exports, "BadgeContainer", () => $1e44b494a510a8f0$export$f710265eb5a003da);
/** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");
function $1e44b494a510a8f0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1e44b494a510a8f0$var$badgeContainerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    position: 'absolute',
    insetBlockStart: `${"var(--ds-space-negative-050, -4px)"}`,
    insetInlineEnd: `${"var(--ds-space-negative-025, -2px)"}`,
    pointerEvents: 'none'
});
const $1e44b494a510a8f0$var$containerStyles = {
    name: "bjn8wh",
    styles: "position:relative"
};
const $1e44b494a510a8f0$export$f710265eb5a003da = (props)=>{
    const { id: badgeId, badge: Badge, children: children, role: role } = props;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $1e44b494a510a8f0$var$containerStyles,
        role: role
    }, children, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $1e44b494a510a8f0$var$badgeContainerStyles,
        id: badgeId,
        "aria-hidden": true
    }, /*#__PURE__*/ (0, $byn9U.jsx)(Badge, null)));
};

});


parcelRegister("510qR", function(module, exports) {

$parcel$export(module.exports, "default", () => $870e46b317f6aa1b$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $XHGTv = parcelRequire("XHGTv");

var $PdmhA = parcelRequire("PdmhA");


var $9JmWF = parcelRequire("9JmWF");

var $9KvU8 = parcelRequire("9KvU8");
function $870e46b317f6aa1b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $870e46b317f6aa1b$var$VAR_PRODUCT_HOME_COLOR_ACTIVE = '--product-home-color-active';
const $870e46b317f6aa1b$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE = '--product-home-bg-color-active';
const $870e46b317f6aa1b$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE = '--product-home-box-shadow-active';
const $870e46b317f6aa1b$var$VAR_PRODUCT_HOME_COLOR_FOCUS = '--product-home-color-focus';
const $870e46b317f6aa1b$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS = '--product-home-bg-color-focus';
const $870e46b317f6aa1b$var$VAR_PRODUCT_HOME_BOX_SHADOW_FOCUS = '--product-home-box-shadow-focus';
const $870e46b317f6aa1b$var$VAR_PRODUCT_HOME_COLOR_HOVER = '--product-home-color-hover';
const $870e46b317f6aa1b$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER = '--product-home-bg-color-hover';
const $870e46b317f6aa1b$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER = '--product-home-box-shadow-hover';
const $870e46b317f6aa1b$var$productLogoStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // Ensure anything passed into
    // productHome is aligned correctly
    display: 'flex',
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    [`@media (max-width: ${(0, $cbe92d4f348ad4dd$export$4033a111ca79977d) - 0.1}px)`]: {
        display: 'none'
    }
});
const $870e46b317f6aa1b$var$customMaxHeightStyles = {
    name: "31vqaf",
    styles: "max-height:28px"
};
const $870e46b317f6aa1b$var$productIconStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // Ensure anything passed into
    // productHome is aligned correctly
    display: 'flex',
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    [`@media (min-width: ${0, $cbe92d4f348ad4dd$export$4033a111ca79977d}px)`]: {
        display: 'none'
    }
});
const $870e46b317f6aa1b$var$productHomeButtonStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    padding: "var(--ds-space-050, 4px)",
    alignItems: 'center',
    background: 'none',
    border: 0,
    borderRadius: "var(--ds-border-radius, 3px)",
    color: 'inherit',
    cursor: 'pointer',
    '&::-moz-focus-inner': {
        border: 0
    },
    '&:first-of-type': {
        marginInlineStart: 0
    },
    '&:hover': {
        backgroundColor: `var(${$870e46b317f6aa1b$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER})`,
        boxShadow: `var(${$870e46b317f6aa1b$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER})`,
        color: `var(${$870e46b317f6aa1b$var$VAR_PRODUCT_HOME_COLOR_HOVER})`
    },
    '&:active': {
        backgroundColor: `var(${$870e46b317f6aa1b$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE})`,
        boxShadow: `var(${$870e46b317f6aa1b$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE})`,
        color: `var(${$870e46b317f6aa1b$var$VAR_PRODUCT_HOME_COLOR_ACTIVE})`
    },
    '&:focus-visible': {
        backgroundColor: `var(${$870e46b317f6aa1b$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS})`,
        color: `var(${$870e46b317f6aa1b$var$VAR_PRODUCT_HOME_COLOR_FOCUS})`,
        outline: `2px solid ${`var(--ds-border-focused, ${(0, $PdmhA.B200)})`}`
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    'div&': {
        pointerEvents: 'none'
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    [`@media (max-width: ${(0, $cbe92d4f348ad4dd$export$4033a111ca79977d) - 0.1}px)`]: {
        margin: `0 ${"var(--ds-space-100, 8px)"}`
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    [`@media (min-width: ${0, $cbe92d4f348ad4dd$export$4033a111ca79977d}px)`]: {
        margin: `0 ${"var(--ds-space-200, 16px)"}`
    }
});
const $870e46b317f6aa1b$var$siteTitleStyles = {
    name: "1q75v0",
    styles: "display:flex;align-items:center;margin-inline-end:var(--ds-space-050, 4px);margin-inline-start:var(--ds-space-050, 4px);padding-inline-end:var(--ds-space-200, 16px)"
};
const $870e46b317f6aa1b$var$hideSiteTitleStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    [`@media (max-width: ${(0, $cbe92d4f348ad4dd$export$4033a111ca79977d) - 0.1}px)`]: {
        display: 'none'
    }
});
/**
 * __Custom product home__
 *
 * Use `CustomProductHome` to provide a custom logo and icon with URLs.
 *
 * - [Examples](https://atlassian.design/components/atlassian-navigation/examples#custom-product-home)
 * - [Code](https://atlassian.design/components/atlassian-navigation/code)
 */ const $870e46b317f6aa1b$var$CustomProductHome = (props)=>{
    const { iconAlt: iconAlt, iconUrl: iconUrl, logoAlt: logoAlt, logoUrl: logoUrl, href: href, onClick: onClick, siteTitle: siteTitle, onMouseDown: onMouseDown, testId: testId, logoMaxWidth: logoMaxWidth = 260, ...rest } = props;
    const theme = (0, $9JmWF.useTheme)();
    const primaryButton = theme.mode.primaryButton;
    const Tag = (0, $9KvU8.getTag)(onClick, href);
    const preventFocusRing = (event)=>{
        event.preventDefault();
        onMouseDown && onMouseDown(event);
    };
    const productHomeButtonDynamicStyles = {
        [$870e46b317f6aa1b$var$VAR_PRODUCT_HOME_COLOR_ACTIVE]: primaryButton.active.color,
        [$870e46b317f6aa1b$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE]: primaryButton.active.backgroundColor,
        [$870e46b317f6aa1b$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE]: primaryButton.active.boxShadow,
        [$870e46b317f6aa1b$var$VAR_PRODUCT_HOME_COLOR_FOCUS]: primaryButton.focus.color,
        [$870e46b317f6aa1b$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS]: primaryButton.focus.backgroundColor,
        [$870e46b317f6aa1b$var$VAR_PRODUCT_HOME_BOX_SHADOW_FOCUS]: primaryButton.focus.boxShadow,
        [$870e46b317f6aa1b$var$VAR_PRODUCT_HOME_COLOR_HOVER]: primaryButton.hover.color,
        [$870e46b317f6aa1b$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER]: primaryButton.hover.backgroundColor,
        [$870e46b317f6aa1b$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER]: primaryButton.hover.boxShadow
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, $byn9U.jsx)(Tag, {
        href: href,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: productHomeButtonDynamicStyles,
        css: $870e46b317f6aa1b$var$productHomeButtonStyles,
        onClick: onClick,
        onMouseDown: preventFocusRing,
        "data-testid": testId && `${testId}-container`,
        ...rest
    }, logoUrl && /*#__PURE__*/ (0, $byn9U.jsx)("img", {
        style: {
            maxWidth: logoMaxWidth
        },
        css: [
            $870e46b317f6aa1b$var$customMaxHeightStyles,
            $870e46b317f6aa1b$var$productLogoStyles
        ],
        src: logoUrl,
        alt: logoAlt,
        "data-testid": testId && `${testId}-logo`
    }), iconUrl && /*#__PURE__*/ (0, $byn9U.jsx)("img", {
        style: {
            maxWidth: logoMaxWidth
        },
        css: [
            $870e46b317f6aa1b$var$customMaxHeightStyles,
            $870e46b317f6aa1b$var$productIconStyles
        ],
        src: iconUrl,
        alt: iconAlt,
        "data-testid": testId && `${testId}-icon`
    })), siteTitle && /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            borderRight: theme.mode.productHome.borderRight
        },
        css: [
            $870e46b317f6aa1b$var$siteTitleStyles,
            (0, $XHGTv.getBooleanFF)('platform.design-system-team.navigation-v2-no-jank_5yhbd') && $870e46b317f6aa1b$var$hideSiteTitleStyles
        ],
        "data-testid": testId && `${testId}-site-title`
    }, siteTitle));
};
var $870e46b317f6aa1b$export$2e2bcd8739ae039 = $870e46b317f6aa1b$var$CustomProductHome;

});
parcelRegister("9KvU8", function(module, exports) {

$parcel$export(module.exports, "getTag", () => $911b89f4364332ea$export$dad497fe1f6e27c0);
const $911b89f4364332ea$export$dad497fe1f6e27c0 = (onClick, href)=>{
    if (href) return 'a';
    if (onClick) return 'button';
    return 'div';
};

});


parcelRegister("jHY0C", function(module, exports) {

$parcel$export(module.exports, "default", () => $904a0eb4f83abc9e$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $XHGTv = parcelRequire("XHGTv");


var $9JmWF = parcelRequire("9JmWF");

var $9KvU8 = parcelRequire("9KvU8");
function $904a0eb4f83abc9e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $904a0eb4f83abc9e$var$VAR_LOGO_MAX_WIDTH = '--logo-max-width';
const $904a0eb4f83abc9e$var$VAR_PRODUCT_HOME_COLOR_ACTIVE = '--product-home-color-active';
const $904a0eb4f83abc9e$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE = '--product-home-bg-color-active';
const $904a0eb4f83abc9e$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE = '--product-home-box-shadow-active';
const $904a0eb4f83abc9e$var$VAR_PRODUCT_HOME_COLOR_FOCUS = '--product-home-color-focus';
const $904a0eb4f83abc9e$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS = '--product-home-bg-color-focus';
const $904a0eb4f83abc9e$var$VAR_PRODUCT_HOME_BOX_SHADOW_FOCUS = '--product-home-box-shadow-focus';
const $904a0eb4f83abc9e$var$VAR_PRODUCT_HOME_COLOR_HOVER = '--product-home-color-hover';
const $904a0eb4f83abc9e$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER = '--product-home-bg-color-hover';
const $904a0eb4f83abc9e$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER = '--product-home-box-shadow-hover';
const $904a0eb4f83abc9e$var$productHomeButtonStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    padding: "var(--ds-space-050, 4px)",
    alignItems: 'center',
    background: 'none',
    border: 0,
    borderRadius: "var(--ds-border-radius, 3px)",
    color: 'inherit',
    cursor: 'pointer',
    '&::-moz-focus-inner': {
        border: 0
    },
    '&:first-of-type': {
        marginInlineStart: 0
    },
    '&:hover': {
        backgroundColor: `var(${$904a0eb4f83abc9e$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER})`,
        boxShadow: `var(${$904a0eb4f83abc9e$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER})`,
        color: `var(${$904a0eb4f83abc9e$var$VAR_PRODUCT_HOME_COLOR_HOVER})`
    },
    '&:active': {
        backgroundColor: `var(${$904a0eb4f83abc9e$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE})`,
        boxShadow: `var(${$904a0eb4f83abc9e$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE})`,
        color: `var(${$904a0eb4f83abc9e$var$VAR_PRODUCT_HOME_COLOR_ACTIVE})`
    },
    '&:focus-visible': {
        backgroundColor: `var(${$904a0eb4f83abc9e$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS})`,
        color: `var(${$904a0eb4f83abc9e$var$VAR_PRODUCT_HOME_COLOR_FOCUS})`,
        outline: `${"var(--ds-border-width-outline, 2px)"} solid ${"var(--ds-border-focused, #4C9AFF)"}`
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    'div&': {
        pointerEvents: 'none'
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    [`@media (max-width: ${(0, $cbe92d4f348ad4dd$export$4033a111ca79977d) - 0.1}px)`]: {
        margin: `0 ${"var(--ds-space-100, 8px)"}`
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    [`@media (min-width: ${0, $cbe92d4f348ad4dd$export$4033a111ca79977d}px)`]: {
        margin: `0 ${"var(--ds-space-200, 16px)"}`
    }
});
const $904a0eb4f83abc9e$var$productLogoStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // Ensure anything passed into
    // productHome is aligned correctly
    display: 'flex',
    maxWidth: `var(${$904a0eb4f83abc9e$var$VAR_LOGO_MAX_WIDTH})`,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    '& > *': {
        maxHeight: 24
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    '& > span > svg': {
        maxWidth: `var(${$904a0eb4f83abc9e$var$VAR_LOGO_MAX_WIDTH})`
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    [`@media (max-width: ${(0, $cbe92d4f348ad4dd$export$4033a111ca79977d) - 0.1}px)`]: {
        display: 'none'
    }
});
const $904a0eb4f83abc9e$var$customMaxHeightStyles = {
    name: "31vqaf",
    styles: "max-height:28px"
};
const $904a0eb4f83abc9e$var$productIconStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // Ensure anything passed into
    // productHome is aligned correctly
    display: 'flex',
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    '& > *': {
        maxHeight: 24
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    [`@media (min-width: ${0, $cbe92d4f348ad4dd$export$4033a111ca79977d}px)`]: {
        display: 'none'
    }
});
const $904a0eb4f83abc9e$var$siteTitleStyles = {
    name: "1q75v0",
    styles: "display:flex;align-items:center;margin-inline-end:var(--ds-space-050, 4px);margin-inline-start:var(--ds-space-050, 4px);padding-inline-end:var(--ds-space-200, 16px)"
};
// When cleaning up feature flag, these styles can be moved into the above block
const $904a0eb4f83abc9e$var$featureFlaggedSiteTitleStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // Under the FF, we've made the site title handle it's spacing, with the
    // PrimaryItemsContainer not needing to worry about its paddingInlineStart.
    // This makes it cleaner for the title styles to appear and disappear with mq's
    marginInlineEnd: "var(--ds-space-100, 8px)",
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    [`@media (max-width: ${(0, $cbe92d4f348ad4dd$export$4033a111ca79977d) - 0.1}px)`]: {
        display: 'none'
    }
});
/**
 * __Product home__
 *
 * The ProductHome component displays the product visual identity composed of:
 * logo, icon, and optional text. Values for logo and icon are never displayed
 * at the same time, where icon is used only when space is restricted. Should be
 * passed into `AtlassianNavigation`'s `renderProductHome` prop.
 *
 * - [Examples](https://atlassian.design/components/atlassian-navigation/examples#product-home)
 * - [Code](https://atlassian.design/components/atlassian-navigation/code)
 */ const $904a0eb4f83abc9e$var$ProductHome = ({ icon: Icon, logo: Logo, siteTitle: siteTitle, onClick: onClick, href: href, onMouseDown: onMouseDown, testId: testId, logoMaxWidth: logoMaxWidth = 260, ...rest })=>{
    const theme = (0, $9JmWF.useTheme)();
    const primaryButton = theme.mode.primaryButton;
    const { iconColor: iconColor = 'inherit', textColor: textColor = theme.mode.productHome.color } = theme.mode.productHome;
    const Tag = (0, $9KvU8.getTag)(onClick, href);
    const preventFocusRing = (e)=>{
        e.preventDefault();
        onMouseDown && onMouseDown(e);
    };
    const productHomeButtonDynamicStyles = {
        [$904a0eb4f83abc9e$var$VAR_PRODUCT_HOME_COLOR_ACTIVE]: primaryButton.active.color,
        [$904a0eb4f83abc9e$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE]: primaryButton.active.backgroundColor,
        [$904a0eb4f83abc9e$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE]: primaryButton.active.boxShadow,
        [$904a0eb4f83abc9e$var$VAR_PRODUCT_HOME_COLOR_FOCUS]: primaryButton.focus.color,
        [$904a0eb4f83abc9e$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS]: primaryButton.focus.backgroundColor,
        [$904a0eb4f83abc9e$var$VAR_PRODUCT_HOME_BOX_SHADOW_FOCUS]: primaryButton.focus.boxShadow,
        [$904a0eb4f83abc9e$var$VAR_PRODUCT_HOME_COLOR_HOVER]: primaryButton.hover.color,
        [$904a0eb4f83abc9e$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER]: primaryButton.hover.backgroundColor,
        [$904a0eb4f83abc9e$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER]: primaryButton.hover.boxShadow,
        [$904a0eb4f83abc9e$var$VAR_LOGO_MAX_WIDTH]: `${logoMaxWidth}px`
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, $byn9U.jsx)(Tag, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: productHomeButtonDynamicStyles,
        css: $904a0eb4f83abc9e$var$productHomeButtonStyles,
        href: href,
        onClick: onClick,
        onMouseDown: preventFocusRing,
        "data-testid": testId && `${testId}-container`,
        ...rest
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $904a0eb4f83abc9e$var$customMaxHeightStyles,
            $904a0eb4f83abc9e$var$productLogoStyles
        ],
        "data-testid": testId && `${testId}-logo`
    }, /*#__PURE__*/ (0, $byn9U.jsx)(Logo, {
        iconColor: iconColor,
        textColor: textColor
    })), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $904a0eb4f83abc9e$var$customMaxHeightStyles,
            $904a0eb4f83abc9e$var$productIconStyles
        ],
        "data-testid": testId && `${testId}-icon`
    }, /*#__PURE__*/ (0, $byn9U.jsx)(Icon, {
        iconColor: iconColor
    }))), siteTitle && /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            borderRight: theme.mode.productHome.borderRight
        },
        css: [
            $904a0eb4f83abc9e$var$siteTitleStyles,
            (0, $XHGTv.getBooleanFF)('platform.design-system-team.navigation-v2-no-jank_5yhbd') && $904a0eb4f83abc9e$var$featureFlaggedSiteTitleStyles
        ],
        "data-testid": testId && `${testId}-site-title`
    }, siteTitle));
};
var $904a0eb4f83abc9e$export$2e2bcd8739ae039 = $904a0eb4f83abc9e$var$ProductHome;

});

parcelRegister("fMzYK", function(module, exports) {

$parcel$export(module.exports, "Profile", () => $02b21e5144076119$export$5120f2d0b8d4cab8);

var $eUqFw = parcelRequire("eUqFw");

var $iMRBA = parcelRequire("iMRBA");
const $02b21e5144076119$export$5120f2d0b8d4cab8 = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { label: labelProp, tooltip: tooltip } = props;
    const label = labelProp || (typeof tooltip === 'string' ? tooltip : 'Your profile and settings');
    // All other implementations of IconButton within the components are using spread props, so
    // to use explicit props could cause regressions.
    // TODO: Remove these spread props for better static analysis
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        role: "listitem"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iMRBA.IconButton), {
        label: label,
        ref: ref,
        ...props
    }));
});
var // This exists only to extract props.
// eslint-disable-next-line @repo/internal/react/use-noop
$02b21e5144076119$export$2e2bcd8739ae039 = (props)=>{};

});

parcelRegister("dCGmR", function(module, exports) {

$parcel$export(module.exports, "Settings", () => $88af4992ef3c0b5b$export$c72f6eaae7b9adff);

var $eUqFw = parcelRequire("eUqFw");

var $iw0Y6 = parcelRequire("iw0Y6");

var $iMRBA = parcelRequire("iMRBA");
const $88af4992ef3c0b5b$export$c72f6eaae7b9adff = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { tooltip: tooltip, ...iconButtonProps } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        role: "listitem"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iMRBA.IconButton), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iw0Y6))), {
            label: typeof tooltip === 'string' ? tooltip : 'Settings Icon'
        }),
        ref: ref,
        tooltip: tooltip,
        ...iconButtonProps
    }));
});
var $88af4992ef3c0b5b$export$2e2bcd8739ae039 = $88af4992ef3c0b5b$export$c72f6eaae7b9adff;

});

parcelRegister("dxeoe", function(module, exports) {

$parcel$export(module.exports, "SignIn", () => $fef0bae967003148$export$b64708c6f1b3ed96);

var $eUqFw = parcelRequire("eUqFw");

var $1ZFzZ = parcelRequire("1ZFzZ");

var $iMRBA = parcelRequire("iMRBA");
const $fef0bae967003148$export$b64708c6f1b3ed96 = (props)=>{
    const { tooltip: tooltip, ...iconButtonProps } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        role: "listitem"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iMRBA.IconButton), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1ZFzZ))), {
            label: typeof tooltip === 'string' ? tooltip : 'Sign-in Icon'
        }),
        tooltip: tooltip,
        ...iconButtonProps
    }));
};
var $fef0bae967003148$export$2e2bcd8739ae039 = $fef0bae967003148$export$b64708c6f1b3ed96;

});

parcelRegister("3g3mg", function(module, exports) {

$parcel$export(module.exports, "NavigationSkeleton", () => $eff777ab229b562f$export$ad5e8e6ace98cc2);
/** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $PdmhA = parcelRequire("PdmhA");


var $iMTf6 = parcelRequire("iMTf6");
var $g668r = parcelRequire("g668r");

var $84HFD = parcelRequire("84HFD");

var $46eNd = parcelRequire("46eNd");

var $kAgsw = parcelRequire("kAgsw");

var $gHwzO = parcelRequire("gHwzO");

var $6gCu1 = parcelRequire("6gCu1");
function $eff777ab229b562f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $eff777ab229b562f$var$containerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    boxSizing: 'border-box',
    height: (0, $cbe92d4f348ad4dd$export$30fa7cc5f2690a43),
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexShrink: 0,
    borderBlockEnd: `1px solid ${`var(--ds-border, ${(0, $PdmhA.N30)})`}`,
    paddingInlineEnd: "var(--ds-space-150, 12px)",
    paddingInlineStart: "var(--ds-space-150, 12px)"
});
const $eff777ab229b562f$var$leftStyles = {
    name: "vtikxo",
    styles: "display:flex;min-width:0;height:inherit;align-items:center;flex-grow:1;& > *{flex-shrink:0;}"
};
const $eff777ab229b562f$var$rightStyles = {
    name: "1mwlrd6",
    styles: "display:flex;align-items:center;flex-shrink:0;& > *{flex-shrink:0;margin-inline-end:var(--ds-space-050, 4px);}"
};
const $eff777ab229b562f$export$ad5e8e6ace98cc2 = ({ primaryItemsCount: primaryItemsCount = 4, secondaryItemsCount: secondaryItemsCount = 4, theme: theme = (0, $iMTf6.defaultTheme), showSiteName: showSiteName = false, shouldShowSearch: shouldShowSearch = true, testId: testId })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $g668r.ThemeProvider), {
        value: theme
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: theme.mode.navigation,
        css: $eff777ab229b562f$var$containerStyles,
        "data-testid": testId
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $eff777ab229b562f$var$leftStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $84HFD.IconButtonSkeleton), {
        marginLeft: 0,
        marginRight: 5,
        size: 26
    }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $kAgsw.ProductHomeSkeleton), {
        showSiteName: showSiteName
    }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $46eNd.PrimaryItemsContainerSkeleton), {
        count: primaryItemsCount
    })), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $eff777ab229b562f$var$rightStyles
    }, shouldShowSearch && /*#__PURE__*/ (0, $byn9U.jsx)((0, $6gCu1.SearchSkeleton), null), Array.from({
        length: secondaryItemsCount
    }, (_, index)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $84HFD.IconButtonSkeleton), {
            key: index,
            marginLeft: 0,
            marginRight: 4,
            size: 26
        })), /*#__PURE__*/ (0, $byn9U.jsx)((0, $gHwzO.ProfileSkeleton), null))));
};
var $eff777ab229b562f$export$2e2bcd8739ae039 = $eff777ab229b562f$export$ad5e8e6ace98cc2;

});
parcelRegister("84HFD", function(module, exports) {

$parcel$export(module.exports, "IconButtonSkeleton", () => $24ac6b86ea6f5c27$export$7a24471cb6f25433);
/** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $9JmWF = parcelRequire("9JmWF");
function $24ac6b86ea6f5c27$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $24ac6b86ea6f5c27$var$buttonHeight = "var(--ds-space-400, 32px)";
const $24ac6b86ea6f5c27$var$skeletonStyles = {
    name: "28gj0e",
    styles: "border-radius:var(--ds-border-radius-circle, 50%);opacity:0.15"
};
const $24ac6b86ea6f5c27$export$7a24471cb6f25433 = ({ className: className, marginLeft: marginLeft, marginRight: marginRight, size: size })=>{
    const theme = (0, $9JmWF.useTheme)();
    const dynamicStyles = {
        marginLeft: typeof marginLeft === 'number' ? marginLeft : "var(--ds-space-050, 4px)",
        marginRight: typeof marginRight === 'number' ? marginRight : 0,
        width: typeof size === 'number' ? size : $24ac6b86ea6f5c27$var$buttonHeight,
        height: typeof size === 'number' ? size : $24ac6b86ea6f5c27$var$buttonHeight,
        ...theme.mode.skeleton
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: dynamicStyles,
        css: $24ac6b86ea6f5c27$var$skeletonStyles
    });
};

});

parcelRegister("46eNd", function(module, exports) {

$parcel$export(module.exports, "PrimaryItemsContainerSkeleton", () => $7ae8a743368be220$export$fdfc48d2117b79a8);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $cX3lo = parcelRequire("cX3lo");
function $7ae8a743368be220$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7ae8a743368be220$var$primaryButtonSkeletonStyles = {
    name: "1bufi09",
    styles: "margin-right:var(--ds-space-150, 12px);margin-left:var(--ds-space-150, 12px)"
};
const $7ae8a743368be220$export$fdfc48d2117b79a8 = /*#__PURE__*/ (0, $eUqFw.memo)(({ count: count })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, Array.from({
        length: count
    }, (_, index)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $cX3lo.PrimaryButtonSkeleton), {
            key: index,
            css: $7ae8a743368be220$var$primaryButtonSkeletonStyles
        }))));

});
parcelRegister("cX3lo", function(module, exports) {

$parcel$export(module.exports, "PrimaryButtonSkeleton", () => $f9fcff453893d63e$export$4bc51fe36728414d);
/** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $9JmWF = parcelRequire("9JmWF");
const $f9fcff453893d63e$var$paddingAll = 4;
const $f9fcff453893d63e$var$buttonHeight = 32;
const $f9fcff453893d63e$var$skeletonStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'inline-flex',
    width: '68px',
    height: `${$f9fcff453893d63e$var$buttonHeight - $f9fcff453893d63e$var$paddingAll * 2.5}px`,
    borderRadius: "var(--ds-border-radius, 4px)",
    opacity: 0.15
});
const $f9fcff453893d63e$export$4bc51fe36728414d = (props)=>{
    const theme = (0, $9JmWF.useTheme)();
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: theme.mode.skeleton,
        css: $f9fcff453893d63e$var$skeletonStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className
    });
};

});


parcelRegister("kAgsw", function(module, exports) {

$parcel$export(module.exports, "ProductHomeSkeleton", () => $6448d18649d80c24$export$3e79e535d76cce4b);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");


var $9JmWF = parcelRequire("9JmWF");
const $6448d18649d80c24$var$VAR_PRODUCT_HOME_COLOR_ACTIVE = '--product-home-color-active';
const $6448d18649d80c24$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE = '--product-home-bg-color-active';
const $6448d18649d80c24$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE = '--product-home-box-shadow-active';
const $6448d18649d80c24$var$VAR_PRODUCT_HOME_COLOR_FOCUS = '--product-home-color-focus';
const $6448d18649d80c24$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS = '--product-home-bg-color-focus';
const $6448d18649d80c24$var$VAR_PRODUCT_HOME_BOX_SHADOW_FOCUS = '--product-home-box-shadow-focus';
const $6448d18649d80c24$var$VAR_PRODUCT_HOME_COLOR_HOVER = '--product-home-color-hover';
const $6448d18649d80c24$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER = '--product-home-bg-color-hover';
const $6448d18649d80c24$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER = '--product-home-box-shadow-hover';
const $6448d18649d80c24$var$VAR_SITE_TITLE_BG_COLOR_AFTER = '--site-title-bg-color-after';
const $6448d18649d80c24$var$productHomeButtonStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    padding: "var(--ds-space-050, 4px)",
    alignItems: 'center',
    background: 'none',
    border: 0,
    borderRadius: "var(--ds-border-radius, 3px)",
    color: 'inherit',
    cursor: 'pointer',
    '&::-moz-focus-inner': {
        border: 0
    },
    '&:first-of-type': {
        marginInlineStart: 0
    },
    '&:active': {
        backgroundColor: `var(${$6448d18649d80c24$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE})`,
        boxShadow: `var(${$6448d18649d80c24$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE})`,
        color: `var(${$6448d18649d80c24$var$VAR_PRODUCT_HOME_COLOR_ACTIVE})`
    },
    '&:focus': {
        backgroundColor: `var(${$6448d18649d80c24$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS})`,
        boxShadow: `var(${$6448d18649d80c24$var$VAR_PRODUCT_HOME_BOX_SHADOW_FOCUS})`,
        color: `var(${$6448d18649d80c24$var$VAR_PRODUCT_HOME_COLOR_FOCUS})`,
        outline: 0
    },
    '&:hover': {
        backgroundColor: `var(${$6448d18649d80c24$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER})`,
        boxShadow: `var(${$6448d18649d80c24$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER})`,
        color: `var(${$6448d18649d80c24$var$VAR_PRODUCT_HOME_COLOR_HOVER})`
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    'div&': {
        pointerEvents: 'none'
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    [`@media (max-width: ${(0, $cbe92d4f348ad4dd$export$4033a111ca79977d) - 0.1}px)`]: {
        margin: `0 ${"var(--ds-space-100, 8px)"}`
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    [`@media (min-width: ${0, $cbe92d4f348ad4dd$export$4033a111ca79977d}px)`]: {
        margin: `0 ${"var(--ds-space-200, 16px)"}`
    }
});
const $6448d18649d80c24$var$productLogoStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    width: 120,
    maxWidth: 120,
    height: 24,
    maxHeight: 28,
    opacity: 0.15,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    '& > *': {
        maxHeight: 24
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    [`@media (max-width: ${(0, $cbe92d4f348ad4dd$export$4033a111ca79977d) - 0.1}px)`]: {
        display: 'none'
    }
});
const $6448d18649d80c24$var$productIconStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    width: 28,
    height: 28,
    borderRadius: "var(--ds-border-radius-circle, 50%)",
    opacity: 0.15,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    '& > *': {
        maxHeight: 24
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    [`@media (min-width: ${0, $cbe92d4f348ad4dd$export$4033a111ca79977d}px)`]: {
        display: 'none'
    }
});
const $6448d18649d80c24$var$siteTitleStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    width: "var(--ds-space-500, 40px)",
    alignItems: 'center',
    backgroundColor: 'transparent',
    marginInlineEnd: "var(--ds-space-050, 4px)",
    marginInlineStart: "var(--ds-space-050, 4px)",
    paddingInlineEnd: "var(--ds-space-200, 16px)",
    '&:after': {
        width: '100%',
        height: 14,
        backgroundColor: `var(${$6448d18649d80c24$var$VAR_SITE_TITLE_BG_COLOR_AFTER})`,
        borderRadius: "var(--ds-border-radius, 4px)",
        content: '""'
    }
});
const $6448d18649d80c24$export$3e79e535d76cce4b = ({ showSiteName: showSiteName })=>{
    const theme = (0, $9JmWF.useTheme)();
    const primaryButton = theme.mode.primaryButton;
    const productHomeButtonDynamicStyles = {
        [$6448d18649d80c24$var$VAR_PRODUCT_HOME_COLOR_ACTIVE]: primaryButton.active.color,
        [$6448d18649d80c24$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE]: primaryButton.active.backgroundColor,
        [$6448d18649d80c24$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE]: primaryButton.active.boxShadow,
        [$6448d18649d80c24$var$VAR_PRODUCT_HOME_COLOR_FOCUS]: primaryButton.focus.color,
        [$6448d18649d80c24$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS]: primaryButton.focus.backgroundColor,
        [$6448d18649d80c24$var$VAR_PRODUCT_HOME_BOX_SHADOW_FOCUS]: primaryButton.focus.boxShadow,
        [$6448d18649d80c24$var$VAR_PRODUCT_HOME_COLOR_HOVER]: primaryButton.hover.color,
        [$6448d18649d80c24$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER]: primaryButton.hover.backgroundColor,
        [$6448d18649d80c24$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER]: primaryButton.hover.boxShadow,
        [$6448d18649d80c24$var$VAR_SITE_TITLE_BG_COLOR_AFTER]: theme.mode.skeleton.backgroundColor
    };
    const siteTitleDynamicStyles = {
        borderRight: theme.mode.productHome.borderRight,
        opacity: theme.mode.skeleton.opacity,
        [$6448d18649d80c24$var$VAR_SITE_TITLE_BG_COLOR_AFTER]: theme.mode.skeleton.backgroundColor
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: productHomeButtonDynamicStyles,
        css: $6448d18649d80c24$var$productHomeButtonStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: theme.mode.skeleton,
        css: $6448d18649d80c24$var$productLogoStyles
    }), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: theme.mode.skeleton,
        css: $6448d18649d80c24$var$productIconStyles
    })), showSiteName && /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: siteTitleDynamicStyles,
        css: $6448d18649d80c24$var$siteTitleStyles
    }));
};

});

parcelRegister("gHwzO", function(module, exports) {

$parcel$export(module.exports, "ProfileSkeleton", () => $0a17d43c9a73388e$export$2bab43fd33adda3b);

var $eUqFw = parcelRequire("eUqFw");

var $84HFD = parcelRequire("84HFD");
const $0a17d43c9a73388e$export$2bab43fd33adda3b = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $84HFD.IconButtonSkeleton), {
        marginLeft: 6,
        marginRight: 6,
        size: 26
    });

});

parcelRegister("6gCu1", function(module, exports) {

$parcel$export(module.exports, "SearchSkeleton", () => $5cabc7fd981f681f$export$d8fbade3e5bbb8e0);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");


var $9JmWF = parcelRequire("9JmWF");

var $84HFD = parcelRequire("84HFD");
const $5cabc7fd981f681f$var$searchInputContainerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    marginRight: "var(--ds-space-100, 8px)",
    marginLeft: "var(--ds-space-250, 20px)",
    position: 'relative',
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    [`@media (max-width: ${(0, $cbe92d4f348ad4dd$export$24ec62cee78b7042) - 1}px)`]: {
        display: 'none !important'
    }
});
const $5cabc7fd981f681f$var$searchInputSkeletonStyles = /*#__PURE__*/ (0, $byn9U.css)({
    boxSizing: 'border-box',
    width: '220px',
    height: "var(--ds-space-400, 32px)",
    padding: `0 ${"var(--ds-space-100, 8px)"} 0 ${"var(--ds-space-500, 40px)"}`,
    borderRadius: "var(--ds-border-radius-200, 6px)",
    opacity: 0.15
});
const $5cabc7fd981f681f$var$searchIconStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    [`@media (min-width: ${0, $cbe92d4f348ad4dd$export$24ec62cee78b7042}px)`]: {
        display: 'none !important'
    }
});
const $5cabc7fd981f681f$export$d8fbade3e5bbb8e0 = ()=>{
    const theme = (0, $9JmWF.useTheme)();
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $5cabc7fd981f681f$var$searchInputContainerStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: theme.mode.skeleton,
        css: $5cabc7fd981f681f$var$searchInputSkeletonStyles
    })), /*#__PURE__*/ (0, $byn9U.jsx)((0, $84HFD.IconButtonSkeleton), {
        css: $5cabc7fd981f681f$var$searchIconStyles,
        marginRight: 5,
        size: 26
    }));
};

});


parcelRegister("5wXIr", function(module, exports) {

$parcel$export(module.exports, "Create", () => $2a3a81bfffc67bcc$export$8ade6fcbf3a7de5d);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $bbaTG = parcelRequire("bbaTG");

var $bkIGg = parcelRequire("bkIGg");

var $8cU5f = parcelRequire("8cU5f");


var $9JmWF = parcelRequire("9JmWF");

var $iMRBA = parcelRequire("iMRBA");

var $57Fe9 = parcelRequire("57Fe9");
const $2a3a81bfffc67bcc$var$wrapperStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    alignItems: 'center',
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    '& [data-hide-on-smallscreens]': {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
        [`@media (max-width: ${(0, $cbe92d4f348ad4dd$export$24ec62cee78b7042) - 1}px)`]: {
            display: 'none !important'
        }
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    '& [data-hide-on-largescreens]': {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
        [`@media (min-width: ${0, $cbe92d4f348ad4dd$export$24ec62cee78b7042}px)`]: {
            display: 'none !important'
        }
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    '&&': {
        marginInlineStart: "var(--ds-space-150, 12px)"
    }
});
const $2a3a81bfffc67bcc$var$TooltipSwitch = ({ buttonTooltip: buttonTooltip, children: children })=>buttonTooltip ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $8cU5f.default), {
        content: buttonTooltip,
        hideTooltipOnClick: true
    }, children) : /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, children);
const $2a3a81bfffc67bcc$export$8ade6fcbf3a7de5d = ({ onClick: onClick, href: href, text: text, buttonTooltip: buttonTooltip, iconButtonTooltip: iconButtonTooltip, testId: testId, label: label })=>{
    const theme = (0, $9JmWF.useTheme)();
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $2a3a81bfffc67bcc$var$wrapperStyles,
        role: "listitem",
        "data-testid": "create-button-wrapper"
    }, /*#__PURE__*/ (0, $byn9U.jsx)($2a3a81bfffc67bcc$var$TooltipSwitch, {
        buttonTooltip: buttonTooltip
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $bbaTG.default), {
        id: "createGlobalItem",
        "aria-label": label,
        onClick: onClick,
        href: href,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        theme: (0, $57Fe9.getCreateButtonTheme)(theme),
        testId: testId && `${testId}-button`,
        "data-hide-on-smallscreens": true
    }, text)), /*#__PURE__*/ (0, $byn9U.jsx)((0, $iMRBA.IconButton), {
        id: "createGlobalItemIconButton",
        testId: testId && `${testId}-icon-button`,
        icon: /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bkIGg))), {
            label: text
        }),
        onClick: onClick,
        href: href,
        tooltip: iconButtonTooltip,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        theme: (0, $57Fe9.getCreateButtonTheme)(theme),
        "aria-label": text,
        "data-hide-on-largescreens": true
    }));
};
var $2a3a81bfffc67bcc$export$2e2bcd8739ae039 = $2a3a81bfffc67bcc$export$8ade6fcbf3a7de5d;

});
parcelRegister("57Fe9", function(module, exports) {

$parcel$export(module.exports, "getCreateButtonTheme", () => $b6f6fddcdcc99923$export$256eebed8e934f30);
const $b6f6fddcdcc99923$export$256eebed8e934f30 = ({ mode: { create: create } })=>(current, props)=>{
        const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = current(props);
        return {
            buttonStyles: {
                ...buttonStyles,
                ...create.default,
                margin: 0,
                fontWeight: "var(--ds-font-weight-medium, 500)",
                ':hover': create.hover,
                ':focus': create.focus,
                // :active doesn't work in FF, becasue we do a
                // e.preventDefault() on mouse down in Button.
                // '&&' is required to add more CSS specificity
                // && it not a valid CSSObject property
                // @ts-ignore
                '&&': {
                    ...props.state === 'active' && create.active
                }
            },
            spinnerStyles: spinnerStyles
        };
    };

});


parcelRegister("8YHhh", function(module, exports) {

$parcel$export(module.exports, "Help", () => $ae01b0ce6424f9a7$export$1be7516c0280bee8);

var $eUqFw = parcelRequire("eUqFw");

var $ioiQ7 = parcelRequire("ioiQ7");

var $9JmWF = parcelRequire("9JmWF");

var $3aZfW = parcelRequire("3aZfW");

var $iMRBA = parcelRequire("iMRBA");
const $ae01b0ce6424f9a7$var$HELP_NOTIFICATION_BADGE_ID = 'atlassian-navigation-help-notification-count';
const $ae01b0ce6424f9a7$export$1be7516c0280bee8 = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { badge: badge, tooltip: tooltip, ...iconButtonProps } = props;
    const { mode: { navigation: navigation } } = (0, $9JmWF.useTheme)();
    const button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iMRBA.IconButton), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ioiQ7))), {
            label: typeof tooltip === 'string' ? tooltip : 'Help Icon',
            secondaryColor: navigation.backgroundColor
        }),
        ref: ref,
        tooltip: tooltip,
        ...iconButtonProps
    });
    return badge ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3aZfW.BadgeContainer), {
        id: $ae01b0ce6424f9a7$var$HELP_NOTIFICATION_BADGE_ID,
        badge: badge,
        role: "listitem"
    }, button) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        role: "listitem"
    }, button);
});
var $ae01b0ce6424f9a7$export$2e2bcd8739ae039 = $ae01b0ce6424f9a7$export$1be7516c0280bee8;

});

const $deed61a8dba991fd$export$e4c79eb95c23a0da = 'atlaskit-portal-container';
const $deed61a8dba991fd$export$72f415121273627e = 'body > .atlaskit-portal-container';
const $deed61a8dba991fd$export$13f57c02915787b3 = 'atlaskit-portal';

const $7f8b23c982f78b1d$export$ed5835cc67e87f72 = 'akPortalMount';
const $7f8b23c982f78b1d$export$80816bd900e5bd00 = 'akPortalUnmount';

const $3e55effaa3b38112$export$a59f8d67326bd1cb = "4.17.2";

const $b4cc463b68660864$export$d6830277b06edd6 = 'normal';
const $b4cc463b68660864$export$4f8f13a66ae77bdd = '--color';
const $b4cc463b68660864$export$e9244ec13bd422b5 = '--bg-color';
const $b4cc463b68660864$export$97e78d9745006c11 = '--bg-color-hover';
const $b4cc463b68660864$export$291d63757828f290 = '--bg-color-active';

// same types defined in analytics-web-client but avoid creating dependency with that
const $0321fb9a7e7b56fc$export$a1562d08625f5d7e = 'ui';
const $0321fb9a7e7b56fc$export$947dac6c72b26f81 = 'track';
const $0321fb9a7e7b56fc$export$f1d537d508d2945a = 'screen';
const $0321fb9a7e7b56fc$export$12346a674644c156 = 'operational';
const $0321fb9a7e7b56fc$export$b055de0e665cb20c = 'unknown';


$parcel$global.rlb("bYT2S")
//# sourceMappingURL=shared~atlassian-navigation~atlaskit~ar.4d8e186f.js.map
